webpackJsonp([1],{

/***/ "+Gxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__("/Put");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("/1Lr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/1Lr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/5eB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_srodowiska_srod_warszawa_js__ = __webpack_require__("5opo");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'srod_warszawa',
  data: function data() {
    return {
      srod_warszawa: __WEBPACK_IMPORTED_MODULE_0__models_srodowiska_srod_warszawa_js__["a" /* default */]
    };
  },
  metaInfo: {
    title: 'Środowisko Wileńskie w Warszawie',
    meta: [{ name: 'description', content: 'W latach 1981-1983 kol. Ryszard Andrys-Jankowski w porozumieniu z Radą Starszych Okręgu Wileńskiego (organizacją nie formalną) rozpoczął starania u Władz Administracyjnych RP i w Zarządzie Głównym ZBoWiD zarejestrowania Klubu Żołnierzy Armii Krajowej' }, { name: 'og:url', content: 'http://akwilno.pl/srodowiska/srod_warszawa' }, { name: 'og:title', content: 'Środowisko Wileńskie w Warszawie' }, { name: 'og:image', content: '/srodowiska/srod_warszawa.jpg' }, { name: 'og:description', content: 'W latach 1981-1983 kol. Ryszard Andrys-Jankowski w porozumieniu z Radą Starszych Okręgu Wileńskiego (organizacją nie formalną) rozpoczął starania u Władz Administracyjnych RP i w Zarządzie Głównym ZBoWiD zarejestrowania Klubu Żołnierzy Armii Krajowej' }, { name: 'twitter:url', content: 'http://akwilno.pl/srodowiska/srod_warszawa' }, { name: 'twitter:title', content: 'Środowisko Wileńskie w Warszawie' }, { name: 'witter:image', content: '/srodowiska/srod_warszawa.jpg' }, { name: 'twitter:description', content: 'W latach 1981-1983 kol. Ryszard Andrys-Jankowski w porozumieniu z Radą Starszych Okręgu Wileńskiego (organizacją nie formalną) rozpoczął starania u Władz Administracyjnych RP i w Zarządzie Głównym ZBoWiD zarejestrowania Klubu Żołnierzy Armii Krajowej' }]
  }
});

/***/ }),

/***/ "/LL+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Obchody 70. rocznicy operacji „Ostra Brama” w Wilnie 5- 8 lipiec 2014 r.")]),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"7","cols":"11","order-lg":"1","order":"2"}},[_c('p',[_vm._v("\n        Siedemdziesiąt lat temu żołnierze Armii Krajowej podjęli walkę o Wilno, pragnąc wyzwolić je własnymi siłami z rąk\n        niemieckich przed wejściem Armii Czerwonej, która wypierając Niemców nie niosła ze sobą wolności, lecz sowieckie\n        zniewolenie. Opanowanie Wilna i wystąpienie wobec Sowietów przez władze cywilne i wojskowe Polskiego Państwa Podziemnego,\n        jako gospodarz terenu było elementem ogólnopolskiej „Akcji Burza”. Jej celem była wolna Polska, uniemożliwienie zastąpienia\n        okupacji niemieckiej – sowiecką na ziemiach „wyzwalanych” przez ZSRS.\n      ")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"5","order-lg":"2","order":"1"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":"/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_1.jpg"}}),_c('br')],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',[_vm._v("\n        Operacja wojskowa „Ostra Brama” rozpoczęła się z 6 na 7 lipca 1944 r. Realizowały ją oddziały Okręgu Wileńskiego i Nowogródzkiego\n        AK pod dowództwem ppłk. Aleksandra Krzyżanowskiego „Wilka”. Plan operacji zakładał, że ogarnięci paniką Niemcy szybko wycofają\n        się z Wilna, w związku z tym nie przewidywano poważniejszych walk o miasto. Stało się inaczej, bowiem z rozkazu Hitlera Wilno\n        zostało przekształcone w strefę ufortyfikowaną, obsadzoną przez około 17- tysięczny garnizon.\n        Żołnierze polscy stanęli wobec dużej przewagi sił niemieckich. 7 lipca na przedpola stolicy Wileńszczyzny dotarły już siły sowieckie.\n        Po tygodniu walk z Niemcami, które życiem przypłaciło około 500 żołnierzy AK, 13 lipca, na Górze Zamkowej Akowcy wywiesili\n        biało - czerwoną flagę. Wisiała ona kilka godzin. Rosjanie zerwali ją i wywiesili czerwoną, następnie rozbroili dowództwo i\n        żołnierzy AK. Większość z nich trafiła do więzień, łagrów i na zesłanie.\n        Po siedemdziesięciu latach żyjący uczestnicy operacji „Ostra Brama” zebrali się na rocznicowych uroczystościach w Wilnie.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Zorganizowało je Stowarzyszenie Łagierników Żołnierzy Armii Krajowej wspólnie z Urzędem ds. Kombatantów i Osób Represjonowanych\n        przy wsparciu Ministerstwa Spraw Zagranicznych, z udziałem Światowego Związku Żołnierzy AK Okręgu Wileńskiego oraz Nowogródzkiego,\n        a także Związku Polaków na Litwie.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        W obchodach wzięli udział kombatanci – żołnierze Armii Krajowej z Polski, Białorusi i Litwy oraz członkowie Stowarzyszenia\n        Łagierników Żołnierzy Armii Krajowej, nauczyciele wraz z uczniami i harcerzami z patriotycznych szkół w Wilnie, Sejnach,\n        Augustowie, Białymstoku, Warszawie, Wołominie, Zelowie, i Krakowie.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Podczas kilkudniowych uroczystości na apel narodowy stawiły się poczty sztandarowe żołnierzy Armii Krajowej oraz harcerzy,\n        w tym Stowarzyszenia Łagierników Żołnierzy AK, Klubu Weteranów Armii Krajowej w Wilnie i Stowarzyszenia Polskich Kombatantów\n        na Litwie na czele z wiceprezesem Edwardem Klonowskim. Był również poczet Niezależnego Związku Harcerskiego „Czerwony Mak” im.\n        Bohaterów Monte Cassino ze Skawiny, a także Stowarzyszenia Klubu Wrzesień 1939.\n      ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',{staticClass:"display-4"},[_vm._v("5 lipca 2014 r.")]),_vm._v(" "),_c('p',[_vm._v("\n        Trzy autokary oraz dwa busy przywiozły uczestników uroczystości z Polski i Białorusi do Wilna w sobotę,\n        5 lipca 2014 r. Obchody 70. rocznicy operacji „Ostra Brama” rozpoczął wzruszający wieczór wspomnień w Domu\n        Polskim z udziałem żołnierzy Armii Krajowej, biorących udział w boju o Wilno.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Gości powitał Artur Kondrat Prezes Stowarzyszenia Łagierników Żołnierzy Armii Krajowej. Po wprowadzeniu historycznym\n        dokonanym przez Andrzeja Siedleckiego, prezesa stowarzyszenia w latach 2011-2014, wspomnieniami z lipca 1944 r.\n        podzielili się: mjr Stefania Szantyr – Powolna, ps. „Hanka”, Honorowy Prezes Stowarzyszenia Łagierników Żołnierzy Armii\n        Krajowej, Włodzimierz Mikuć, ps. „Jarema” - Prezes Okręgu Wileńskiego AK, żołnierz I Wileńskiej Brygady AK, kpt. Weronika\n        Sebastianowicz, ps. ”Różyczka” ze Stowarzyszenia Żołnierzy AK na Białousi, płk Tadeusz Bieńkowicz, ps. „Rączy” Kawaler VM –\n        Prezes Polskiego Związku Więźniów Komunizmu w Krakowie, mjr Czesław Sawicz, Lidia Lwow, ps. „Lala” – łączniczka V Wileńskiej\n        Brygady AK mjr. Zygmunta Szendzielarza ps. „Łupaszka” oraz ks. kpt Czesław Wierzbicki, ps. „Kula”.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Żołnierze AK biorący udział w operacji „Ostra Brama” przywołali we wspomnieniach poległych, zmarłych i żyjących\n        bohaterów walki o Wilno. Refleksja nad losami Polski i Polaków, szczególnie dramatycznymi na utraconych Kresach II RP,\n        wzruszenie i atmosfera serdeczności udzieliła się wszystkim uczestnikom spotkania i towarzyszyła nam w kolejnych dniach\n        peregrynacji po miejscach czynu zbrojnego Armii Krajowej.\n      ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',{staticClass:"display-4"},[_vm._v("6 lipca 2014 r.")]),_vm._v(" "),_c('p',[_vm._v("\n        Uroczystości zainaugurowała msza św. w kościele pw. Św. Teresy w intencji żołnierzy Armii Krajowej poległych\n        podczas zdobywania Wilna. O zobowiązaniu płynącym z ich ofiary mówił w płomiennym kazaniu ksiądz Stanisław Koczwara -\n        profesor Instytutu Teologicznego w Wilnie. Po liturgii był czas na osobistą modlitwę w połączonej z kościołem kaplicy w\n        Ostrej Bramie przed obrazem Najświętszej Maryi Panny Matki Miłosierdzia.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Główna ceremonia miała miejsce na cmentarzu na Rossie, przy mauzoleum „Matka i Serce Syna”, gdzie spoczywają polscy\n        żołnierze polegli w walkach o Wilno w latach 1919-1920, a także podczas operacji „Ostra Brama” w 1944 r. Przy ich kwaterach\n        zgromadzili się żołnierze Okręgu Wileńskiego i Nowogródzkiego AK, którzy przybyli na obchody 70. rocznicy walk o Wilno z\n        Polski, Białorusi i Litwy.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        W uroczystościach wzięli udział m.in.: Kierownik Urzędu do Spraw Kombatantów i Osób Represjonowanych Jan Stanisław Ciechanowski,\n        Sekretarz Rady Ochrony Pamięci Walk i Męczeństwa Andrzej Krzysztof Kunert, Minister w Rządzie Republiki Litewskiej Jarosław\n        Niewierowicz, Poseł na Sejm RP Leszek Dobrzyński, Konsul Generalny RP w Wilnie Stanisław Cygnarowski oraz Przewodniczący Związku\n        Polaków na Litwie Michał Mackiewicz. Licznie przybyła społeczność polska w Wilnie, cieszyła obecność młodych ludzi, harcerzy,\n        widoczna była grupa Miłośników Wilna i Ziemi Wileńskiej, delegacja Macierzy Szkolnej, uczestnicy wyprawy edukacyjnej z IPN\n        Oddział w Krakowie - Bratnia Pomoc Akademicka im. św. Jana z Kęt, Klub Historyczny im. Armii Krajowej w Zelowie, Klub Gazety\n        Polskiej z Gdańska. Obecni byli historycy zajmujący się podziemiem niepodległościowym na Wileńszczyźnie: Maciej Korkuć, Tomasz\n        Balbus i Piotr Niwiński. Oprawę muzyczną uroczystości zapewnił Chór Misericordia z parafii Św. Faustyny Kowalskiej w Koninie.\n        Wydarzenia sprzed 70 lat uczciły polskie myśliwce wojskowe, przelatując dwukrotnie nad wileńską nekropolią.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Konieczność zachowania pamięci o wyjątkowym pokoleniu akowców, ich ofierze dla Ojczyzny i dramatycznych losach podkreślali\n        w swych wystąpieniach ministrowie Jan Stanisław Ciechanowski i Andrzej Krzysztof Kunert, konsul Stanisław Cygnarowski oraz\n        Andrzej Siedlecki przemawiający w imieniu Stowarzyszenia Łagierników Żołnierzy Armii Krajowej. We wzruszający sposób o sensie\n        konspiracyjnego zaangażowania, o rodzinnym Wilnie i nostalgii za nim mówiła mjr Stefania Szantyr – Powolna. Osobistym\n        świadectwem podzielił się też płk. Tadeusz Bieńkowicz, ps. „Rączy”. Uczestnicy obchodów uczcili poległych bohaterów,\n        składając wieńce i zapalając światła pamięci.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Kontynuacja obchodów miała miejsce w Domu Kultury Polskiej w Wilnie. Oprócz ww. gości wziął w niej udział mer Regionu Soleczniki\n        Zdzisław Palewicz oraz Michał Dworczyk – Prezes Fundacji Wolność i Demokracja.\n        Michał Mackiewicz - Prezes Związku Polaków na Litwie dokonał uroczystego otwarcia wystawy fotograficznej Jerzego Karpowicza\n        „Miejsca pamięci narodowej na Ziemi Wileńskiej”.\n        W kolejnej części uroczystości Szef Urzędu do Spraw Kombatantów i Osób Represjonowanych Jan Stanisław Ciechanowski\n        udekorował Medalem „Pro Patria” osoby szczególnie zasłużone w kultywowaniu pamięci o walce o niepodległość RP i\n        martyrologii narodu polskiego: Bożennę Bargieł, Monikę Brzezińską, Władysława Mackiewicza i Janinę Macutkiewicz.\n        Zostały wręczone pamiątkowe medale, ryngrafy i inne dowody uznania za patriotyczną działalność.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Nie zabrakło wspomnień i historycznych refleksji. Wileńska młodzież z Polskiego Studia Teatralnego w Wilnie,\n        kierowanego przez Lilę Kiejzik zaprezentowała montaż literacko – muzyczny poświęcony żołnierzom AK. Następnie\n        realizację planu „Burza” na Wileńszczyźnie ustami świadków historii przybliżył film dokumentalny „Drogi do Ostrej\n        Bramy” w reż. Ewy Szakalickiej. Uroczysta kolacja zakończyła ten bogaty w wydarzenia dzień.\n      ")])])],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-carousel',{staticClass:"carousel_relacja",staticStyle:{"text-shadow":"1px 1px 2px #333","margin":"0 0em 2em 0em"},attrs:{"controls":"","indicators":"","background":"#ababab","interval":0}},_vm._l((_vm.relacja.lip6.part1),function(carousel){return _c('div',{key:carousel.id},[_c('b-carousel-slide',{attrs:{"caption":carousel.title,"text":carousel.text,"img-src":carousel.img}})],1)}),0)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-carousel',{staticClass:"carousel_relacja",staticStyle:{"text-shadow":"1px 1px 2px #333","margin":"0 0em 2em 0em"},attrs:{"controls":"","indicators":"","background":"#ababab","interval":0}},_vm._l((_vm.relacja.lip6.part2),function(carousel){return _c('div',{key:carousel.id},[_c('b-carousel-slide',{attrs:{"caption":carousel.title,"text":carousel.text,"img-src":carousel.img}})],1)}),0)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',{staticClass:"display-4"},[_vm._v("7 lipca 2014 r.")]),_vm._v(" "),_c('p',[_vm._v("\n        Trzeci dzień obchodów rozpoczęły uroczystości w podwileńskich Krawczunach w 70. rocznicę bitwy stoczonej 13 lipca 1944 r.\n        przez Zgrupowanie AK mjr. Mieczysława Potockiego „Węgielny” z wojskami niemieckimi dowodzonymi przez gen. Stahela.\n        O jej przebiegu opowiedzieli trzej uczestnicy: ks. kpt. Czesław Wierzbicki „Kula”, kpt. Czesław Sawicz oraz kpt.\n        Lech Rudziński.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Po modlitwie, złożeniu wiązanek pod pomnikiem upamiętniającym bitwę z 13 lipca 1944 r. i odśpiewaniu kilku partyzanckich\n        pieśni uczestnicy uroczystości udali się do Kalwarii Wileńskiej, gdzie pochowani są żołnierze polegli pod Krawczunami.\n        Tu również złożono wieńce i odmówiono modlitwę za żołnierzy z Wileńskiego i Nowogródzkiego Okręgu AK poległych podczas\n        zdobywania Wilna.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Kolejnym miejscem na mapie obchodów był drewniany kościółek w Kolonii Wileńskiej, gdzie odprawiona została msza święta w\n        intencji żołnierzy AK poległych w lipcu 1944 r. podczas walk w Kolonii Wileńskiej oraz zmarłych w polowym szpitalu\n        tu zorganizowanym. Po mszy świętej nastąpił przemarsz uczestników uroczystości na cmentarz, gdzie na grobach żołnierzy\n        zapalono znicze, a przy pamiątkowym pomniku złożono wieńce. O udziale w akcji ratowania rannych i o zesłańczych\n        doświadczeniach opowiedziała kpt. Stanisława Kociełowicz, wiceprezes Stowarzyszenia Łagierników Żołnierzy AK.\n      ")])])],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"12","md":"9"}},[_c('b-carousel',{staticClass:"carousel_relacja",staticStyle:{"text-shadow":"1px 1px 2px #333","margin":"0 0em 2em 0em"},attrs:{"controls":"","indicators":"","background":"#ababab","interval":0}},_vm._l((_vm.relacja.lip7),function(carousel){return _c('div',{key:carousel.id},[_c('b-carousel-slide',{attrs:{"caption":carousel.title,"text":carousel.text,"img-src":carousel.img}})],1)}),0)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',{staticClass:"display-4"},[_vm._v("8 lipca 2014 r.")]),_vm._v(" "),_c('p',[_vm._v("\n        Na wileńskim szlaku męczeństwa polskich patriotów szczególne miejsce zajmują Ponary. W ciągu trzech lat –\n        od lipca 1941 do lipca 1944 wymordowano tu około sto tysięcy osób. W tej liczbie ok. 70 tysięcy Żydów – obywateli\n        II RP (z wileńskiego getta i przywożonych z okolicy) i ok. 20 tysięcy Polaków. Zbrodni dokonali Niemcy przy pomocy\n        litewskich ochotników zgłaszających się do specjalnego oddziału wykonującego egzekucje.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Prezes Stowarzyszenia Łagierników Żołnierzy Armii Krajowej Artur Kondrat podsumował czterodniowe obchody 70.\n        rocznicy operacji „Ostra Brama”, dziękując ich uczestnikom.\n      ")])])],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"12","md":"9"}},[_c('b-carousel',{staticClass:"carousel_relacja",staticStyle:{"text-shadow":"1px 1px 2px #333","margin":"0 0em 2em 0em"},attrs:{"controls":"","indicators":"","background":"#ababab","interval":0}},_vm._l((_vm.relacja.lip8),function(carousel){return _c('div',{key:carousel.id},[_c('b-carousel-slide',{attrs:{"caption":carousel.title,"text":carousel.text,"img-src":carousel.img}})],1)}),0)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',[_vm._v("\n        Podziękowania i słowa najwyższego uznania należne są prezesowi, zarządowi i członkom Stowarzyszenia Łagierników Żołnierzy\n        Armii Krajowej, którzy wzięli na siebie trud zorganizowania uroczystości. Ich piękną stroną był ogromny szacunek okazywany\n        licznie przybyłym żołnierzom AK, którzy siedemdziesiąt lat temu o Wilno walczyli.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Wyrokiem mocarstw ich ukochane miasto pozostało poza granicami Polski, którą oddano w sowiecką zależność.\n        To oni ponieśli koszt wiarołomstwa sojuszników cierpieniem w sowieckich bądź polskich więzieniach, w łagrach, na zsyłce,\n        w powojennej partyzantce, w ubeckich katowniach. Dobrze, że dzięki wrażliwości ludzi tworzących Stowarzyszenie\n        Łagierników Żołnierzy Armii Krajowej honorowani i otaczani serdecznością są Ci, którzy w młodości walczyli za Polskę i\n        przez lata byli represjonowani, odzierani z godności, nazywani bandytami, wykreślani z pamięci narodu. Nareszcie słyszą:\n        „ Armia Krajowa jest perłą w historii narodu polskiego” (słowa św. Jana Pawła II przywołane podczas uroczystości przez\n        Andrzeja Siedleckiego). Gratulujemy organizatorom\n      ")]),_vm._v(" "),_c('p',{staticClass:"text-right"},[_c('i',[_vm._v("Danuta i Zbigniew Kaszlejowie")])]),_vm._v(" "),_c('b-button',{attrs:{"target":"_blank","href":"https://plus.google.com/photos/101929072860543101454/albums/6035271401086936609?banner=pwa"}},[_vm._v("\n        Część I do pobrania\n      ")]),_vm._v(" "),_c('b-button',{attrs:{"target":"_blank","href":"https://plus.google.com/photos/101929072860543101454/albums/6035278359196913313?banner=pwa"}},[_vm._v("\n        Część II do pobrania\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Put":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__("fnDg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]);

/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__("diQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__("vaPR");
function injectStyle (ssrContext) {
  __webpack_require__("QOuL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "03yE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spuscizna_jana_gozdawy_vue__ = __webpack_require__("Vs2P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_307160d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_spuscizna_jana_gozdawy_vue__ = __webpack_require__("Nf/c");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spuscizna_jana_gozdawy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_307160d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_spuscizna_jana_gozdawy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0hj2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1LwG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  carousel: [{
    id: 0,
    title: '',
    text: 'Poświęcenie ryngrafu w Skorbucianach 13.05.2012',
    img: "/aktualnosci/zawiesz_posw_votum/zawiesz_posw_votum_foto_3.jpg"
  }, {
    id: 1,
    title: '',
    text: 'Poświęcenie ryngrafu w Koloni Wileńskiej 14.05.2012',
    img: "/aktualnosci/zawiesz_posw_votum/zawiesz_posw_votum_foto_4.jpg"
  }, {
    id: 2,
    title: '',
    text: 'Poświęcenie ryngrafu w Koleśnikach 15.05.2012r.',
    img: "/aktualnosci/zawiesz_posw_votum/zawiesz_posw_votum_foto_5.jpg"
  }, {
    id: 3,
    title: '',
    text: 'Kolonia Wileńska',
    img: "/aktualnosci/zawiesz_posw_votum/zawiesz_posw_votum_foto_6.jpg"
  }, {
    id: 4,
    title: '',
    text: 'Koleśniki',
    img: "/aktualnosci/zawiesz_posw_votum/zawiesz_posw_votum_foto_7.jpg"
  }, {
    id: 5,
    title: '',
    text: 'Skorbuciany',
    img: "/aktualnosci/zawiesz_posw_votum/zawiesz_posw_votum_foto_8.jpg"
  }]
});

/***/ }),

/***/ "1S12":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Okres Czerwiec 41' - Lipiec 44'")]),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6","order-md":"1","order":"2"}},[_c('p',[_vm._v("\n        Zajęcie Wileńszczyzny przez wojska niemieckie i inny podział administracyjny, zatwierdzenie przez Komendę Główną na\n        Komendanta Okręgu Wileńskiego, ppłk Aleksandra Krzyżanowskiego „Wilk”, rozpoczęło nowy rozdział działalności\n        konspiracyjnej Związku Walki Zbrojnej Okręgu.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        W połowie 1942 r. Komenda Główna przemianowała dotychczasowy Związek Walki Zbrojnej na Armię Krajową odróżniając część\n        sił zbrojnych Polskiego Państwa Podziemnego od sił zbrojnych na zachodzie to jest jednostek walczących pod ogólnym\n        dowództwem aliantów.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Odtworzono Komendę Garnizonu miasta Wilna „Dwór”. Garnizon podzielono na cztery dzielnice. Zadaniem ich było przygotowanie,\n        a następnie utworzenie Oddziałów wojskowych w sile Batalionu."),_c('br')])]),_vm._v(" "),_c('b-col',{attrs:{"md":"5","order-md":"2","order":"1"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":"/historia/okres_41_44/Podział_Okregu_Wilenskiego.jpg"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lead"},[_vm._v("Podział Okręgu Wileńskiego na Obwody (powiaty)")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',{staticClass:"lead"},[_vm._v("\n        „Pole” zostaje podzielone na trzy rejony :\n      ")]),_vm._v(" "),_c('ul',_vm._l((_vm.okres_41_44.powiaty.list.rejony),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0)])],1),_vm._v(" "),_c('b-row',{staticClass:"justify-content-sm-center"},_vm._l((_vm.okres_41_44.powiaty.cards),function(card){return _c('b-col',{key:card.id,attrs:{"md":"3","cols":"6"}},[_c('b-card',{staticClass:"mb-2",staticStyle:{"width":"10em","min-height":"25em"},attrs:{"img-src":card.img,"img-top":"","tag":"article"}},[_c('p',{staticClass:"card-text"},[_vm._v("\n          "+_vm._s(card.desc)+"\n        ")])])],1)}),1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"8"}},[_c('ul',_vm._l((_vm.okres_41_44.powiaty.list.desc),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',[_vm._v("\n        Poza Garnizonem miejskim i rejonami do Okręgu Wileńskiego należał Podokręg Kowieński.\n        Powstają Komendy Rejonów i Obwodów wraz z siatką wywiadu i łączności. Powołana zostaje Komenda Dywersji „Kedyw”,\n        którego Dowódcą zostaje por. Adam Boryczka „Tońko”, „Brona”.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Ludność pochodzenia białoruskiego mieszkająca na Wileńszczyźnie w pełni zaakceptowała Związek Walki Zbrojnej i\n        z nim współpracowała.\n      ")]),_vm._v(" "),_c('p',{staticClass:"display-4 mt-3"},[_vm._v("Okręgowa Delegatura Rządu")]),_vm._v(" "),_c('p',[_vm._v("\n        Po kilkukrotnych zmianach decyzji Głównego Delegata Rządu w Warszawie odnośnie kandydata na Okręgowego Delegata Rządu\n        Okręgu Wileńskiego, na posiedzeniu Rady Wojewódzkiej pod przewodnictwem ppłk Aleksandra Krzyżanowskiego „Wesołowski”,\n        „Dziemido”, „Wilk” w dniu 28 lutego 1942 r. wybrano przedstawiciela Stronnictwa Narodowego dr Zygmunta Fedorowicza „Albin”,\n        „Pani Maria”, „Józef”.\n      ")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Wileńska Delegatura składała się z następujących komórek:")]),_vm._v(" "),_c('ul',_vm._l((_vm.okres_41_44.okreg_deleg.list.wilno),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0),_vm._v(" "),_c('p',[_vm._v("\n        Kierownictwo Walki Cywilnej - występowało jako gremium Stronnictw Politycznych: Jerzy Dobrzański „Pan S” z ramienia PPS-WRN,\n        Henryk Jackiewicz „Pan L” z ramienia SL, Edmund Greczanik „Pan D” z ramienia SD, Feliks Kasperowicz „Pan N” z ramienia SN, NN\n        „Pan R” z ramienia ONR, Adam Galiński „Pan P” z ramienia piłsudczyków.\n      ")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Ponadto przy Delegacie Rządu działał:")]),_vm._v(" "),_c('ul',_vm._l((_vm.okres_41_44.okreg_deleg.list.rzad),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0)])],1),_vm._v(" "),_c('b-row',[_vm._l((_vm.okres_41_44.okreg_deleg.cards.part1),function(card){return _c('b-col',{key:card.id,attrs:{"md":"3","cols":"6"}},[_c('b-card',{staticClass:"mb-2",staticStyle:{"width":"10em","min-height":"25em"},attrs:{"img-src":card.img,"img-top":"","tag":"article"}},[_c('p',{staticClass:"card-text"},[_vm._v("\n          "+_vm._s(card.desc)+"\n        ")])])],1)}),_vm._v(" "),_vm._l((_vm.okres_41_44.okreg_deleg.cards.part2),function(card){return _c('b-col',{key:card.id,attrs:{"md":"3","cols":"6"}},[_c('b-card',{staticClass:"mb-2",staticStyle:{"width":"10em","min-height":"25em"},attrs:{"img-src":card.img,"img-top":"","tag":"article"}},[_c('p',{staticClass:"card-text"},[_vm._v("\n          "+_vm._s(card.desc)+"\n        ")])])],1)})],2),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',{staticClass:"display-4 mt-3"},[_vm._v("Komenda Okręgu Wileńskiego Armii Krajowej.")])])],1),_vm._v(" "),_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"md":"10"}},[_c('b-card',[_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":"/historia/okres_41_44/Aleksander_Krzyzanowski.jpg"}}),_c('br')],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('strong',[_vm._v("Ppłk Aleksander Krzyżanowski „Andrzej Wesołowski”, „Smętek”, „Dziemido”, „Wilk”")]),_vm._v("\n            Drugi Komendant Związku Walki Zbrojnej i Armii Krajowej Okręgu Wileńskiego.\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',[_vm._v("\n        Mjr Aleksander Krzyżanowski w listopadzie 1939 r. został skierowany przez gen. Karaszewicza-Tokarzewskiego do Wilna dokąd\n        dotarł w lutym 1940 r. i objął stanowisko kwatermistrza Komendy Okręgu. W kwietniu 1940 r. został zastępcą Komendanta Sulika\n        i jednocześnie szefem sztabu Komendy. Awansowany na stopień podpułkownika 22.01.1941 r. Po aresztowaniu ppłk Nikodema Sulika\n        przejął obowiązki Komendanta Okręgu. W czasie pełnienia stanowiska Komendanta Okręgu podejmował kilkakrotnie próby uzgodnienia\n        współdziałania Armii Krajowej z partyzantką sowiecką - bez powodzenia. Po zakończeniu walk o Wilno ppłk Krzyżanowski ujawnił\n        się za zgodą Komendy Głównej jako generał Kulczycki i podjął rozmowy z dowództwem 3. Frontu Białoruskiego Czerwonej Armii.\n        Aresztowany przez NKWD przebywał w więzieniach w Wilnie i w ZSRR. 28.09.1944 został awansowany na stopień pułkownika.\n        Zwolniony w listopadzie 1947 r. i powrócił do Kraju. Aresztowany przez UB 02.07.1948 osadzony w więzieniu w Warszawie,\n        gdzie 29.09.1951 r. zmarł. Awansowany pośmiertnie na stopień generała brygady."),_c('br'),_vm._v("\n        W lutym 1942 r. Związek Walki Zbrojnej, zostaje przemianowany na Armię Krajową. W połowie 1942 roku Komenda Główna Armii\n        Krajowej w Warszawie, deleguje do Wilna mjr Lubosława Krzeszowskiego \"Ludwik\", który obejmuje stanowisko Szefa Sztabu Komendy\n        Okręgu. Objęcie stanowiska przez \"Ludwika\" spowodowało reorganizację Okręgu. Podzielony on został na cztery Inspektoraty\n        Rejonowe, które dzieliły się na Obwody terytorialnie obejmujące poszczególne powiaty. W każdym Obwodzie utworzony zostaje\n        Ośrodek   Dywersyjny lub Dywersyjno-Partyzancki. Brak jest danych źródłowych, określających jakie zadania miały i w jakiej\n        zależności były one w stosunku do siebie i Komend Inspektoratów Rejonowych. Wiadome jest, że Ośrodki Dywersyjno - Partyzanckie\n        były podwaliną dla kadry i szkieletem mających powstać Oddziałów Partyzanckich. "),_c('br'),_vm._v("\n        W początkach roku 1944 następuje ponowna reorganizacja Okręgu. Powstały Inspektoraty. Podlegały im działające lub powoływane\n        na ich terenie Oddziały Partyzanckie, które następnie otrzymały nazwy Brygad Partyzanckich Armii Krajowej z numerem., a z czasem\n        samorzutnie przyjęły nazwy od pseudonimów swoich komendantów.\n      ")]),_vm._v(" "),_c('p',{staticClass:"lead mt-3"},[_vm._v("Obsada personalna Komendy Okręgu Wileńskiego była następująca:")]),_vm._v(" "),_c('ul',_vm._l((_vm.okres_41_44.komenda.list.obsada),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0),_vm._v(" "),_c('p',{staticClass:"lead mt-3"},[_vm._v("Inspektoraty:")]),_vm._v(" "),_c('ul',_vm._l((_vm.okres_41_44.komenda.list.inspektoraty),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0)])],1),_vm._v(" "),_c('b-row',[_vm._l((_vm.okres_41_44.komenda.cards.part1),function(card){return _c('b-col',{key:card.id,attrs:{"md":"3","cols":"6"}},[_c('b-card',{staticClass:"mb-2",staticStyle:{"width":"10em","min-height":"25em"},attrs:{"img-src":card.img,"img-top":"","tag":"article"}},[_c('p',{staticClass:"card-text"},[_vm._v("\n          "+_vm._s(card.desc)+"\n        ")])])],1)}),_vm._v(" "),_vm._l((_vm.okres_41_44.komenda.cards.part2),function(card){return _c('b-col',{key:card.id,attrs:{"md":"3","cols":"6"}},[_c('b-card',{staticClass:"mb-2",staticStyle:{"width":"10em","min-height":"25em"},attrs:{"img-src":card.img,"img-top":"","tag":"article"}},[_c('p',{staticClass:"card-text"},[_vm._v("\n          "+_vm._s(card.desc)+"\n        ")])])],1)})],2),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_vm._l((_vm.okres_41_44.komenda.zgrupowania),function(zgrupowanie){return _c('div',[_c('p',{staticClass:"lead mt-3"},[_vm._v(_vm._s(zgrupowanie.title))]),_vm._v(" "),_c('ul',_vm._l((zgrupowanie.list),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0)])}),_vm._v(" "),_c('p',[_vm._v("\n        Poza Zgrupowaniami Partyzanckimi działały 6. Brygada mjr \"Konara\" i Oddział Rozpoznawczy\n        Komendanta Okręgu por. „Groma” oraz Garnizon miasta Wilna.\n      ")]),_c('p'),_c('p',{staticClass:"lead mt-2"},[_vm._v("Jednocześnie z powołaniem Zgrupowań, nastąpił podział sztabów na:")]),_vm._v(" "),_c('ul',_vm._l((_vm.okres_41_44.komenda.list.sztaby),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0),_vm._v(" "),_c('p',[_vm._v("\n        Oba sztaby rozpoczęły przygotowania do Operacji \"Ostra Brama\" mającej za zadanie opanowanie miasta Wilna i jego najbliższych\n        okolic w czasie odstępowania wojsk niemieckich, a zajęciem tych terenów przez wojska sowieckie. Operacja ta miała się odbyć z\n        udziałem połączonych sił zbrojnych Armii Krajowej obu Okręgów Wileńskiego i Nowogródzkiego pod wspólnym dowództwem ppłk Aleksandra\n        Krzyżanowskiego \"Wilk\". "),_c('br'),_vm._v("\n        Dowództwo II Frontu Białoruskiego wojsk sowieckich kierowane przez marszałka Iwana Czerniahowskiego, przy ścisłej współpracy z\n        zastępcą Ministra Spraw Wewnętrznych /NKWD/ Berii, generałem NKWD Iwanem Sierowem, realizując wcześniejsze uchwały Biura\n        Politycznego ZSRR dotyczące zniszczenia fizycznego Armii Krajowej na terenach zajmowanych przez Związek Sowiecki przysłały swoich\n        oficerów łącznikowych, celem ustalenia zasad prowadzenia wspólnych działań zbrojnych przeciwko Niemcom. Jak się później okazało\n        nie byli to oficerowie liniowi wojsk frontowych, ale specjalnie przeszkoleni wyżsi oficerowie NKWD, mający za zadanie rozpoznanie\n        sił Oddziałów Armii Krajowej, ich miejsca postoju, uzbrojenie, nastroje polityczne itd. "),_c('br'),_vm._v("\n        Oficjalnie podawano, że Armia Krajowa Okręgów Wileńskiego i Nowogródzkiego będzie przemianowana na 19 Dywizję Wojsk\n        Sprzymierzonych, podlegając politycznie Rządowi Polskiemu na Emigracji, natomiast taktycznie Dowództwu wojsk sowieckich.\n        Wszystkie te deklaracje i działania zostały przez Komendę Okręgu przyjęte jako wiarygodne, a okazały się ogromnym kłamstwem.\n        Efekty tych działań w rozdziale \"Rozbrojenie i aresztowanie\".\n      ")]),_vm._v(" "),_c('p',{staticClass:"display-4 mt-4"},[_vm._v("Legalizacja")]),_vm._v(" "),_c('p',[_vm._v("\n        Dowódca Oddziału VI Biuro Informacji i Propagandy - ppor. Leon Lech Bejnar \"Nowina\" /Paweł Jasienica/.\n        W końcu 1939 roku wynikła bardzo pilna potrzeba utworzenia przy sztabie Okręgu Wileńskiego SZP komórki legalizacyjnej.\n        Zadaniem jej byłoby wykonywanie dokumentów, którymi mogliby się posługiwać ludzie związani z konspiracją, oficerowie pragnący\n        wstąpić do Wojska Polskiego we Francji po przez Litwę, Szwecję oraz tak zwani uchodźcy ,których w Wilnie było około 30 tysięcy."),_c('br'),_vm._v("\n        Ówczesne władze tak sowieckie jak i następnie litewskie żądały od ludzi znajdujących się w Wilnie , dokumentów uzasadniających ich pobyt na\n        tych terenach."),_c('br'),_vm._v("\n        Otrzymano z likwidujących się polskich urzędów państwowych i samorządowych sporo czystych blankietów na dowody osobiste,\n        zaświadczeń pracy, metryk urodzenia i tym podobnych."),_c('br'),_vm._v("\n        Na polecenie członka Sztabu Okręgu księdza Kazimierza Kucharskiego \"Szymon\" jego zaufany współpracownik Stanisław Kiałka\n        \"Bolesław\" „Drzewica\", \"Jelonek\" \"Szarotka\" otrzymał polecenie organizacji takiej komórki."),_c('br'),_vm._v("\n        Jednocześnie z poleceniem podał adres doc. Wydziału Sztuk Pięknych USB Jerzego Hoppena , który przyjął propozycję i włączył do\n        tej pracy grafika Edwarda Kuczyńskiego \"Kalina\". Skład ten uzupełnił jako pracownik biurowy i fotograf ks. Stefan Dzierżek jezuita.\n        Z poręczenia doc. Hopppena zgodziła się współpracować z Komórką Legalizacyjną firma cynkograficzna Zaniewskiego przy ul. Wielkiej.\n        Trudności przy składaniu zleceń w firmie Zaniewskich, zmusiły doc. Hoppena do nawiązania współpracy ze studentem Wydziału Sztuk\n        Pięknych USB metaloplastyki Michała Warakomskiego \"Piotr\", \"Jacek\" jako kierownika cynkografii na potrzeby Legalizacji.\n        Po ustąpieniu doc. Hoppena ze względów zdrowotnych z tej pracy, w grudniu 1939 roku, jego miejsce zajął Romuald Warakomski\n        \"Hilary\" jako grafik. Dział chemicznego \"prania\" zwłaszcza litewskich paszportów prowadziła studentka chemii USB Irena\n        Butkiewiczówna \"Irka Lwowska\", \"Renata\". "),_c('br'),_vm._v("\n        Legalizacja w okresie od grudnia 1939 do maja 1940 r. wypuściła około 3.000 różnych dokumentów.\n        W marcu 1940 r. do pracy w Legalizacji przystąpiły siostry Józefa i Maria Rymkiewiczówne.\n        W okresie od listopada 1940 r. do grudnia 1941 Legalizacja posiadała pracownie : graficzną, fotograficzną, cynkografię, warsztat wulkanizacyjny pieczęci i drukarnię.\n        W tym okresie Legalizacją kierował - Stanisław Kiałka \"Ślęczek\", \"Bolesław\"\n        \"Kuźnią\" obejmująca: cynkografię, warsztat wulkanizacyjny, drukarnię - Michał Warakomski \"Piotr\", \"Jacek\".\n        Doradcą technicznym był - doc. Jerzy Hoppen .\n        I grafikiem - Edward Kuczyński \"Kalina\".\n        II grafikiem - Romuald Warakomski \"Jerzy\", \"Hilary\".\n        Pracownicy Biurowi – Józefa Rymkiewicz „Ziuta” i Maria Rymkiewicz „Jaśmin”.\n        Pracownia chemiczna - Irena Butkiewiczówna \"Renata\", \"Irka Lwowska\".\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Bardzo trudne warunki lokalowe Legalizacji oraz konieczność zmiany fotografa nastąpiła po przeprowadzeniu się komórki do\n        mieszkania Stanisława Turskiego \"Roman\" fotografa i chemika.\n        Wobec konieczności zlikwidowania skrzynki kontaktowej przyjmującej zamówienia na nowe dokumenty i przekazywania gotowych\n        dokumentów, założono nową w mieszkaniu państwa Kafarskich przy ul. Dominikańskiej 2.\n        Jednocześnie jako łączniczki Legalizacji z Komendą Okręgu zostały zaprzysiężone Józefa Kafarska \"Wrzos\" i Stanisława Kafarska\n        \"Hańcza\". Ta skrzynka kontaktowa działała aż do stycznia 1945r.\n        Nawał pracy i czasowe odejście z Legalizacji Stanisława Kiałki nastąpiły zmiany organizacyjne i w roku 1942 skład osobowy\n        przedstawiał się następująco:\n      ")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("„Kuźnia”:")]),_vm._v(" "),_c('ul',_vm._l((_vm.okres_41_44.legalizacja.list.kuznia),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0),_vm._v(" "),_c('p',[_vm._v("\n        Od roku 1941 do 1943 Legalizacja posiadała pracownię przy ul. Zygmuntowskiej, w której wykończano opracowane dokumenty przed\n        doręczeniem Komendzie Okręgu. W pierwszej połowie 1942 roku, nastąpiły aresztowania w komórkach podległych Komendzie Okręgu,\n        a także zostali aresztowani z Legalizacji: Maria Tomkiewicz \"Grażyna\", Józefa Rynkiewicz \"Ziuta\" , Kowalska o nie ustalonym\n        imieniu \"Maria\". Po bardzo ciężkim śledztwie i torturach zastosowanych przez będących w służbie niemieckiego Gestapa Litwinów,\n        zostały zamordowane w Ponarach pod Wilnem nie wydając nikogo.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        W grudniu 1941 r. Romuald Warakomski \"Hilary\" stanowisko swoje przekazuje Halinie Turskiej \"Aldona\" docentowi filologii USB.\n        Pracowali w niej starszy asystent filologii, asystentka przy tej katedrze oraz młody mężczyzna używający pseudonimu \"Gucio\",\n        nazwisk ich nie dało się ustalić. Łączność prowadziły: Józefa Rymkiewicz \"Ziuta\", Maria Rymkiewicz \"Jaśmin\", Janina Doboszyńska.\n      ")])],2)],1),_vm._v(" "),_c('b-row',[_vm._l((_vm.okres_41_44.legalizacja.cards.part1),function(card){return _c('b-col',{key:card.id,attrs:{"md":"3","cols":"6"}},[_c('b-card',{staticClass:"mb-2",staticStyle:{"width":"10em","min-height":"25em"},attrs:{"img-src":card.img,"img-top":"","tag":"article"}},[_c('p',{staticClass:"card-text"},[_vm._v("\n          "+_vm._s(card.desc)+"\n        ")])])],1)}),_vm._v(" "),_vm._l((_vm.okres_41_44.legalizacja.cards.part2),function(card){return _c('b-col',{key:card.id,attrs:{"md":"3","cols":"6"}},[_c('b-card',{staticClass:"mb-2",staticStyle:{"width":"10em","min-height":"25em"},attrs:{"img-src":card.img,"img-top":"","tag":"article"}},[_c('p',{staticClass:"card-text"},[_vm._v("\n          "+_vm._s(card.desc)+"\n        ")])])],1)})],2),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',[_vm._v("\n        Po aresztowaniu \"Aldony\" komórkę legalizacji przejęła Maria Sadowska \"Wiesława\", absolwentka Wydziału Sztuk Pięknych USB.\n        Następna zmiana miejsca pracy tego działu Legalizacji do mieszkania państwa Mahrburgów wzbogaciło personel o trzy kobiety matkę\n        i dwie córki. Anna miała pseudonim \"Hanka\". Jesienią 1943 r. dział fotografii przejął Zdzisław Pleskaczewski \"Zbyszek\".\n        Sekcja łączności składała się z Stanisławy Smoter \"Zośka\", Jadwigi Dulównej \"Jadzia\" i Ireny Barszczewskiej \"Lolka\".\n        Komórka legalizacyjna Okręgu Wileńskiego SZP, ZWZ, a następnie Armii Krajowej pracowała w zasadzie przez cały czas\n        poszczególnych okupacji. Wykonała przeszło 35.000 różnych dokumentów koniecznych dla ludzi, którzy dzięki nim mogli\n        działać w konspiracji, utrzymywać łączność kurierską tak z Warszawą jak i całą Europą. Była to praca bardzo ważna,\n        bardzo niebezpieczna, a aresztowania w zasadzie kończyły się śmiercią po bardzo ciężkich śledztwach połączonych z torturami.\n        Ludzie wymienieni w tym  opracowaniu z poczucia patriotyzmu, bezinteresownie spełniali swój patriotyczny obowiązek wiedząc,\n        że żadna nagroda nigdy ich nie spotka. Działaniem swoim zasłużyli na pamięć potomnych.\n      ")]),_vm._v(" "),_c('p',{staticClass:"display-4 mt-3"},[_vm._v("Tajne nauczanie")]),_vm._v(" "),_c('p',[_vm._v("\n        Strajki młodzieży gimnazjalnej i związane z tym zaprzestanie nauki przez część uczniów oraz zamknięcie Uniwersytetu Stefana\n        Batorego było powodem rozpoczęcia prowadzenia konspiracyjnego nauczania.\n        Powołana w Wilnie Komenda Okręgu Służby Zwycięstwa Polski zgodnie z przyjętą strukturą organizacyjną miała tak zwany pion\n        cywilny, którego jeden z departamentów miał się zajmować sprawami oświaty w zaistniałych warunkach.\n        Rozwiązanie tej organizacji przez Rząd na Emigracji i przemianowanie jego na Związek Walki Zbrojnej odmieniło sytuację,\n        ponieważ Związek ten nie miał w swoich strukturach organizacyjnych spraw cywilnych.\n        Powstała konieczność zorganizowania nauczania młodzieży tego potrzebującej w warunkach konspiracyjnych. W zasadzie\n        poszczególni nauczyciele tak gimnazjalni jak i profesorowie uniwersyteccy zaczęli skupiać młodzież pragnącą uczyć się dalej.\n        Fenomenem tej działalności była jej masowość. Młodzież podejmując naukę na tak zwanych kompletach traktowała to jako\n        działalność niepodległościową, przeciwstawiając się w ten sposób okupantom. Nauczyciele, kompletując zespół uczniów również\n        musieli spełniać   warunki konspiracji tak w doborze uczniów jak i warunków nauczania.\n        Pierwszymi organizatorami i koordynatorami tego działania w zakresie gimnazjum byli : prof. Uniwersytetu Stefana Batorego\n        Stanisław Hiller, Janina Bohdanowiczówna, dyrektorka gimnazjum im. Czartoryskiego i ks. HenrykHlebowicz.\n        Powstała Tajna Organizacja Nauczycielska kierowana przez Stanisława Zdybka. W tym okresie w kierownictwie organizacji\n        działał późniejszy Okręgowy Delegat Rządu Zygmunt Fedorowicz. Łącznikiem \"Tajnego Nauczania\" w Wilnie do kontaktów z Warszawą\n        był Stanisław Lisowski były przewodniczący Oddziału Związku Nauczycielstwa Polskiego.\n      ")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n        Organizacją tajnego nauczania na poziomie uniwersyteckim zajmował się\n        prof. Stanisław Hiller, prodziekan zamkniętego przez okupantów Uniwersytetu Stefana Batorego.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Na początku 1942 roku kierownikiem tajnego nauczania powszechnego i gimnazjalnego został Jan Bobko, były naczelnik\n        Wydziału Szkolnictwa Średniego w Kuratorium. Po powołaniu urzędu Delegata Rządu Okręgu Wileńskiego, Jan Bobko został\n        kierownikiem Wydziału Oświaty w Delegaturze, następcą jego został Stanisław Starościak, były inspektor szkolny. Prof.\n        Stanisław Hiller poświęcił się wykładom na Tajnym Wydziale Lekarskim. Po ustąpieniu Jana Bobko ze stanowiska kierownika\n        Wydziału Oświaty w Okręgowej Delegaturze Rządu, miejsce to objął były dyrektor gimnazjum im. Zygmunta Augusta Jan Żelski.\n      ")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n        Dla usprawnienia działań w zakresie tajnego nauczania, miasto Wilno zostało podzielone na\n        trzy ośrodki na poziomie szkół średnich.\n      ")]),_vm._v(" "),_c('ul',_vm._l((_vm.okres_41_44.tajne.list.osrodki),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0),_vm._v(" "),_c('p',[_vm._v("\n        Ośrodki miały oddzielnych kierowników odpowiedzialnych za nauczanie podstawowe. Między innymi byli to Apolonia\n        Makarewiczowa i Stanisław Zdybek.\n      ")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n        O zakresie tajnego nauczania świadczy ilość uzyskanych świadectw maturalnych w latach:\n      ")]),_vm._v(" "),_c('ul',_vm._l((_vm.okres_41_44.tajne.list.swiadectwa),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0),_vm._v(" "),_c('p',[_vm._v("\n        Wszyscy oni uzyskali matury eksternistyczne. Są to dane tylko z \"Ośrodka Uniwersyteckiego\" kierowanego przez prof.\n        Władysława Dziewulskiego. Przez cały okres trwania tajnego nauczanie na poziomie uniwersyteckim rektorem Tajnego\n        Uniwersytetu Stefana Batorego był prof. Stefan Ehrenkreutz.\n        Dziekanem Tajnego Wydziału Lekarskiego był prof. Michał Reicher \"Sosna\", który w drugiej połowie 1941 musiał opuścić Wilno.\n        Stanowisko dziekana objął prof. Stanisław Legeżyński, równolegle na tym Wydziale prowadzone były studia farmaceutyczne,\n        którymi kierował prof. Jan Muszyński. Wykładali tam farmację mgr Henryk Zajączkowski, późniejszy\n        Szef Farmacji Okręgu Wileńskiego, dr med. Wiktor Dunin-Horkiewicz \"Kamil\", dr med. Feliks Olesiński , dr. med.\n        Stefan Cierpiński \"Korwin\". Na konspiracyjnym   Wydziale lekarskim studiowało w okresie okupacji ponad 200 osób.\n      ")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n        Dziekanem Wydziału Humanistycznego był prof. Jan Oko, zastępcą prof.\n        Tadeusz Czeżowski, natomiast wykłady prowadzili profesorowie :\n      ")]),_vm._v(" "),_c('ul',_vm._l((_vm.okres_41_44.tajne.list.profesorowie),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0)])],1),_vm._v(" "),_c('b-row',_vm._l((_vm.okres_41_44.tajne.cards),function(card){return _c('b-col',{key:card.id,attrs:{"xl":"2","md":"4","cols":"6"}},[_c('b-card',{staticClass:"mb-2",staticStyle:{"width":"10em","min-height":"25em"},attrs:{"img-src":card.img,"img-top":"","tag":"article"}},[_c('p',{staticClass:"card-text"},[_vm._v("\n          "+_vm._s(card.desc)+"\n        ")])])],1)}),1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',[_vm._v("\n        Wydział Teologiczny kontynuował nauczanie w ramach Seminarium Duchownego do 3 marca 1942 roku, kiedy to wszyscy wykładowcy\n        zostali aresztowani przez Niemców. Na wydziale Prawa i Nauk Społecznych wykłady systematycznie prowadzili profesorowie :\n        Stefan Ehrenkreutz, Iwo Jaworski, Kazimierz Petrusewicz, Bronisław Wróblewski, docent Witold Świda i ks. Bronisław Żongołłowicz.\n      ")]),_vm._v(" "),_c('p',{staticClass:"lead mt-3"},[_vm._v("Na Wydziale Matematyczno - Przyrodniczym wykładali profesorowie:")]),_vm._v(" "),_c('ul',_vm._l((_vm.okres_41_44.tajne.list.prof_mat_prz),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0),_vm._v(" "),_c('p',[_vm._v("\n        Ze studentami Wydziału Sztuk Pięknych pracowali profesorowie : Bronisław Jamont, Tymon Niesiołowski i Stefan Narębski.\n        Dzięki poświęceniu i pomimo zagrożenia aresztowaniem Tajne Nauczanie na poziomie Uniwersyteckim i szkolnictwa gimnazjalnego,\n        Polacy mieszkający na Wileńszczyźnie posiadali kadrę ludzi wykształconych, zasilając kadrę naukową w szkołach i uczelniach\n        polskich po opuszczeniu Wilna.\n      ")]),_vm._v(" "),_c('p',{staticClass:"display-4 mt-3"},[_vm._v("Służby sanitarne")]),_vm._v(" "),_c('p',[_vm._v("\n        Sytuacja jaka wytworzyła się w Wilnie po 17 września 1939 r. spowodowała konieczność zorganizowania opieki medycznej nad ludźmi,\n        którzy znaleźli się na tamtym terenie pozbawieni środków do życia, a w przypadku zachorowania opieki lekarskiej. Organizacje\n        społeczne bardzo skutecznie, zajęły się tym problemem.\n      ")]),_vm._v(" "),_vm._l((_vm.okres_41_44.sluzby),function(sluzba){return _c('div',{key:sluzba.id},[_c('p',{staticClass:"lead mt-3"},[_vm._v(_vm._s(sluzba.title))]),_vm._v(" "),_c('ul',_vm._l((sluzba.list),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0),_vm._v(" "),(sluzba.text)?_c('p',[_vm._v(_vm._s(sluzba.text))]):_vm._e()])}),_vm._v(" "),_c('b-img',{attrs:{"center":"","fluid":"","src":"/historia/okres_41_44/schemat_org_sluzby_sanitarnej.jpg"}}),_c('br'),_vm._v(" "),_c('p',{staticClass:"display-4 mt-3"},[_vm._v("Sowieckie represje")]),_vm._v(" "),_c('p',[_vm._v("\n        Przekroczenie przez wojska sowieckie granic Państwa Polskiego w dniu 17 września 1939 r. bez wypowiedzenia zawartego paktu o\n        nieagresji i bez wypowiedzenia wojny był pierwszym sygnałem realizacji doktryny bolszewickiej wyniszczenia narodu polskiego.\n        Natychmiast po wkroczeniu drugiej linii wojsk składających się z doborowych jednostek NKWD, rozpoczęły się aresztowania w\n        pierwszym rzędzie inteligencji polskiej bez względu na ich zachowania i poglądy polityczne.\n        Aresztowania takie trwały przez cały okres pierwszej okupacji sowieckiej z okresowymi falami masowych aresztowań i wywózek na\n        \"Nieludzką Ziemię\".\n        W świetle przytoczonych dokumentów sowieckich szczegółowe omawianie tych spraw staje się nie celowe.\n        Przytoczone poniżej chronologicznie podawane dokumenty, każdemu powinny nasunąć odpowiednie wnioski.\n        W świetle dokumentów archiwalnych przekazanych Rzeczypospolitej Polskiej przez władze Rosji w latach 90-tych XX wieku, a\n        dotyczących okresu II wojny Światowej, można z dużym prawdo podobieństwem stwierdzić, że wojska NKWD i straży więziennej na\n        podstawie decyzji Biura Politycznego podjętej w sprawie jeńców wojennych i osób aresztowanych w 1939 r. i przebywających w\n        więzieniach na początkach 1940 r. dokonały masowych mordów osób zatrzymanych i przebywających w więzieniach na terenie\n        województwa  wileńskiego.\n        Mordów takich w drugiej połowie czerwca 1941 r. dokonano w więzieniach w Berezweczu, Starej Wilejce. Święcianach, na Łukiszkach\n        w Wilnie. Więźniów których nie mogli wywieźć w głąb ZSSR, wymordowano z broni maszynowej na podwórzach więziennych lub w\n        celach. Szacuje się, że zginęło wówczas około 2.500 osób. Nigdy nikt ani mocodawców ani wykonawców tych mordów nie oskarżył\n        ani ukarał. Polityka likwidacji obywateli narodowości polskiej, którzy znaleźli się na terenach okupowanych przez sowietów trwała nadal.\n        Należy pamiętać o tym, że granice wschodnie Rzeczypospolitej Polskiej a Związkiem Socjalistycznych Republik Radzieckich zostały\n        zmienione dopiero 10 marca 1946 r. Granice te zostały ustalone traktatem podpisanym przez te same państwa w 1921 r.\n        Odkrycie przez Niemców w 1942 r. masowych grobów polskich oficerów w Katyniu na Białorusi, zbadanie ich przez powołaną\n        Międzynarodową Komisję Specjalistów oraz wydania przez nią orzeczenia stwierdzającego czas śmierci tych osób wraz z częściowym\n        ich rozpoznaniem, na podstawie odnalezionych przy zwłokach dokumentów dało prawo zwrócenia się przez Rząd Polski na Emigracji\n        do Międzynarodowego Czerwonego Krzyża w Genewie o szczegółowe zbadanie tej sprawy, wobec oficjalnego wypierania się przez rząd\n        sowiecki dokonania tej zbrodni.\n        Wystąpienie to stało się powodem zerwania przez Rząd sowiecki stosunków dyplomatycznych z Rzeczypospolitą Polską.\n        Zerwanie stosunków dyplomatycznych uniemożliwiło na bardzo długi okres wyjaśnienia tych spraw, a władzy sowieckiej kontynuowania\n        w dalszym ciągu polityki eksterminacji obywateli polskich. Kontynuowania takiej obłudnej polityki.\n        Przytoczone dalej dokumenty potwierdzają kontynuowanie takiej polityki.\n      ")]),_vm._v(" "),_c('b-card',{staticClass:"mt-5"},[_c('strong',[_vm._v("\n          Do wszystkich Brygad i Oddziałów."),_c('br'),_vm._v("\n          Stanowisko Centralnych Komitetów Komunistycznych Partii Ukrainy, Białorusi i Litwy w Moskwie."),_c('br'),_vm._v("\n          Dnia 22 czerwca 1943 r."),_c('br')]),_vm._v(" "),_c('i',[_c('p',{staticClass:"mt-3"},[_vm._v("\n            Pismo okólna."),_c('br'),_vm._v("\n            O wojskowo- politycznych zadaniach pracy w zachodnich Obwodach Białorusi.\n          ")]),_vm._v(" "),_c('p',[_c('ol',[_c('li',[_vm._v("Zachodnie Obwody radzieckich Białorusi, stanowią integralną część Republiki Białoruskiej.")]),_vm._v(" "),_c('li',[_vm._v("Na zajętym przez Niemców terytorium Białorusi dopuszczalne jest tylko działalność, która kieruje się interesami mas pracujących państwa radzieckiego.")]),_vm._v(" "),_c('li',[_vm._v("Istnienie różnorodnych organizacji kierowanych przez polskie burżuazyjne ośrodki, należy traktować jako bezprawne wtrącanie się do spraw naszego Kraju.")]),_vm._v(" "),_c('li',[_vm._v("Nasze główne zadanie sprowadza się do tego, aby szerzej rozwijać radziecki ruch partyzancki, wciągając do niego wszystkie warstwy ludności, w tym i Polaków.")]),_vm._v(" "),_c('li',[_vm._v("Nacjonalistyczne oddziały i grupy tworzone przez Polskie koła reakcyjne, należy izolować od ludzi pracy, narodowości polskiej.")]),_vm._v(" "),_c('li',[_vm._v("Wszelkimi sposobami zwalczać Oddziały i grupy nacjonalistyczne.")])])])])]),_vm._v(" "),_c('b-card',{staticClass:"mt-5"},[_c('strong',[_vm._v("\n          Egzemplarz Nr 7"),_c('br'),_vm._v("\n          Ściśle tajne. Surowo tajne, wcześniejsze ujawnienie karalne"),_c('br'),_vm._v("\n          Rozkaz bojowy."),_c('br'),_vm._v("\n          Do Komendantów i Komisarzy Oddziałów Partyzanckich, Brygady im. Stalina."),_c('br'),_vm._v("\n          30 listopada 1943 r. - godz. 15.00"),_c('br')]),_vm._v(" "),_c('i',[_c('p',{staticClass:"mt-3"},[_vm._v("\n            W wykonaniu rozkazu Naczelnika Głównego Sztabu Ruchu Partyzanckiego przy Kwaterze Naczelnego Dowództwa Czerwonej Armii gen.\n            por. Ponomarenki i upoważnionego Głównego Sztabu Ruchu Partyzanckiego w Kwaterze Naczelnego Dowództwa WKB/b/B. SZ. O.\n            Baranowickiego Okręgu gen. maj. Płatonowa, w dniu 1 grudnia 1943 r. ogłosić punktualnie o godz. 7 rano, by we wszystkich\n            zajętych punktach rejonu, przystąpić do osobistego rozbrajania wszystkich polskich legionistów /partyzantów/. Odebraną broń\n            i dokumenty zarejestrować, a zespół legionistów razem z odebraną bronią, dostarczyć do polskiego obozu Miłaszewskiego w\n            rejonie wsi Niestorowicze, iwińskiego rejonu. W razie oporu w czasie rozbrajania ze strony legionistów /partyzantów /\n            rozstrzeliwać na miejscu.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Z chwilą otrzymania niniejszego rozkazu natychmiast należy rozesłać go, ściśle poufnymi listami do wykonania w rejony\n            operacyjne waszych grup, kompanii i plutonów ze zleceniem wykonania niniejszego rozkazu.\n          ")]),_vm._v(" "),_c('p',[_vm._v("Rozkaz należy trzymać w ścisłej tajemnicy.")]),_vm._v(" "),_c('p',[_vm._v("Za ujawnienie tego rozkazu z jakich by nie było powodów, będą osobiście odpowiadać Dowódca Oddziałów.")]),_vm._v(" "),_c('p',{staticClass:"text-right"},[_vm._v("\n            Komendant Brygady im. Stalina /-/ płk Gulewicz"),_c('br'),_vm._v("\n            Komisarz Brygady im. Stalina /-/ płk Muranow"),_c('br'),_vm._v("\n            Naczelnik Sztabu Brygady im. Stalina /-/ ppłk Karpow\n          ")])])]),_vm._v(" "),_c('p',{staticClass:"lead mt-5"},[_vm._v("Odbito 10 egzemplarzy")]),_vm._v(" "),_c('ul',_vm._l((_vm.okres_41_44.odbitki.list),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0)],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1TLu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1bRH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Bibliografia")]),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},_vm._l((_vm.people),function(person){return _c('div',{key:person.id,staticClass:"mb-4"},[_c('p',[_vm._v(_vm._s(person.name))]),_vm._v(" "),_c('ul',_vm._l((person.books),function(book){return _c('li',[_vm._v(_vm._s(book))])}),0)])}),0)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Teq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5DkK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Kontakt")]),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"xl":"5"}},[_c('b',[_vm._v("Projekt i realizacja:")]),_c('a',{attrs:{"href":"https://pl.linkedin.com/in/boni0","target":"_blank"}},[_vm._v(" Dawid Bonik")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("\n        Administratorem strony jest Fundacja Ośrodka KARTA.\n      ")]),_c('br'),_vm._v("\n      Fundacja Ośrodka KARTA"),_c('br'),_vm._v("\n      ul. Narbutta 29"),_c('br'),_vm._v("\n      02-536 Warszawa"),_c('br'),_vm._v("\n      Tel. (022) 848-07-12"),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"mailto:adres ok@karta.org.pl"}},[_vm._v("ok@karta.org.pl")]),_c('br'),_c('br'),_vm._v(" "),_c('ul',{staticClass:"social-icons"},[_c('li',[_c('a',{staticClass:"social-icon",attrs:{"target":"_blank","href":"http://karta.org.pl"}},[_c('i',{staticClass:"fa fa-3x fa-globe"})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"social-icon",attrs:{"target":"_blank","href":"https://www.facebook.com/OsrodekKARTA/"}},[_c('i',{staticClass:"fa fa-3x fa-facebook"})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"social-icon",attrs:{"target":"_blank","href":"https://twitter.com/osrodekkarta"}},[_c('i',{staticClass:"fa fa-3x fa-twitter"})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"social-icon",attrs:{"target":"_blank","href":"https://www.youtube.com/channel/UCsCbgqBfQI9a1MyCKx8E3dg"}},[_c('i',{staticClass:"fa fa-3x fa-youtube"})])])])]),_vm._v(" "),_c('b-col',{attrs:{"xl":"6"}},[_c('gmap-map',{staticStyle:{"min-height":"300px"},attrs:{"center":_vm.karta,"zoom":17,"map-type-id":"terrain"}},[_c('gmap-marker',{attrs:{"position":_vm.karta,"draggable":false}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__("kXiA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("0hj2");
function injectStyle (ssrContext) {
  __webpack_require__("bh3G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__("Vj7G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__("Nk69");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5opo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  profiles: [{
    id: 0,
    cols: {
      xl: '2',
      lg: '4',
      md: '3',
      sm: '4'
    },
    title: '',
    text: 'Pierwszy Prezes Środowiska Ryszard Andrys-Jankowski',
    img: '/srodowiska/srod_warszawa/ryszard_andrys_jankowski.jpg'
  }, {
    id: 1,
    cols: {
      xl: '2',
      lg: '4',
      md: '3',
      sm: '4'
    },
    title: '',
    text: 'Zygmunt Ryszard Szwojnicki Drugi Prezes Środowiska',
    img: '/srodowiska/srod_warszawa/zygmunt_ryszard_szwojnicki.jpg'
  }, {
    id: 2,
    cols: {
      xl: '2',
      lg: '4',
      md: '3',
      sm: '4'
    },
    title: '',
    text: 'Jerzy Gillern Trzeci Prezes Środowiska',
    img: '/srodowiska/srod_warszawa/jerzy_gillern.jpg'
  }, {
    id: 3,
    cols: {
      xl: '2',
      lg: '4',
      md: '3',
      sm: '4'
    },
    title: '',
    text: 'Tadeusz Siemaszko Czwarty Prezes Środowiska',
    img: '/srodowiska/srod_warszawa/tadeusz_siemaszko.jpg'
  }, {
    id: 4,
    cols: {
      xl: '2',
      lg: '4',
      md: '3',
      sm: '4'
    },
    title: '',
    text: 'Janusz Bohdanowicz Piąty Prezes Środowiska',
    img: '/srodowiska/srod_warszawa/janusz_bohdanowicz.jpg'
  }],
  lists: {
    konkursy: ['Liceum Ogólnokształcące im. Powstańców Warszawskich w Warszawie ul. Zbarska 1 – 02.10.2006 r.', 'Liceum Ogólnokształcące im. C.K. Norwida w Wyszkowie – 01.03.2007 r.', 'Liceum Ogólnokształcące Zespół Szkół Nr 3. w Wyszkowie ul. J. Matejki 9 – 20.06.2007 r.', 'Zespół Szkolenia Ustawicznego w Wyszkowie ul. Matejki 9 – 20.06.2007 r', 'Gimnazjum Publiczne w Czerniewicach – 10.10.2007 r.', 'Gimnazjum Publiczne w Żelechlinku – 09.05.2008 r.', 'Gimnazjum Publiczne w Żelechlinku – 20.02. 2009 r.', 'Gimnazjum Publiczne w Lubochni – 24.02.2009 r.', 'Gimnazjum z Oddziałami Dwujęzycznymi Nr 47 im. Marszałka J. Piłsudskiego w Warszawie, ul. Grenady nr 16 – 16.03.2009 r. rozdanie nagród 23.03.2009 r.', 'Gimnazjum nr 86 im. Ignacego Augusta Boernera Warszawie ul. Thommeego 1 – 16.03.2009 r. i 23.03.2009 r.', 'Gimnazjum nr 50 im. gen. W. Sikorskiego w Warszawie, ul. J. Bema 76 –16.03.2009 r. i 23.03.2009 r.', 'Gimnazjum nr 6 im. Pułku Armii Krajowej Baszta, w Warszawie ul. Gruszczyńskiego 12 – 16.03.2009 r. i 23.03. 2009 r.', 'Publiczne Gimnazjum w Lubochni – 26.03.2010 r.', 'Publiczne Gimnazjum w Żelechlinku – 26.03.2010 r.', 'Publiczne Gimnazjum w Rzeczycy – 26.03.2010 r.', 'Gimnazjum Nr 3 w Tomaszowie Mazowieckim – 26.03.2010 r.', 'Gimnazjum z Oddziałami Dwujęzycznymi Nr 47 im. Marszałka J. Piłsudskiego w Warszawie, ul. Grenady 16 - 29.03.2010 r. i 09.04.2010 r.', 'Gimnazjum nr 50 im. gen. W. Sikorskiego w Warszawie, ul. J. Bema 76 –29.03.2010 r. i 09.04.2010 r.', 'Gimnazjum nr 45 im. Powstania Warszawskiego w Warszawie, ul. Żelazna 71 –29.03.2010 r. i 09. 04. 2010 r.', 'Gimnazjum nr 86 im. Ignacego Augusta Bernera w Warszawie, ul. Thommeego – 29.03.2010r. i 09.04.10 r.'],
    sympozja: [{
      id: 0,
      text: 'Liceum Ogólnokształcące nr 2 w Lęborku. Nauczyciel historii mgr Bogusława Zielińska.',
      list: ['Armia Krajowa Okręg Wileński']
    }, {
      id: 1,
      text: 'Liceum Ogólnokształcące Nr 1 w Lęborku. Nauczyciel historii Bogdan Lipich.',
      list: ['Polskie Państwo Podziemne']
    }, {
      id: 2,
      text: 'Gimnazjum Nr 2 im. Armii Krajowej w Kwidzynie. Nauczyciel historii mgr Beata Kamińska.',
      list: ['Cichociemni', 'Represje wobec Armii Krajowej w powojennej Polsce', 'Pamiętnik powstańca', 'Armia Krajowa dawniej, a dziś']
    }, {
      id: 3,
      text: 'Zespół Szkół Ponadgimnazjalnych im. Ignacego Łukaszewicza w Krośnie. Nauczyciel historii mgr Krzysztof Zajka.',
      list: ['Armia Krajowa Podokręg Rzeszów']
    }, {
      id: 4,
      text: 'Gimnazjum Samorządowe im. Jana Pawła II w Bolszewie. Nauczyciel historii mgr Aleksandra Hirsch.',
      list: ['Okręg Wileński AK Inspektorat „F”', 'Represje sowieckie Okręgu Wileńskiego AK', 'Polskie Państwo Podziemne', 'Organizacja i działalność niepodległościowa ZWZ i AK Okręg Wileński', 'Służby Sanitarne Cywilne i Armii Krajowej']
    }, {
      id: 5,
      text: 'Zespół Szkół Ponadgimnazjalnych nr 4 im. Jakuba Wejhera w Wejherowie. Nauczyciel historii mgr Sebastian Cieślikowski.',
      list: ['Działalność POW „ Gryf Pomorski” w okresie II Wojny Światowej', 'Działalność polskich organizacji niepodległościowych na Pomorzu']
    }],
    prelekcje_materialy_biblioteki: [{
      id: 0,
      title: 'Prelekcje w tym samym okresie (Łącznie zorganizowano i przeprowadzono 7 prelekcji.)',
      list: ['Prelekcja o Armii Krajowej Okręgu Wileńskiego w Gimnazjum nr 47 im. J. Piłsudskiego w Warszawie – Janusz Bohdanowicz.', 'Dwie prelekcje w Gimnazjum nr 50 im. gen. Sikorskiego w Warszawie o PPP, SZP i AK Okręgu Wileńskiego – Romuald Paprocki i Janusz Bohdanowicz.', 'Dwie prelekcje w Domu Spotkań z Historią w Warszawie przy ul. Karowej o działalności niepodległościowej w okresie 1939-1941 i o okresie 1941-1945 – Romuald Paprocki i Janusz Bohdanowicz.', 'Prelekcja w V Liceum Ogólnokształcącym im. Ks. Józefa Poniatowskiego w Warszawie o Armii Krajowej Okręgu Wileńskiego- Janusz Bohdanowicz.', 'Prelekcja w Gimnazjum Publicznym im. Aliny Janusz w Starych Załubicach o działalności niepodległościowej Okręgu Wileńskiego w okresie 1939-1945 – Romuald Paprocki i Janusz Bohdanowicz.']
    }, {
      id: 1,
      title: 'Przekazane materiały historyczne do bibliotek wytypowanych Gimnazjów.',
      list: ['Gimnazjum nr 47 im. Józefa Piłsudskiego w Warszawie.', 'Samorządowe Gimnazjum im. Jana Pawła II w Bolszewie.', 'Publiczne Gimnazjum im. Ofiar Katynia w Piątnicy', 'Publiczne Gimnazjum w Lubochni.', 'Publiczne Gimnazjum w Żelechlinku.', 'Zespół Szkół Ponadgimnazjalnych nr 3 w Zamościu.', 'Gimnazjum Publiczne w Starych Załubicach.']
    }, {
      id: 2,
      title: 'Do bibliotek w/w szkół w okresie sprawozdawczym nie odpłatnie przekazano.',
      list: ['Zeszytów z materiałami historycznymi - egz. 316', 'Nagrań elektronicznych na płytach - egz. 152', 'Książki historyczne - egz. 72', 'Przekaz Wileński - egz. 10', 'Pamiętnik Okręgu Wileńskiego - egz. 37', 'Rozmaitości Wileńskie - egz. 91']
    }],
    zarzad_wykaz: [{
      id: 0,
      title: 'Zarząd Środowiska w roku 2011 i do czerwca 2012 roku przekazał nieodpłatnie (Ponadto w Gimnazjum nr 3 im. Marszałka Józefa Piłsudskiego w Warszawie odbyła się prelekcja dla uczniów klas 2-ich i 3-ich. Prelekcji wysłuchało 62 uczniów.)',
      list: ['W Wilnie nauczycielom szkół polskich i działaczom AWPL i Związkowi Polaków na Litwie - 28 nagrań elektronicznych materiałów historycznych, 19 książek historycznych i 50 zeszytów historycznych.', 'Członkom Klubu Weteranów Armii Krajowej na Litwie - 50 nagrań elektronicznych materiałów historycznych.', 'Dla Domu Kultury Polskiej w Wilnie - 49 książek o tematyce historycznej Armii Krajowej', 'Dla władz rejonu Wileńskiego i Solecznickiego, nauczycieli szkół polskich tych rejonów i przedstawicielom Rzeczypospolitej na Litwie oraz działaczom mieszkającym na Litwie - 274 nagrań elektronicznych materiałów historycznych dotyczących Okręgu Wileńskiego Armii Krajowej.', 'Bibliotece Gimnazjum nr 3 im. Marszałka Józefa Piłsudskiego w Warszawie - 69 książek o historii Armii Krajowej.', 'Koledze Longinowi Tomaszewskiemu w Warszawie - 26 nagrań elektronicznych o Armii Krajowej.', 'Do ryngrafów brygadowych dołączono i przekazano partyzantom lub ich rodzinom - 368 nagrań elektronicznych dotyczących ich Brygad.']
    }, {
      id: 1,
      title: 'Wykaz tematów proponowanych przez Okręg Woleński',
      list: ['Organizacja i działalność niepodległościowa SZP i ZWZ Okręgu Wileńskiego od września 1939 do czerwca 1941 r.', 'Organizacja i działalność niepodległościowa ZWZ i AK Okręgu Wileńskiego od czerwca 1941 do czerwca 1945 r.', 'Represje sowieckie obywateli polskich za działalność niepodległościową Okręgu Wileńskiego.', 'Inspektorat „A” – Zgrupowanie Nr. 1 i Garnizon m. Wilno majora „Pohoreckiego” lub jego jednostki', 'Inspektorat „BC” – Zgrupowanie Nr. 2 Majora „Węgielnego”lub jego jednostki', 'Inspektorat „F” – Zgrupowanie Nr. 3 Majora „Jaremy” lub jego jednostki', 'Legalizacja.', 'Polskie Państwo Podziemne. Władze administracji cywilnej.', 'Służby sanitarne. Cywilne i Armii Krajowej.']
    }]
  },
  videos: [{
    id: 0,
    text: 'Finał konkursu historycznego w gimnazjum w Lubochni 24 lutego 2009r. (fragment)',
    url: "https://www.youtube.com/embed/C4xKhAD8HKE"
  }, {
    id: 1,
    text: 'Finały konkursów historycznych w gimnazjum w Żelechlinku w latach 2008 i 2009 (fragment)',
    url: "https://www.youtube.com/embed/VBoXZrqJlH4"
  }, {
    id: 2,
    text: 'Finał konkursu historycznego z udziałem 10 drużyn z pięciu gimnazjów z Warszawy (fragment)',
    url: "https://www.youtube.com/embed/NLc0-i5TVfE"
  }],
  carousel: [{
    id: 0,
    title: '',
    text: '6 Brygada "Tonki" i "Konara"',
    img: "/srodowiska/srod_warszawa/6_Brygada.jpg"
  }, {
    id: 1,
    title: '',
    text: '3 Brygada "Szczerbca"',
    img: "/srodowiska/srod_warszawa/3_Brygada.jpg"
  }, {
    id: 2,
    title: '',
    text: '7 Brygada "Wilhelma"',
    img: "/srodowiska/srod_warszawa/7_Brygada.jpg"
  }, {
    id: 3,
    title: '',
    text: 'Ryngraf 13 Brygady "Nietoperza"',
    img: "/srodowiska/srod_warszawa/13_Brygady.jpg"
  }, {
    id: 4,
    title: '',
    text: '1 Brygada Juranda',
    img: "/srodowiska/srod_warszawa/1_Brygada.jpg"
  }]
});

/***/ }),

/***/ "6+8O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tablice_epitafijne_vue__ = __webpack_require__("nCfJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7aba4d14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tablice_epitafijne_vue__ = __webpack_require__("pUeM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tablice_epitafijne_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7aba4d14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tablice_epitafijne_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7+tn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  brygady: [{
    brygada: 'Oddział Kmicica',
    data: '25.03.1943',
    link: '/historia/dzialalnosc_bojowa/Oddzial_Kmicica.pdf'
  }, {
    brygada: '13. Brygada „Nietoperza”',
    data: '07.07.1943',
    link: '/historia/dzialalnosc_bojowa/13_Brygada.pdf'
  }, {
    brygada: '5. Brygada „Łupaszki”.',
    data: '31.08.1943',
    link: '/historia/dzialalnosc_bojowa/5_Brygada.pdf'
  }, {
    brygada: '6. Brygada „Tońka”, „Konara”.',
    data: '07.08.1943',
    link: '/historia/dzialalnosc_bojowa/6_Brygada.pdf'
  }, {
    brygada: '3. Brygada „Szczerbca”.',
    data: '02.10.1943',
    link: '/historia/dzialalnosc_bojowa/3_Brygada.pdf'
  }, {
    brygada: '1. Brygada "Juranda"',
    data: '',
    link: '/historia/dzialalnosc_bojowa/1_Brygada.pdf'
  }, {
    brygada: '7. Brygada „Wilhelma”.',
    data: '02.02.1944',
    link: '/historia/dzialalnosc_bojowa/7_Brygada.pdf'
  }, {
    brygada: '8. Brygada „Tura”.',
    data: '02.02.1944',
    link: '/historia/dzialalnosc_bojowa/8_Brygada.pdf'
  }, {
    brygada: '9. Brygada „Małego’,„Gracza”',
    data: '02.02.1944',
    link: '/historia/dzialalnosc_bojowa/9_Brygada.pdf'
  }, {
    brygada: '36. Brygada „Wujka”.',
    data: '02.02.1944',
    link: ''
  }, {
    brygada: '4. Brygada „Ronina”.',
    data: '02.03.1944',
    link: '/historia/dzialalnosc_bojowa/4_Brygada.pdf'
  }, {
    brygada: '12. Brygada „Cerbera”.',
    data: '10.03.1944',
    link: ''
  }, {
    brygada: '24. Brygada „Wawrzeckiego”.',
    data: '12.03.1944',
    link: '/historia/dzialalnosc_bojowa/24_Brygada.pdf'
  }, {
    brygada: '23. Brygada „Ostrogi”, „Światołdycza”.',
    data: '21.04.1944',
    link: '/historia/dzialalnosc_bojowa/23_Brygada.pdf'
  }, {
    brygada: 'Oddział „Frycza”.',
    data: '23.04.1944',
    link: '/historia/dzialalnosc_bojowa/oddzial_kedywu_por_frycza.pdf'
  }, {
    brygada: 'Oddział Rozpoznawczy Komendanta Okręgu',
    data: '15.05.1944',
    link: '/historia/dzialalnosc_bojowa/ORKO.pdf'
  }, {
    brygada: '2. Brygada „Kaziuka”.',
    data: '02.07.1944',
    link: ''
  }, {
    brygada: '19. Samoobrona „7-ka „Wilhelma”.',
    data: '15.10.1944',
    link: '/historia/dzialalnosc_bojowa/Oddzial_Samoobrony.pdf'
  }]
});

/***/ }),

/***/ "8PBB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9/TB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navBar',
  data: function data() {
    return {
      navBarCollapse: false
    };
  }
});

/***/ }),

/***/ "9BR3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navBar_vue__ = __webpack_require__("9/TB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dbfecc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navBar_vue__ = __webpack_require__("CTAx");
function injectStyle (ssrContext) {
  __webpack_require__("8PBB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0dbfecc2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dbfecc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AEMW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_historia_okres_39_41__ = __webpack_require__("Xn5b");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'okres_39_41',
  data: function data() {
    return {
      okres_39_41: __WEBPACK_IMPORTED_MODULE_0__models_historia_okres_39_41__["a" /* default */]
    };
  },
  metaInfo: {
    title: 'Okres Wrzesień 39\' - Czerwiec 41\'',
    meta: [{ name: 'description', content: 'Po 17. września Wileńszczyzna znalazła się pod okupacją radziecką. Czas tymczasowości tzw. Zachodniej Białorusi okupant wykorzystał na wywożenie wszelkich zasobów magazynowych oraz maszyn i urządzeń. ' }, { name: 'og:url', content: 'http://akwilno.pl/historia/okres_39_41' }, { name: 'og:title', content: 'Okres Wrzesień 39\' - Czerwiec 41\'' }, { name: 'og:image', content: '/historia/okres_39_41.jpg' }, { name: 'og:description', content: 'Po 17. września Wileńszczyzna znalazła się pod okupacją radziecką. Czas tymczasowości tzw. Zachodniej Białorusi okupant wykorzystał na wywożenie wszelkich zasobów magazynowych oraz maszyn i urządzeń. ' }, { name: 'twitter:url', content: 'http://akwilno.pl/historia/okres_39_41' }, { name: 'twitter:title', content: 'Okres Wrzesień 39\' - Czerwiec 41\'' }, { name: 'witter:image', content: '/historia/okres_39_41.jpg' }, { name: 'twitter:description', content: 'Po 17. września Wileńszczyzna znalazła się pod okupacją radziecką. Czas tymczasowości tzw. Zachodniej Białorusi okupant wykorzystał na wywożenie wszelkich zasobów magazynowych oraz maszyn i urządzeń. ' }]
  }
});

/***/ }),

/***/ "AdjB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Środowisko Wileńskie w Gdańsku")]),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',[_vm._v("\n        Po zarejestrowaniu w 1990 r. Światowego Związku Żołnierzy Armii Krajowej - jako samodzielnej organizacji\n        kombatanckiej - ukształtowała się w Gdańsku jego komórka pod nazwą: \"Środowisko Wileńskie w Gdańsku\".\n        Zaistniała możliwość swobodnego zrzeszenia się weteranów niepodległościowej działalności na Wileńszczyźnie\n        z lat II Wojny Światowej. Środowisko Wileńskie w Gdańsku rozwijało wieloraką działalność, na którą przede\n        wszystkim składało się:\n      ")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"10"}},[_c('ul',[_c('li',[_vm._v("integrowanie rozproszonych na Pomorzu Gdańskim uczestników niepodległościowej działalności na Ziemi Wileńskiej,")]),_vm._v(" "),_c('li',[_vm._v("gromadzenie dokumentacji historycznej dotyczącej walki zbrojnej oraz działalności zaplecza i\n              struktur Polskiego Państwa Podziemnego (służby sanitarne, tajne nauczanie, pomoc społeczna).")]),_vm._v(" "),_c('li',[_vm._v("popularyzowanie niepodległościowego wysiłku Wileńszczyzny, która stanowiła integralną część\n              Polski, aż do podpisania (16 lutego 1946 r.) Traktatu o zmianach granicy wschodniej Państwa Polskiego,")]),_vm._v(" "),_c('li',[_vm._v("przekazywanie tradycji Ziemi Wileńskiej następnym pokoleniom Polaków, którym powojenna rzeczywistość -\n              z przyczyn ustrojowych - uniemożliwiała poznawanie patriotyzmu Kresów Północno – Wschodnich.")])])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"7","order-md":"1","order":"2"}},[_c('p',[_vm._v("\n            Pierwszym prezesem Środowiska został "),_c('b',[_vm._v("kol. Olgierd Christa pseudonim \"Noc\", \"Leszek\"")]),_vm._v(", żołnierz 3.\n            Brygady \"Szczerbca\", a od 1946 r. - Oddziału \"Łupaszki\", który działał na terenie Pomorza Gdańskiego\n            (aż do 1947r.). Równocześnie był on inicjatorem i przewodniczącym Komisji Historycznej Okręgu\n            Wileńskiego, powołanej dla publikowania nieznanych dokumentów z lat konspiracji i z czasów zakłamania\n            ideologicznego. Był również inicjatorem, redaktorem i wydawcą \"Wileńskiego Przekazu\" publikującego\n            zbierane materiały historyczne. W latach 1990 - 1996 ukazało się około 80 zeszytów oraz 13 suplementów, które zawierały:\n          ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("krótkie opisy do działalności AK Okręgu Wileńskiego,")]),_vm._v(" "),_c('li',[_vm._v("mało znane fragmenty dziejów zgrupowań bojowych,")]),_vm._v(" "),_c('li',[_vm._v("relacje uczestników akcji zbrojnych i świadków wydarzeń,")]),_vm._v(" "),_c('li',[_vm._v("sylwetki poszczególnych osobowości Polskiego Państwa Podziemnego,")]),_vm._v(" "),_c('li',[_vm._v("prawdy o konspiracji, które były fałszowane przez komunistyczne służby bezpieczeństwa.")])])]),_vm._v(" "),_c('b-col',{attrs:{"md":"5","order-md":"2","order":"1"}},[_c('b-img',{attrs:{"width":"200px","center":"","src":"/srodowiska/srod_gdansk/olgierd_christa.jpg","center":"","fluid":""}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-5"},[_c('b-col',{attrs:{"md":"7"}},[_c('b-img',{attrs:{"center":"","src":"/srodowiska/srod_gdansk/wilenski_przekaz.jpg","center":"","fluid":""}})],1),_vm._v(" "),_c('b-col',{staticClass:"lead",attrs:{"md":"5"}},[_vm._v("\n          Komplet zeszytów i suplementów \"Wileńskiego Przekazu\" został złożony w archiwum\n          Instytutu Pamięci Narodowej w Gdańsku. Napisał książkę pod tytułem\n          \"U Szczerbca i Łupaszki\" Wydawnictwo Auditor Warszawa 2000 r.\n        ")])],1),_vm._v(" "),_c('p',[_c('b',{staticClass:"lead"},[_vm._v("Okładka \"Wileńskiego Przekazu\" z \"Orłem Ruszczyca\" na tle Ostrej Bramy.")])]),_vm._v(" "),_c('p',[_vm._v("\n        Biały Orzeł zrywa się do niepodległości po latach rozbiorów Polski. Ferdynand Ruszczyc artysta -\n        malarz, brał czynny udział w procesie odradzania się Uniwersytetu w Wilnie, a następnie\n        zorganizował - unikalny w skali kraju - Wydział Sztuk Pięknych Uniwersytetu Stefana Batorego w Wilnie.\n      ")]),_vm._v(" "),_c('b-row',{staticClass:"justify-content-center mb-5"},[_c('b-col',{attrs:{"md":"5","sm":"7","cols":"10"}},[_c('b-card',{staticClass:"mb-2",staticStyle:{"width":"20em","min-height":"18em"},attrs:{"img-src":"/srodowiska/srod_gdansk/medal_45_1_2.jpg","img-top":"","tag":"article"}},[_c('p',{staticClass:"card-text"},[_vm._v("\n              Medal z okazji 45-lecia walk o Wilno Brygad Armii Krajowej Okręgu Wileńskiego\n            ")])])],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5","sm":"7","cols":"10"}},[_c('b-card',{staticClass:"mb-2",staticStyle:{"width":"20em","min-height":"18em"},attrs:{"img-src":"/srodowiska/srod_gdansk/medal_50_1_2.jpg","img-top":"","tag":"article"}},[_c('p',{staticClass:"card-text"},[_vm._v("\n              Medal z okazji 45-lecia walk o Wilno Brygad Armii Krajowej Okręgu Wileńskiego\n            ")])])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-5"},[_c('b-col',{attrs:{"md":"7","order-md":"1","order":"2"}},[_c('p',[_vm._v("\n            W latach 1994 - 1998 Prezesem Środowiska był kol. Marian Korejwo ps. \"Milimetr\", żołnierz 3. Brygady\n            \"Szczerbca\". Kontynuował działalność integracyjną żołnierzy AK Okręgu Wileńskiego oraz zorganizował\n            obchody rocznicowe o zasięgu krajowym. Był inicjatorem wykonania tablicy epitafijnej poświęconej\n            Komendantowi i żołnierzom 3. Brygady poległym w walce, zamordowanym przez sowieckie NKWD i polski Urząd\n            Bezpieczeństwa. Tablica ta obecnie jest zamontowana w Bazylice Mariackiej w Gdańsku, a jej replika -\n            w kościele pw. Matki Boskiej Ostrobramskiej w Szczecinie - Żelichowie. Opracował i wydał unikalny zbiór\n            piosenek partyzanckich, wojskowych, harcerskich i okolicznościowych pod tytułem: \"Śpiewamy przy ognisku\".\n            Wydał również swoje wspomnienia pt.: \"Moje ścieżki partyzanckie”.\n          ")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"5","order-md":"2","order":"1"}},[_c('b-img',{attrs:{"width":"200px","center":"","src":"/srodowiska/srod_gdansk/marian_korejwo.jpg","center":"","fluid":""}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-5"},[_c('b-col',{attrs:{"md":"7","order-md":"1","order":"2"}},[_c('p',[_vm._v("\n            W 1998 r. Prezesem Środowiska został kol. Janusz Bohdanowicz ps. \"Czortek\",\n            żołnierz 7. Brygady \"Wilhelma\". Kontynuuje dotychczasowe poczynania oraz inicjuje\n            współpracę z młodzieżą szkolną. W tym celu wyłoniła się Komisja Współpracy z Młodzieżą\n            Szkolną w składzie: przewodniczący Janusz Bohdanowicz oraz członkowie: Regina Klima i Romuald\n            Łucewicz. Wydał książkę pt. „Brygada \"Wilhelma\". Oddziały Partyzanckie \"Żuka\" i \"Gozdawy\".\n            Projektował i nadzorował budowę cmentarza - kwatery żołnierzy 7. Brygady w Skorbucianach (Wileńszczyzna).\n          ")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"5","order-md":"2","order":"1"}},[_c('b-img',{attrs:{"width":"200px","center":"","src":"/srodowiska/srod_gdansk/janusz_bohdanowicz.jpg","center":"","fluid":""}})],1)],1),_vm._v(" "),_c('p',[_c('b',{staticClass:"lead"},[_vm._v("Okładka \"Wileńskiego Przekazu\" z \"Orłem Ruszczyca\" na tle Ostrej Bramy.")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"10"}},[_c('ul',[_c('li',[_vm._v("3 dla młodzieży szkół podstawowych na Wileńszczyźnie. W każdym\n              konkursie uczestniczyło po 30 uczniów reprezentujących 10 polskich szkół.")]),_vm._v(" "),_c('li',[_vm._v("20 konkursów w kraju dotyczących wiedzy o Kresach Północno - Wschodnich, w których uczestniczyło 360\n              uczniów ze szkół ponadpodstawowych. W nagrodę 90 laureatów wzięło udział w kilkudniowych wyjazdach do\n              Wilna na koszt miejscowych Samorządów. W każdym wyjeździe uczestniczyło 2-uch lub 3-ech nauczycieli\n              delegowanych przez szkoły jako opiekunów. Wszyscy uczestnicy konkursów oraz nauczyciele przygotowujący\n              młodzież do udziału w konkursie i wykonawcy części artystycznej uświetniającej konkursy, każdorazowo\n              otrzymywali imienne dyplomy oraz pamiątkowe drobiazgi i nagrody książkowe. Wyróżnione referaty konkursowe\n              zostały wydane w kilku egzemplarzach i przekazane zainteresowanym środowiskom. Referat Alicji Piernickiej\n              w całości został opublikowany w \"Tygodniku Wileńszczyzny\" wydawanym przez Samorząd Rejonu Wileńskiego.\n              Wykaz opracowań autorskich, wyróżnionych w ramach konkursu znajduję się poniżej.")])])])],1)],1)],1),_vm._v(" "),_vm._l((_vm.srod_gdansk.videos),function(video){return _c('b-row',{key:video.id,staticClass:"mb-5"},[_c('b-col',{attrs:{"md":"7"}},[_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":video.url,"allowfullscreen":""}})],1),_vm._v(" "),_c('b-col',{staticClass:"lead",attrs:{"md":"4"}},[_vm._v("\n      "+_vm._s(video.text)+"\n    ")])],1)}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',[_c('b',{staticClass:"lead"},[_vm._v("Wykaz Konkursów historycznych i sympozjów organizowanych w Gimnazjach i Liceach w Kraju")])]),_vm._v(" "),_c('b-button',{staticClass:"mb-3",attrs:{"target":"_blank","href":"/srodowiska/srod_gdansk/REGULAMIN-I-ZESZYTY-KONKURSU-AK.zip"}},[_vm._v("\n        REGULAMIN I ZESZYTY KONKURSU AK\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Biblioteka Samorządowego Gimnazjum w Bolszewie posiada do dyspozycji\n        zainteresowanych wszystkie opracowania Komisji Historycznej i prace uczniów.\n      ")]),_vm._v(" "),_c('ol',_vm._l((_vm.srod_gdansk.lists.konkurs),function(item,index){return _c('li',[_vm._v(_vm._s(item))])}),0)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-5"},[_c('b-col',{staticClass:"mb-2",attrs:{"md":"5"}},[_c('b-img',{attrs:{"center":"","src":"/srodowiska/srod_gdansk/folder_info_1.jpg","fluid":""}})],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('b-img',{attrs:{"center":"","src":"/srodowiska/srod_gdansk/folder_info_2.jpg","fluid":""}})],1),_vm._v(" "),_c('span',{staticClass:"lead text-center"},[_vm._v("\n      W 2001 roku Środowisko wydało folder informujący o prowadzonej działalności oświatowo-wychowawczej z młodzieżą szkolną.\n    ")])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-5"},[_c('b-col',{attrs:{"cols":"5"}},[_c('b-img',{attrs:{"center":"","src":"/srodowiska/srod_gdansk/wystawa_foto_okreg_wilenski.jpg","center":"","fluid":""}})],1),_vm._v(" "),_c('b-col',{staticClass:"lead",attrs:{"cols":"5"}},[_vm._v("\n        Z materiałów zebranych w latach ubiegłych zorganizowano wystawę fotograficzną\n        obrazującą działalność bojową Oddziałów i Brygad Armii Krajowej Okręgu Wileńskiego w latach 1943 i 1944.\n        (Plakat zewnętrzny pierwszej wystawy fotografii historii Oddziałów i Brygad Okręgu Wileńskiego Armii Krajowe)\n    ")])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',[_c('b',{staticClass:"lead"},[_vm._v("Wykaz miejsc i dat prezentacji wystawy w Kraju.")])]),_vm._v(" "),_c('ol',_vm._l((_vm.srod_gdansk.lists.wystawy),function(item,index){return _c('li',[_vm._v(_vm._s(item))])}),0)])],1),_vm._v(" "),_c('p',{staticClass:"lead text-center"},[_vm._v("Fotografie do konkursów i wyjazdów do Wilna")]),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"10","xl":"8"}},[_c('b-carousel',{staticClass:"carousel",staticStyle:{"text-shadow":"1px 1px 2px #333","margin":"0 0em 2em 0em"},attrs:{"controls":"","indicators":"","background":"#ababab","interval":0}},_vm._l((_vm.srod_gdansk.carousel),function(carousel){return _c('div',{key:carousel.id},[_c('b-carousel-slide',{attrs:{"caption":carousel.title,"text":carousel.text,"img-src":carousel.img}})],1)}),0)],1)],1),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Biblioteki do których przekazano nieodpłatnie po dwa egzemplarze nagranych opracowań historycznych")]),_vm._v(" "),_c('b-row',{staticClass:"mb-4"},[_c('b-col',{attrs:{"md":"6"}},[_c('b-img',{attrs:{"center":"","src":"/srodowiska/srod_gdansk/biblioteki_przekazano_srod_gdansk_1.jpg","fluid":""}}),_c('br'),_vm._v(" "),_c('b-img',{staticClass:"mb-5",attrs:{"center":"","src":"/srodowiska/srod_gdansk/biblioteki_przekazano_srod_gdansk_3.jpg","fluid":""}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"mt-4 text-center"},[_c('span',{staticClass:"lead"},[_vm._v("KATYŃ- znak ludobójstwa.")])])],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-img',{attrs:{"center":"","src":"/srodowiska/srod_gdansk/biblioteki_przekazano_srod_gdansk_2.jpg","fluid":""}}),_c('br'),_vm._v(" "),_c('b-img',{attrs:{"center":"","src":"/srodowiska/srod_gdansk/biblioteki_przekazano_srod_gdansk_4.jpg","fluid":""}}),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"lead"},[_vm._v("Brygady Armii Krajowej.")])])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('ol',{staticClass:"mb-5"},_vm._l((_vm.srod_gdansk.lists.biblioteki),function(item,index){return _c('li',[_vm._v(_vm._s(item))])}),0),_vm._v(" "),_c('p',[_vm._v("\n        Przekazano również bezpłatnie 160 takich samych kompletów dla szkół i Kierownikom urzędów samorządowych\n        powiatów i gmin współpracujących ze Środowiskiem oraz innym osobom w formie upominków. Nagrania\n        również zostały przekazanie dla Koła Żołnierzy AK w Anglii , Stowarzyszenia Kombatantów Polskich w\n        Kanadzie oraz nauczycielom Polskiej Wyższej Szkoły Rolniczej w Białej Wace, Polskiej Szkole Średniej\n        w Bezdanach, Polskiej Szkole Średniej w Turgielach / Republika Litewska/ i Polskiemu Uniwersytetowi w Wilnie.\n      ")])])],1),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Wydawnictwo Środowiska jako uzupełnienie literatury historycznej")]),_vm._v(" "),_c('b-row',{staticClass:"mb-5"},[_c('b-col',{attrs:{"lg":"3","md":"6"}},[_c('b-img',{attrs:{"center":"","src":"/srodowiska/srod_gdansk/wydawnictwo_srodowiska_srod_gdansk_1.jpg","fluid":""}}),_c('br')],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"3","md":"6"}},[_c('b-img',{attrs:{"center":"","src":"/srodowiska/srod_gdansk/wydawnictwo_srodowiska_srod_gdansk_2.jpg","fluid":""}}),_c('br')],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"3","md":"6"}},[_c('b-img',{attrs:{"center":"","src":"/srodowiska/srod_gdansk/wydawnictwo_srodowiska_srod_gdansk_3.jpg","fluid":""}}),_c('br')],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"3","md":"6"}},[_c('b-img',{attrs:{"center":"","src":"/srodowiska/srod_gdansk/wydawnictwo_srodowiska_srod_gdansk_4.jpg","fluid":""}}),_c('br')],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-5"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-img',{attrs:{"center":"","src":"/srodowiska/srod_gdansk/tablica_epitafijna_65_rocznica.jpg","fluid":""}}),_c('br')],1),_vm._v(" "),_c('b-col',{attrs:{"md":"8"}},[_c('span',{staticClass:"lead"},[_vm._v("\n        W roku 2005 Prezes Janusz Bohdanowicz wyjechał na stałe do Warszawy, jednocześnie rezygnując z pełnionego stanowiska.\n        Walne Zebranie Sprawozdawczo-Wyborcze Środowiska na Prezesa wybrało kol. Józefa Jatkowskiego „Bratek”.\n        Nowo wybrany Zarząd Środowiska nie podjął współpracy z młodzieżą szkolną. W roku 2009 Prezes Środowiska\n        zainicjował ufundowanie, wykonanie i zamocowanie tablicy epitafijnej poświęconej żołnierzom Armii Krajowej\n        Okręgów Wileńskiego i Nowogródzkiego w 65 rocznicę operacji „Ostra Brama”. Tablica ta została zamocowana w\n        Katedrze Polowej Wojska Polskiego w Warszawie w dn. 08 listopada 2009 r.\n      ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-5"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-img',{attrs:{"center":"","src":"/srodowiska/srod_gdansk/jozef_jatkowski_srod_gdansk.jpg","fluid":""}}),_c('br')],1),_vm._v(" "),_c('b-col',{attrs:{"md":"8"}},[_c('span',{staticClass:"lead"},[_vm._v("\n        W dniu 11.05.2010 r. Walne Zebranie Sprawozdawcze - Wyborcze Środowiska ponownie wybrało\n        kol. Józefa Jatkowskiego na Prezesa Środowiska.\n      ")])])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BF5h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_historia_okres_41_44__ = __webpack_require__("FZdh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'okres_41_44',
  data: function data() {
    return {
      okres_41_44: __WEBPACK_IMPORTED_MODULE_0__models_historia_okres_41_44__["a" /* default */]
    };
  },
  metaInfo: {
    title: 'Okres Czerwiec 41\' - Lipiec 44\'',
    meta: [{ name: 'description', content: 'Zajęcie Wileńszczyzny przez wojska niemieckie i inny podział administracyjny, zatwierdzenie przez Komendę Główną na Komendanta Okręgu Wileńskiego, ppłk Aleksandra Krzyżanowskiego „Wilk”, rozpoczęło nowy rozdział działalności konspiracyjnej Związku Walki Zbrojnej Okręgu.' }, { name: 'og:url', content: 'http://akwilno.pl/historia/okres_41_44' }, { name: 'og:title', content: 'Okres Czerwiec 41\' - Lipiec 44\'' }, { name: 'og:image', content: '/historia/okres_41_44.jpg' }, { name: 'og:description', content: 'Zajęcie Wileńszczyzny przez wojska niemieckie i inny podział administracyjny, zatwierdzenie przez Komendę Główną na Komendanta Okręgu Wileńskiego, ppłk Aleksandra Krzyżanowskiego „Wilk”, rozpoczęło nowy rozdział działalności konspiracyjnej Związku Walki Zbrojnej Okręgu.' }, { name: 'twitter:url', content: 'http://akwilno.pl/historia/okres_41_44' }, { name: 'twitter:title', content: 'Okres Czerwiec 41\' - Lipiec 44\'' }, { name: 'witter:image', content: '/historia/okres_41_44.jpg' }, { name: 'twitter:description', content: 'Zajęcie Wileńszczyzny przez wojska niemieckie i inny podział administracyjny, zatwierdzenie przez Komendę Główną na Komendanta Okręgu Wileńskiego, ppłk Aleksandra Krzyżanowskiego „Wilk”, rozpoczęło nowy rozdział działalności konspiracyjnej Związku Walki Zbrojnej Okręgu.' }]
  }
});

/***/ }),

/***/ "BuPm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BvEH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_okres_41_44_vue__ = __webpack_require__("BF5h");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad375250_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_okres_41_44_vue__ = __webpack_require__("1S12");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_okres_41_44_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad375250_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_okres_41_44_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CMmO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'urocz_w_wilnie',
  metaInfo: {
    title: 'Uroczystości w Wilnie i zbiórka darów na rzecz żołnierzy AK z Kresów Wschodnich organizowane przez Stowarzyszenie Łagierników Żołnierzy AK',
    meta: [{ name: 'description', content: 'Stowarzyszenie Łagierników Żołnierzy Armii Krajowejwspólnie z Urzędem do Spraw Kombatantów i Osób Represjonowanych przy wsparciu Ministerstwa Spraw Zagranicznych, a także z udziałem Światowego Związku Żołnierzy AK Okręgu Wileńskiego oraz Nowogródzkiego organizuje Uroczystości w dniach od 5 do 8 lipca poświęcone 70 rocznicy operacji Wojskowej „Ostra Brama” w Wilnie.' }, { name: 'og:url', content: 'http://akwilno.pl/urocz_w_wilnie' }, { name: 'og:title', content: 'Uroczystości w Wilnie i zbiórka darów na rzecz żołnierzy AK z Kresów Wschodnich organizowane przez Stowarzyszenie Łagierników Żołnierzy AK' }, { name: 'og:image', content: '/aktualnosci/urocz_w_wilnie.jpg' }, { name: 'og:description', content: 'Stowarzyszenie Łagierników Żołnierzy Armii Krajowejwspólnie z Urzędem do Spraw Kombatantów i Osób Represjonowanych przy wsparciu Ministerstwa Spraw Zagranicznych, a także z udziałem Światowego Związku Żołnierzy AK Okręgu Wileńskiego oraz Nowogródzkiego organizuje Uroczystości w dniach od 5 do 8 lipca poświęcone 70 rocznicy operacji Wojskowej „Ostra Brama” w Wilnie.' }, { name: 'twitter:url', content: 'http://akwilno.pl/urocz_w_wilnie' }, { name: 'twitter:title', content: 'Uroczystości w Wilnie i zbiórka darów na rzecz żołnierzy AK z Kresów Wschodnich organizowane przez Stowarzyszenie Łagierników Żołnierzy AK' }, { name: 'witter:image', content: '/aktualnosci/urocz_w_wilnie.jpg' }, { name: 'twitter:description', content: 'Stowarzyszenie Łagierników Żołnierzy Armii Krajowejwspólnie z Urzędem do Spraw Kombatantów i Osób Represjonowanych przy wsparciu Ministerstwa Spraw Zagranicznych, a także z udziałem Światowego Związku Żołnierzy AK Okręgu Wileńskiego oraz Nowogródzkiego organizuje Uroczystości w dniach od 5 do 8 lipca poświęcone 70 rocznicy operacji Wojskowej „Ostra Brama” w Wilnie.' }]
  }
});

/***/ }),

/***/ "CS0e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  zgrupowania: [{
    id: 0,
    name: 'Zgrupowanie nr. 1',
    participants: ['Garnizon miasta Wilna', '3 Brygada por. „Szczerbca”', '7 Brygada por. „Wilhelma”', 'Oddział Partyzancki por. „Gozdawy”', 'Oddział Rozpoznawczy Komendanta Okręgu por. „Groma”'],
    img: {
      url: '/historia/powolanie_zgrupowan/antoni_olechnowicz.jpg',
      desc: 'Dowódcą Inspektoratu „A” oraz tego zgrupowania był Dypl. Mjr Antoni Olechnowicz „Podhorecki”'
    }
  }, {
    id: 1,
    name: 'Zgrupowanie nr. 2',
    participants: ['1 Brygada por. „Juranda”', '2 Brygada por. „Kaziuka”', '4 Brygada por. „Romina”', '5 Brygada por. „Łupaszki”', '23 Brygada por. „Ostrogi” i por. „Światołdycza”', '24 Brygada por. „Wawerzeckiego”', '36 Brygada por. „Wujka”'],
    img: {
      url: '/historia/powolanie_zgrupowan/mieczyslaw_potocki.jpg',
      desc: 'Dowódca Inspektoratu „BC” oraz tego zgrupowania był Mjr.dypl. Mieczysław Potocki „Węgielny”'
    }
  }, {
    id: 2,
    name: 'Zgrupowanie nr. 3',
    participants: ['9 Brygada chor. „Małego” i kpt. „Gracza”', '10 Brygada por. „Gustawa”', '12 Brygada por. „Cerbera”', '13 Brygada „Nietoperza”'],
    img: {
      url: '/historia/powolanie_zgrupowan/czeslaw_debicki.jpg',
      desc: 'Dowódca Inspektoratu „F” oraz tego zgrupowania był mjr inż. Czesław Dębicki „Jarema”'
    }
  }]
});

/***/ }),

/***/ "CTAx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb5",attrs:{"id":"navBarContainer"}},[_c('b-navbar',{attrs:{"variant":"light","fixed":"top","toggleable":"","toggle-breakpoint":"lg"}},[_c('b-navbar-brand',{on:{"click":function($event){_vm.navBarCollapse=false}}},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"d-inline-block align-top",attrs:{"src":"/main/menu_logo.png","alt":""}}),_vm._v("\n        AK Wilno\n      ")])],1),_vm._v(" "),_c('b-nav-toggle',{attrs:{"target":""}},[_c('span',{staticClass:"navbar-toggler-icon",on:{"click":function($event){_vm.navBarCollapse=!_vm.navBarCollapse}}})]),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"navBar","visible":_vm.navBarCollapse}},[_c('b-nav',{attrs:{"is-nav-bar":""}},[_c('b-nav-item',{on:{"click":function($event){_vm.navBarCollapse=false}}},[_c('router-link',{attrs:{"active-class":"activeNav","to":"/","exact":""}},[_vm._v("Start")])],1),_vm._v(" "),_c('b-nav-item',{on:{"click":function($event){_vm.navBarCollapse=false}}},[_c('router-link',{attrs:{"active-class":"activeNav","to":"/aktualnosci"}},[_vm._v("Aktualności")])],1),_vm._v(" "),_c('b-nav-item',{on:{"click":function($event){_vm.navBarCollapse=false}}},[_c('router-link',{attrs:{"active-class":"activeNav","to":"/o_autorze"}},[_vm._v("O Autorze")])],1),_vm._v(" "),_c('b-nav-item',{on:{"click":function($event){_vm.navBarCollapse=false}}},[_c('router-link',{attrs:{"active-class":"activeNav","to":"/kolekcja"}},[_vm._v("Kolekcja Janusza Bohdanowicza")])],1),_vm._v(" "),_c('b-nav-item',{on:{"click":function($event){_vm.navBarCollapse=false}}},[_c('router-link',{attrs:{"active-class":"activeNav","to":"/historia"}},[_vm._v("Historia AK na Wileńszczyźnie")])],1),_vm._v(" "),_c('b-nav-item',{on:{"click":function($event){_vm.navBarCollapse=false}}},[_c('router-link',{attrs:{"active-class":"activeNav","to":"/srodowiska"}},[_vm._v("Środowiska kombatanckie")])],1),_vm._v(" "),_c('b-nav-item',{on:{"click":function($event){_vm.navBarCollapse=false}}},[_c('router-link',{attrs:{"active-class":"activeNav","to":"/sponsorzy"}},[_vm._v("Sponsorzy")])],1),_vm._v(" "),_c('b-nav-item',{on:{"click":function($event){_vm.navBarCollapse=false}}},[_c('router-link',{attrs:{"active-class":"activeNav","to":"/kontakt"}},[_vm._v("Kontakt")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("dXrS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e22f0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("O0jz");
function injectStyle (ssrContext) {
  __webpack_require__("tbYJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e22f0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EYoL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Kolekcja osobista "),_c('br'),_vm._v("śp. Janusza Bohdanowicza")]),_c('br'),_vm._v(" "),_c('p',[_vm._v("\n    W 2009 roku Archiwum Ośrodka KARTA otrzymało w darze kolekcję osobistą Janusza Bohdanowicza pseud. „Czortek”.\n    Wśród materiałów przekazanych do Archiwum Ośrodka KARTA znajdują się teczki osobowe byłych żołnierzy Armii Krajowej\n    Okręgu Wileńskiego (m.in. por. Wilhelma Tupikowskiego i Aleksandra Alesionka), a także dokumentacja dotycząca działalności\n    Brygad Armii Krajowej Okręgu Wileńskiego, m.in. 3. Brygady „Szczerbca”, 6. Wileńskiej Samodzielnej Brygady\n    Partyzanckiej AK oraz 7. Brygady Armii Krajowej „Wilhelma” Okręgu Wileńskiego, w tym: arkusze ewidencji przebiegu służby,\n    relacje i wspomnienia żołnierzy dotyczące ich wojennych losów np. udziału brygady w ochronie sztabu Armii Krajowej Okręg Wilno,\n    ataku na Troki czy na bunkry wojska litewskiego, korespondencja prywatna dotycząca wydarzeń wojennych, rozkazy dzienne,\n    zaświadczenia o działalności antysowieckiej, protokoły przesłuchań, wyroki skazujące na karę pozbawienia wolności za\n    działalność antypaństwową z czasów PRL, karty zwolnienia z więzienia. Kolekcja zawiera także bogatą dokumentację\n    działalności środowiska 7. Brygady Żołnierzy AK: statut, akty darowizny, opisy prowadzonych akcji pomocy ludności\n    polskiej na Wileńszczyźnie.\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    Kolekcja osobista śp. Janusza Bohdanowicza jest udostępniana bezpłatnie w czytelni Ośrodka KARTA\n    (ul. Narbutta 29, Warszawa, e-mail: archiwum@karta.org.pl) od poniedziałku do środy w godz. 9.30-16.30.\n    Przed wizytą w archiwum zachęcamy Państwa do zapoznania się z\n    "),_c('a',{attrs:{"href":"./kolekcja/Inwentarz_Kolekcji_Janusza_Bohdanowicza.pdf","target":"_blank"}},[_vm._v("Inwentarzem Kolekcji.")])]),_vm._v(" "),_c('p',[_vm._v("\n    Część materiałów archiwalnych z kolekcji osobistej śp. Janusza Bohdanowicza została zdigitalizowana i\n    jest udostępniana bezpłatnie na stronie Biblioteki Cyfrowej Ośrodka KARTA.\n    "),_c('a',{attrs:{"href":"http://dlibra.karta.org.pl/dlibra/collectiondescription?dirids=1272","target":"_blank"}},[_vm._v("\n        Zapraszamy Państwa do odwiedzenia strony dLibra.karta.org.pl.\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FAah":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Działalność bojowa Oddziałów i Brygad")]),_c('br'),_vm._v(" "),_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"cols":"11"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":"/historia/dzialalnosc_bojowa/mapa_potyczek_walk.jpg"}}),_c('br')],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('span',{staticClass:"lead"},[_vm._v("\n        Mapa usytuowania miejsc potyczek i walk Oddziałów zbrojnych\n        Armii Krajowej Okręgu Wileńskiego w okresie 1943 i 1944.\n      ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"justify-content-md-center mt-5"},[_c('b-col',{attrs:{"md":"11"}},[_c('p',[_vm._v("Brygady i Oddziały Okręgu Wileńskiego Armii Krajowej (kolejność wg rozpoczęcia działań)")]),_vm._v(" "),_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.brygady,"fields":_vm.fields},scopedSlots:_vm._u([{key:"link",fn:function(data){return [(data.value)?_c('a',{attrs:{"target":"_blank","href":data.value}},[_vm._v("link")]):_vm._e()]}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FCnN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FGQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_home_js__ = __webpack_require__("xlOB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  methods: {
    elo: function elo(img) {
      return img;
    }
  },
  data: function data() {
    return {
      carousels: __WEBPACK_IMPORTED_MODULE_0__models_home_js__["a" /* default */].carousels
    };
  },
  metaInfo: {
    title: 'Strona główna',
    meta: [{ name: 'robots', content: 'index,follow' }, { name: 'description', content: 'AK Wilno - strona stworzona przez śp. Janusz Bohdanowicz, który znaczną część swojego życia poświęcił na gromadzenie materiałów o Armii Krajowej na Wileńszczyźnie.' }, { name: 'og:url', content: 'http://akwilno.pl' }, { name: 'og:title', content: 'Strona główna' }, { name: 'og:image', content: '/main/menu_logo.png' }, { name: 'og:description', content: 'AK Wilno - strona stworzona przez śp. Janusz Bohdanowicz, który znaczną część swojego życia poświęcił na gromadzenie materiałów o Armii Krajowej na Wileńszczyźnie.' }, { name: 'twitter:url', content: 'http://akwilno.pl' }, { name: 'twitter:title', content: 'AK Wilno' }, { name: 'witter:image', content: '/main/menu_logo.png' }, { name: 'twitter:description', content: 'AK Wilno - strona stworzona przez śp. Janusz Bohdanowicz, który znaczną część swojego życia poświęcił na gromadzenie materiałów o Armii Krajowej na Wileńszczyźnie.' }]
  }
});

/***/ }),

/***/ "FUPz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FZdh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  powiaty: {
    cards: [{
      id: 0,
      img: '/historia/okres_41_44/Bolesław_Zagorny.jpg',
      desc: 'Kpt. Bolesław Zagórny „Jan”'
    }, {
      id: 1,
      img: '/historia/okres_41_44/Bolesław_Zarzycki.jpg',
      desc: 'Mjr Bolesław Zarzycki „Rojan”'
    }, {
      id: 2,
      img: '/historia/okres_41_44/Tadeusz_Topor_Wasowski.jpg',
      desc: 'Tadeusz Topór- Wąsowski „Nowicki”'
    }, {
      id: 3,
      img: '/historia/okres_41_44/Adam_Boryczka.jpg',
      desc: 'Por. Adam Boryczka „Tońko” „Brona”'
    }],
    list: {
      desc: ['Komendantem Garnizonu został - mjr dypl. Antoni Olechnowicz „Pohorecki”.', 'Szefem sztabu kpt. Bolesław Wasilewski „Zosia”, który po przeniesieniu do sztabu Komendy Okręgu Nowogródzkiego miał pseudonim „Zoja”, „Bustromiak”.', 'Komendantem Dzielnicy „A” - kpt. Bolesław Zagórny „Jan”.', 'Komendantem Dzielnicy „B” - mjr Władysław Zarzycki „Rojan”.', 'Komendantem Dzielnicy „C” - mjr Tadeusz Wąsowski „ Nowicki”.', 'Komendantem Dzielnicy „D” - kpt. Józef Grzesiak „Kmita”.', 'Komendantem powiatów województwa wileńskiego „Pole” zostaje - mjr inż. Czesław Dębicki „Jarema”.'],
      rejony: ['Rejon I - obejmujący powiaty : wileńsko-trocki i święciański, którego dowódcą został mjr Stanisław Marchewka „Lis”.', 'Rejon II - obejmujący powiaty : brasławski, postawski i głębocki, którego dowódcą został ppor. Waldemar Żaba „Bocian”, a następnie mjr Stefan Świechowski „Sulima”.', 'Rejon III - obejmujący powiaty: oszmiański, wilejski, mołodeczański, którego dowódcą został kpt.Stefan Zalewski „Skiwski”.']
    }
  },
  okreg_deleg: {
    cards: {
      part1: [{
        id: 0,
        img: '/historia/okres_41_44/Zygmunt_Fedorowicz.jpg',
        desc: 'Zygmunt Fedorowicz "Albin", "Pani Maria", "Józef"'
      }, {
        id: 1,
        img: '/historia/okres_41_44/Henryk_Jackiewicz.jpg',
        desc: 'Henryk Jackiewicz „Marian”'
      }, {
        id: 2,
        img: '/historia/okres_41_44/Władysław_Babicki.jpg',
        desc: 'Władysław Babicki „Jerzy”'
      }, {
        id: 3,
        img: '/historia/okres_41_44/Witold_Pawlikowski.jpg',
        desc: 'Witold Pawlikowski „Rafał”'
      }],
      part2: [{
        id: 4,
        img: '/historia/okres_41_44/Wacław_Iszora.jpg',
        desc: 'Wacław Iszora „Wacławski”'
      }, {
        id: 5,
        img: '/historia/okres_41_44/Adam_Galinski.jpg',
        desc: 'Adam Galiński „Pan P”'
      }, {
        id: 6,
        img: '/historia/okres_41_44/Wacław_Podbereski.jpg',
        desc: 'Wacław Podbereski „Szary”'
      }]
    },
    list: {
      wilno: ['I z-ca Delegata - Henryk Jackiewicz "Marian".', 'II z-ca Delegata - Jerzy Dobrzański "Maciej".', 'Biuro Delegata Rządu - kierowanego przez Władysława Babickiego „Jerzy”, a następnie przez Witolda Pawlikowskiego „Rafał”.', 'Sekretarz Delegata - Wacław Religioni „Marian”.', 'Inspektorat Samorządowy - kierowany przez Wacława Iszorę „Wacławski”.', 'Wydział Bezpieczeństwa - kierowany przez Witolda Świerzewskiego „Bartek”, a następnie Kazimierza Protasewicza „Sokół”.', 'Wydział Informacji i Prasy - kierownikiem był Władysław Babicki” „Jerzy”, poprzednio był kierownikiem Biura Delegata.', 'Opieki Społecznej - kierowany przez Adama Galińskiego „Adam”, „Pan P”, następnie przez ks. Aleksandra Lachowicza „Leszczyna”.', 'Wydział Zdrowia - kierowany przez dr Feliksa Kasperowicza „Szczęsny”, „Pan N”, następnie dr Witolda Brynka.', 'Wydział Oświaty - kierowany przez Jana Bobkę, a jego zastępcą został Stanisław Starościak.', 'Wydział Przemysłu i Handlu - kierowany przez inż. Władysława Hajdukiewisza.', 'Wydział Rolnictwa - kierowany przez Ludwika Chomińskiego.', 'Wydział Sprawiedliwości - kierowany przez Władysława Dmochowskiego.', 'Wydział Finansowy - kierowany przez Wacława Maurycego Gajewskiego.'],
      rzad: ['Sąd Karny Specjalny - przewodniczącym był Jan Radwański „Zygmunt”, „Rawicz”, „Barnaba”.', 'Łączność zewnętrzna - kurierska, radiowa, szyfrowa były prowadzone przez zespoły ludzi każdorazowo dobieranych.', 'Komórka Legalizacji - prowadzona przez Wacława Podbereskiego „Szary”, kurier Delegatury Rządu do Delegata Rządu na Kraj w Warszawie.']
    }
  },
  komenda: {
    cards: {
      part1: [{
        id: 0,
        img: '/historia/okres_41_44/Lubosław_Krzeszowski.jpg',
        desc: 'Mjr Lubosław Krzeszowski „Ludwik”'
      }, {
        id: 1,
        img: '/historia/okres_41_44/Teodor_Cetys.jpg',
        desc: 'Mjr dypl. Teodor Cetys „Sław”'
      }, {
        id: 2,
        img: '/historia/okres_41_44/Zofia_Dab_Biernacka.jpg',
        desc: 'Zofia Dąb-Biernacka „Jagienka”'
      }, {
        id: 3,
        img: '/historia/okres_41_44/Barbara_Skarzanka.jpg',
        desc: 'Barbara Skarżanka „Ewa”'
      }],
      part2: [{
        id: 4,
        img: '/historia/okres_41_44/Aniela_Dziewulska.jpg',
        desc: 'Aniela Dziewulska „Krystyna”'
      }, {
        id: 5,
        img: '/historia/okres_41_44/Michal_Warakomski.jpg',
        desc: 'Michał Warakomski „Piotr”'
      }, {
        id: 6,
        img: '/historia/okres_41_44/Mieczyslaw_Potocki.jpg',
        desc: 'Mjr dypl. Mieczysław Potocki „Węgielny”'
      }, {
        id: 6,
        img: '/historia/okres_41_44/Jerzy_Bronikowski.jpg',
        desc: 'Kpt. Jerzy Bronikowski „Czarny Jan”'
      }]
    },
    list: {
      obsada: ['Komendant Okręgu - ppłk Aleksander Krzyżanowski "Wilk".', 'Zastępca Komendanta i Szefem Sztabu - ppłk Lubosław Krzeszowski "Ludwik".', 'Dowódca Oddziału I-go Ogólno-Organizacyjnego i Odtwarzania Wojska Polskiego - ppłk Julian Kulikowski "Witold Drohomirski".', 'Dowódca Oddziału II-go Wywiadu Operacyjnego - kpt. Stawiej "Otto".', 'Kontrwywiad - Mirosław Głębocki "Cecylia".', 'Dowódca Oddziału III-go Operacyjno Szkoleniowego - cc mjr Teodor Cetys "Sław", "Wiking".', 'Dowódca Oddziału IV-go Kwatermistrzostwo i Służby Logistyczne - mjr dypl. Kazimierz Heilman "Tomasz".', 'Dowódca Oddziału V-go Łączność Operacyjna - kpt. Stefan Czernik "Orwat".', 'Łączność z konspiracją - Zofia Dąb-Biernacka "Jagienka".', 'Łączność z Inspektoratami i Brygadami - Barbara Skarżanka "Ewa".', 'Łączność wewnętrzna Sztabu Okręgu - Aniela Dziewulska "Krystyna".', 'Dowódca Oddziału VI-go Biuro Informacji i Prasy - Antoni Kokociński "Juliusz".', 'Dowódca Oddziału VII-go Legalizacja - Michał Warakomski "Piotr".'],
      inspektoraty: ['Dowódcą Inspektoratu "A" obejmującego miasto Wilno i powiat wileńsko- trocki - mjr dypl. Antoni Olechnowicz "Pohorecki” z dwoma podinspektorami: północny', 'kpt. Emanuel Prokesche "Emka", południowy - kpt. Jerzy Bronikowski "Dzik", „Czarny Jan”.', 'Oraz garnizon miasta Wilna - mjr Leon Koplewski „Bezmian" "Skarbek".', 'Szef Sztabu Inspektoratu - mjr Aleksander Wasilewski "Olesiński".', 'Dowódcą Inspektoratu "BC" obejmującego powiaty święciański, brasławski i dziśnieński - mjr dypl. Mieczysław Potocki "Kamień", "Węgielny".', 'Szef sztabu - por. Jan Drozdowicz "Gerwazy".', 'Dowódcą Inspektoratu "F" obejmującego powiaty: oszmiański, wilejski, mołodecki - mjr inż. Czesław Dębicki "Jarema".', 'Szef Sztabu - kpt. Michał Kwakszys "Kowal".'],
      sztaby: ['Szef Sztabu Powstania wewnątrz miasta Wilna - ppłk Lubosław Krzeszowski "Ludwik", oraz sztab Oddziałów w polu.', 'Szef Sztabu - mjr dypl. Teodor Cetys "Sław".', 'Dowódca Oddziału I Organizacyjno-Szkoleniowego - kpt. Zbigniew Brodzikowski "Rańcza".', 'Dowódca Oddziału II Wywiad Operacyjny- popr. Bolesław Nowak "Majewski".', 'Dowódca Oddziału III Operacyjnego - ppłk Zygmunt Izydor Blumski "Strycharski".', 'Dowódca Oddziału IV Kwatermistrzostwo - mjr Kazimierz Radzikowski "Robur".', 'Dowódca Oddziału V Łączności Operacyjnej - kpt. Stefan Czernik "Orwat".', 'Dowódca Oddziału VI Biuro Informacji i Propagandy - ppor. Leon Lech Bejnar "Nowina" /Paweł Jasienica/.']
    },
    zgrupowania: [{
      id: 0,
      title: 'I Zgrupowanie:',
      list: ['2. Brygada por. "Kaziuka"', '3. Brygada por. "Szczerbca"', '5. Brygada por. Łupaszki"', '7. Brygada por. "Wilhelma"', 'Oddział Partyzancki por. „Gozdawy”', 'Oddział Rozpoznawczy Dowództwa Zgrupowania por. "Groma"']
    }, {
      id: 1,
      title: 'II Zgrupowanie:',
      list: ['1. Brygada por. "Juranda"', '4. Brygada por. "Ronina"', '23. Brygada por. Światołdycza"', '24. Brygada por. "Wawrzeckiego"', '36. Brygada por "Wujka"', 'Oddział "Kedywu" por. "Frycza"', 'Oddział Rozpoznawczy Dowództwa Zgrupowania por. "Ptasznika"']
    }, {
      id: 2,
      title: 'III Zgrupowanie:',
      list: ['8. Brygada por. "Tura"', '9. Brygada, chor. "Małego"', '12. Brygada por. "Cerbera"', '13. Brygada por. Nietoperza"', 'Oddział Osłony Dowództwa Zgrupowania por. "Gracza"']
    }]
  },
  legalizacja: {
    cards: {
      part1: [{
        id: 0,
        img: '/historia/okres_41_44/Stanisław_Kialka.jpg',
        desc: 'Stanisław Kiałka „Bolesław”, „Jelonek”'
      }, {
        id: 1,
        img: '/historia/okres_41_44/Jerzy_Hoppen.jpg',
        desc: 'Prof. Jerzy Hoppen'
      }, {
        id: 2,
        img: '/historia/okres_41_44/Stefan_Dzierzek.jpg',
        desc: 'kleryk Stefan Dzierżek'
      }, {
        id: 3,
        img: '/historia/okres_41_44/Romuald_Warakomski.jpg',
        desc: 'Romuald Warakomski „Hilary”'
      }],
      part2: [{
        id: 4,
        img: '/historia/okres_41_44/Stanisław_Turski.jpg',
        desc: 'Stanisław Turski „Roman”'
      }, {
        id: 5,
        img: '/historia/okres_41_44/Jozefa_Kafarska.jpg',
        desc: 'Józefa Kafarska „Wrzos”'
      }, {
        id: 6,
        img: '/historia/okres_41_44/Stanisława_Kafarska.jpg',
        desc: 'Stanisława Kafarska „Hańcza”'
      }, {
        id: 6,
        img: '/historia/okres_41_44/Zdzisław_Pleskaczewski.jpg',
        desc: 'Zdzisław Pleskaczewski „Zbyszek”'
      }]
    },
    list: {
      kuznia: ['Kierownik placówki oraz warsztat wulkanizacyjny I dział druków - Michał Warakomski "Piotr"', 'Grafika - Romuald Warakomski "Hilary".', 'Fotografia - Stanisław Turski "Roman".', 'Cynkografia - Stanisław Weber "Bohdan".', 'Dział propagandy - Eudokia Bobaryko, Anna Bobaryko.', 'Łączność - Irena Barszczewska "Lolka". „Gospoda”', 'Kierownik placówki - Halina Turska "Aldona".', 'Zespół biurowy - 3 osoby o nie ustalonych personaliach.', 'Łączność - Halina Gierżunówna "Hanka", Józefa Rymkiewicz „Ziuta", Maria Rymkiewicz "Jaśmin" i Janina Doboszyńska.']
    }
  },
  tajne: {
    cards: [{
      id: 0,
      img: '/historia/okres_41_44/Stanislaw_Hiller.jpg',
      desc: 'Prof. Stanisław Hiller'
    }, {
      id: 1,
      img: '/historia/okres_41_44/Janina_Bohdanowiczowna.jpg',
      desc: 'Janina Bohdanowiczówna'
    }, {
      id: 2,
      img: '/historia/okres_41_44/Jan_Zelski.jpg',
      desc: 'Jan Żelski'
    }, {
      id: 3,
      img: '/historia/okres_41_44/Michal_Reicher.jpg',
      desc: 'Prof. Michał Reicher'
    }, {
      id: 4,
      img: '/historia/okres_41_44/Wladysław_Dziewulski.jpg',
      desc: 'Prof. Władysław Dziewulski'
    }, {
      id: 5,
      img: '/historia/okres_41_44/Stefan_Ehrenkreutz.jpg',
      desc: 'Prof. Stefan Ehrenkreutz'
    }],
    list: {
      osrodki: ['Ośrodek zwany uniwersyteckim, ponieważ wykładowcami byli również nauczyciele uniwersyteccy. Kierował nim prof. Władysław Dziewulski i Ananiasz Rojecki, prowadzący średnio 40 kompletów.', 'Ośrodek prowadzony przez Janinę Bohdanowiczównę.', 'Ośrodek kierowany przez Jana Żelskiego.'],
      swiadectwa: ['1940/1941   -   10 osób', '1942/1943   -   25 osób', '1943/1944   -   18 osób', '1944/1945   -   9 osób.'],
      profesorowie: ['Ludwik Chmaj - pedagogika', 'Tadeusz Czeżowski - filozofia', 'Konrad Górski - filologia polska', 'Jan Oko i Stefan Srebrny - filologię klasyczną', 'Janusz Iwaszkiewicz i Henryk Łowmiański - historię', 'Olgierd Chomiński - filologię słowiańską', 'mgr Gustaw Foss - filologię niemiecką'],
      prof_mat_prz: ['Jan Pruffer - zoologię', 'Władysław Dziewulski - astronomię', 'Szczepan Szczeniowski - fizykę teoretyczną', 'Julian Rudnicki - matematykę', 'Edward Pasendorfer - geologię', 'Edward Bekier - chemię fizyczną', 'Leon Jasmanowicz - matematykę', 'Irena Kardymowiczowa - krystalografię i mineralogię', 'Stefan Kownas - botanikę', 'Eugeniusz Michalski - chemię', 'Henryk Nireodniczański - fizykę doświadczalną i teoretyczną']
    }
  },
  sluzby: [{
    id: 0,
    title: 'Pierwszymi świadczącymi na szerszą skalę opiekę lekarską byli:',
    list: ['Dr Maria Pietrusewiczowa', 'Prof. dr Kazimierz Pelczar', 'Dr Jerzy Dobrzański', 'Dr Stanisław Markiewicz "Plus"'],
    text: ''
  }, {
    id: 1,
    title: 'Zorganizowana służba sanitarna pod nazwą Szefostwo Sanitarne Okręgu Wileńskiego, jako samodzielny pion organizacyjny Oddziału IV Sztabu Kwatermistrzostwa.',
    list: ['Pierwszym szefem sanitarnym został - dr Adam Galiński "Adam", "Pan P",', 'Zastępcami - dr Stefan Borkowski, dr Wiktor Dunin- Horkawicz "Kamil", dr Stanisław Markiewicz "Pius",', 'Szefem farmacji i zaopatrzenia w leki - mgr farm. Henryk Zajączkowski.'],
    text: ''
  }, {
    id: 2,
    title: 'W tym składzie zespół ten pracował od wiosny 1943 roku do wiosny 1943 roku. Jako naczelne zadania dla służb sanitarnych ustalono:',
    list: ['organizowanie służby sanitarnej w Wilnie i w terenie', 'zapewnienie jej obsady personalnej i zaopatrywanie w środki medyczne', 'organizowanie szkolenia sanitarnego dla przygotowania średniego personelu,', 'opracowanie planu mobilizacyjnego w zakresie osobowym i materiałowym na wypadek powstania', 'współpraca z Wydziałem Zdrowia Okręgowej Delegatury Rządu'],
    text: ''
  }, {
    id: 3,
    title: 'Właściwą opiekę lekarską, tego potrzebującym konspiratorom zapewniali wyznaczeni przez Komendę Okręgu Komendanci poszczególnych szpitali. Dyrektorami szpitali byli Niemcy, a Komendantami :',
    list: ['Szpitala Św. Jakuba - dr Feliks Oleński', 'Szpitala kolejowy na Wilczej Łapie - dr Jan Janowicz', 'Szpitala Czerwonego Krzyża na ul. Bogusławskiej - dr Zdzisław Kieturak', 'Szpitala Neurologicznego przy ul. Witoldowej - doc. dr Janina Murynowicz', 'Szpitala Zakaźnego na Zwierzyńcu - dr Zofia Wasilewska- Świdowa', 'Lecznicy Ocznej Św. Józefa - dr Józef Kucharski', 'Szpitala dla jeńców wojennych - dr Władysław Żemojtel "Znachor", "Biały Jan".'],
    text: 'Szpital na Antokolu prowadził specjalistyczne szkolenia lekarzy w zakresie chirurgii, dla lekarzy brygadowych. Szkoleniem tym kierował prof., dr Kornel Michejda, przy cichej zgodzie niemieckiego dyrektora dr Reichelta. Tak zorganizowana służba sanitarna w szpitalach miejskich spełniała swoje zadania tym bardziej, że prawie cały personel pomocniczy stanowili Polacy w większości zaprzysiężeni żołnierze ZWZ- AK.'
  }, {
    id: 4,
    title: 'W 1943 roku powołano służby sanitarne dla poszczególnych Inspektoratów.',
    list: ['Szefem sanitarnym Inspektoratu "A" został - dr Stefan Cierpiński "Korwin",', 'Szefem sanitarnym Inspektoratu "BC" został - dr Wilhelm Berecki', 'Szefem sanitarnym Inspektoratu "F" został - dr Maciej Brzozowski "Mietek", a po nim - dr Michał Holak "Bonifacy"', 'Szefem sanitarnym Podokręgu Kowieńskiego - dr Adam Dowgird "Dominik".'],
    text: ''
  }, {
    id: 5,
    title: 'Do poszczególnych Brygad i Oddziałów Partyzanckich skierowywano lekarzy lub wyróżniających się wiadomościami studentów ostatnich lat studiów na Wydziale Lekarskim. Skierowani zostali do :',
    list: ['1. Brygady "Juranda" - dr Jan Rymian "Pean"', '2. Brygady "Kaziuka" - dr Bogdan Kopeć', '3. Brygady "Szczerbca" - dr Lech Iwanowski "Lancet"', '5. Brygady "Łupaszki" - dr Konstanty Pukjaniec "Strumyk"', '7. Brygady "Wilhelma" - dr Zygmunt Jastrzębski', '8. Brygady "Tura" - dr Anatoliusz Balc "Ponury"', '9. Brygady "Małego" - dr Zbroisław Haczkowski', '13. Brygady "Nietoperza" - dr Stanisław Żebrowski "Lancet I"', '24. Brygady "Wawrzeckiego" - dr Egeniusz Waszczuk'],
    text: ''
  }, {
    id: 6,
    title: 'Natomiast studenci do:',
    list: ['4. Brygady "Ronina" - Jan Mańkowski "Medyk"', '12. Brygady "Cerbera" - Zbigniew Szacki "Trus"', '23. Brygady "Ostrogi" Światołdycza" - Bohdan Buchowski', '36. Brygady "Wujka" - Michał Żołnierowicz'],
    text: ''
  }, {
    id: 7,
    title: 'Wiosną 1944 roku utworzono Szefostwo Sanitarnej Służby Polowej kierowaną przez prof. dr Michała Reichera "Sosna", któremu podlegali:',
    list: ['Szef sanitarny I Zgrupowania "Pohoreckiego" - dr Stefan Cierpiński "Korwin"', 'Szef sanitarny II Zgrupowania "Węgielnego" - dr Tadeusz Ginko „Jan”', 'Szef III Zgrupowania "Jaremy" - dr Mieczysław Pimpicki "Orzeł"'],
    text: 'Sytuacja na foncie walk sowiecko - niemieckich wiosną 1944 roku wymagała przyśpieszenia przygotowań do czynnego uczestniczenia w Operacji "Burza" to jest wyzwalania przez Armię Krajową ziem położonych w granicach Państwa Polskiego, przed wkroczeniem wojsk sowieckich.'
  }, {
    id: 8,
    title: 'Na potrzeby poszczególnych Zgrupowań Oddziałów Partyzanckich utworzono szpitale polowe.',
    list: ['I Zgrupowanie "Pohoreckiego" utworzyło szpital w Onżadowie koło Taboryszek oraz w Sorok Tatarach', 'II Zgrupowanie "Węgielnego" utworzyło szpital w Prużanach nad Wilią oraz w Kalinie koło Rzeszy', 'III Zgrupowanie utworzyło szpitale w leśniczówce koło Wielkich Wojsznaryszek i w Antoniszkach.'],
    text: ''
  }, {
    id: 9,
    title: 'Przy Zgrupowaniach działały również Czołówki Sanitarne noszące numer danego Zgrupowania.',
    list: ['Dla I Zgrupowania utworzona na bazie szpitala w Onżadowie kierowana przez dr Stefana Cierpińskiego "Korwin", natomiast chirurgiem w niej był dr Michał Juszczynski', 'Czołówką II zgrupowana kierował dr Tadeusz Ginko, została ona utworzona na bazie szpitala w Prużanach.', 'Czołówką III Zgrupowania utworzoną na bazie szpitala polowego w Antoniszkach, kierował dr Tadeusza Wiszniewskiego "Hel".', 'Przy Komendzie Okręgu powstała Czołówka Sanitarna „K” z komendantem dr Władysławem Żemojtelem.'],
    text: 'Konspiracyjna służba sanitarna Okręgu Wileńskiego była jedną z najlepiej zorganizowanych i najsprawniej działających służb pionu kwatermistrzowskiego. Pracujący w jej strukturach lekarze, felczerzy, pielęgniarki, sanitariusze, farmaceuci dobrze wypełnili swój ludzki, zawodowy i żołnierski obowiązek.'
  }],
  odbitki: {
    list: ['Egz. Nr 1 - do akt', 'Nr 2 i 3 - Oddział in. Bolszewików', 'Nr 4 i 5 Oddział Suworowa', 'Nr 6 Oddział Czapajewa', 'Nr 8 Oddział im. Buciennego', 'Nr 9 Oddział Ryżska', 'Nr 10 Oddział im. Październikowej Rewolucji']
  }
});

/***/ }),

/***/ "Fo1U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Sponsorzy")]),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('p',[_vm._v("\n        Niezwykle ciekawa i wartościowa kolekcja osobista Janusza Bohdanowicza, która stanowi zapis historii Brygad AK Okręgu Wileńskiego\n        (m.in. 3. Brygady „Szczerbca”, 6. Wileńskiej Samodzielnej Brygady Partyzanckiej AK oraz 7. Wileńskiej Brygady AK Okręgu Wileńskiego),\n        została zdigitalizowana i jest już dostępna w Bibliotece Cyfrowej Ośrodka KARTA (AW III/618). Prezentowane dokumenty dotyczą przebiegu\n        służby żołnierzy Brygad Armii Krajowej Okręgu Wileńskiego.\n      ")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3","cols":"12"}},[_c('b-img',{attrs:{"width":"200px","center":"","src":"/sponsorzy/sponsorzy_logo.jpg","center":"","fluid":""}})],1)],1),_vm._v(" "),_c('p',[_vm._v("\n    Twórca kolekcji – śp. Janusz Bohdanowicz (zm. 5 lipca 2013) - od końca lat 80. aktywnie uczestniczył w tworzeniu się organizacji\n    kombatanckich weteranów AK. Został przewodniczącym Środowiska Żołnierzy 7. Brygady „Wilhelma”, następnie prezesem Środowiska\n    Wileńskiego Światowego Związku Żołnierzy Armii Krajowej (ŚZŻAK) w Gdańsku, a następnie w Warszawie, członkiem Komisji Historycznej\n    Okręgu Wileńskiego, członkiem Rady Naczelnej i Prezydium Zarządu Głównego ŚZŻAK, przewodniczącym Komisji Współpracy z Młodzieżą Szkolną.\n    Od 18 kwietnia 2011 do 20 września 2012 był prezesem Okręgu Wileńskiego ŚZŻAK. Ostatnie lata swego życia poświęcił gromadzeniu materiałów,\n     ich cyfryzacji oraz tworzeniu strony internetowej - AKWilno.pl.\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    Digitalizacja i udostępnienie w Bibliotece Cyfrowej Ośrodka KARTA oraz na stronie internetowej AKWilno.pl przechowywanej w\n    Archiwum Ośrodka KARTA kolekcji osobistej Janusza Bohdanowicza, a także przebudowa strony internetowej zostały sfinansowane\n    przez Urząd do Spraw Kombatantów i Osób Represjonowanych.\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fqf/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sponsorzy',
  metaInfo: {
    title: 'Sponsorzy',
    meta: [{ name: 'description', content: 'Digitalizacja i udostępnienie w Bibliotece Cyfrowej Ośrodka KARTA oraz na stronie internetowej AKWilno.pl przechowywanej w Archiwum Ośrodka KARTA kolekcji osobistej Janusza Bohdanowicza, a także przebudowa strony internetowej zostały sfinansowane przez Urząd do Spraw Kombatantów i Osób Represjonowanych.' }, { name: 'og:url', content: 'http://akwilno.pl/sponsorzy' }, { name: 'og:title', content: 'Sponsorzy' }, { name: 'og:image', content: '/sponsorzy/sponsorzy_logo.jpg' }, { name: 'og:description', content: 'Digitalizacja i udostępnienie w Bibliotece Cyfrowej Ośrodka KARTA oraz na stronie internetowej AKWilno.pl przechowywanej w Archiwum Ośrodka KARTA kolekcji osobistej Janusza Bohdanowicza, a także przebudowa strony internetowej zostały sfinansowane przez Urząd do Spraw Kombatantów i Osób Represjonowanych.' }, { name: 'twitter:url', content: 'http://akwilno.pl/sponsorzy' }, { name: 'twitter:title', content: 'Sponsorzy' }, { name: 'witter:image', content: '/sponsorzy/sponsorzy_logo.jpg' }, { name: 'twitter:description', content: 'Digitalizacja i udostępnienie w Bibliotece Cyfrowej Ośrodka KARTA oraz na stronie internetowej AKWilno.pl przechowywanej w Archiwum Ośrodka KARTA kolekcji osobistej Janusza Bohdanowicza, a także przebudowa strony internetowej zostały sfinansowane przez Urząd do Spraw Kombatantów i Osób Represjonowanych.' }]
  }
});

/***/ }),

/***/ "G5Ao":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"id":"sideBarContainer"}},[_c('b-nav',{staticClass:"d-none d-sm-block bg-light sidebar"},[_c('b-row',{staticClass:"mb-3",attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"10"}},[_c('b-img',{attrs:{"src":"/main/menu_logo.png","fluid":""}})],1)],1),_vm._v(" "),_c('b-container',[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_c('router-link',{attrs:{"active-class":"activeSide","to":"/","exact":""}},[_vm._v("Start")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"active-class":"activeSide","to":"/aktualnosci"}},[_vm._v("Aktualności")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"active-class":"activeSide","to":"/o_autorze"}},[_vm._v("O Autorze")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"active-class":"activeSide","to":"/kolekcja"}},[_vm._v("Kolekcja Janusza Bohdanowicza")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"active-class":"activeSide","to":"/historia"}},[_vm._v("Historia AK na Wileńszczyźnie")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"active-class":"activeSide","to":"/srodowiska"}},[_vm._v("Środowiska kombatanckie")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"active-class":"activeSide","to":"/sponsorzy"}},[_vm._v("Sponsorzy")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"active-class":"activeSide","to":"/kontakt"}},[_vm._v("Kontakt")])],1)])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GprE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Aresztowania, rozbrojenia i represje sowieckie - EPILOG")]),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6","order-md":"1","order":"2"}},[_c('p',[_vm._v("\n        Dnia 17 lipca 1944 roku wydzielony z szeregów 7. Brygady Oddział po wycofaniu się z Bogusz,\n        forsownym marszem dowodzony przez Komendanta \"Wilhelma\" przesuwał się w kierunku Puszczy Rudnickiej.\n        Po drodze napotkał pozostałą część Brygady ,czasowo dowodzoną przez kpt. \"Czarnego Jana\".\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Po porozumieniu się kpt. \"Czarnego Jana\" z Komendantem \"Wilhelmem\" kontynuowano marsz w dalszym ciągu w kierunku Puszczy.\n        Po drodze kolumna była kilkakrotnie zawracana, przez stojące lub przemaszerowujące wojska sowieckie.\n        Żadnych oznak wrogości nie okazywali. Pod wieczór cała kolumna dotarła do wsi Piełokańce.\n        Podczas przeprawiania się samochodów ciężarowych taborów brygadowych mostek nie wytrzymał obciążenia i\n        zaczął bardzo niebezpiecznie siadać. Samochody musiały zawrócić i ew. udać się inną drogą na wyznaczone przez\n        Komendanta miejsce postoju Brygady.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Po przejściu wsi, w lesie ciągnącym się wzdłuż drogi, na lewym brzegu tej drogi, zarządzono postój.\n        Bardzo zmęczeni, wielogodzinnym marszem, żołnierze poukładali się do snu. Obowiązywał zakaz palenia ognisk.\n      ")])]),_vm._v(" "),_c('b-col',{staticClass:"mb-5",attrs:{"md":"5","order-md":"2","order":"1"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":"/historia/rozbrojenie_aresztowanie_epilog_dokumenty/miejsce_aresztowania_przez_nkwd.jpg"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lead"},[_vm._v("\n        Miejsce aresztowania przez NKWD oficerów Armii Krajowej podstępnie\n        zaproszonych na odprawę ze sztabem II Frontu Białoruskiego\n      ")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',{staticClass:"lead"},[_c('b',[_vm._v("Bardzo wczesnym rankiem, ogłoszono bardzo cicho pobudkę.")])]),_vm._v(" "),_c('p',[_vm._v("\n        Komendant w otoczeniu dowódców plutonów i oficerów, którzy zgłosili się w ostatnim czasie zrobił odprawę\n        na której chcących na własną rękę próbować się wydostać z okrążenia, zwalniał z Brygady. Dość dużo chętnych,\n        znających te tereny skorzystało z tego, pozostali zostali uformowani w kolumnę marszową.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Po przejściu około 400-500 metrów na końcu lasu rozpościerała się ogromna łąka o powierzchni ok. 3 - 4 hektarów.\n        Łąka była otoczona wojskiem sowieckim, a na niej siedziało już rozbrojonych kilkuset żołnierzy Armii Krajowej.\n        Po obu stronach drogi leżała nasza partyzancka broń, nieraz krwią czy nawet życiem okupiona.\n        Na cichy rozkaz komendanta przed odrzuceniem posiadanej broni należało, przynajmniej wyjąć zamek i odrzucić w innym\n        kierunku lub w możliwy sposób uszkodzić ją przed oddaniem. Przechodząc obok leżącej już oddanej prze inne\n        Oddziały ,my również musieliśmy oddać swoją.\n      ")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_c('b',[_vm._v("Pozbawieni broni ,czuliśmy się jak rozebrani do naga, skazani na czyjąś łaskę.")])]),_vm._v(" "),_c('p',[_vm._v("\n        Posiadanie broni było symbolem i zarazem w tamtych warunkach bywało synonimem osobistego poczucia wartości,\n        byłem podmiotem a nie przedmiotem, z którym mogli robić co chcieli. Uczucia bezsilności, beznadziejności\n        nie można oddać w słowach, to mogą zrozumieć w pełni tylko Ci, którzy na własnej skórze tego doświadczyli.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Martwa cisza ,tylko komendy w języku rosyjskim wskazują miejsca na którym mamy siadać z jednoczesnym uprzedzeniem,\n        że wszelkie podnoszenie się i przechodzenie ,będzie zaliczane do prób ucieczki i spowoduje użycie broni.\n        Zdesperowani przesiedzieliśmy na tej łące, aż do wczesnego popołudnia. Zarządzono uformowanie kolumny marszowej,\n        ósemkami, co kilka metrów po obu stronach z bronią skierowaną w naszym kierunku szli żołnierze sowieccy z zielonymi\n        otokami na czapkach. Kilka razy podczas przejścia przez wieś, od ludności miejscowej otrzymaliśmy po kawałku chleba\n        lub wody do picia.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Właśnie podczas przemarszu przez którąś wieś koleżanka \"Teo\" Teodozja Mrukówna obecnie Piaskowska,\n        sanitariuszka II plutonu 7 Brygady, krokiem w lewo i zwrotem w kierunku przemaszerowującej kolumny, zdołała zbiec.\n        Ponieważ nie była w mundurze wojskowym, to po zdjęciu opaski nie wyróżniała się spośród stojącej ludności wiejskiej.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Natomiast zdarzało się kilkakrotnie, że próbujący oddalać się pojedynczo lub w kilka osób, natychmiast powodował\n        dołączanie się do konwoju żołnierzy na koniach i po dogonieniu ich byli zabijani na miejscu i pozostawiani.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        W ten sposób wytworzona sytuacja powodowała, jakąś bezwładność, apatię, beznadziejność nawet obezwładniała.\n        Pod wieczór kolumna dotarła do jakiejś miejscowości, w której plac był ogrodzony rozpadającym się bardzo starym murem.\n        W środku stały dwa baraki i osiem lub dziesięć dużych pustych stajni, wojska niemieckie trzymały tam konie taborowe.\n        Ogłoszono, że oficerowie mają zająć miejsca w barakach, pozostali w stajniach. Do baraków również pozwolono przejść\n        kobietom sanitariuszkom i otworzyć punkt doraźnej pomocy sanitarnej.\n      ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6","order-md":"1","order":"2"}},[_c('p',{staticClass:"lead"},[_c('b',[_vm._v("Wojska konwojujące pozostawiając tylko straż przy bramie z rezerwą na zmiany, odmaszerowały.")])]),_vm._v(" "),_c('p',[_vm._v("\n        Musiano we własnym zakresie zorganizować dowóz wody „beczkowoz”, uruchomić kuchnię, która coś gotowała,\n        ale dwa kotły odkryte o pojemności ok. 150 litrów każdy, na taką ilość ludzi zebranym na placu nie dawała\n        żadnej pewności na dostanie czegokolwiek oprócz chorych i najbardziej potrzebujących. Dużo więcej pomogła nam\n        ludność miejscowa, która w miarę swoich możliwości podawała przez bramę jakąś żywność. Strażnicy przy bramie\n        nawet specjalnie nie bardzo szczegółowo sprawdzali co zostaje podane.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Zauważyliśmy, pojawianie się jakichś ludzi, którzy zaczęli wypytywać o poszczególne osoby z różnych Brygad i\n        Batalionów Okręgu Nowogródzkiego. Między innymi często pojawiało się pytanie o Komendanta \"Wilhelma\", adiutanta\n        \"Żuka\" i innych. Zostali oni ostrzeżeni i w możliwy sposób w tamtych warunkach osłaniani. Spowodowało to ucieczkę\n        por Wilhelma Tupikowskiego ps. \"Wilhelm\" Komendanta 7. Brygady, por. Eugeniusza Szymaniaka ps. \"Poraj\" dowódcę\n        1 plutonu, por Aleksandra Dukszto ps. \"Wicher\" dowódcę 2 plutonu oraz kilkudziesięciu żołnierzy 7. Brygady.\n        Żadnych działań, pilnująca nasz straż nie przejawiała.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        22 lub 23 lipca przybyła do Miednik delegacja Armii Berlinga jak wówczas nazywano Wojsko Polskie formowane na terenie\n        ZSRR oraz kilku cywili przedstawicieli Związku Patriotów Polskich, przedstawiający się jako kapitan Wojska Polskiego o\n        nazwisku Soroka, bardzo źle mówiący po polsku, próbował przekonywać nas abyśmy wstąpili do wojska i wspólnie bili hitlerowców.\n        Na pytania w jakich formacjach będziemy służyli i pod czyim dowództwem, odpowiadał bardzo zawile, tłumacząc, że o tym będą\n        decydować tzw. \"wojen komaty\" odpowiedniki polskich PKU. Na zgłoszenie postulatu, że wstępujemy do Wojska Polskiego ale pod\n        dowództwem Komendanta Okręgu generała „Wilka”, wycofał się z dyskusji. Kilkunastu żołnierzy zgłosiło się na ochotnika, nawet\n        nie zapisując wyprowadzono ich poza obręb otoczony murami i umieszczono w jakiejś chałupie we wsi. Rano w chałupie pozostało\n        chyba dwie osoby, które zostały przyprowadzone ponownie za mury. Przywitani zostali gwizdami i śmiechem.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        W nocy z 26 na 27 lipca 1944 roku zostały zwiększone patrole, pilnujące wokół murów jak i przy bramie.\n        Nie wypuszczano już nikogo na zewnątrz, a grupa przywożąca wodę otrzymała silny konwój. 28 lipca z rana\n        zarządzono zbiórkę, przeprowadzono rewizję, nie bardzo szczegółową ale już u bardzo wielu kolegów zabrano\n        sporo rzeczy osobistych, które zdaniem rewidujących nam nie przysługiwały. Około południa uformowano z zatrzymanych\n        i przebywających w stajniach lub na placu kolumnę, w szyku ósemkowym, zostaliśmy otoczeni bardzo silnym i gęstym\n        konwojem wojsk NKWD z bronią skierowaną w naszym kierunku, gotową do strzału.\n      ")])]),_vm._v(" "),_c('b-col',{staticClass:"mb-5",attrs:{"md":"5","order-md":"2","order":"1"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":"/historia/rozbrojenie_aresztowanie_epilog_dokumenty/miejsce_pobytu_rozbrojonych_aresztowanych.jpg"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lead"},[_vm._v("\n        Miejsce pobytu rozbrojonych i aresztowanych oficerów i żołnierzy Armii Krajowej Okręgu Wileńskiego\n        w okresie od 18 do 28 lipca 1944 r. Skąd wywieziono oficerów do obozów w Riazaniu i Diagilewie\n        natomiast żołnierzy początkowo do Kaługi, a następnie do obozów pracy leśnej.\n      ")]),_vm._v(" "),_c('b-img',{staticClass:"mt-5",attrs:{"center":"","fluid":"","src":"/historia/rozbrojenie_aresztowanie_epilog_dokumenty/miedniki_krolewskie.jpg"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lead"},[_vm._v("\n        Miedniki Królewskie. Lipiec 18 - 28.07.1944. Droga pomiędzy byłymi stajniami obecnie miejsca przebywania aresztowanych żołnierzy.\n      ")]),_vm._v(" "),_c('b-img',{staticClass:"mt-5",attrs:{"center":"","fluid":"","src":"/historia/rozbrojenie_aresztowanie_epilog_dokumenty/miedniki_krolewskie2.jpg"}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"lead"},[_vm._v("\n        Miedniki Królewskie. Lipiec 18 - 28.1944r. Grupa aresztowanych żołnierzy Armii Krajowej Okręgu Wileńskiego.\n      ")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',{staticClass:"lead"},[_c('b',[_vm._v("W Miednikach pozostali oficerowie, którzy mieszkali w barakach.")])]),_vm._v(" "),_c('p',[_vm._v("\n        Przed wymarszem dowódca konwoju zapowiedział, że jakiekolwiek oddalenie się z szeregu, będzie uznawane za\n        ucieczkę i do oddalającego będą strzelać. Przemarsz trwał kilka godzin. Całą kolumnę, po godzinie marszu\n        zatrzymywano, bez prawa zmiany miejsca lub oddalenia się. Kolumna dotarła do stacji kolejowej na, której już\n        stały wagony towarowe z za drutowanymi okienkami. Kolumnę tak jak podprowadzano, dzielono odliczając po 45\n        osób do jednego wagonu. Wagony były zupełnie puste, a po władowaniu się 45 ludzi prawie, że nie było miejsca\n        na stanie na obu nogach. Drzwi zostały zasunięte i zamknięte. Pociąg ruszył w nocy z 28 na 29 lipca.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Kierunek nie znany. Następnego dnia pod wieczór pociąg zatrzymał się i do każdego wagonu podano t.zw. suchy prowiant,\n        śledzie i suchary, w jakiejś tam ilości, do podziału między wszystkich. Tak powtarzało się przez całą podróż.\n        Tego rodzaju jedzenie bez wody przy wysokiej temperaturze zewnętrznej, było nie do zniesienia. Za podanie manierki\n        lub menażki wody przez konwojentów, żądali oni zegarka lub butów. Potrzeby fizjologiczne trzeba było załatwiać w\n        wagonie lub przy okazji zatrzymania się pociągu w polu i wypuszczeniu poszczególnymi wagonami, tuż przy wagonach,\n        otoczeni przez konwojentów. Próby ustalenia w jakim kierunku jedzie pociąg, nie dawały żadnego rezultatu, ponieważ\n        trasa prowadziła w różnych kierunkach, północnym, wschodnim, południowym, a nawet bardzo krótko na zachód.\n        Prawdopodobnie tak puszczano pociąg, po wolnych torach. Po drodze na jakiejś stacji zostaliśmy obrzuceni kamieniami,\n        przez ludzi znajdujących się na stacji po otrzymaniu informacji od konwojentów naszych, że konwojują faszystów.\n        Podróż trwała 7 dni.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Rano 5 sierpnia 1944 roku pociąg stanął na jakiejś stacji. Usłyszeliśmy jakiś ruch wokół wagonów rozmowy\n        prowadzone nie tylko przez konwojentów. Rano zaczęto otwierać wagony i rozkazano wysiadać. Kilku dniowa\n        podróż w takich warunkach odbiła się na naszej kondycji fizycznej. Przy formowaniu kolumny marszowej,\n        zgodnie ze zwyczajami sowieckimi ósemkami, często trzeba było, podtrzymywać jeden drugiego.\n        Na czele kolumny pojawiła się orkiestra wojskowa przybyła z miasta i przy dźwiękach marszy, kolumna ruszyła.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Po wprowadzeniu do miasta, na jakimś placu po raz pierwszy zaczęto nas spisywać. Należało podać imię, nazwisko,\n        imię ojca i datę urodzenia. Na podstawie tych danych dawano przydział do poszczególnych grup. Okazało się,\n        że to były przydziały do poszczególnych rodzajów broni. Np. strzelcy, broń przeciw pancernej karabinów maszynowych\n        itd. Rozlokowano nas w różnych częściach miasta Kaługi.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Aby nas zająć już na drugi dzień sformowano nas w dość duże grupy i pod nadzorem uzbrojonych strażników odgruzowywaliśmy\n        miasto, a wydobyte cegły po cztery sztuki kazano przenosić na dość dużą odległość. Były już zorganizowane kuchnie, w\n        których trzy razy dziennie wydawano, głodowe posiłki. Gdzieś po 10 dniach odgruzowywania i noszenia cegieł, którymi\n        koledzy, którzy zgłosili się, że są fachowcami, murarzami, tynkarzami, stolarzami i t p. przebudowywali stajnie lub\n        garaże na koszary, w których mieliśmy mieszkać. Któregoś dnia przyprowadzono nas wszystkich na duży plac, przegrodzony\n        płotem z kolczastego drutu, duży barak przechodził przez ogrodzenie. Wejście było z jednej strony, natomiast wyjście z\n        drugiej. Już byliśmy podzieleni na drużyny, plutony i kompanie. Do baraku wpuszczani plutonami. Wokół zewnętrznego\n        ogrodzenia pojawiły się kobiety Rosjanki, proponujące wymianę posiadanej garderoby i obuwia za dopłatą na łachy, nie\n        nadające się właściwie do noszenia, jednocześnie informując, że i tak w baraku będą zabierać wszystko. Po wejściu,\n        kazano rozebrać się i oddać ubranie do dezynfekcji. W następnym pomieszczeniu siedziało kilka kobiet z maszynkami do\n        strzyżenia włosów i brzytwami do golenia. W pierwszej chwili konsternacja, ale nie wybredne pseudo żarty spowodowały\n        podchodzenie do nich i poddanie się tym fryzjerskim zabiegom.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Okazało się po latach, że to była reguła lagrowa. Kobiety były fryzjerkami dla mężczyzn, natomiast mężczyźni dla kobiet.\n        Jeden ze sposobów poniżenia i załamywania psychicznego. W następnym pomieszczeniu była pseudo łaźnia. Kilkanaście\n        natrysków z zimną wodą. Wydano po kawałku mydła, które w tej wodzie wcale nie mydliło się, natomiast pozostałe\n        gdziekolwiek włosy razem z wodą spływały. W następnym pomieszczeniu, magazynie po podaniu numeru rozmiaru ciała i\n        obuwia, sowiecki Żołnierz wydawał nowe ubranie, bieliznę i obuwie. Jeżeli nie pasowało, należało wymieniać między sobą.\n        Magazynier ani zwrotów ani do wymiany nie przyjmował. Wydane sorty składały się z koszuli, kalesonów, spodni, bluzy,\n        furażerki, onuc i butów. Były to sorty żołnierzy sowieckich. Po wyjściu przez drugie wyjście, ogoleni ze ściętymi\n        włosami na głowie, w sowieckim ubraniu, furażerce nie mogliśmy się rozpoznać. Po powrocie do miejsca zakwaterowania,\n        wydano pościel oraz worki na sienniki, które należało napchać przywiezioną słomą.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Tak rozpoczęła się, przymusowa próba służby w armii sowieckiej. Codzienne ćwiczenia, musztra według regulaminów\n        sowieckich przeplatane tak zwanymi prasówkami i pogadankami propagandy politycznej prowadzonymi przez oficerów\n        politycznych. Zamiast broni wydano drewniane atrapy, z którymi musieliśmy ćwiczyć. Trwało to kilka tygodni.\n        W między czasie zwolniono do domu kobiety nasze sanitariuszki, roczniki 1928 i wyższe.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Pod koniec pierwszego tygodnia miesiąca wrześnie 1944 roku wyprowadzono nas na plac przy koszarowy, na którym w ciągu\n        nocy postawiono podwyższenie z barierką od przodu. Ustawiono wszystkich w czworobok z otwartym bokiem od strony trybuny.\n        Wprowadzono poczet sztandarowy wojsk sowieckich i oficer w randze pułkownika bez wstępu wydał komendę przygotowania się\n        do przysięgi. Trzykrotnie powtarzał pierwsze słowa przysięgi i trzykrotnie martwa cisza z naszej strony.\n        Trudno określić czy to było zaskoczenie czy spodziewana reakcja. Wydano komendę wyprowadzenia sztandaru.\n        Dowódcy poszczególnych kompanii wydali rozkaz powrotu do koszar. Więcej na ćwiczenia już nie wyprowadzano.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Po dwu dniach bezczynności, ponownie zaprowadzono nas do tej samej łaźni. Ubranie należało ułożyć w kostkę i odłożyć na\n        wskazane miejsce. Po przyjściu przez natryski z letnią wodą, ponownie znaleźliśmy się w pomieszczeniu, w którym wydawano odzież.\n        Tym razem była również odzież wojska sowieckiego lecz już bardzo zniszczona, było po upraniu ale to nie dawało wyglądu ubrania\n        czystego.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        10 września 1944 roku po zbiórce wszystkich i wystąpieniu na rozkaz fachowców kilkunastu branż, którzy odmaszerowali do koszar,\n        pozostali pod konwojem zostali wyprowadzeni na stację kolejową, na której przed miesiącem wyładowywaliśmy się. Do podstawionych\n        wagonów towarowych, tym razem plutonami, bo tak nas ustawiono po 45 osób i kazano wsiadać do wagonów. Po paru godzinach pociąg\n        ruszył. Kierunki jazdy były różne w cztery strony świata. W zależności od kierunku jazdy, próbowaliśmy odgadnąć dokąd jedziemy.\n        O istnieniu łagrów wiedzieliśmy, niektórzy z nas i nasze rodziny zostały tym dotknięte i dlatego nawet najbardziej pesymistyczne\n        pogłoski znajdowały posłuch. Po kilku dniach podróży w czasie której na posiłki wydano suchy prowiant, pociąg zatrzymywał się\n        kilkakrotnie i można było wysiadać dla załatwienia potrzeb fizjologicznych.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Wyładowano nas w grupie około 700 osób w lesie przez, który przechodziła jedno torowa linia kolejowa. Po odejściu o\n        kilkanaście metrów od torów przydzieleni dowódcy wojskowi wydali rozkaz dobrania się parami jako pary wspólnie pracujące\n        w lesie przy wyrębie drzewa. Wydano dla każdego siekierę i na parę piłę ręczną. Wydzielono drużynę gospodarczą, kucharzy,\n        a pozostałym polecono budowę szałasów pod którymi będziemy spali. Pobyt nasz według słów i oficerskiego słowa pułkownika,\n        miał trwać sześć tygodni. Trwał do połowy grudnia 1945 roku.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Przez cały czas pobytu w lesie nie otrzymaliśmy nigdy ani sienników, ni koców, spaliśmy w tym w czym chodziliśmy i pracowaliśmy.\n        Ubrania zmieniano dwa razy w ciągu roku. Jesienią na zimowe, wiosną na letnie. Na dwoje ludzi wyznaczono działki w kwadracie o\n        boku ok. 50 mb. Norma dzienna konieczna do wykonania aby dostać posiłek wynosiła u nas 12 metrów przestrzennych. W innych t zw.\n        batalionach w zależności od jakości lasu była inna. Norma wyżywieniowa wg określeń naszych strażników była taka dla wojsk poza\n        liniowych. Wynosiła dziennie 400 gram chleba, pieczonego według receptury znanej tylko piekarzom. Rano miska czegoś co\n        nazywano zupą, ale ją nie było. Po wykonaniu normy obiad, miska zupy o różnej nazwie ale podobnym smaku, przypominającym pomyje,\n        dwie łyżki stołowe gotowanego prosa z jakimś tłuszczem, jadalnym tylko gdy był ciepły jeszcze płynny, po zastygnięciu stawał się\n        nie jadalny, nawet przy bardzo dużym głodzie, a na kolację ponownie miska zupy i co kilka dni po dwie łyżeczki od herbaty cukru.\n        Ponadto raz na 7 dni po dwie garści pokrajanych drobno łodyg tytoniowych, które dało się palić tylko w gazecie.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Aby zarobić na dodatkową porcję chleba tam nazywany \"dopełnitielnyj pajok\" trzeba było wykonać wyznaczoną normę przynajmniej w\n        110 %. Porcje te wydawano okresowo co jakiś czas, dla osób którym udało się uzyskać zaświadczenie o wykonaniu w takim procencie\n        normy. Już temperatura spadła do 5 - 7 stopni poniżej zera, śnieg leżał na stałe, a my spaliśmy na gołej ziemi bez żadnej pościeli\n        lub przykrycia. Wzdłuż szałasu przewidzianego na 150 ludzi, był on o wymiarach 7 na 40 metrów, wysokości przez środek 2,5 metra\n        wykopaliśmy rów ,w którym przez całą noc dyżurny palił niewielki ogień przez całą długość. Dawało to od strony ognia jakieś ciepło,\n        natomiast od drugiej furażerka położona pod głowę przymarzała do ziemi. W połowie października wydano zimowe ubranie również\n        wojskowe, używane, otrzymaliśmy: spodnie watowane, bluzy, bieliznę, kurtki watowane, zimowe czapki t. zw. \"papachy\" oraz „walonki”.\n        Były to filcowe bardzo mocno sprasowane buty, do nich onuce. Jeżeli było sucho to było to bardzo ciepłe obuwie. Gorzej na mokro,\n        bo nasiąkały i waga każdego osiągała do kilku kilogramów, co przy bardzo już wyczerpanych organizmach dawało się odczuwać jak\n        kajdany.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Termin pobytu pierwotnie wyznaczony na sześć tygodni był kilkakrotnie przedłużany. W grudniu 1944 roku pozwolono nam po\n        wykonaniu normy w lesie kopać doły pod ziemianki. Drzewo na budowę trzeba było przynieść na plecach z lasu.\n        Sytuacja była na tyle przymusowa, że dalsze przebywanie w szałasach było nie możliwe. Stworzone przez nadzór NKWD warunki\n        zmusiły nas do takiego wysiłku. Zaczęły się objawiać pierwsze objawy opuchlizny głodowej, owrzodzenia całego ciała,\n        zapalenia płuc itp. Służby sanitarnej nie mieliśmy. Szpital był oddalony o kilkanaście kilometrów. W zasadzie ziemianki\n        były budowane w godzinach nocnych, do robót wykończeniowych jak układanie z przyniesionych przez resztę zatrudnionych\n        żerdzi o średnicy ok. 10 cm, miejsc do spania, korytarza przez środek ziemianki, drzwi itp. wyznaczono oddzielne grupy,\n        które do lasu wycinać nie chodziły. Do ziemianek wprowadziliśmy się w drugiej połowie grudnia 1944 roku.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Po kilku dniach dołączyła do nas grupa pozostawionych w Kałudze fachowców. W ciągu pobytu nauczyliśmy się, a nawet doszliśmy\n        do perfekcji w oszukiwaniu nadzorców przyjmujących codzienną normę. Sprawy te każda para miała opanowane we własnym zakresie,\n        a najwyżej dzieliła się osiągnięciami. Bardzo uciążliwą sprawą stawały się bardzo często, pobudki w nocy, do ładowania wagonów.\n        Wyczerpanie fizyczne ciągłą ponad siły pracą, przy głodowych racjach wyżywieniowych doprowadzała do takiego wycieńczenia organizmów,\n        że nawet sowieccy lekarze dawali zwolnienia od pracy. Ciągła inwigilacja, znikanie po nocy ludzi wzywanych do politruka,\n        beznadziejna sytuacja polegająca na nie określonym przez nikogo okresie pobytu, ciągłe kłamliwe obietnice nadzoru NKWD-owskiego o\n        rychłym powrocie do domu były bardzo demoralizujące i przygnębiające. Zdarzały się samo okaleczenia, na skutek wyczerpania tak\n        fizycznego jak i psychicznego. Z nastaniem wiosny, zaczęły przybierać na sile ucieczki tak pojedyncze jak i grupowe. Według\n        bardzo nie pełnych i nie pewnych danych uciekło z Kaługi, a następnie z obozów leśnych około 250 osób z których tylko bardzo\n        małą część udało się formacjom NKWD złapać.\n      ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Z żołnierzy 7. Brygady uciekli, według wiadomości posiadanych przeze mnie:")]),_vm._v("\n        Jan Czerwiński „Żuk”, Władysław Żukowski \"Jawła\", Anatol Iwanowski \"Budda\", Wiktor Iwanowski „Szpak”, Aleksander Nowoszyński\n        \"Alek\", Józef Garbaczenek \"Wilk\", Eugeniusz Iwaszkiewicz \"Kmicic\" złapany, sądzony i skazany na 8 lat \"łagrów\",\n        Wacław Iwaszkiewicz \"Cichy\" złapany sądzony i skazany na 10 lat \"łagrów\", Apolinary Kozakiewicz \"Grot\", Henryk Piotrowski\n        \"Grom\", Rybiński Kazimierz \"Zawisza\"i Mieczysław Wołodźko \"Róża\".\n      ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("\n          Przez cały okres pobytu byliśmy strzeżeni przez uzbrojonych żołnierzy wojsk NKWD, w czterech obozach,\n          odrutowanych, oddalonych od siebie o ok. 15 km:\n        ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("I batalion w miejscowości Prudy na 48 kilometrze,")]),_vm._v(" "),_c('li',[_vm._v("III i IV bataliony w miejscowości Średniaki na 40 kilometrze,")]),_vm._v(" "),_c('li',[_vm._v("II batalion w miejscowości Maleicha na 28 kilometrze.")])])]),_vm._v(" "),_c('p',[_vm._v("\n        W jakiej formie fizycznej i psychicznej wytrzymywał każdy uwięziony, zależało od wielu czynników. Jak był, przygotowany\n        do pracy fizycznej, jak organizm jego był odporny na nie dożywianie, jak daleko posuwał się w ryzykanckich poczynaniach\n        dla zdobycia żywności, a polegało to na grupowym wyjściu nocą ze strzeżonego obozu, dojścia do najbliższego kołchozu,\n        rozbicia zamknięcia ziemianki w której przechowywano żywność i powrót do obozu w sposób niezauważony przez strażników.\n        To oprócz posiadania kilku kilogramów ziemniaków, dawało jakąś dziwną pewność psychiczną, przeciwstawiania się strażnikom\n        zmuszających nas do wykonania tej niewolniczej normy, od której zależało dostanie posiłku, który nie zaspokoił ciągłego\n        uczucia głodu.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Gehenna ta trwała do połowy grudnia 1945 roku. Kazano zdać narzędzia pracy i przygotować się do odjazdu, do którego\n        byliśmy właściwie gotowi już na drugi dzień po wjeździe z lasu na nasze miejsce przywieziono z wyrokami 5 lat\n        \"łagrów\" oficerów Armii Radzieckiej, którzy po przebytej niewoli w obozach niemieckich zdecydowali się na powrót do\n        swojej Ojczyzny.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Podstawiono wagony osobowe, kolei trans syberyjskiej z przedziałami do leżenia. Po przez Moskwę dojechaliśmy pod\n        Smoleńsk do miejscowości Kirowo i tam w bardzo czystych, odnowionych ziemiankach, po kilku po sobie następujących\n        spisach danych osobowych, zaczęto nas przemundorowywać. Mieliśmy otrzymać przysłane przez Anglików, ich sorty wojskowe.\n        Ale jak to bywa w tym najszczęśliwszym kraju świata, część umundurowania zginęła lub zaginęła. Dostaliśmy częściowo\n        brytyjskie, częściowo sowieckie, ale nowe sorty wojskowe.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Dnia 29 lub 30 grudnia 1945 roku ponownie załadowano nas ale już do pustych wagonów towarowych i ruszyliśmy w stronę\n        Brześcia nad Bugiem, stacji granicznej. Granicę przekroczyliśmy 5 stycznia 1946 roku, po 17 miesiącach przymusowego\n        pobytu na „nieludzkiej ziemi\".\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        W Terespolu oczekiwał nas konwój wojska polskiego, któremu zakazano rozmów z nami. Po dojechaniu do Białej Podlaskiej,\n        wojsko odmaszerowało, pozostawiając nas w wagonach, w których mieliśmy czekać na wydanie dokumentów. Na drugi czy trzeci\n        dzień zaczęto robić nam zdjęcia do dokumentów i sporządzać spisy danych osobowych. Tegoż dnia wydano rozkaz opuszczenia\n        wagonów, które stały się potrzebne dla następnego transportu zwalnianych z łagrów Polaków.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Ogłoszone przez kościół i w szkołach wiadomości o konieczności zapewnienia nam miejsc do zatrzymania się na krótki okres,\n        potrzebny na oczekiwanie na dokumenty, dał nadspodziewane wyniki. Cała ludność Białej Podlaskiej, zgłosiła chęć przyjęcia\n        na ten okres kogoś z powracających żołnierzy Podziemnego Państwa Polskiego Armii Krajowej Okręgu Wileńskiego. Począwszy od\n        12 stycznia zaczęto wydawać dokumenty wystawione przez Ministerstwo Bezpieczeństwa Publicznego w Warszawie stwierdzające,\n        że zostaliśmy zwolnieni i udajemy się do i tutaj wpisywano podaną miejscowość. Dokument nie stwierdza skąd zostaliśmy zwolnieni,\n        po jakim okresie pobytu, za co byliśmy zatrzymani ani na jakiej podstawie. Dla nas powracających wówczas, było to mało ważne,\n        ważniejsze było to że jesteśmy wolni i w Kraju, w Ojczyźnie. Jedną z tych nie zapomnianych chwil pierwszych dni powrotu do\n        Ojczyzny, była zorganizowana w kościele parafialnym na intencję naszego powrotu uroczysta Msza Święta. Po ogłoszeniu tego, a\n        jeszcze mieszkaliśmy w wagonach na stacji kolejowej, uformowaliśmy czwórkami kolumnę marszową. I co najdziwniejsze, pomimo\n        tylokrotnych rewizji, wymiany ubrań, pojawiły się na \"papachach\" polskie orzełki przechowane z naszych partyzanckich czapek i\n        co niektórzy posiadali biało czerwone opaski. Śpiew maszerującej kolumny wojska i to piosenek nie śpiewanych przez Ludowe\n        Wojsko Polskie, a piosenek wojskowych z przed 1939 roku ,wywołał ludność Białej Podlaskiej na ulice.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Uroczysta Msza Święta i patriotyczne kazanie wywołały nie u jednego łzy, nie wiem czy radości czy wzruszenia,\n        czy obu tych uczuć naraz, w każdym razie takich chwil nie zapomina się. Ogólna atmosfera w tamtym czasie, nie\n        ustabilizowana sytuacja polityczna, masowa nagonka na Armię Krajową, której żołnierzami byliśmy, przeżycia obozowe\n        nie sprzyjały możliwościom utrzymywania kontaktów z większą ilością znajomych. Kontakty nasze ograniczały się do\n        rodzinnych lub najbliższych kolegów, znających siebie jeszcze z cywila.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Lata późniejsze jeszcze bardziej oddaliły nas od siebie, podejrzliwość władz, służba w Armii Krajowej stanowiła\n        skazę na naszych życiorysach, to wszystko sprawiło, że dopiero po kilkudziesięciu latach można było spokojnie oddychać,\n        nie nazywano nas oficjalnie \"bandytami\", \"czarną reakcją\" lub innymi epitetami. To również wytworzyło luki w pamięci i\n        sprawiło trudności w odtwarzaniu i opisywaniu tamtych lat, okresu wzniosłych uczuć, czystego patriotyzmu nie skażonego\n        kunktatorstwem, interesowności, wyrachowaniem.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Patriotyzm, poczucie spełnienia obowiązku względem Ojczyzny, walka o jej Niepodległość i Niezawisłość było najważniejsze i\n        dlatego my żyjący pamiętając, że pozostawiliśmy kilka set grobów na Wileńszczyźnie, kilkadziesiąt w głębi ZSRR Kolegów,\n        którzy oddali życie za sprawę, musimy pozostawić prawdziwy obraz naszej działalności. W archiwach pełno tworzonych\n        tendencyjnie dla celów politycznych pod dyktando sowieckie tak o organizacjach jak i szeregowych członkach tych organizacji\n        dokumentów spaczających historię i uwłaczających tym ludziom. Niech to będzie przynajmniej tworzyło równowagę i możliwość\n        porównań dla chcących poznać tamten okres, ówczesnych ludzi, a może swoich przodków.\n      ")]),_vm._v(" "),_c('b',[_c('p',[_vm._v("\n          Aresztowanych żołnierzy załadowano do wagonów towarowych po 45 osób, za drutowano i dnia 28 lipca 1944 roku\n          wywieziono do Kaługi. Po odmowie złożenia przysięgi wojsk radzieckich, ponownie przewieziono do obozów ciężkiej\n          pracy leśnej, przy wyrębie drewna.\n        ")]),_vm._v(" "),_c('p',[_vm._v("Podzielono na 4 obozy usytuowane w okolicach Jegoriewska. ")]),_vm._v(" "),_c('p',[_vm._v("Zwolniono i przewieziono do Kraju w styczniu 1946 roku. ")]),_vm._v(" "),_c('p',[_vm._v("\n          Zwolnienia dokonał Urząd Bezpieczeństwa Publicznego w Białej Podlaskiej, wystawiając odpowiednie zaświadczenia i\n          zakładając specjalną ewidencję.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Natomiast oficerów przewieziono do więzień w Wilnie i po bardzo uciążliwych śledztwach, wywieziono do obozów\n          oficerskich skąd zwalniano małymi grupami dopiero w 1947 roku i później.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Tak zakończył się omawiany opracowaniem okres walki o niepodległość i niezawisłość\n          Ojczyzny w granicach obowiązujących w tamtym okresie.\n        ")]),_vm._v(" "),_c('p',[_vm._v("Walka trwała dalej, powstały Oddziały Samoobrony walczące jeszcze kilka lat. ")]),_vm._v(" "),_c('p',[_vm._v("\n          Represje sowieckie nasilały się coraz bardziej, aresztowania, preparowane sprawy sądowe, wieloletnie wyroki,\n          skazujące na wieloletni pobyt w łagrach, okupiony wyrokami śmierci lub śmiercią z wyniszczenia organizmów .\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Działania zbrojne NKWD na Wileńszczyźnie w drugiej połowie 1944 - 1946 były bezwzględne i polegały na fizycznym\n          likwidowaniu osób narodowości polskiej, określonej w polityce radzieckiej jako element wrogi ustrojowi sowieckiemu.\n        ")])]),_vm._v(" "),_c('b-card',[_c('strong',{staticClass:"text-left"},[_vm._v("\n          1944 lipiec 16, Moskwa. –"),_c('br'),_vm._v("\n          Raport Ł. Berii dla J. Stalina,W. Mołotowa, i A. Antonowa"),_c('br'),_vm._v("\n          o działaniach operacyjno-czekistowskich w Wilnie"),_c('br'),_vm._v("\n          Państwowy Komitet Obrony"),_c('br'),_vm._v("\n          tow. Stalin J. W."),_c('br'),_vm._v("\n          RKL ZSRS tow. Mołotow W. M.."),_c('br'),_vm._v("\n          Sztab Generalny Acz - tow. Antonow"),_c('br'),_vm._v("\n          Ściśle tajne\n        ")]),_vm._v(" "),_c('i',[_c('p',{staticClass:"mt-3"},[_vm._v("\n            Delegowany przez nas do Wilna wraz z grupą pracowników NKWD zastępca Ludowego Komisarza Spraw Wewnętrznych, tow.\n            Sierow informuje co następuje: W celu przeprowadzenia działań operacyjno - czekistowskich wydzielono 19 grup NKWD - NKGB,\n            które od rana 14 lipca przystąpiły do pracy. Ochrona miasta, magazynów i innych obiektów zorganizowana została siłami\n            batalionu wojsk NKWD.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            W ciągu dnia wykryto i skonfiskowano dwa składy z bronią polskiej Armii Krajowej, w których znajdowały się\n            302 niemieckie ciężkie karabiny maszynowe, 152 karabiny i 40 granatów. Broń tą Polacy próbowali wywieźć do\n            swoich Oddziałów do lasu, lecz zostali zatrzymani.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Zorganizowane grupy żołnierzy wojsk NKWD, prowadzą przeczesywanie w celu schwytania ukrywających się Niemców i ich\n            likwidacji. Schwytano żywcem 12 osób, zabito 4 osoby. Do końca dnia w mieście zaprowadzono porządek,\n            ugaszono pożary, wystawiono patrole, sprzątnięto niemieckie trupy.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            W okresie niemieckiej okupacji w rejon Wilna przybył nie legalnie samolotem z Warszawy przedstawiciel t. zw.\n            Londyńskiego Rządu Polskiego w charakterze \"Komendanta Wileńskiego i Nowogródzkiego Okręgów Wojennych\"\n            generał o pseudonimie \"Wilk\" ,według posiadanych danych jego nazwisko brzmi Kasplicki., oprócz \"Wilka\" jest\n            pułkownik \"Szczebic\" /Umbek/ nazywający siebie przedstawicielem polskiego sztabu generalnego. \"Wilk\" i \"Szczernicz\"\n            rozwinęli znaczną działalność w zakresie formowania i kierowania polskimi oddziałami wojskowymi.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Na podstawie oświadczeń wielu oficerów Polskiej Armii Krajowej , którzy zostali przez nas przesłuchani,\n            a także na podstawie osobistych obserwacji formacje te liczą ogółem 30 pojedynczych brygad o liczebności\n            od 300 do 600 osób każda.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Oprócz tego, podczas niemieckiej okupacji istniała w Wilnie polska podziemna organizacja wojskowa, która była\n            zorganizowana w trzech oddziałach. Z tych trzech oddziałów także obecnie istnieją oddział nr 1 o liczebności 1.500\n            osób. Rwa oddziały , według słów szefa sztabu oddziałów, nie istnieją, ponieważ jeden z nich został rozbity przez\n            Niemców w czasie próby opanowania Wilna, a drugi Niemcy rozpędzili w okresie jego organizacji.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Na dzień dzisiejszy w Wilnie znajduje się nie więcej niż 2.000 żołnierzy Polskiej Armii Krajowej, a w powiatach :\n            nowogródzkim /Turkeli , Wołkorabiszki / do 7 - 8.000 osób, Miedniki / Kolonia Górka / do 8.000 osób i wokół Wilna /\n            majątek Wierki Nowe / 3 - 4.000 osób. Ogółem nie więcej niż 25.000 osób.\n            Nasi oficerowie i generałowie byli we wszystkich tych powiatach i widzieli ich rozmieszczenie i liczebność.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Wszyscy polscy żołnierze zorganizowani są w Brygady i uzbrojeni w większości w rosyjskie karabiny i pistolety maszynowe,\n            rewolwery i granaty. .Oprócz tego w Brygadach znajduj a się ciężkie i ręczne karabiny maszynowe, rusznice przeciwpancerne,\n            działa, niemieckie działa samobieżne, a nawet czołgi. / w 2 Brygadzie widzieliśmy 3 czołgi /. Mają także środki\n            transportu - samochody, motocykle, konie.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Polacy zaopatrują się u miejscowej ludności. Przy czym, dowódca 2 Brygady mjr Więgiel oświadczył nam że w\n            tej sprawie ma zgodę gen. majora Armii Czerwonej Biełkina - Gładyszewa / dowódca 277 Dywizji 5 Armii /.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Polacy awanturują się siłą odbierają miejscowej ludności żywność, bydło i konie., oświadczając że idzie to do polskiej armii.\n            Mają miejsca groźby, że jeśli miejscowi mieszkańcy Litwy będą zdawać żywność Armii Czerwonej, to Polacy za to ich ukarają.\n            Wszyscy żołnierze Armii Polskiej umundurowani są w mundury polsko - niemieckie z naramiennikami i naszywkami, w\n            konfederatkach lub pilotkach na głowie, w większość ma znaczek / orzeł / a na rękawie biało - czerwoną opaskę.\n            Na samochodach są biało- żółte kokardy, na domach w których rozlokowani są Polacy również są kokardy.\n            Każdy żołnierz posiada drukowane zaświadczenie, że jest żołnierzem Polskiej Armii Krajowej o należy do określonego oddziału.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Polacy starannie ukrywają swoich dowódców i miejsca ich przebywania.\n            Udało się nam ustalić jedynie dowódców Brygad \"do spraw pilnych, w związku z rozmieszczeniem wojsk Armii Czerwonej w tym\n            rejonie. W związku z tym że dowództwo 3 Frontu Białoruskiego umożliwiło polskim organizacjom wojskowym działanie, Polacy\n            zaczęli stawać się beszczelni. Po oczyszczeniu Wilna z Niemców, na ratuszu miejskim wywieszono flagę sowiecką.\n            Po pewnym czasie poniżej flagi sowieckiej pojawiła się Polska flaga, która od razu co prawda została zdjęta. Wczoraj\n            wieczorem w Wilnie chowano naszych oficerów, którzy zginęli podczas wzięcia Wilna. Nad grobem dowódca pułku powiedział,\n            że zginęli za wyzwolenie litewskiej   stolicy Wilna. Stojący obok dwaj polscy żołnierze zwrócili się do naszego pułkownika\n            Kaprałowa i stwierdzili, że widocznie pułkownik / przemawiający . nie wie, że Wilno nigdy nie było i nie będzie litewskie.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Gdy jednostki Armii Czerwonej znajdowały się na przed polach Wilna, dowódca polskiej 2 Brygady, nawiązał łączność z naszym\n            generałem Biełkjinem-Gładyszewem i zwrócił się z wnioskiem o współdziałanie Polaków przy wzięciu Wilna.\n            Generał Biełkin-Gładyszew napisał do dowódcy Brygady Polaka, oficjalny dokument, w którym wskazuje że \" w sprawie\n            współdziałania jednostek Armii Czerwonej z waszymi jednostkami w opanowaniu Wilna powinniście nawiązać łączność z\n            pułkownikiem Morozowem, który otrzymał instrukcje w tej sprawie. Szczególną uwagę zwróćcie na waszą odsłoniętą lewą\n            flankę, której z północy zagrażają Niemcy\". Po kilku dniach Polak ten zdobył od generała Biełkina oficjalny dokument\n            z wyrażeniem wdzięczności dla Polaków.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Generał Biełkin napisał następująco :\"Ja, generał Biełkin oświadczam, że Polscy żołnierze dobrze bili się o opanowanie Wilna. W imieniu służby wyrażam wdzięczność. Brygada zasłużyła sobie na prawo korzystania ze wszystkich niezbędnych przywilejów\".\n            Wedle Polaków te dwa dokumenty dają im prawo do stwierdzenia, że zajęli Wilno razem z Armią Czerwoną. Faktycznie natomiast\n            sprawa wyglądała taL : \"Generał Wilk\" otrzymał z Warszawy rozkaz zajęcia Wilna przez jednostki Polskiej Armii Krajowej.\n            Skierowała się tam rzeczywiście jedna Brygada, Niemcy ją doszczętnie rozbili i na tym zakończyło się\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            \" Zajmowanie\" Wilna przez Polaków.\n            W chwili obecnej Polacy rozprzestrzeniają pogłoski, ze z Brygad będzie sformowana \"dywizja\" Polska.\n            Ludność /polska/ bardzo życzliwie i przyjaźnie i odnosi się do tych formacji, wiele osób nosi wpięte w klapy biało-żółte\n            kokardki, jako znak polskiego patrioty. Dzisiaj u komendanta miasta zjawił się oficer Polak z prośbą o zgodę na\n            zorganizowanie w Wilnie demonstracji i przemarsz dwóch trzech setek żołnierzy. Myśmy na to nie zezwolili.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Obecnie Polscy prowadzą wzmożoną mobilizację do Armii Krajowej i gromadzą broń. Wczoraj w mieście zatrzymano furmankę z\n            bronią, na której jechał polski żołnierz. Podczas przesłuchania oświadczył, że broń została zebrana u ludności i\n            przeznaczona dla polskich Brygad. Broń skonfiskowano. Oprócz tego, obecność tej \"Polskiej Armii\" dezorientuje miejscową\n            ludność. Wielu ludzi myśli, że jest to Armia Polska Berlinga, a kiedy oficerowie aprowizacyjni z 3 Frontu Białoruskiego\n            przyszli do Oszmiany po żywność mieszkańcy oświadczyli im, że już wszystkie świadczenia obowiązkowe wypełnili dla Armii\n            polskiej Berlinga.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            NKWD ZSRS melduje, że do posiadanych w Wilnie dwóch batalionów wojsk NKWD i jednego pułku, który przybędzie do Wilna\n            jutro 16 lipca, w rejon Wilna przerzucamy dodatkowo jedną dywizję wojsk wewnętrznych NKWD i cztery oddziały wojsk ochrony\n            pogranicza w związku z czym w ciągu najbliższych 4 - 5 dni w rejonie Wilna będą zgrupowane jednostki wojsk NKWD o ogólnej\n            liczebności 12.000 osób. Tow. Sierow otrzymał od nas dodatkowe polecenie udzielenia pomocy dowództwu i Radzie Wojennej\n            Frontu w wykonaniu Dyrektywy Kwatery Głównej Naczelnego Dowództwa Nr 220145 z 14.07. b. R. i zgodnie z tą dyrektywą\n            zabezpieczenia niezbędnych działań czekistowskich.\n          ")])]),_vm._v(" "),_c('strong',{staticClass:"text-left"},[_vm._v("\n          Ludowy Komisarz Spraw Wewnętrznych"),_c('br'),_vm._v("\n          Związku SRS"),_c('br'),_vm._v("\n          Ł. Beria.\n        ")])]),_vm._v(" "),_c('b-card',{staticClass:"mt-5"},[_c('strong',{staticClass:"text-left"},[_vm._v("\n          1944 lipiec 17, Moskwa. -Pismo przewodnie Ł.Berii"),_c('br'),_vm._v("\n          do J.Stalina,W.Mołotowa iA.Antonowa"),_c('br'),_vm._v("\n          przekazujące meldunek"),_c('br'),_vm._v("\n          I.Sierowa i I.Czerniachowskiego"),_c('br'),_vm._v("\n          o aresztowaniu ppłk A.Krzyżanowskiego"),_c('br'),_vm._v("\n          i planie rozbrojenia polskich formacji wojskowych."),_c('br'),_vm._v("\n          Ściśle tajne.\n        ")]),_vm._v(" "),_c('i',[_c('p',{staticClass:"mt-3"},[_vm._v("\n            W dniu dzisiejszym otrzymano od t. t. Czerniachowskiego następującą informację :\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Dzisiaj był wezwany tak zwany gen. mjr \"Wilk\" /Kulczyckij/. Wilkowi oświadczono,\n            że nas interesują miejsca rozlokowania polskich formacji i dlatego byłoby pożądane,\n            by nasi oficerowie je poznali. Wilk wyraził zgodę i podał nam 6 miejscowości, gdzie rozmieszczone są jego pułki i brygady.\n            Prócz tego zainteresowaliśmy się jego składem oficerskim i zaproponowaliśmy zebrać wszystkich dowódców pułków, brygad ich\n            zastępców i szefów sztabów. Na to również \"Wilk\" wyraził zgodę i wydał w tym zakresie odpowiednie rozkazy i przekazał je\n            swojemu oficerowi łącznikowemu, który niezwłocznie wyjechał do swojego sztabu.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Po tym \"Wilk\" został przez nas rozbrojony, a obecny przy tym kapitan - szef sztabu, który jest przedstawicielem Rządu\n            londyńskiego, usiłował chwycić pistolet w celu stawiania oporu, naciągnął kurek, lecz został rozbrojony.\n            Wychodząc z tego, żeśmy otrzymali miejsca rozlokowania polskich formacji, opracowaliśmy następujący plan operacji :\n          ")]),_vm._v(" "),_c('p',[_c('ol',[_c('li',[_vm._v("Do miejsc tych zostali wysłani doświadczeni generałowie i Komisarze bezpieczeństwa Państwowego NKWD, w celu rozpoznania i zgłębienia podejść do Polaków.")]),_vm._v(" "),_c('li',[_vm._v("Jednocześnie do miejsc rozmieszczenia Polaków skierowano formacje 3-go Frontu Białoruskiego wydzielone do rozbrojenia Polaków. ")]),_vm._v(" "),_c('li',[_vm._v("Dzisiaj o godz. 19 do rozbrojenia oficerskiej kadry dowódczej wysłano grupę wojsk pogranicza i pracowników kierowniczek kadry NKWD. ")]),_vm._v(" "),_c('li',[_vm._v("Jutro, 18 lipca, o godz. 4-tej z rana jednostki przeznaczone do rozbrojenia Polaków będą wyprowadzone na pozycje wyjściowe, udziela się im pouczenia i przystąpią do operacji.")])])]),_vm._v(" "),_c('p',[_vm._v("\n            O wynikach operacji będą meldować.\n          ")])])]),_vm._v(" "),_c('b-card',{staticClass:"mt-5"},[_c('strong',{staticClass:"text-left"},[_vm._v("\n          Kopia, maszynopis."),_c('br'),_vm._v("\n          GARF, f. 9401, op. 2, d. 65, 1. 398-399"),_c('br'),_vm._v("\n          Przedruk : NKWD i polskoje podpolje, s. 35-37."),_c('br'),_c('br'),_vm._v("\n\n          1944 lipiec 18.moskwa.-raport Ł.Berii"),_c('br'),_vm._v("\n          dla J.Stalina, W.Mołotowa i A.Antonowa o rezultatach"),_c('br'),_vm._v("\n          operacji rozbrajania oddziałów AK Okręgu Wileńskiego."),_c('br'),_vm._v("\n          Ściśle tajne\n        ")]),_vm._v(" "),_c('i',[_c('p',{staticClass:"mt-3"},[_vm._v("\n            Towarzysz Stalin"),_c('br'),_vm._v("\n            Towarzysz Mołotow"),_c('br'),_vm._v("\n            Towarzysz Antonow.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            W dniu dzisiejszym 18 lipca, od T.T.Sierowa i Czerniakowskiego otrzymano następującą informację:\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Wczoraj o godzinie 20 w rejonie wsi Bogusze zostali zebrani dowódcy brygad i batalionów, rzekomo w celu przeglądu\n            przed dowódcą frontu. Ogółem zebrało się 26 oficerów, w tym 9 dowódców brygad,12 dowódców oddziałów i 5 oficerów\n            sztabowych armii polskiej.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Na nasze polecenie zdania broni oficerowie odpowiedzieli odmową i dopiero po zapowiedzi użycia broni, oficerowie\n            rozbroili się. Ponadto wczoraj zostali zatrzymani: komendant Okręgu Wileńskiego podpułkownik Krzeszowski\n            Lubosław, pseudonim \"Ludwik\", oraz komendant Okręgu Nowogródzkiego pułkownik Szydłowski Adam pseudonim \"Poleszuk\".\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Szydłowski został w maju br. Zrzucony w Warszawie na spadochronie z Włoch z zadaniem zorganizowania polskich partyzantów\n            w okręgu Nowogródzkim. Dzisiaj o świcie przystąpiliśmy do przeczesywania lasów, w których, według naszych danych\n            znajdowali się Polacy. W niektórych miejscach Polaków nie było. Ustalono ze w nocy wymaszerowali w kierunku południowym.\n            Dzięki podjętym krokom Polacy zostali doścignięci i rozbrojeni.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Według stanu na godzinę 16 rozbrojono 3500 osób, w tym 200 oficerów i podoficerów.\n            Podczas rozbrajania skonfiskowano broń: 3000 pistoletów, 300 karabinów maszynowych, 50 cekaemów,15 moździerzy, 7\n            dział lekkich, 12 samochodów i dużą ilość granatów i nabojów.\n            Polskich oficerów szeregowców kieruje się pod konwojem do punktów zbornych, a broń zwożona do magazynów.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Jednostki biorące udział w operacji prowadzą dalsze rozpoznanie, ściganie i rozbrajanie oddziałów polskich.\n            W wyniku przesłuchania dowódców oddziałów i brygad, a także \"komendantów\" Okręgu Wileńskiego i Nowogródzkiego\n            ustalono że ogólna liczba wszystkich żołnierzy tak zwanej Polskiej Armii Krajowej rozlokowanych w strefie 3\n            Frontu Białoruskiego waha się / w granicach / od 8. Do 10 tysięcy.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Ze względu na to że dowództwo \"armii\" zamierzało z tych rozproszonych oddziałów skompletować dwie dywizje\n            uwzględniając dodatkową mobilizację polskiej ludności, w związku z tym rozpuszczono pogłoskę, że w polskiej armii\n            znajduje się ponad 20 tysięcy osób. Podczas przeprowadzania operacji rozbrajania żadnych ekscesów nie było.\n          ")])]),_vm._v(" "),_c('strong',{staticClass:"text-left"},[_vm._v("\n          Ludowy Komisarz Spraw Wewnętrznych"),_c('br'),_vm._v("\n          Związku SRS"),_c('br'),_vm._v("\n          Ł.Beria\n        ")])]),_vm._v(" "),_c('b-card',{staticClass:"mt-5"},[_c('strong',{staticClass:"text-left"},[_vm._v("\n          Kopia maszynopis."),_c('br'),_vm._v("\n          GARF, f. 9401, op. 2, d. 65 l. 398-399."),_c('br'),_vm._v("\n          Przedruk: NKWD polskoje podpolje, s.35-37."),_c('br'),_c('br'),_vm._v("\n\n          1944 lipiec 20. Moskwa - pismo Ł.Berii do J.Stalina"),_c('br'),_vm._v("\n          o przebiegu operacji rozbrajania oddziałów AK."),_c('br'),_vm._v("\n          Nr 778/b\n          Ściśle tajne\n        ")]),_vm._v(" "),_c('i',[_c('p',{staticClass:"mt-3"},[_vm._v("\n            Państwowy Komitet Obrony"),_c('br'),_vm._v("\n            Towarzysz Stalin J. W.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Od t. Sierowa i Czerniachowskiego otrzymano dzisiaj następującą informacje o przebiegu operacji rozbrojenia\n            szeregowych i oficerów Polskiej Armii Krajowej. Ogółem według wstępnych podliczeń, w ciągu dwóch dni operacji\n            rozbrojono ponad 6000 osób. W tym 650 oficerów i podoficerów.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Podczas rozbrajania skonfiskowano 5100 karabinów, 350 pistoletów maszynowych, 230 ręcznych i ciężkich karabinów\n            maszynowych, 12 dział lekkich, 27 samochodów, 7 radiostacji, 350 koni i dużą ilość amunicji. Polscy szeregowi i\n            oficerowie konwojowani są do punktów zbornych.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Według stanu na 20 lipca br. Z godziny 12, w punkcie zbornym w Miednikach znajduje się 4000 osób, pozostali są w drodze.\n            Podczas przeprowadzania operacji niektóre pododdziały Polaków przeszły do lasu, porzuciły broń i rozeszły się do domów,\n            ponieważ większość szeregowych i oficerów tych oddziałów mieszka w województwie wileńskim.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Szacujemy że do domów rozeszło się do 1000 szeregowych z różnych oddziałów. Podjęto kroki w celu zebrania porzuconej broni.\n            Podczas rozbrajania miały miejsce następujące fakty: Po pierwszym dniu operacji niektóre przemieszczające się oddziały\n            polskie dowiedziały się o rozbrajaniu i podjęły decyzję o przejściu w rejon bagien, do tzw. Puszczy Rudnickiej, w pobliże\n            miasteczka Jaszuny, mając nadzieję że nie dotrą tam jednostki wojskowe. Zajęli tam /pozycje/ obronne. 19 lipca przed końcem\n            dnia jednostki 152 rejonu umocnionego i 86 pułku /wojsk ochrony pogranicza/ podeszły pod pozycje Polaków, okrążyły ich i\n            poleciły rozbroić się. Polscy oficerowie początkowo odpowiedzieli odmownie, a następnie zgodzili się i poprosili o zgodę\n            na przenocowanie we wsi. W rezultacie rozbrojono do 1500 osób. Jeden batalion Polaków przeszedł do lasu, na zachód od\n            Jaszun zajął /pozycje/ obronne wzdłuż drogi i odmówił rozbrojenia się. Posłano tam batalion w celu ich rozbrojenia.\n            W pozostałych /przypadkach/ ekscesów nie było. Z reguły grupy 200-300 Polaków rozbrajane były przez 10-15 naszych żołnierzy.\n            Przy tym jako charakterystyczne /należy/ zaznaczyć że absolutna większość szeregowych wyraża chęć wstąpienia do armii\n            polskiej Berlinga.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            W związku z tym, że operacja rozbrajania dobiega końca /pozostały drobne rozproszone grupy i pojedynczy żołnierze/ t.\n            Sierow i Czerniachowski proszą o zgodę na następujące działania:\n            "),_c('ol',[_c('li',[_vm._v("Dopuścić do punktu zbornego Polskiej Armii Krajowej przedstawicieli armii Berlinga, znajdujących się tutaj w celu selekcji /osób/ chcących służyć w armii polskiej spośród szeregowców i podoficerów. ")]),_vm._v(" "),_c('li',[_vm._v("Szeregowców i podoficerów, którzy wyrazili chęć wstąpienia do armii polskiej skierować do pułków zapasowych Głównego Zarządu Formowania w celu następnego wykorzystania ich w jednostkach tyłowych Armii Czerwonej. ")]),_vm._v(" "),_c('li',[_vm._v("Kadrę oficerską, mającą znaczenie NKWD-NKGB i Kontrwywiadu \"Smiersz\". ")]),_vm._v(" "),_c('li',[_vm._v("Pozostałą kadrę oficerską skierować do obozów NKWD, ponieważ w innych warunkach będą się oni zajmować organizowaniem różnych polskich organizacji podziemnych.")])])])]),_vm._v(" "),_c('strong',{staticClass:"text-left"},[_vm._v("\n          Proszę o Wasze wytyczne."),_c('br'),_vm._v("\n          Ludowy Komisarz Spraw Wewnętrznych"),_c('br'),_vm._v("\n          Związku SRS"),_c('br'),_vm._v("\n          Ł.Beria\n        ")])]),_vm._v(" "),_c('b-card',{staticClass:"mt-5"},[_c('strong',{staticClass:"text-left"},[_vm._v("\n          Kopia, maszynopis."),_c('br'),_vm._v("\n          GARF, f. 9401, op. 2, d. 66, l. 11-12."),_c('br'),_vm._v("\n          Notatka szefa KGB ZSSR A. Szelepina dla N. Chruszczowa (9 marca 1959 r.)"),_c('br'),_vm._v("\n          Do Towarzysza Chruszczowa N.S.\n        ")]),_vm._v(" "),_c('i',[_c('p',{staticClass:"mt-3"},[_vm._v("\n            W Komitecie Bezpieczeństwa Państwowego przy Radzie Ministrów ZSSR od 1940 roku przechowywane są akta ewidencyjne\n            i inne materiały dotyczące rozstrzelanych w tymże roku jeńców i internowanych oficerów, żandarmów, policjantów,\n            osadników, obszarników itp. osób z byłej burżuazyjnej Polski. W sumie na podstawie decyzji specjalnej trójki NKWD\n            ZSSR rozstrzelano 21,857 osób, z czego: w Lesie Katyńskim ( obwód Smoleński) 4,421 osób, w obozie Starobielskim w\n            pobliżu Charkowa ~ osób, w obozie Ostaszkowskim (obwód Kaliniński) 6,311 osób i 7.305 osób było rozstrzelanych w\n            innych obozach i więzieniach Zachodniej Ukrainy i Zachodniej Białorusi.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Cała operacja likwidacji wymienionych osób przeprowadzona została na podstawie Decyzji KC KPZR z 5 marca 1940 roku.\n            Wszyscy oni osądzeni zostali na najwyższy wymiar kary na podstawie akt ewidencyjnych zaprowadzonych dla nich jako\n            jeńców wojennych i internowanych w 1939 roku.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Od momentu przeprowadzenia wymienionej operacji, tj. od 1940 roku, żadnych informacji związanych z tą sprawą nikomu nie\n            udzielano i wszystkie akta w liczbie 21,857 przechowywane są w opieczętowanym pomieszczeniu.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Z punktu widzenia Organów Sowieckich wszystkie te akta nie przedstawiają ani operacyjnej, ani historycznej wartości.\n            Wątpliwe jest, by mogły one przedstawiać rzeczywistą wartość dla naszych polskich przyjaciół. Przeciwnie nawet,\n            jakakolwiek nieprzewidziana niedyskrecja może doprowadzić do zdekonspirowania przeprowadzonej operacji, ze wszystkimi\n            niepożądanymi dla naszego państwa następstwami. Tym bardziej, że w stosunku do rozstrzelanych w Lesie Katyńskim\n            funkcjonuje wersja oficjalna, potwierdzona przeprowadzonym z inicjatywy Organów Władzy Sowieckiej w 1944 roku śledztwem\n            Komisji nazywającej się; \"Komisja Specjalna powołana dla ustalenia i zbadania okoliczności rozstrzelania w Lesie Katyńskim\n            przez niemiecko-faszystowskich okupantów jeńców wojennych - polskich oficerów\"5.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Zgodnie z konkluzjami tej komisji, wszyscy zlikwidowani tam Polacy uznani zostali za zlikwidowanych przez niemieckich\n            okupantów. Materiały śledztwa były w tym okresie szeroko komentowanc w prasie sowieckiej i zagranicznej. Konkluzje komisji\n            trwale zapadły w świadomość międzynarodowej społeczności.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            W związku z wyżej powiedzianym wydaje się celowe zniszczenie wszystkich akt ewidencyjnych dotyczących osób rozstrzelanych w\n            1940 roku w ramach wyżej wymienionej operacji.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Dla odpowiedzi na potencjalne pytania po linii KC KPZR bądź Rządu Sowieckiego można pozostawić protokoły posiedzeń\n            trójki NKWD ZSSR, która osądziła wymienione osoby na karę rozstrzelania, i akta dotyczące wykonania decyzji trójki.\n            Objętość tych dokumentów jest niewielka i przechowywać je można w specjalnej teczce.\n          ")])])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Gz1I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rozbrojenie_aresztowanie_epilog_dokumenty_vue__ = __webpack_require__("tUJr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48a67f1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rozbrojenie_aresztowanie_epilog_dokumenty_vue__ = __webpack_require__("GprE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rozbrojenie_aresztowanie_epilog_dokumenty_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48a67f1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rozbrojenie_aresztowanie_epilog_dokumenty_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H1rm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'kontakt',
  data: function data() {
    return {
      karta: {
        lat: 52.2060729,
        lng: 21.015674
      }
    };
  },

  metaInfo: {
    title: 'Kontakt',
    meta: [{ name: 'description', content: 'Administratorem strony jest Fundacja Ośrodka KARTA. Fundacja Ośrodka KARTA ul. Narbutta 29 02-536 Warszawa Tel. (022) 848-07-12' }, { name: 'og:url', content: 'http://akwilno.pl/kontakt' }, { name: 'og:title', content: 'Kontakt' }, { name: 'og:image', content: '/main/menu_logo.png' }, { name: 'og:description', content: 'Administratorem strony jest Fundacja Ośrodka KARTA. Fundacja Ośrodka KARTA ul. Narbutta 29 02-536 Warszawa Tel. (022) 848-07-12' }, { name: 'twitter:url', content: 'http://akwilno.pl/kontakt' }, { name: 'twitter:title', content: 'Kontakt' }, { name: 'witter:image', content: '/main/menu_logo.png' }, { name: 'twitter:description', content: 'Administratorem strony jest Fundacja Ośrodka KARTA. Fundacja Ośrodka KARTA ul. Narbutta 29 02-536 Warszawa Tel. (022) 848-07-12' }]
  }
});

/***/ }),

/***/ "H7H4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HBxM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_historia_js__ = __webpack_require__("RMDY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'historia',
  data: function data() {
    return {
      historiaList: __WEBPACK_IMPORTED_MODULE_0__models_historia_js__["a" /* default */].list
    };
  },
  metaInfo: {
    title: 'Historia AK na Wileńszczyźnie',
    meta: [{ name: 'description', content: 'Historia AK na Wileńszczyźnie w okresach 39\'-41\' oraz 41\'-44\', działalność bojowa oddziałow i brygad, operacja "Ostra Brama"' }, { name: 'og:url', content: 'http://akwilno.pl/historia' }, { name: 'og:title', content: 'Historia AK na Wileńszczyźnie' }, { name: 'og:image', content: '/aktualnosci/relacja_z_obchodow.jpg' }, { name: 'og:description', content: 'Historia AK na Wileńszczyźnie w okresach 39\'-41\' oraz 41\'-44\', działalność bojowa oddziałow i brygad, operacja "Ostra Brama"' }, { name: 'twitter:url', content: 'http://akwilno.pl/historia' }, { name: 'twitter:title', content: 'Historia AK na Wileńszczyźnie' }, { name: 'witter:image', content: '/aktualnosci/relacja_z_obchodow.jpg' }, { name: 'twitter:description', content: 'Historia AK na Wileńszczyźnie w okresach 39\'-41\' oraz 41\'-44\', działalność bojowa oddziałow i brygad, operacja "Ostra Brama"' }]
  }
});

/***/ }),

/***/ "HDn2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  profiles: [{
    id: 0,
    cols: {
      xl: '2',
      lg: '4',
      md: '3',
      sm: '6'
    },
    title: '',
    text: 'Ryszard Andrys-Jankowski „Orlik”, „Jankowski”',
    img: '/srodowiska/okreg_wilenski/ryszard_andrys_jankowski.jpg'
  }, {
    id: 1,
    cols: {
      xl: '2',
      lg: '4',
      md: '3',
      sm: '6'
    },
    title: '',
    text: 'Lech Iwanowski „Lancet”',
    img: '/srodowiska/okreg_wilenski/lech_iwanowski.jpg'
  }, {
    id: 2,
    cols: {
      xl: '2',
      lg: '4',
      md: '3',
      sm: '6'
    },
    title: '',
    text: 'Ludwik Świda „Błysk”',
    img: '/srodowiska/okreg_wilenski/ludwik_swida.jpg'
  }, {
    id: 3,
    cols: {
      xl: '2',
      lg: '4',
      md: '3',
      sm: '6'
    },
    title: '',
    text: 'Henryk Szostakowski „Czekan”',
    img: '/srodowiska/okreg_wilenski/henryk_szostakowski.jpg'
  }, {
    id: 4,
    cols: {
      xl: '2',
      lg: '4',
      md: '3',
      sm: '6'
    },
    title: '',
    text: 'Janusz Bohdanowicz „Czortek”',
    img: '/srodowiska/okreg_wilenski/janusz_bohdanowicz.jpg'
  }],
  videos: [{
    id: 0,
    text: 'Mauzoleum Marszałka i Cmentarz Żołnierski na Rossie Uroczyste poświęcenie dnia 13.07.1993r. (fragment)',
    url: "https://www.youtube.com/embed/RfWuflhQTis"
  }, {
    id: 1,
    text: 'Uroczystości poświęcenia cmentarzy żołnierzy AK nad Naroczą i w Worzianach (fragment)',
    url: "https://www.youtube.com/embed/xAYhDe7v_BE"
  }, {
    id: 2,
    text: 'Relacje żołnierzy podkomendnych płk "Kotwicza" Cmentarz w Surkontach Ostatnia walka oddziałów AK z NKWD',
    url: "https://www.youtube.com/embed/hvdAHRVztQQ"
  }, {
    id: 3,
    text: 'Poświęcenie odbudowanego cmentarza żołnierzy Armii Krajowej w kolonii Wileńskiej 10.07.1993r. (fragment)',
    url: "https://www.youtube.com/embed/8NW6oPl3Egw"
  }, {
    id: 4,
    text: 'Wyświęcenie odbudowanego cmentarza kwatery żołnierzy 7 brygady AK "Wilhelma" (fragment) Skorbuciany Litwa 14 lipca 1991r.',
    url: "https://www.youtube.com/embed/hyIEmZjyQX0"
  }, {
    id: 5,
    text: 'Uroczystości poświęcenia cmentarza 6-tej brygady "Konara" w Koleśnikach dnia 9 lipca 1993r. rejon Soleczniki Litwa (fragment)',
    url: "https://www.youtube.com/embed/VqcXFE0QjPA"
  }, {
    id: 6,
    text: 'Glinciszki koło Podbrzezia - cmentarz 38 mieszkańców Glińczyszek zamordowanych przez policję Litewską z posterunku w Podbrzeziu w dniu 30 czerwca 1944r.',
    url: "https://www.youtube.com/embed/60fmp4MPXeA"
  }],
  carousel: [{
    id: 0,
    title: '',
    text: 'Mauzoleum Marszałka i Cmentarz Żołnierski na Rossie Uroczyste poświęcenie dnia 13.07.1993r. (fragment)',
    img: "/srodowiska/okreg_wilenski/pamiatkowy_ryngraf.jpg"
  }, {
    id: 1,
    title: '',
    text: 'Mauzoleum Marszałka i Cmentarz Żołnierski na Rossie Uroczyste poświęcenie dnia 13.07.1993r. (fragment)',
    img: "/srodowiska/okreg_wilenski/ryngraf_3brygada.jpg"
  }, {
    id: 2,
    title: '',
    text: 'Mauzoleum Marszałka i Cmentarz Żołnierski na Rossie Uroczyste poświęcenie dnia 13.07.1993r. (fragment)',
    img: "/srodowiska/okreg_wilenski/ryngraf_6brygada.jpg"
  }, {
    id: 3,
    title: '',
    text: 'Mauzoleum Marszałka i Cmentarz Żołnierski na Rossie Uroczyste poświęcenie dnia 13.07.1993r. (fragment)',
    img: "/srodowiska/okreg_wilenski/ryngraf_7brygada.jpg"
  }]
});

/***/ }),

/***/ "HO1f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_o_autorze_vue__ = __webpack_require__("mlNU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_157360f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_o_autorze_vue__ = __webpack_require__("YzLN");
function injectStyle (ssrContext) {
  __webpack_require__("FUPz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_o_autorze_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_157360f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_o_autorze_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HPoU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aplayer__ = __webpack_require__("RvFq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aplayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aplayer__);
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        narrow: {
            type: Boolean,
            default: false
        },
        autoplay: {
            type: Boolean,
            default: false
        },
        showlrc: {
            type: Number,
            default: 0
        },
        mutex: {
            type: Boolean,
            default: false
        },
        theme: {
            type: String,
            default: '#b7daff'
        },
        mode: {
            type: String,
            default: 'circulation'
        },
        preload: {
            type: String,
            default: 'auto'
        },
        listmaxheight: String,
        music: {
            type: [Object, Array],
            required: true,
            validator: function validator(value) {
                var songs = void 0;
                if (!(value instanceof Array)) {
                    songs = [value];
                } else {
                    songs = value;
                }
                for (var i = 0; i < songs.length; i++) {
                    var song = songs[i];
                    if (!song.url || !song.title || !song.author) {
                        song.title = song.title || 'Untitled';
                        song.author = song.author || 'Unknown';
                        return false;
                    }
                }
                return true;
            }
        }
    },
    data: function data() {
        return {
            control: null
        };
    },

    watch: {
        music: function music(_music) {
            this.control.option.music = _music;
            this.control.setMusic(0);
            if (this.autoplay) {
                this.control.play();
            }
            this.$emit('change', _music);
        }
    },
    mounted: function mounted() {
        var _this = this;

        var player = this.control = new __WEBPACK_IMPORTED_MODULE_0_aplayer___default.a({
            element: this.$el,
            narrow: this.narrow,
            autoplay: this.autoplay,
            showlrc: this.showlrc,
            mutex: this.mutex,
            theme: this.theme,
            preload: this.preload,
            mode: this.mode,
            listmaxheight: this.listmaxheight,
            music: this.music
        });
        player.on('play', function () {
            _this.$emit('play');
        });
        player.on('pause', function () {
            _this.$emit('pause');
        });
        player.on('canplay', function () {
            _this.$emit('canplay');
        });
        player.on('playing', function () {
            _this.$emit('playing');
        });
        player.on('ended', function () {
            _this.$emit('ended');
        });
        player.on('error', function () {
            _this.$emit('error');
        });
    }
});

/***/ }),

/***/ "HUt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__("fcFS");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("PKAF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I6Bx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_aktualnosci_zawiesz_posw_votum_js__ = __webpack_require__("1LwG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'zawiesz_posw_votum',
  data: function data() {
    return {
      carousels: __WEBPACK_IMPORTED_MODULE_0__models_aktualnosci_zawiesz_posw_votum_js__["a" /* default */].carousel
    };
  },
  metaInfo: {
    title: 'Zawieszenie i poświęcenie votum ryngrafów Armii Krajowej w Kościołach na Litwie',
    meta: [{ name: 'description', content: 'W kwietniu 2011r. Prezes Okręgu Wileńskiego Światowego Związku Żołnierzy Armii Krajowej – Janusz Bohdanowicz – wziął udział w uroczystości poświęcenia nowej dzwonnicy przy kaplicy w Skorbucianach koło Wilna, gdzie znajduje się cmentarz żołnierzy 7 Wileńskiej Brygady AK, poległych w czasie II Wojny Światowej.' }, { name: 'og:url', content: 'http://akwilno.pl/zawiesz_posw_votum' }, { name: 'og:title', content: 'Zawieszenie i poświęcenie votum ryngrafów Armii Krajowej w Kościołach na Litwie' }, { name: 'og:image', content: '/aktualnosci/zawiesz_posw_votum/zawiesz_posw_votum_foto_1.jpg' }, { name: 'og:description', content: 'W kwietniu 2011r. Prezes Okręgu Wileńskiego Światowego Związku Żołnierzy Armii Krajowej – Janusz Bohdanowicz – wziął udział w uroczystości poświęcenia nowej dzwonnicy przy kaplicy w Skorbucianach koło Wilna, gdzie znajduje się cmentarz żołnierzy 7 Wileńskiej Brygady AK, poległych w czasie II Wojny Światowej.' }, { name: 'twitter:url', content: 'http://akwilno.pl/zawiesz_posw_votum' }, { name: 'twitter:title', content: 'Zawieszenie i poświęcenie votum ryngrafów Armii Krajowej w Kościołach na Litwie' }, { name: 'witter:image', content: '/aktualnosci/zawiesz_posw_votum/zawiesz_posw_votum_foto_1.jpg' }, { name: 'twitter:description', content: 'W kwietniu 2011r. Prezes Okręgu Wileńskiego Światowego Związku Żołnierzy Armii Krajowej – Janusz Bohdanowicz – wziął udział w uroczystości poświęcenia nowej dzwonnicy przy kaplicy w Skorbucianach koło Wilna, gdzie znajduje się cmentarz żołnierzy 7 Wileńskiej Brygady AK, poległych w czasie II Wojny Światowej.' }]
  }
});

/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__("aPSQ");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("rrPM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JDVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__("kJiG");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("nHb0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KV9B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'odzn_gen_krzyzanowski',
  metaInfo: {
    title: 'Odznaczenie dla Generała A. Krzyżanowskiego "Wilka"',
    meta: [{ name: 'description', content: 'Żołnierze Armii Krajowej Okręgu Wileńskiego i Nowogródzkiego na spotkaniu u Prezydenta Rzeczpospolitej dla wręczenia po śmierci odznaczenia dla gen. A. Krzyżanowskiego "Wilka" Warszawa 17.09.2012' }, { name: 'og:url', content: 'http://akwilno.pl/odzn_gen_krzyzanowski' }, { name: 'og:title', content: 'Odznaczenie dla Generała A. Krzyżanowskiego "Wilka"' }, { name: 'og:image', content: '/aktualnosci/odzn_gen_krzyzanowski.jpg' }, { name: 'og:description', content: 'Żołnierze Armii Krajowej Okręgu Wileńskiego i Nowogródzkiego na spotkaniu u Prezydenta Rzeczpospolitej dla wręczenia po śmierci odznaczenia dla gen. A. Krzyżanowskiego "Wilka" Warszawa 17.09.2012' }, { name: 'twitter:url', content: 'http://akwilno.pl/odzn_gen_krzyzanowski' }, { name: 'twitter:title', content: 'Odznaczenie dla Generała A. Krzyżanowskiego "Wilka"' }, { name: 'witter:image', content: '/aktualnosci/odzn_gen_krzyzanowski.jpg' }, { name: 'twitter:description', content: 'Żołnierze Armii Krajowej Okręgu Wileńskiego i Nowogródzkiego na spotkaniu u Prezydenta Rzeczpospolitej dla wręczenia po śmierci odznaczenia dla gen. A. Krzyżanowskiego "Wilka" Warszawa 17.09.2012' }]
  }
});

/***/ }),

/***/ "Ks7a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_odzn_gen_krzyzanowski_vue__ = __webpack_require__("KV9B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aa1e794_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_odzn_gen_krzyzanowski_vue__ = __webpack_require__("LJeF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_odzn_gen_krzyzanowski_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aa1e794_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_odzn_gen_krzyzanowski_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LJeF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Odznaczenie dla Generała A. Krzyżanowskiego \"Wilka\"")]),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6","order-md":"1","order":"2"}},[_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":"https://www.youtube.com/embed/0bA96iGL1Jw","allowfullscreen":""}})],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","order-md":"2","order":"1"}},[_c('p',{staticClass:"lead"},[_vm._v("\n        Żołnierze Armii Krajowej Okręgu Wileńskiego i Nowogródzkiego na spotkaniu u Prezydenta Rzeczpospolitej dla\n        wręczenia po śmierci odznaczenia dla gen. A. Krzyżanowskiego \"Wilka\""),_c('br'),_vm._v(" "),_c('i',[_vm._v("Warszawa 17.09.2012")])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6640cd21_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("oTbp");
function injectStyle (ssrContext) {
  __webpack_require__("r4EB")
  __webpack_require__("XYbA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6640cd21"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6640cd21_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MABx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_srodowiska_vue__ = __webpack_require__("eI7/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6b74a96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_srodowiska_vue__ = __webpack_require__("xNNT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_srodowiska_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6b74a96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_srodowiska_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mcx+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  srodowiska: [{
    id: 0,
    title: 'Okręg Wileński Polskiego Państwa Podziemnego',
    text: 'W roku 1970 Edward Gierek objął najwyższe stanowisko Władz partyjnych w Kraju i jednocześnie zostały bardzo złagodzone inwigilacje, aresztowania i represje stosowane przez Służby Bezpieczeństwa do żołnierzy Armii Krajowej Okręgu Wileńskiego',
    url: "/srodowiska/okreg_wilenski",
    img: '/srodowiska/okreg_wilenski.jpg'
  }, {
    id: 1,
    title: 'Środowisko Wileńskie w Gdańsku',
    text: 'Po zarejestrowaniu w 1990 r. Światowego Związku Żołnierzy Armii Krajowej - jako samodzielnej organizacji kombatanckiej - ukształtowała się w Gdańsku jego komórka pod nazwą: "Środowisko Wileńskie w Gdańsku"',
    url: "/srodowiska/srod_gdansk",
    img: '/srodowiska/srod_gdansk.jpg'
  }, {
    id: 2,
    title: 'Środowisko Wileńskie w Warszawie',
    text: 'W latach 1981-1983 kol. Ryszard Andrys-Jankowski w porozumieniu z Radą Starszych Okręgu Wileńskiego (organizacją nie formalną) rozpoczął starania u Władz Administracyjnych RP i w Zarządzie Głównym ZBoWiD zarejestrowania Klubu Żołnierzy Armii Krajowej',
    url: "/srodowiska/srod_warszawa",
    img: '/srodowiska/srod_warszawa.jpg'
  }]
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__, {
  load: {
    key: 'AIzaSyC5BNrRl02UO6sCcXMHzd-EIaLfnfWBEio'
  }
});


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: 'UA-87579118-1',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
});



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_9_vue_awesome_components_Icon__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
  //document.title = to.meta.title
  next();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
  mounted: function mounted() {
    window.scrollTo({ top: 0, left: 0 });
    //window.scrollTo({top: 0, left: 0,  behavior: 'smooth'})
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),

/***/ "NV6A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_srodowiska_srod_gdansk_js__ = __webpack_require__("Rc04");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'srod_gdansk',
  data: function data() {
    return {
      srod_gdansk: __WEBPACK_IMPORTED_MODULE_0__models_srodowiska_srod_gdansk_js__["a" /* default */]
    };
  },
  metaInfo: {
    title: 'Środowisko Wileńskie w Gdańsku',
    meta: [{ name: 'description', content: 'Po zarejestrowaniu w 1990 r. Światowego Związku Żołnierzy Armii Krajowej - jako samodzielnej organizacji kombatanckiej - ukształtowała się w Gdańsku jego komórka pod nazwą: "Środowisko Wileńskie w Gdańsku".' }, { name: 'og:url', content: 'http://akwilno.pl/srodowiska/srod_gdansk' }, { name: 'og:title', content: 'Środowisko Wileńskie w Gdańsku' }, { name: 'og:image', content: '/srodowiska/srod_gdansk.jpg' }, { name: 'og:description', content: 'Po zarejestrowaniu w 1990 r. Światowego Związku Żołnierzy Armii Krajowej - jako samodzielnej organizacji kombatanckiej - ukształtowała się w Gdańsku jego komórka pod nazwą: "Środowisko Wileńskie w Gdańsku".' }, { name: 'twitter:url', content: 'http://akwilno.pl/srodowiska/srod_gdansk' }, { name: 'twitter:title', content: 'Środowisko Wileńskie w Gdańsku' }, { name: 'witter:image', content: '/srodowiska/srod_gdansk.jpg' }, { name: 'twitter:description', content: 'Po zarejestrowaniu w 1990 r. Światowego Związku Żołnierzy Armii Krajowej - jako samodzielnej organizacji kombatanckiej - ukształtowała się w Gdańsku jego komórka pod nazwą: "Środowisko Wileńskie w Gdańsku".' }]
  }
});

/***/ }),

/***/ "Nf/c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Spuścizna Jana Gozdawy-Gołębiowskiego udostępniona w OSA")]),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"7","cols":"11","order-lg":"1","order":"2"}},[_c('p',[_vm._v("\n        Zakończyliśmy realizację projektu obejmującego opracowanie, digitalizację i upowszechnienie kolekcji osobistej Jana Gozdawy-Gołębiowskiego (1925 – 2013). W jej skład wchodzą materiały dotyczące życia Jana Gozdawy-Gołębiowskiego, jego braci, również żołnierzy AK oraz materiały dokumentujące działania Armii Krajowej na terenie Obszaru Warszawskiego.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Spuścizna została zinwentaryzowana w Otwartym Systemie Archiwizacji (OSA: "),_c('a',{attrs:{"href":"https://osa.archiwa.org/"}},[_vm._v("https://osa.archiwa.org/")]),_vm._v("). Można ją przeszukiwać przy użyciu wyszukiwarki.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Inwentarz dostępny jest "),_c('a',{attrs:{"href":"https://karta.org.pl/sites/default/files/attachments/inwentarz_kolekcji_jana_gozdawy-golebiowskiego.pdf"}},[_vm._v("tutaj")]),_vm._v(", a z oryginałami można zapoznać w Archiwum Ośrodka KARTA.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Zadanie publiczne: \"Opracowanie, digitalizacja i upowszechnienie kolekcji osobistej Jana Gozdawy-Gołębiowskiego - podchorążego w 2. Plutonie Kompanii Sztabowej Obszaru Warszawskiego AK \"Koszta\" jest współfinansowane ze środków otrzymanych od Urzędu do Spraw Kombatantów i Osób Represjonowanych.\n      ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-img',{attrs:{"fluid":"","src":"/aktualnosci/logo_UDSKiOR_male.jpg"}})],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"5","order-lg":"2","order":"1"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":"/aktualnosci/spuscizna_jana_gozdawy_golebiowskiego.jpg"}}),_c('br')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Nk69":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Nzle":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-4"},[_vm._v("Uroczystości w Wilnie i zbiórka darów na rzecz żołnierzy AK z Kresów Wschodnich organizowane przez Stowarzyszenie Łagierników Żołnierzy AK")]),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',{staticClass:"lead"},[_c('b',[_vm._v("\n        PROGRAM OBCHODÓW UROCZYSTOŚCI POŚWIĘCONYCH 70 ROCZNICY\n        WYBUCHU POWSTANIA WILEŃSKIEGO – OPERACJI WOJSKOWEJ „OSTRA BRAMA” – 7 LIPCA\n        ")])])])],1),_vm._v(" "),_c('b-button',{staticClass:"btn-white-space",attrs:{"target":"_blank","href":"http://armiakrajowa-lagiernicy.pl/uroczystosci-poswiecone-69-rocznicy-wybuchu-powstania-wilenskiego-operacji-wojskowej-ostra-brama-wilno-07-lipca-2013r/"}},[_vm._v("\n    Uroczystości poświęcone 70 rocznicy wybuchu Powstania Wileńskiego- operacji Wojskowej „Ostra Brama” Wilno – 07 lipca 2014r.\n  ")]),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{attrs:{"cols":"11"}},[_c('p',[_vm._v("\n        Stowarzyszenie Łagierników Żołnierzy Armii Krajowejwspólnie z Urzędem do Spraw Kombatantów i Osób Represjonowanych przy\n        wsparciu Ministerstwa Spraw Zagranicznych, a także z udziałem Światowego Związku Żołnierzy AK Okręgu Wileńskiego oraz\n        Nowogródzkiego organizuje Uroczystości w dniach od 5 do 8 lipca poświęcone 70 rocznicy operacji Wojskowej „Ostra Brama” w\n        Wilnie.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        W obchodach wezmą udział kombatanci – żołnierze Armii Krajowej zPolski, Białorusi i Litwy oraz członkowie Stowarzyszenia,\n        nauczyciele wraz zuczniami i harcerzami z patriotycznych szkół w Bujwidzach, Wojdatach, Soleczniakach, Wilnie, Sejnach,\n        Suwałkach, Augustowie, Białymstoku, Warszawie, Wołominie i Krakowie.\n      ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("\n          Przybędziemy na Uroczystości pamięci narodowej na cmentarz w Wilnie 7 lipca do sanktuarium „Na Rossie” w 70\n          rocznicę wybuchu Powstania Wileńskiego – Operacji „Ostra Brama”, która została zaplanowana w ramach ogólnopolskiej\n          „Akcji Burza”, gdzie w dniach od 7 do 13 lipca 1944r stoczyły chwalebny bój z okupantem niemieckim oddziały Armii Krajowej\n          pod dowództwem płk Aleksandra Krzyżanowskiego „Wilka”, dowódcy Okręgu Wileńskiego „Wiano”.\n        ")])]),_vm._v(" "),_c('p',[_vm._v("\n        Przewidziano zakwaterowanie, wyżywienie i transport dla 120 osób, które zostaną przywiezione do Wilnatrzema\n        autokarami i w tym 2 busami z 15 kombatantami z Białorusi.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Wyjazd wszystkich uczestników do Wilna nastąpi w dniu 05 lipca 2014 r. o godz. 8:00 (sobota) z dworca\n        centralnego w Warszawie przy ul Emilii Plater, azakwaterowanie odbędzie się w hoteluCORNER w Wilnie, przy\n        ul. Sevcenkos 16, Wilno 3111. Dzielnica: Stare Miasto. Przywitanie przybyłych gości przez Zarząd Główny w\n        miejscu zakwaterowania w hoteluCornero godz. 17:30, godz. 18:30 uroczysta kolacja w restauracji hotelu.\n        Wieczór wspomnień z udziałem uczestników Akcji „Ostra Brama” żołnierzy AK w sali gościnnej w miejscu zakwaterowania\n        godz. 19:30-22:00\n      ")]),_vm._v(" "),_c('p',{staticClass:"display-4"},[_vm._v("Dzień I Obchodów")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Niedziela, 06.07.2014 r.")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"10"}},[_c('ul',[_c('li',[_c('p',[_vm._v("7:30-8:30 - śniadanie")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("\n              10:00 - Msza Św. w Kościele Ojców Franciszkanów przy ul. Trockiej modlitwa za zmarłych\n              żołnierzy AK z okręgu Wileńskiego i Nowogródzkiego poległych podczas zdobywania Wilna.\n              ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("\n              12:00 – Główna Uroczystość poświęcona pamięci Powstaniu Wileńskiemu na cmentarzu\n              „Na Rossie” z udziałem przedstawicieli władz RP\n              ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("14:00-15:00 - obiad w Domu Polskim")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("\n              16:00 - dalszy ciąg Uroczystości rocznicowych w Domu Polskim w Wilnie, w ramach którego\n              przewidziano wystąpienia, prelekcje oraz montaż teatralno-muzyczny, którego charakter będzie nawiązywał do wydarzeń\n              z Powstania Wileńskiego\n              ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("19:00-20:00 - uroczysta kolacja przy muzyce w Domu Polskim w Wilnie")])])])])],1),_vm._v(" "),_c('p',{staticClass:"display-4"},[_vm._v("Dzień II Obchodów")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Poniedziałek, 07.07.2014 r.")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"10"}},[_c('ul',[_c('li',[_c('p',[_vm._v("7:30-8:30 - śniadanie")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("\n                10:00 złożenie przez środowiska kombatanckie oraz zaproszonych gości wieńców i\n                zapalenie zniczy poległym żołnierzom AK w podwileńskich Krawczunach w 70 rocznicę bitwy stoczonej 13 lipca 1944 roku z wojskami\n                niemieckimi dowodzonymi przez gen. Stahela. modlitwa za zmarłych żołnierzy AK z okręgu Wileńskiego i Nowogródzkiego poległych podczas zdobywania Wilna.\n              ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("\n              12:00 – złożenie wiązanek i zapalenie zniczy w Kalwarii Wileńskiej\n              ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("14:00 - uroczysty obiad")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("\n              16:00 - przyjazd do kaplicy w Ostrej Bramie z łaskami słynącym obrazem Najświętszej\n              Maryi Panny Matki Miłosierdzia- wspólna modlitwa za dusze poległych w boju żołnierzy Armii Krajowej\n              ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("17:00 - przyjazd doKościóła św. Piotra i Pawła na Antokolu")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("18:30 - kolacja pożegnalna przy muzyce")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("20:00 - zapalenie zniczy w Kolonii Wileńskiejna grobach poległych żołnierzy AK\n              w szturmie na Wilno przez młodzież z Polski i Litwy")])])])])],1),_vm._v(" "),_c('p',{staticClass:"display-4"},[_vm._v("Dzień III Obchodów")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Wtorek, 08.07.2014 r.")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"10"}},[_c('ul',[_c('li',[_c('p',[_vm._v("7:30-8:30 - śniadanie")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("\n                09:30 modlitwa, a następnie złożenie hołdu pamięci i zapalenie zniczy pomordowanym w\n                Ponarach kilku tysiącom Polaków oraz ponad 80 tysięcy obywateli narodowości żydowskiej i\n                pochodzenia innych narodowości przez okupanta niemieckiego\n              ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("\n                10:30 - autokary po Uroczystości składania wieńców w Ponarach\n                odwożą uczestników do Sejn, Białegostoku i Warszawy\n              ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("10:30 - wyjazd busaz kombatantami do Lidy na Białoruś")])])])])],1),_vm._v(" "),_c('b-card',{staticClass:"text-left"},[_c('strong',[_vm._v("Zarząd Stowarzyszenia")]),_vm._v(" "),_c('p',[_vm._v("\n          Andrzej Siedlecki – Prezes"),_c('br'),_vm._v("\n          Artur Kondrat – Wiceprezes"),_c('br'),_vm._v("\n          Tel: 505-047-488\n        ")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O0jz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OsWC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zawiesz_posw_votum_vue__ = __webpack_require__("I6Bx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6da6152d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zawiesz_posw_votum_vue__ = __webpack_require__("aPm1");
function injectStyle (ssrContext) {
  __webpack_require__("gT/o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zawiesz_posw_votum_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6da6152d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zawiesz_posw_votum_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Otsa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  tables: {
    bialystok: {
      id: 0,
      city: 'Białystok',
      carousel: [{
        id: 0,
        title: '',
        text: 'Białystok ul. Kilińskiego. Pomnik z tablicami.',
        img: "/historia/tablice_epitafijne/bialystok_kilinskiego.jpg"
      }]
    },
    gdansk: {
      id: 1,
      city: 'Gdańsk',
      carousel: [{
        id: 0,
        title: '',
        text: 'Gdańsk. Bazylika Mariacka. Tablica epitafijna 3. Brygady „Szczerbca”.',
        img: "/historia/tablice_epitafijne/gdansk_mariacka1.jpg"
      }, {
        id: 1,
        title: '',
        text: 'Gdańsk. Bazylika Mariacka. Tablica epitafijna 6. Brygady „Tońki” i „Konara”.',
        img: "/historia/tablice_epitafijne/gdansk_mariacka2.jpg"
      }, {
        id: 2,
        title: '',
        text: 'Gdańsk. Bazylika Mariacka. Tablica epitafijna ORKO.',
        img: "/historia/tablice_epitafijne/gdansk_mariacka3.jpg"
      }, {
        id: 3,
        title: '',
        text: 'Gdańsk. Bazylika Mariacka. Tablica epitafijna 7. Brygady „Wilhelma”.',
        img: "/historia/tablice_epitafijne/gdansk_mariacka4.jpg"
      }, {
        id: 4,
        title: '',
        text: 'Gdańsk. Bazylika Mariacka. Tablica epitafijna Garnizonu miasta Wilna.',
        img: "/historia/tablice_epitafijne/gdansk_mariacka5.jpg"
      }, {
        id: 5,
        title: '',
        text: 'Gdańsk. Bazylika Mariacka. Tablica epitafijna Ośrodka Mobilizacyjnego Okręgu Wileńskiego Armii Krajowej.',
        img: "/historia/tablice_epitafijne/gdansk_mariacka6.jpg"
      }, {
        id: 6,
        title: '',
        text: 'Gdańsk. Bazylika Mariacka. Tablica epitafijna 8. Brygady „Tura”.',
        img: "/historia/tablice_epitafijne/gdansk_mariacka7.jpg"
      }, {
        id: 7,
        title: '',
        text: 'Gdańsk. Bazylika Mariacka. Tablica epitafijna „Inki”.',
        img: "/historia/tablice_epitafijne/gdansk_mariacka8.jpg"
      }, {
        id: 8,
        title: '',
        text: 'Gdańsk. Bazylika Mariacka. Tablica epitafijna Pomordowanym w Ponarach k/Wilna.',
        img: "/historia/tablice_epitafijne/gdansk_mariacka9.jpg"
      }, {
        id: 9,
        title: '',
        text: 'Gdańsk. Bazylika Mariacka. Kaplica Matki Boskiej Ostrobramskiej.',
        img: "/historia/tablice_epitafijne/gdansk_mariacka10.jpg"
      }, {
        id: 10,
        title: '',
        text: 'Gdańsk. Kościół p.w. Św. Brygidy. Tablica epitafijna Oddziałów bojowych Okręgów Wileńskiego i Nowogródzkiego.',
        img: "/historia/tablice_epitafijne/gdansk_mariacka11.jpg"
      }, {
        id: 11,
        title: '',
        text: 'Gdańsk. Kościół p.w. Św. Brygidy. Tablica epitafijna mjr „Łupaszko”.',
        img: "/historia/tablice_epitafijne/gdansk_mariacka12.jpg"
      }, {
        id: 12,
        title: '',
        text: 'Gdańsk. Kościół p.w. Św. Brygidy. Tablica epitafijna Żołnierzom Oddziału „Kmicica” oraz Brygad „Łupaszki” i „Ronina”.',
        img: "/historia/tablice_epitafijne/gdansk_mariacka13.jpg"
      }]
    },
    krakow: {
      id: 2,
      city: 'Kraków',
      carousel: [{
        id: 0,
        title: '',
        text: 'Kraków. Kościół p/WSW. Jadwigi Królowej.',
        img: "/historia/tablice_epitafijne/krakow_1.jpg"
      }, {
        id: 1,
        title: '',
        text: 'Kraków. Kościół p/WSW. Jadwigi Królowej.',
        img: "/historia/tablice_epitafijne/krakow_2.jpg"
      }, {
        id: 2,
        title: '',
        text: 'Tablica upamiętniająca „wartę wileńską” ul. Loretańska 11, krużganki loretańskie kościoła OO. Kapucynów.',
        img: "/historia/tablice_epitafijne/krakow_3.jpg"
      }, {
        id: 3,
        title: '',
        text: 'Tablica upamiętniająca 8. Brygadę „Tura”.',
        img: "/historia/tablice_epitafijne/krakow_4.jpg"
      }]
    },
    lodz: {
      id: 3,
      city: 'Łódź',
      carousel: [{
        id: 0,
        title: '',
        text: 'Łódź ul. Św. Jerzego 9. Kościół Garnizonowy p.w. Św. Jerzego. Tablicę projektował: Modest Bobowicz „Wilcz” i Eugeniusz Czerniawski żołnierze AK Okręg Nowogródzki i Wileński.',
        img: "/historia/tablice_epitafijne/lodz_1.jpg"
      }, {
        id: 1,
        title: '',
        text: 'Łódź ul. Retkińska 127. Kościół p.w. Najświętszego Serca Jezusowego. Tablicę projektował i ufundował płk Edward Stefanowicz AK Wilno.',
        img: "/historia/tablice_epitafijne/lodz_2.jpg"
      }, {
        id: 2,
        title: '',
        text: 'Łódź ul. Retkińska 127. Kościół p.w. Najświętszego Serca Jezusowego. Tablicę projektował i ufundował płk Edward Stefanowicz AK Wilno.',
        img: "/historia/tablice_epitafijne/lodz_3.jpg"
      }, {
        id: 3,
        title: '',
        text: 'Łódź ul. Kopcińskiego 1/3. Kościół p.w. Św. Teresy. Komendantowi i żołnierzom 23. Brygady.',
        img: "/historia/tablice_epitafijne/lodz_4.jpg"
      }, {
        id: 4,
        title: '',
        text: 'Łódź ul. Kopcińskiego1/3. Kościół p.w. Św. Teresy.',
        img: "/historia/tablice_epitafijne/lodz_5.jpg"
      }, {
        id: 5,
        title: '',
        text: 'Łódź ul. Kopcińskiego1/3. Kościół p.w. Św. Teresy.',
        img: "/historia/tablice_epitafijne/lodz_6.jpg"
      }, {
        id: 6,
        title: '',
        text: 'Łódź ul. Sienkiewicza 60. Kościół p.w. Najświętszego Imienia Jezus..',
        img: "/historia/tablice_epitafijne/lodz_7.jpg"
      }]
    },
    olsztyn: {
      id: 4,
      city: 'Olsztyn',
      carousel: [{
        id: 0,
        title: '',
        text: 'Olsztyn. Kościół Najświętszego Serca Jezusa. Tablica żołnierzom „Kmicica”.',
        img: "/historia/tablice_epitafijne/olsztyn_1.jpg"
      }, {
        id: 1,
        title: '',
        text: 'Olsztyn. Kościół Najświętszego Serca Jezusa. Tablica 6. Brygady.',
        img: "/historia/tablice_epitafijne/olsztyn_2.jpg"
      }, {
        id: 2,
        title: '',
        text: 'Zimna Woda k/Nidzicy. Tablica poświęcona „Łupaszce”.',
        img: "/historia/tablice_epitafijne/olsztyn_3.jpg"
      }, {
        id: 3,
        title: '',
        text: 'Tablica epitafijna odsłonięta i poświęcona 09.091984 r. w kościele Matki Boskiej Ostrobramskiej w Rucianem - Nidzie.',
        img: "/historia/tablice_epitafijne/olsztyn_4.jpg"
      }, {
        id: 4,
        title: '',
        text: 'Tablica epitafijna i pomnik ufundowany przez żołnierzy 13. Brygady w Rucianem – Nidzie',
        img: "/historia/tablice_epitafijne/olsztyn_5.jpg"
      }, {
        id: 5,
        title: '',
        text: 'Olsztyn. Kościół p.w. Matki Boskiej Ostrobramskiej ul. Pana Tadeusza 16. Tablica Ponarska.',
        img: "/historia/tablice_epitafijne/olsztyn_6.jpg"
      }, {
        id: 6,
        title: '',
        text: 'Pisz. Tablica Komendantowi i Żołnierzom 5. Brygady „Łupaszki”.',
        img: "/historia/tablice_epitafijne/olsztyn_7.jpg"
      }, {
        id: 7,
        title: '',
        text: 'Olsztyn. Kościół p.w. Matki Boskiej Ostrobramskiej ul. Pana Tadeusza 16. Tablica poświęcona Komendantowi Okręgu Wileńskiego AK gen. A. Krzyżanowskiemu.',
        img: "/historia/tablice_epitafijne/olsztyn_8.jpg"
      }, {
        id: 8,
        title: '',
        text: 'Ostróda. Kościół p.w. NMP ul. Czarneckiego. Tablica „Łupaszki”.',
        img: "/historia/tablice_epitafijne/olsztyn_9.jpg"
      }]
    },
    szczecin: {
      id: 5,
      city: 'Szczecin',
      carousel: [{
        id: 0,
        title: '',
        text: 'Szczecin. Kościół p.w. Matki Boskiej Ostrobramskiej 3. Brygady „Szczerbca” Szczecin-Żelichowo.',
        img: "/historia/tablice_epitafijne/szczecin_1.jpg"
      }, {
        id: 1,
        title: '',
        text: 'Szczecin. Kościół p.w. Matki Boskiej Ostrobramskiej 7. Brygady „Wilhelma” Szczecin-Żelichowo.',
        img: "/historia/tablice_epitafijne/szczecin_2.jpg"
      }, {
        id: 2,
        title: '',
        text: 'Szczecin. Kościół p.w. Matki Boskiej Ostrobramskiej 2. Brygady „Kaziuka” Szczecin-Żelichowo.',
        img: "/historia/tablice_epitafijne/szczecin_3.jpg"
      }]
    },
    warszawa: {
      id: 6,
      city: 'Warszawa',
      carousel: [{
        id: 0,
        title: '',
        text: 'Warszawa pl. Krasińskich Katedra Polowa Wojska Polskiego.',
        img: "/historia/tablice_epitafijne/warszawa_1.jpg"
      }, {
        id: 1,
        title: '',
        text: 'Warszawa ul. Narbutta. Kościół OO Jezuitów. Tablica 1. Brygady „Juranda”.',
        img: "/historia/tablice_epitafijne/warszawa_2.jpg"
      }, {
        id: 2,
        title: '',
        text: 'Warszawa ul. Senatorska 31. Kościół św. Antoniego. Tablica 5. Brygady „Łupaszki”.',
        img: "/historia/tablice_epitafijne/warszawa_3.jpg"
      }, {
        id: 3,
        title: '',
        text: 'Warszawa ul. Senatorska 31. Kościół św. Antoniego.',
        img: "/historia/tablice_epitafijne/warszawa_4.jpg"
      }, {
        id: 4,
        title: '',
        text: 'Warszawa ul. Senatorska 31. Kościół św. Antoniego. Tablica Pamięci Bolesława Krzyżanowskiego.',
        img: "/historia/tablice_epitafijne/warszawa_5.jpg"
      }, {
        id: 5,
        title: '',
        text: 'Warszawa ul. Krakowskie Przedmieście 68. Kościół akademicki św. Anny. Tablica 6. Brygady „Tońki” i „Konara”.',
        img: "/historia/tablice_epitafijne/warszawa_6.jpg"
      }, {
        id: 6,
        title: '',
        text: 'Warszawa ul. Krakowskie Przedmieście 68. Kościół akademicki św. Anny. Tablica Żeglarzom „Błękitnej Jedynki”.',
        img: "/historia/tablice_epitafijne/warszawa_7.jpg"
      }, {
        id: 7,
        title: '',
        text: 'Warszawa ul. Krakowskie Przedmieście 68. Kościół akademicki św. Anny. Tablica nauczycielom Wileńskim.',
        img: "/historia/tablice_epitafijne/warszawa_8.jpg"
      }, {
        id: 8,
        title: '',
        text: 'Warszawa ul. Freta 10. Kościół Dominikanów św. Jacka. Tablica Komendanta Okręgu Wileńskiego.',
        img: "/historia/tablice_epitafijne/warszawa_9.jpg"
      }, {
        id: 9,
        title: '',
        text: 'Warszawa ul. Freta 10. Kościół Dominikanów św. Jacka. Tablica Ponarska.',
        img: "/historia/tablice_epitafijne/warszawa_10.jpg"
      }, {
        id: 10,
        title: '',
        text: 'Warszawa ul. Freta 10. Kościół Dominikanów św. Jacka.',
        img: "/historia/tablice_epitafijne/warszawa_11.jpg"
      }, {
        id: 11,
        title: '',
        text: 'Warszawa ul. Freta 10. Kościół Dominikanów św. Jacka. Tablica 13. Brygady „Nietoperza”.',
        img: "/historia/tablice_epitafijne/warszawa_12.jpg"
      }, {
        id: 12,
        title: '',
        text: 'Warszawa. Tablica epitafijna 13. Brygady „Nietoperza”.',
        img: "/historia/tablice_epitafijne/warszawa_13.jpg"
      }, {
        id: 13,
        title: '',
        text: 'Warszawa. Tablica Brygady „Jura”, „Orlicza” i „Tumrego”.',
        img: "/historia/tablice_epitafijne/warszawa_14.jpg"
      }, {
        id: 14,
        title: '',
        text: 'Warszawa. Tablica pomordowanym w Berezweczu.',
        img: "/historia/tablice_epitafijne/warszawa_15.jpg"
      }, {
        id: 15,
        title: '',
        text: 'Piastów k/Warszawy ul. Orzeszkowej 23. Kościół p.w. św. Michała Archanioła. Tablica pomordowanym w Ponarach k/Wilna.',
        img: "/historia/tablice_epitafijne/warszawa_16.jpg"
      }]
    },
    wilno: {
      id: 7,
      city: 'Wilno',
      carousel: [{
        id: 0,
        title: '',
        text: 'Wilno. DOM Kultury Polskiej ul. Nougarduko 39.',
        img: "/historia/tablice_epitafijne/wilno_1.jpg"
      }, {
        id: 1,
        title: '',
        text: 'Wilno. DOM Kultury Polskiej ul. Nougarduko 39.',
        img: "/historia/tablice_epitafijne/wilno_2.jpg"
      }, {
        id: 2,
        title: '',
        text: 'Wilno. DOM Kultury Polskiej ul. Nougarduko 39.',
        img: "/historia/tablice_epitafijne/wilno_3.jpg"
      }, {
        id: 3,
        title: '',
        text: 'Wilno. DOM Kultury Polskiej ul. Nougarduko 39.',
        img: "/historia/tablice_epitafijne/wilno_4.jpg"
      }, {
        id: 4,
        title: '',
        text: 'Wilno. Puszcza Rudnicka. Rudniki miejsce pochówku żołnierzy Oddziału „Komara”.',
        img: "/historia/tablice_epitafijne/wilno_5.jpg"
      }, {
        id: 5,
        title: '',
        text: 'Krawczuny k/Wilma. Miejsce walk Brygad AK z Wermachtem 13.07.1944',
        img: "/historia/tablice_epitafijne/wilno_6.jpg"
      }, {
        id: 6,
        title: '',
        text: 'Wilno. Kościół Dominikanów p.w. św. Ducha. Tablica poświęcona Żołnierzom Armii Krajowej.',
        img: "/historia/tablice_epitafijne/wilno_7.jpg"
      }]
    },
    wroclaw: {
      id: 8,
      city: 'Wrocław',
      carousel: [{
        id: 0,
        title: '',
        text: 'Wrocław. Kościół Garnizonowy pw. św. Elżbiety.',
        img: "/historia/tablice_epitafijne/wroclaw_1.jpg"
      }, {
        id: 1,
        title: '',
        text: 'Wrocław. Kościół Garnizonowy pw. św. Elżbiety. Tablica St. Kiałki.',
        img: "/historia/tablice_epitafijne/wroclaw_2.jpg"
      }, {
        id: 2,
        title: '',
        text: 'Wrocław. Kościół Garnizonowy pw. św. Elżbiety. Tablica „Kotwicza”.',
        img: "/historia/tablice_epitafijne/wroclaw_3.jpg"
      }, {
        id: 3,
        title: '',
        text: 'Wrocław. Kościół Garnizonowy pw. św. Elżbiety. Tablica „Wilka”..',
        img: "/historia/tablice_epitafijne/wroclaw_4.jpg"
      }, {
        id: 4,
        title: '',
        text: 'Wrocław. Kościół pw. św. Elżbiety przy Rynku. Tablica 3. Brygady „Szczerbca”.',
        img: "/historia/tablice_epitafijne/wroclaw_5.jpg"
      }, {
        id: 5,
        title: '',
        text: 'Wrocław. Tablica M. Jończyka.',
        img: "/historia/tablice_epitafijne/wroclaw_6.jpg"
      }, {
        id: 6,
        title: '',
        text: 'Wrocław. Tablica „Kima”.j.',
        img: "/historia/tablice_epitafijne/wroclaw_7.jpg"
      }, {
        id: 7,
        title: '',
        text: 'Wrocław. Tablica 6. Brygady.',
        img: "/historia/tablice_epitafijne/wroclaw_8.jpg"
      }]
    }
  }
});

/***/ }),

/***/ "PKAF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q5zO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_srodowiska_okreg_wilenski_js__ = __webpack_require__("HDn2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'okreg_wilenski',
  data: function data() {
    return {
      okreg_wilenski: __WEBPACK_IMPORTED_MODULE_0__models_srodowiska_okreg_wilenski_js__["a" /* default */]
    };
  },
  metaInfo: {
    title: 'OKRĘG WILEŃSKI POLSKIEGO PAŃSTWA PODZIEMNEGO',
    meta: [{ name: 'description', content: 'W roku 1970 Edward Gierek objął najwyższe stanowisko Władz partyjnych w Kraju i jednocześnie zostały bardzo złagodzone inwigilacje, aresztowania i represje stosowane przez Służby Bezpieczeństwa do żołnierzy Armii Krajowej Okręgu Wileńskiego' }, { name: 'og:url', content: 'http://akwilno.pl/srodowiska/okreg_wilenski' }, { name: 'og:title', content: 'OKRĘG WILEŃSKI POLSKIEGO PAŃSTWA PODZIEMNEGO' }, { name: 'og:image', content: '/srodowiska/okreg_wilenski.jpg' }, { name: 'og:description', content: 'W roku 1970 Edward Gierek objął najwyższe stanowisko Władz partyjnych w Kraju i jednocześnie zostały bardzo złagodzone inwigilacje, aresztowania i represje stosowane przez Służby Bezpieczeństwa do żołnierzy Armii Krajowej Okręgu Wileńskiego' }, { name: 'twitter:url', content: 'http://akwilno.pl/srodowiska/okreg_wilenski' }, { name: 'twitter:title', content: 'OKRĘG WILEŃSKI POLSKIEGO PAŃSTWA PODZIEMNEGO' }, { name: 'witter:image', content: '/srodowiska/okreg_wilenski.jpg' }, { name: 'twitter:description', content: 'W roku 1970 Edward Gierek objął najwyższe stanowisko Władz partyjnych w Kraju i jednocześnie zostały bardzo złagodzone inwigilacje, aresztowania i represje stosowane przez Służby Bezpieczeństwa do żołnierzy Armii Krajowej Okręgu Wileńskiego' }]
  }
});

/***/ }),

/***/ "QOuL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RMDY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  list: [{
    id: 0,
    title: 'Okres od września 1939 do 21 czerwca 1941',
    text: 'Po 17. września Wileńszczyzna znalazła się pod okupacją radziecką. Czas tymczasowości tzw. Zachodniej Białorusi okupant wykorzystał na wywożenie wszelkich zasobów magazynowych oraz maszyn i urządzeń',
    url: '/historia/okres_39_41',
    img: '/historia/okres_39_41.jpg'
  }, {
    id: 1,
    title: 'Okres od czerwca 1941 do lipca 1944',
    text: 'W połowie 1942 r. Komenda Główna przemianowała dotychczasowy Związek Walki Zbrojnej na Armię Krajową odróżniając część sił zbrojnych Polskiego Państwa Podziemnego od sił zbrojnych na zachodzie to jest jednostek walczących pod ogólnym dowództwem aliantów.',
    url: '/historia/okres_41_44',
    img: '/historia/okres_41_44.jpg'
  }, {
    id: 2,
    title: 'Działalność bojowa Oddziałów i Brygad',
    text: 'Działalność bojowa Oddziałów i Brygad wraz z listą brygad oraz oddziałów Okręgu Wileńskiego Armii Krajowej rozpisaną wedug kolejności rozpoczęcia działań',
    url: '/historia/dzialalnosc_bojowa',
    img: '/historia/dzialalnosc_bojowa.jpg'
  }, {
    id: 3,
    title: 'Powołanie Zgrupowań – operacja „Ostra Brama”',
    text: 'Lista powoanych zgrupowań z uwzględnieniem uczestników oraz dowódców inspektoratów, plany operacji, urtyfikowania miasta Wilna oraz fragment dokumentu "Droga do „Ostrej Bramy”"',
    url: '/historia/powolanie_zgrupowan',
    img: '/historia/powolanie_zgrupowan.jpg'
  }, {
    id: 4,
    title: 'Rozbrojenie, aresztowanie, epilog, dokumenty',
    text: 'Dnia 17 lipca 1944 roku wydzielony z szeregów 7. Brygady Oddział po wycofaniu się z Bogusz, forsownym marszem dowodzony przez Komendanta "Wilhelma" przesuwał się w kierunku Puszczy Rudnickiej. Po drodze napotkał pozostałą część Brygady ,czasowo dowodzoną przez kpt. "Czarnego Jana".',
    url: '/historia/rozbrojenie_aresztowanie_epilog_dokumenty',
    img: '/historia/rozbrojenie_aresztowanie_epilog_dokumenty.jpg'
  }, {
    id: 5,
    title: 'Tablice Epitafijne Okręgu Wileńskiego',
    text: 'Zdjęcia tablic epitafijnych Okręgu Wileńskiego z podziałem na miasta, w których się znajdują oraz z opisem dokładnej lokalizacji poszczególnych tablic',
    url: '/historia/tablice_epitafijne',
    img: '/historia/tablice_epitafijne.jpg'
  }, {
    id: 6,
    title: 'Bibliografia',
    text: '',
    url: '/historia/bibliografia',
    img: '/historia/bibliografia.jpg'
  }]
});

/***/ }),

/***/ "Rc04":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  carousel: [{
    id: 0,
    text: 'Biały Bór. Woj. zachodnio-pomorskie. Poczet sztandarowy Technicznej Szkoły Rolniczej. Otwarcie Wystawy fotograficznej AK Okręg Wilno',
    img: '/srodowiska/srod_gdansk/poczet_sztandarowy_technicznej_szkoly_rolniczej.jpg'
  }, {
    id: 1,
    text: 'Biały Bór. Woj. zachodnio-pomorskie Techniczna Szkoła Rolnicza. Wystawa fotograficzna AK Okręg Wilno',
    img: '/srodowiska/srod_gdansk/techniczna_szkola_rolnicza.jpg'
  }, {
    id: 2,
    text: 'Szkoła im. Armii Krajowej w Gdańsku Morenie.Otwarcie konkursu przez panią dyr. mgr Niekrasz.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_3.jpg'
  }, {
    id: 3,
    text: 'Szkoła im. Armii Krajowej w Gdańsku Morenie. Konkurs „Co wiem o AK Okręg Wilno”',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_4.jpg'
  }, {
    id: 4,
    text: 'Szkoła im. Armii Krajowej w Gdańsku Morenie. Konkurs „Co wiem o AK Okręg Wilno”',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_5.jpg'
  }, {
    id: 5,
    text: 'Gimnazjum Zespołu Szkół Nr2 w Wejherowie. Konkurs „Co wiem o AK Okręgu Wilno”. Komisja ocen od lewej: Romuald Łucewicz, Regina Klima, Janusz Bohdanowicz, Zofia Zygmuntowicz, Longina Koleśnik.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_6.jpg'
  }, {
    id: 6,
    text: 'Gimnazjum Zespołu Szkół Nr2 w Wejherowie. Konkurs „Co wiem o AK Okręgu Wilno” Dyrektorka Gimnazjum mgr Bożena Kowalska wręcza dyplomy.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_7.jpg'
  }, {
    id: 7,
    text: 'Gimnazjum Zespołu Szkół Nr 2 w Wejherowie. Konkurs „Co wiem o AK Okręgu Wilno”',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_8.jpg'
  }, {
    id: 8,
    text: 'Gimnazjum Sportowe w Gdańsku Oliwie. Konkurs „Co wiem o AK Okręg Wilno”. Komisja ocen: Regina Klima, Zofia Zygmuntowicz, Longina Koleśnik Janusz Bohdanowicz.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_9.jpg'
  }, {
    id: 9,
    text: 'Gimnazjum Sportowe w Gdańsku Oliwie. Konkurs „Co wiem o AK Okręg Wilno”. Obserwatorzy Łucja Białobłocka, Wacław Dziewulski, Stanisław Kowalski, Hipolit Alesionek i inni.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_10.jpg'
  }, {
    id: 10,
    text: 'Gimnazjum Sportowe w Gdańsku Oliwie. Konkurs „Co wiem o AK Okręg Wilno”. Laureatki : Lilianna Krogulec, Małgorzata Sikorska, Dominika Żółtowska, Monika Borucka, Katarzyna Klimek, Gabriela Trębińska.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_11.jpg'
  }, {
    id: 11,
    text: 'Gimnazjum nr 2 w Wejherowie Prelekcja na tle wystawy fotografii AK Okręg Wilno',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_12.jpg'
  }, {
    id: 12,
    text: 'Eksponowana w szkołach w Gdańsku i Wejherowie. Wystawa fotograficzna „Katyń w dokumentach”.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_13.jpg'
  }, {
    id: 13,
    text: 'Wystawa fotograficzna „Katyń w dokumentach” Eksponowana w szkołach w Gdańsku i Wejherowie',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_14.jpg'
  }, {
    id: 14,
    text: 'Wystawa fotograficzna „Katyń w dokumentach” Eksponowana w szkołach w Gdańsku i Wejherowie',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_15.jpg'
  }, {
    id: 15,
    text: 'Wystawa fotograficzna „Katyń w dokumentach” Eksponowana w szkołach w Gdańsku i Wejherowie',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_16.jpg'
  }, {
    id: 16,
    text: 'Skorbuciany k/ Wilna. Cmentarz żołnierzy 7. Brygady „Wilhelma”. Apel poległych przy dźwiękach werbli i trąbki.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_17.jpg'
  }, {
    id: 17,
    text: 'Ligojnie rej. wileński. Powitanie przez Starostę gminy Pogiry Marię Maciulewicz.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_18.jpg'
  }, {
    id: 18,
    text: 'Ligojnie rej. wileński. Nauczyciele szkół gminy Wejherowo uczestnicy wycieczki przy ognisku.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_19.jpg'
  }, {
    id: 19,
    text: 'Niemenczyn. Festiwal zespołów artystycznych z Wileńszczyzny pod nazwą „Polskie Kwiaty.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_20.jpg'
  }, {
    id: 20,
    text: 'Pomaturalna Szkoła Rolnicza w Białej Wace Rep. Litewska. Komisja ocen konkursu  „Poprawnego czytania w języku polskim” uczniów szkół Wileńszczyzny. Od lewej: Maria Wziątek, Longina Koleśnik, Zofia Zygmuntowicz, Antoni Kaczyński, Walentyna Treszczyńska nauczycielka z Pogir i Janusz Bohdanowicz.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_21.jpg'
  }, {
    id: 21,
    text: 'Wilno cmentarz Rossa. Składanie kwiatów przy Mauzoleum Marszałka Polski Józefa Piłsudskiego i zapalenie zniczy na grobach żołnierzy Armii Krajowej.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_22.jpg'
  }, {
    id: 22,
    text: 'Krawczuny. Apel poległych w miejscu walki spotkaniowej z doborowymi jednostkami wojsk niemieckich wycofującymi się z Wilna .',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_23.jpg'
  }, {
    id: 23,
    text: 'Kolonia Wileńska. Po Apelu Poległych z trąbką i werblami.Relacja kol. Zofii Zygmuntowicz uczestniczki pierwszych pogrzebów żołnierzy poległych w walkach w dniu 6 i 7 lipca 1944 r.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_24.jpg'
  }, {
    id: 24,
    text: 'Kalwaria Wileńska. Laureaci konkursu historycznego przy grobach żołnierzy Armii Krajowej poległych w walkach z Wermachtem pod Krawczunami.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_25.jpg'
  }, {
    id: 25,
    text: 'Sorok Tatary. Przed wejściem do meczetu. Spotkanie z przewodniczącym gminy tatarskiej.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_26.jpg'
  }, {
    id: 26,
    text: 'Gimnazjum Sportowe w Gdańsku Oliwie.Konkurs „Co wiem o AK Okręg Wilno”. Fragment dekoracji sali.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_27.jpg'
  }, {
    id: 27,
    text: 'Gimnazjum Sportowe w Gdańsku Oliwie.Konkurs „Co wiem o AK Okręg Wilno”. Uczniowie wykonawcy części artystycznej.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_28.jpg'
  }, {
    id: 28,
    text: 'Gimnazjum Zespołu Szkół Nr 2w Wejherowie. Konkurs H. Sienkiewicz i Jego twórczość. Komisja ocen od lewej: Regina Klima, Janusz Bohdanowicz i Longina Koleśnik.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_29.jpg'
  }, {
    id: 29,
    text: '',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_30.jpg'
  }, {
    id: 30,
    text: 'Gimnazjum Samorządowe Gminy Wejherowo w Bolszewie. Fragment dekoracji sceny, części artystycznej finału konkursu „Co wiem o AK Okręg Wilno”.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_31.jpg'
  }, {
    id: 31,
    text: 'Gimnazjum Zespołu Szkół Nr 3 w Wejherowie. Konkurs "Co wiem o AK Okręg Wilno". Dekoracja sali finału konkursu.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_32.jpg'
  }, {
    id: 32,
    text: 'Pomaturalna Szkoła Rolnicza. Biała Waka.Uczestnicy konkursu „Poprawnego czytania w języku polskim”',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_33.jpg'
  }, {
    id: 33,
    text: 'Pomaturalna Szkoła Rolnicza. Biała Waka. Konkurs „Poprawnego czytania w języku polskim” Komisja ocen od lewej : Aldona Klarska, Maria Wziątek, Longina Koleśnik, Zofia Zygmuntowicz, Zdzisław Zygmuntowicz, Janusz Bohdanowicz.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_34.jpg'
  }, {
    id: 34,
    text: 'Gimnazjum Zespołu Szkół im. Armii Krajowej w Gdańsku Morenie. Laureatki: Kamila Oleszek i Agata Bielecka w Wilnie',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_35.jpg'
  }, {
    id: 35,
    text: 'Laureaci Konkursów AK-owskiech ze szkół gdańskich i wejherowskich wizytą u księdza proboszcza Kolonii Wileńskiej Aloizego Koncziusa.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_36.jpg'
  }, {
    id: 36,
    text: 'Laureatki konkursu AK-owskiego ze Szkoły im. Armii Krajowej i członkowie Komisji ocen w Trokach',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_37.jpg'
  }, {
    id: 37,
    text: 'Wilno. Październik 2000 r. kościół pw. Św. Piotra i Pawła. Nauczyciele i laureaci konkursów historycznych.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_38.jpg'
  }, {
    id: 38,
    text: 'Wilno. Październik 2000 r. kościół pw. Św. Piotra i Pawła. Nauczyciele i laureaci konkursów historycznych.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_39.jpg'
  }, {
    id: 39,
    text: 'Wilno Mauzoleum Marszałka Piłsudskiego.Maj 2000 r. Laureaci konkursów historycznych z kombatantami.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_40.jpg'
  }, {
    id: 40,
    text: 'Rudniki. Maj 2000 r. Spotkanie z żołnierzem 7. Brygady „Wilhelma” Witoldem Aładowiczem.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_41.jpg'
  }, {
    id: 41,
    text: 'Kalwaria Wileńska. Maj 2000 r. Zbiorowa mogiła żołnierzy poległych w walce z Wermachtem pod Krawczunami 13 lipca 1944 r.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_42.jpg'
  }, {
    id: 42,
    text: 'Wilkiszki uczestnicy wycieczki. Szpital partyzancki 3. Brygady „Szczerbca” laureaci konkursów i kombatanci.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_43.jpg'
  }, {
    id: 43,
    text: 'Troki. Maj 2000 r. Laureaci konkursów historycznych z kombatantami.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_44.jpg'
  }, {
    id: 44,
    text: 'Kalwaria Wileńska. Maj 2002 r. Zbiorowa mogiła żołnierzy poległych w walce z Wermachtem pod Krawczunami 13 lipca 1944 r.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_45.jpg'
  }, {
    id: 45,
    text: 'Wilno Mauzoleum Marszałka Piłsudskiego. Maj 2004 r. Laureaci konkursów historycznych z kombatantami.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_46.jpg'
  }, {
    id: 46,
    text: 'Troki. Maj 2004 r. Laureaci konkursów historycznych z kombatantami zwiedzają zamek najeziorny.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_47.jpg'
  }, {
    id: 47,
    text: 'Kolonia Wileńska. Lipiec 2004. Uczestnicy wyjazdu w miejscu przekraczania rzeki Wilenki w ataku na Belmont 8 lipca 1944 r.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_48.jpg'
  }, {
    id: 48,
    text: 'Bogusze. Lipiec 2004 r. Odsłonięcie pomnika w miejscu aresztowania oficerów Armii Krajowej przez NKWG w dniu 18 lipca 1944 r.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_49.jpg'
  }, {
    id: 49,
    text: 'Krawczuny. Lipiec 2004 r. Uroczystości rocznicowe walk Armii Krajowej z Wermachtem 13.07.1944 r.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_50.jpg'
  }, {
    id: 50,
    text: 'Kolonia Wileńska. Lipiec 2004 r. Apel poległych w walkach o Wilno 8 lipca 1944 r.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_51.jpg'
  }, {
    id: 51,
    text: 'Pikiliszki. Lipiec 2004. Dworek Marszałka Józefa Piłsudskiego, w którym był po raz ostatni w 1933 r.',
    img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_52.jpg'
  }],
  videos: [{
    id: 0,
    text: 'Obchody 50-tej rocznicy walk o Wilno Sopot-Borodziej 13 lipca 1994r. (fragment)',
    url: "https://www.youtube.com/embed/EKc5JqcyFtM"
  }, {
    id: 1,
    text: 'Uroczyste odsłonięcie i poświęcenie tablicy epitafialnej dowódcy okręgu Wileńskiego Armii Krajowej Gen. A. Rzyżanowskiego w Wrocławiu (fragment)',
    url: "https://www.youtube.com/embed/doi5DgIuJAk"
  }, {
    id: 2,
    text: 'Chór środowiska Wileńskiego we Wrocławiu śpiewa piosenki partyzanckie (fragment)',
    url: "https://www.youtube.com/embed/GA4vplL7zDc"
  }],
  lists: {
    konkurs: ['Pomaturalna Wileńska Szkoła Rolnicza. Biała Waka 15 maja 1999 r.', 'Gimnazjum im. Armii Krajowej. Gdańsk Morene 15 kwietnia 2000 r.', 'Pomaturalna Wileńska Szkoła Rolnicza Biała Waka. 3 maja 2000 r.', 'Gimnazjum Zespołu Szkół Nr 3 w Wejherowie. 19 maja 2000 r.', 'Gimnazjum Zespołu Szkół Nr 2 w Wejherowie. 27 października 2000 r.', 'Gimnazjum Zespołu Szkół Nr 2 w Wejherowie. 9 kwietnia 2001 r.', 'Gimnazjum Samorządowe w Bolszewie. 25 kwietnia 2001 r.', 'Gimnazjalnego Nr 17 Gdańsk Oliwa. 10 maja 2001 r.', 'Zespół Szkół Rolniczo-Ekonomicznych w Bytowie. 21 stycznia 2002 r.', 'Gimnazjum Zespołu Szkół Nr 2 w Wejherowie. 10 kwietnia 2002 r.', 'Gimnazjalnego Nr 17 Gdańsk Oliwa. 24 kwietnia 2002 r.', 'Gimnazjum Nr 3 Gdańsk Chełm. 9 maja 2002 r.', 'Gimnazjum Samorządowe w Bolszewie. 18 maja 2002 r.', 'Szkoła w Bezdanach. 4-te klasy podstawowe', 'Gimnazjum Samorządowe w Bolszewie. Sympozjum historyczne. 5 maja 2003 r.', 'Liceum Nr 1 im. Króla Jana III Sobieskiego w Wejherowie. 12 maja 2003 r.', 'Szkoła w Turgielach. 4-te klasy podstawowe. 28 maja 2003 r.', 'Gimnazjum Samorządowe w Bolszewie. 05 kwietnia 2004 r.', 'Gimnazjum Samorządowe w Bolszewie. 19 kwietna 2004 r.', 'Gimnazjum Publiczne im. „Ofiar Katynia” w Piątnicy. 28 maja 2004 r.', 'Samorządowe Gimnazjum w Bolszewie. 25 maja 2005 r.', 'Samorządowe Gimnazjum w Bolszewie. 20 maja 2005 r.', 'Zespół Szkół Ogólnokształcących Nr 2 w Lęborku. 22 czerwca 2005 r.'],
    wystawy: ['Gdańsk sala Domu Architekta od 03 - 21.07. 1989 r.', 'Gdańsk EMPiK Długi Targ od 01- 15. 08. 1989 r.', 'Gdańsk Wrzeszcz sala SD ul. Sobótki od 01 - 23.09. 1989 r.', 'Toruń Biblioteka UMK od 22. 11.1989 r. do 05.01.1990 r.', 'Bydgoszcz EMPiK od 15 - 27. 01. 1990 r.', 'Białystok sala Urzędu miasta od 13. 02. do 18.04. 1990 r.', 'Legnica w kościele od 07 - 21.07.1990 r.', 'Opole Muzeum Miasta od 23. 08. do 15.11.1990 r.', 'Nysa Muzeum Miasta luty i marzec 1991. r.', 'Szczecin Sala Wystawowa od 15. 05. do 20.06.1991 r.', 'Gorzów Wlkp. Sala Wystaw Stow. „PAX” 16.06. do 27. 07. 1991 r.', 'Piła Sala Wystawowa od 26. 09. do 7. 10. 1991 r.', 'Wrocław Sala Szkoły Oficerskiej od 11- 19. 11. 1991 r.', 'Gdańsk Koluszki Szkoła Podstawowa 10 - 17. 04. 1992 r.', 'Gdańsk Wrzeszcz Gimnazjum Nr 7. od 02 - 09. 05. 1992 r.', 'Szczecin w Zamku od 01-31. 08. 1994 r.', 'Wejherowo Muzeum Przebendowskich od 21. 09. do 15. 10. 1996 r.', 'Bielsko Biała Gimnazjum od 01-28.02. 1997 r.', 'Warszawa Biblioteka Wojska Polskiego od 01-31.07.1998 r.', 'Słupsk Sala Związku Solidarność od 01-31.05. 1999 r.', 'Bytów Muzeum Kaszubskie od 01-31.10. 1999 r.', 'Biały Bór woj. Zach. Pomorskie. Średnia Szkoła Rol. 12 - 17.01.2000 r.', 'Gdańsk Morena Szkoła im. AK od 29. 02. do 15. 03.2000 r.', 'Wejherowo Zespół Szkół Nr 3. od 19 - 29.05.2000 r.', 'Wejherowo Zespół Szkół Nr 2. od 27.10. do 08.11.2000 r.', 'Samorządowe Gimnazjum w Bolszewie w 2002 i 2003 r. -3 razy.'],
    biblioteki: ['Biblioteka Główna Akademii Medycznej ul Parkowa Nr 1/3 51-616 WROCŁAW', 'Biblioteka Gł. Politechniki Warszawskiej Pl. Politechniki Nr 1, WARSZAWA', 'Biblioteka Główna SGGW ul. Nowoursynowska Nr 166, 02-6975 WARSZAWA', 'Biblioteka Gł. Politechniki Szczecińskiej ul. Piastów Nr 17, 73-122 SZCZECIN', 'Biblioteka Główna Akademii Medycznej ul. Rybacka 1, 70-204 SZCZECIN', 'Biblioteka Główna Akademii Rolniczej ul. Janosika 8, 70-204 SZCZECIN', 'Biblioteka Gł. Akademii Wych. Fizycznego ul. Czyżweskiego 29, GDAŃSK', 'Biblio. Gł. Uniwersytetu Szczecińskiego ul. Jedn. Narodowej 22 A, 70-413 SZCZECIN', 'Biblio. Gł. Uniwersytetu Warm. Mazur. ul. Michała Oczapowskiego 4, 10-719 OLSZTYN', 'Biblioteka Gł. Akademii Medycznej ul. Oczki Nr 1, 00-071 WARSZAWA', 'Biblioteka Główna AWF ul. Marymoncka Nr 34, 00-913 WARSZAWA', 'Bib. Gł. Akademii Wych. Fizycznego ul. Mickiewicza 98, 51-684 WROCŁAW', 'Bib. Gł. Politechniki Gdańskiej ul. Narutowicza Nr 11/12, 80-952 GDAŃSK', 'Bib. Główna Uniwersytetu Gdańskiego ul. Armii Krajowej Nr 110, SOPOT', 'Bib. Gł. Wyższej Szkoły Oficerskiej. Czajkowskiego 109 51-150WROCŁAW', 'Bib. Gł. Wyższej Szkoły Wojskowej ul. Kaliskiego Nr 1, 01-747 WARSZAWA', 'Biblioteka Katolickiego Uniwersytetu Lubelskiego ul. Szopena, LUBLIN', 'Bib. Parafialna przy kościele pw. Najświętszego Serca Pana Jezusa, GDAŃSK', 'Bib. Muzeum Narodowe Pl. Powstańców Warszawy Nr 5, 50- 153 WROCŁAW', 'Bib. Gł. Politechniki Wrocławskiej i NOT Wybrzeże Wyspiańskiego 27, 50-370 WROCŁAW', 'Bib. Szkoły Głównej Handlowej ul. Rakowiecka 22B, 02-521 WARSZAWA', 'Biblioteka Uniwersytetu im. Mikołaja Kopernik TORUŃ', 'Bib. Uniwersytecka im. A. Mickiewicza ul. Ratajczaka 38/40, POZNAŃ', 'Biblioteka Uniwersytecka w Łodzi ul. Jana Matejki Nr 34/38, 90-237 ŁÓDŹ', 'Biblioteka Uniwersytecka ul. Dobra Nr 56/60, 00-312 WARSZAWA', 'Bib. Uniwersytet Wrocławski ul. Szajnochy Nr 7/10, 50-76 WROCŁAW', 'Bib. Fundacja Zakład Narodowy im. Ossolińskich ul. Szewska Nr 37, 50-139 WROCŁAW', 'Biblioteka Kapitulna ul. Kanonia Nr 12, 50-528 WROCŁAW', 'Centralna Biblioteka Wojskowa ul. Ostrobramska Nr 109, 04-41 WARSZAWA', 'IPN Oddział Gdański ul. Witomińska Nr 19, 81-311 GDYNIA', 'Instytut Pamięci Narodowej Oddz. Bydgoszcz, BYDGOSZCZ', 'Akademia Świętokrzyska w Kielcach. Filia w Piotrkowie Trybunalskim, ul. Słowackiego Nr 114/11, PIOTRKÓW TRYBUNALSKI', 'Biblioteka Główna Akademii Medycznej ul. Debinki Nr 1, GDAŃSK', 'Biblioteka Główna Uniwersytetu Marii Curie Skłodowskiej, LUBLIN', 'Publiczna Biblioteka Pedagogiczna Al. Niepodległości Nr.34, 61-714 POZNAŃ']
  }
});

/***/ }),

/***/ "RgFJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  people: [{
    id: 0,
    name: 'LONGIN TOMASZEWSKI',
    books: ['Kronika Wileńska 1939-1941. Wydawnictwo POMOST. Warszawa 1989.', 'Kronika Wileńska 1941-1945. Z dziejów Polskiego Państwa Podziemnego. Oficyna Wydawnicza POMOST Warszawa 1992.', 'Kronika Wileńska 1939-1941. Wydawnictwo POMOST. Wydanie III, poszerzone i uzupełnione. Warszawa 1994.', 'Wileńszczyzna lat wojny 1939-1945. Oficyna Wydawnicza RYTM. Warszawa 1999.', 'Współdziałania Okręgowej Delegatury Rządu i Stronnictw Politycznych z Armią Krajową w walce o wyzwolenie Wileńszczyzny. Biblioteka „Kuriera Wileńskiego”. Sympozjum historyczne, „Rok 1944 na Wileńszczyźnie” .Wilno 30.06 i 01.07.1994 r.']
  }, {
    id: 1,
    name: 'ROMAN KORAB-ŻEBRYK',
    books: ['Operacja Wileńska A K. Państwowe Wydawnictwo Naukowe. Warszawa 1988.Wydanie II.']
  }, {
    id: 2,
    name: 'EDMUND BANASIKOWSKI',
    books: ['Na zew ziemi wileńskiej. Editions Spotkania. Warszawa –Paryż 1990.']
  }, {
    id: 3,
    name: 'JAROSŁAW WOŁKONOWSKI',
    books: ['Okręg Wileński Związku Walki Zbrojnej Armii Krajowej w latach 1939-1945. Oficyna Wydawnicza „ADIUTOR” Wilno-Warszawa, 1996.']
  }, {
    id: 4,
    name: 'TADEUSZ SZYNKOWSKI',
    books: ['BŁYSKAWICA” na ziemi wileńskiej. Wydawnictwo Polskie w Wilnie. Biblioteka Magazynu Wileńskiego.']
  }, {
    id: 5,
    name: 'JANUSZ BOHDANOWICZ',
    books: ['Konspiracja i walki zbrojne na Wileńszczyźnie i epilog. Gdańsk, 1990. Broszura. Kserokopia.', 'Życiorysy Dowódców i Kalendaria działalności Brygad. Gdańsk 1989. Broszura. Kserokopia.']
  }, {
    id: 6,
    name: 'KRZYSZTOF A. TOCHMAN',
    books: ['Adam Boryczka. Z dziejów WIN-u. Obywatelskie Stowarzyszenie „OSTOJA”. Zwierzyniec - Rzeszów 1999 tom I, 2001 tom II.']
  }, {
    id: 7,
    name: 'OTTO TEODOR SAWICKI',
    books: ['Album 6. Dyspozycyjnej Brygady AK.']
  }, {
    id: 8,
    name: 'ROMUALD WARAKOMSKI',
    books: ['Komórka Legalizacyjna Sztabu Okręgu Wileńskiego Armii Krajowej w latach 1939 - 1947. Towarzystwo Miłośników Wilna i Ziemi Wileńskiej Oddz. Bydgoszcz. 1996.']
  }, {
    id: 9,
    name: 'JAN BARADYN-ŻYLIŃSKI',
    books: ['Ojczyźnie i Przysiędze Hipokratesa Zawsze Wierni. Wydawnictwo TAKT. Kielce 1997.']
  }, {
    id: 10,
    name: 'ADAM WALCZAK',
    books: ['13. Brygada Armii Krajowej Okręgu Wileńskiego. Wydanie kserograficzne.Toruń 1984.']
  }, {
    id: 11,
    name: 'KAZIMIERZ KRAUZE',
    books: ['Ostatni raport. Wileński Przekaz Nr 8 - 12. Okręg Wileński Środowisko w Gdańsku Światowy Związek Żołnierzy Armii Krajowej. Rok 1991.']
  }, {
    id: 12,
    name: 'WIKTOR SADOWSKI',
    books: ['12. Brygada w pamięci partyzantów. Wileński przekaz Nr 3 - 5. Okręg Wileński Środowisko w Gdańsku Światowy Związek Żołnierzy Armii Krajowej. Rok 1993.']
  }, {
    id: 13,
    name: 'INSTYTUT STUDIÓW POLITYCZNYCH POLSKIEJ AKADEMII NAUK',
    books: ['Katyń. Dokumenty ludobójstwa. Dokumenty i materiały archiwalne przekazane Polsce 14.10.1992 r. Warszawa 1992. Wydawca Instytut Studiów Politycznych.']
  }, {
    id: 14,
    name: 'TATIANA CARIEWSKAJA, ANDRZEJ CHMIELARZ, ANDRZEJ PACZKOWSKI, EWA ROSOWSKA, SZYMON RUDNICKI',
    books: ['Teczka Specjalna J.W. Stalina. Raporty NKWD z Polski 1944 - 1946. Instytut Studiów Politycznych Polskiej Akademii Nauk. Instytut Historyczny Uniwersytetu Warszawskiego. Oficyna Wydawnicza RYTM. Warszawa 1998.']
  }]
});

/***/ }),

/***/ "S1EH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Aktualności")]),_c('br'),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},_vm._l((_vm.news),function(msg){return _c('div',{key:msg.id},[_c('b-media',{staticClass:"mb-3",attrs:{"tag":"li"}},[_c('b-img',{attrs:{"slot":"aside","src":msg.img,"width":"120"},slot:"aside"}),_vm._v(" "),_c('h5',{staticClass:"mt-0 mb-2"},[_c('router-link',{staticClass:"router-link-list",attrs:{"active-class":"activeSide","to":msg.url,"exact":""}},[_vm._v(_vm._s(msg.title))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"10"}},[_vm._v("\n            "+_vm._s(msg.text)),_c('router-link',{attrs:{"active-class":"activeSide","to":msg.url,"exact":""}},[_vm._v(".....więcej")])],1)],1)],1)],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Tg1H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dzialalnosc_bojowa_vue__ = __webpack_require__("nD/r");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2086ebe1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dzialalnosc_bojowa_vue__ = __webpack_require__("FAah");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dzialalnosc_bojowa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2086ebe1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dzialalnosc_bojowa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VBAp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kolekcja_vue__ = __webpack_require__("qeZy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82ec7ec8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kolekcja_vue__ = __webpack_require__("EYoL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kolekcja_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82ec7ec8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kolekcja_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Vs2P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'spuscizna_jana_gozdawy',
  metaInfo: {
    title: 'Spuścizna Jana Gozdawy-Gołębiowskiego udostępniona w OSA',
    meta: [{ name: 'description', content: 'Zakończyliśmy realizację projektu obejmującego opracowanie, digitalizację i upowszechnienie kolekcji osobistej Jana Gozdawy-Gołębiowskiego (1925 – 2013)' }, { name: 'og:url', content: 'http://ak-wilno.pl/spuscizna_jana_gozdawy_golebiowskiego' }, { name: 'og:title', content: 'Spuścizna Jana Gozdawy-Gołębiowskiego udostępniona w OSA' }, { name: 'og:image', content: '/aktualnosci/spuscizna_jana_gozdawy_golebiowskiego.jpg' }, { name: 'og:description', content: 'Zakończyliśmy realizację projektu obejmującego opracowanie, digitalizację i upowszechnienie kolekcji osobistej Jana Gozdawy-Gołębiowskiego (1925 – 2013)' }, { name: 'twitter:url', content: 'http://ak-wilno.pl/spuscizna_jana_gozdawy_golebiowskiego' }, { name: 'twitter:title', content: 'Spuścizna Jana Gozdawy-Gołębiowskiego udostępniona w OSA' }, { name: 'witter:image', content: '/aktualnosci/spuscizna_jana_gozdawy_golebiowskiego.jpg' }, { name: 'twitter:description', content: 'Zakończyliśmy realizację projektu obejmującego opracowanie, digitalizację i upowszechnienie kolekcji osobistej Jana Gozdawy-Gołębiowskiego (1925 – 2013)' }]
  }
});

/***/ }),

/***/ "WfX2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  carousel: {
    lip6: {
      part1: [{
        id: 0,
        title: '',
        text: 'Uroczystości zainaugurowała Msza Św. w kościele pw. Św. Teresy',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_2.jpg"
      }, {
        id: 1,
        title: '',
        text: 'Uroczystości zainaugurowała Msza Św. w kościele pw. Św. Teresy',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_3.jpg"
      }, {
        id: 2,
        title: '',
        text: 'Uroczystości zainaugurowała Msza Św. w kościele pw. Św. Teresy',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_4.jpg"
      }, {
        id: 3,
        title: '',
        text: 'Uroczystości zainaugurowała Msza Św. w kościele pw. Św. Teresy',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_5.jpg"
      }, {
        id: 4,
        title: '',
        text: 'Uroczystości zainaugurowała Msza Św. w kościele pw. Św. Teresy',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_6.jpg"
      }, {
        id: 5,
        title: '',
        text: 'Uroczystości zainaugurowała Msza Św. w kościele pw. Św. Teresy',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_7.jpg"
      }, {
        id: 6,
        title: '',
        text: 'Uroczystości zainaugurowała Msza Św. w kościele pw. Św. Teresy',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_8.jpg"
      }, {
        id: 7,
        title: '',
        text: 'Uroczystości zainaugurowała Msza Św. w kościele pw. Św. Teresy',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_9.jpg"
      }, {
        id: 8,
        title: '',
        text: 'Uroczystości zainaugurowała Msza Św. w kościele pw. Św. Teresy',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_10.jpg"
      }],
      part2: [{
        id: 0,
        title: '',
        text: 'Główna ceremonia na cmentarzu „Na Rossie”',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_11.jpg"
      }, {
        id: 1,
        title: '',
        text: 'Główna ceremonia na cmentarzu „Na Rossie”',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_12.jpg"
      }, {
        id: 2,
        title: '',
        text: 'Główna ceremonia na cmentarzu „Na Rossie”',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_13.jpg"
      }, {
        id: 3,
        title: '',
        text: 'Główna ceremonia na cmentarzu „Na Rossie”',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_14.jpg"
      }, {
        id: 4,
        title: '',
        text: 'Główna ceremonia na cmentarzu „Na Rossie”',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_15.jpg"
      }, {
        id: 5,
        title: '',
        text: 'Główna ceremonia na cmentarzu „Na Rossie”',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_16.jpg"
      }, {
        id: 6,
        title: '',
        text: 'Główna ceremonia na cmentarzu „Na Rossie”',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_17.jpg"
      }, {
        id: 7,
        title: '',
        text: 'Główna ceremonia na cmentarzu „Na Rossie”',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_18.jpg"
      }, {
        id: 8,
        title: '',
        text: 'Główna ceremonia na cmentarzu „Na Rossie”',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_19.jpg"
      }, {
        id: 9,
        title: '',
        text: 'Główna ceremonia na cmentarzu „Na Rossie”',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_20.jpg"
      }, {
        id: 10,
        title: '',
        text: 'Główna ceremonia na cmentarzu „Na Rossie”',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_21.jpg"
      }, {
        id: 11,
        title: '',
        text: 'Główna ceremonia na cmentarzu „Na Rossie”',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_22.jpg"
      }, {
        id: 12,
        title: '',
        text: 'Główna ceremonia na cmentarzu „Na Rossie”',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_23.jpg"
      }, {
        id: 13,
        title: '',
        text: 'Główna ceremonia na cmentarzu „Na Rossie”',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_24.jpg"
      }, {
        id: 14,
        title: '',
        text: 'Główna ceremonia na cmentarzu „Na Rossie”',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_25.jpg"
      }, {
        id: 15,
        title: '',
        text: 'Główna ceremonia na cmentarzu „Na Rossie”',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_26.jpg"
      }, {
        id: 16,
        title: '',
        text: 'Główna ceremonia na cmentarzu „Na Rossie”',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_27.jpg"
      }, {
        id: 17,
        title: '',
        text: 'Główna ceremonia na cmentarzu „Na Rossie”',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_28.jpg"
      }, {
        id: 18,
        title: '',
        text: 'Główna ceremonia na cmentarzu „Na Rossie”',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_29.jpg"
      }, {
        id: 19,
        title: '',
        text: 'Główna ceremonia na cmentarzu „Na Rossie”',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_30.jpg"
      }]
    },
    lip7: [{
      id: 0,
      title: '',
      text: 'Uroczystości w podwileńskich Krawczunach',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_31.jpg"
    }, {
      id: 1,
      title: '',
      text: 'Uroczystości w podwileńskich Krawczunach',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_34.jpg"
    }, {
      id: 2,
      title: '',
      text: 'Uroczystości w podwileńskich Krawczunach',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_35.jpg"
    }, {
      id: 3,
      title: '',
      text: 'Uroczystości w podwileńskich Krawczunach',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_36.jpg"
    }, {
      id: 4,
      title: '',
      text: 'Uroczystości w podwileńskich Krawczunach',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_37.jpg"
    }, {
      id: 5,
      title: '',
      text: 'Uroczystości w podwileńskich Krawczunach',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_38.jpg"
    }, {
      id: 6,
      title: '',
      text: 'Uroczystości w Kalwarii Wileńskiej',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_42.jpg"
    }, {
      id: 7,
      title: '',
      text: 'Uroczystości w Kalwarii Wileńskiej',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_43.jpg"
    }, {
      id: 8,
      title: '',
      text: 'Uroczystości w Kalwarii Wileńskiej',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_44.jpg"
    }, {
      id: 9,
      title: '',
      text: 'Uroczystości w Kalwarii Wileńskiej',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_45.jpg"
    }, {
      id: 10,
      title: '',
      text: 'Uroczystości w Kalwarii Wileńskiej',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_46.jpg"
    }, {
      id: 11,
      title: '',
      text: 'Uroczystości w Kalwarii Wileńskiej',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_47.jpg"
    }, {
      id: 12,
      title: '',
      text: 'Msza Św. w drewnianym kościółku w Kolonii Wileńskiej z 1935 r.',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_48.jpg"
    }, {
      id: 13,
      title: '',
      text: 'Msza Św. w drewnianym kościółku w Kolonii Wileńskiej z 1935 r.',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_49.jpg"
    }, {
      id: 14,
      title: '',
      text: 'Msza Św. w drewnianym kościółku w Kolonii Wileńskiej z 1935 r.',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_50.jpg"
    }, {
      id: 15,
      title: '',
      text: 'Msza Św. w drewnianym kościółku w Kolonii Wileńskiej z 1935 r.',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_51.jpg"
    }, {
      id: 16,
      title: '',
      text: 'Msza Św. w drewnianym kościółku w Kolonii Wileńskiej z 1935 r.',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_52.jpg"
    }, {
      id: 17,
      title: '',
      text: 'Msza Św. w drewnianym kościółku w Kolonii Wileńskiej z 1935 r.',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_53.jpg"
    }, {
      id: 18,
      title: '',
      text: 'Msza Św. w drewnianym kościółku w Kolonii Wileńskiej z 1935 r.',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_54.jpg"
    }],
    lip8: [{
      id: 0,
      title: '',
      text: 'Uroczystość w Ponarach – miejscu masowej zagłady ofiar reżimu nazistowskiego',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_55.jpg"
    }, {
      id: 1,
      title: '',
      text: 'Uroczystość w Ponarach – miejscu masowej zagłady ofiar reżimu nazistowskiego',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_56.jpg"
    }, {
      id: 2,
      title: '',
      text: 'Uroczystość w Ponarach – miejscu masowej zagłady ofiar reżimu nazistowskiego',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_57.jpg"
    }, {
      id: 3,
      title: '',
      text: 'Uroczystość w Ponarach – miejscu masowej zagłady ofiar reżimu nazistowskiego',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_58.jpg"
    }, {
      id: 4,
      title: '',
      text: 'Uroczystość w Ponarach – miejscu masowej zagłady ofiar reżimu nazistowskiego',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_59.jpg"
    }, {
      id: 5,
      title: '',
      text: 'Uroczystość w Ponarach – miejscu masowej zagłady ofiar reżimu nazistowskiego',
      img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_60.jpg"
    }]
  }
});

/***/ }),

/***/ "X7DP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XYbA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xn5b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  pierwsza_okupacja: {
    cards: [{
      id: 0,
      img: '/historia/okres_39_41/Wladysław_Kaminski.jpg',
      desc: 'Mjr Władysław Kamiński "Śliwa"'
    }, {
      id: 1,
      img: '/historia/okres_39_41/Henryk_Hlebowicz.jpg',
      desc: 'ks. Henryk Hlebowicz „Bolesław Szewik”'
    }, {
      id: 2,
      img: '/historia/okres_39_41/Nikodem_Sulik.jpg',
      desc: 'Ppłk dypl.Nikodem Sulik „Karol Sarnowski”'
    }, {
      id: 3,
      img: '/historia/okres_39_41/Jozef_Grzesiak.jpg',
      desc: 'Kpt. Józef Grzesiak "Kmita"'
    }],
    list: ['Komitet Pomocy Uchodźcom Wojennym - kierowany przez Ignacego Zagórskiego, dr Marię Petrusewiczową i Antoniego Pańskiego.', 'Komisariat Rządu - kierowany przez Bronisława Świątnickiego „Ojciec” i prof. Rajmunda Gostkowskiego.', 'Koła Pułkowe - Kierowane przez ppłk Adama Obtułowicza „Karol Podgórski”, „Leon”.', 'Związek Wolnych Polaków - kierowany przez Jana Kazimierza Mackiewicza.', 'Komitet Walki o Wyzwolenie - kierowany przez mjr rez. Władysława Kamińskiego „Śliwa”.', 'Obóz Niepodległości - kierowany przez prof. Witolda Staniewicza.', 'Organizacja Socjalistyczno-Niepodległościowa „Wolność” - kierowana przez Wacława Zagórskiego, prof. Feliksa Grossa, redaktora Zbigniewa Mitznera i Tadeusza Zajączkowskiego.', 'Akcja Ludowa - kierowana przez Jerzego Wrońskiego i ks. Henryka Hlebowicza.', 'Organizacja Wojskowa Narodu Walczącego - kierowana przez Antoniego Anatola Rymaszewskiego „Andrzej”.', 'Służba Zwycięstwu Polski - kierowana przez ppłk dypl. Nikodema Sulika „Ładyna”, „Jodko”.']
  },
  konsp_wladze: {
    list: ['ksiądz Kazimierz Kucharski „Szczepan”,', 'ppłk Nikodem Sulik „Karol Sarnowski”, „Karol Jodko” i „Ładyna”.', 'Bronisław Świątnicki „Ojciec”,', 'kpt. Aleksander Wasilewski „Wład”, „Olesiński” w zastępstwie kpt. dypl. Antoniego Olechnowicza „Meteor”, „Pohorecki”.', 'por. Julian Pietraszewski „Julian”.', 'dr Jerzy Dobrzański „Maciej” z ramienia PPS-WRN.', 'Witold Świerzewski „Bartek” z ramienia Stronnictwa Narodowego.', 'Piotr Kownacki również ze Stronnictwa Narodowego.', 'dwaj przedstawiciele Sanacji oraz drugi przedstawiciel PPS-WRN, których nazwisk nie udało się odtworzyć.']
  },
  zasady_dzialalnosci: {
    cards: [{
      id: 0,
      img: '/historia/okres_39_41/Kazimierz_Kucharski.jpg',
      desc: 'Ks. Kazimierz Kucharski „Szczepan”'
    }, {
      id: 1,
      img: '/historia/okres_39_41/Aleksander_Wasile.jpg',
      desc: 'Kpt. Aleksander Wasilewski „Olesiński”'
    }, {
      id: 2,
      img: '/historia/okres_39_41/Antoni_Olechnowicz.jpg',
      desc: 'Kpt. dypl. Antoni Olechnowicz „Pohorecki”'
    }, {
      id: 3,
      img: '/historia/okres_39_41/Jerzy_Dobrzanski.jpg',
      desc: 'Dr Jerzy Dobrzański „Maciej"'
    }],
    list: ['Wszyscy, bez względu na przynależność polityczną danej grupy, służymy jednej najważniejszej sprawie, jaką jest odzyskanie niepodległości.', 'Od tej służby nie odsuwamy nikogo, kto po wypadkach wrześniowych niczym nie zhańbił swojej godności Polaka.', 'Nie wskrzeszajmy przeszłości i obecnie nie będziemy robić z nią żadnych obrachunków.', 'Sprawę przyszłego kształtu ustrojowego Polski, zostawiamy do rozstrzygnięcia po odzyskaniu niepodległości.']
  },
  komenda_wilno: {
    cards: [{
      id: 0,
      img: '/historia/okres_39_41/Czeslaw_Debicki.jpg',
      desc: 'Mjr Czesław Dębicki „Jarema”'
    }, {
      id: 1,
      img: '/historia/okres_39_41/Stefan_Czernik.jpg',
      desc: 'Por. Stefan Czernik „Orwat”'
    }, {
      id: 2,
      img: '/historia/okres_39_41/Jerzy_Urbankiewicz.jpg',
      desc: 'Por Jerzy Urbankiewicz „Zawada”'
    }, {
      id: 3,
      img: '/historia/okres_39_41/Sergiusz_Zyndram_Koscialkowski.jpg',
      desc: 'Sergiusz Zyndram-Kościałkowski „Fakir”'
    }],
    list: ['Komendant Okręgu - ppłk dypl. Nikodem Sulik „Karol Sarnowski”, „Karol Jodko”, „Ładyna”.', 'Adiutant Komendanta Okręgu - por. Bolesław Wasilewski „Zosia”.', 'Zastępca Komendanta Okręgu i szef sztabu - ppłk Adam Obtułowicz „Karol Podgórski”, „Leon”.', 'Zastępca Komendanta d/s. Propagandy i Prasy - mjr rez. Władysław Kamiński „Śliwa”.', 'Kwatermistrz - mjr Aleksander Krzyżanowski „Wesołowski”, „Dziemido”, „Wilk”.', 'Szef Ogólnoorganizacyjny - kpt. dypl. Antoni Olechnowicz „Pohorecki”.', 'Szef Wywiadu - ppłk dypl. Zygmunt Cetnerowski „Zygmunt”.', 'Szef Łączności - por. Stefan Czernik „Orwat”.', 'Przewodniczący Komisji Finansowej, Legalizacji, Sanitarnej oraz Spraw Młodzieży', 'ks. Kazimierz Kucharski „Szczepan”.', 'Komendant Garnizonu m. Wilna „Dwór” - kpt. Aleksander Wasilewski „Olesiński” oraz kpt. Karol Zieliński „Czerw”, „Tomczyk”, „Brzoza”.', 'Komendant pozostałej części województwa „Pole”- mjr Józef Roczniak oraz kpt. inż. Czesław Dębicki „Jarema”.', 'Wojskowy Sąd Specjalny - Stanisław Ochocki „Justyn”.', 'Egzekutywa - por. Jerzy Urbankiewicz „Jurek”, Jarosław Skrodzki „Zeks”„', '„Sergiusz Zyndram-Kościałkowski „Lech”, „Fakir”']
  },
  rada_woj: {
    list: ['Przewodniczący - ppłk dypl. Nikodem Sulik „Karol Sarnowski”.', 'Wiceprzewodniczący - mjr rez. Władysław Kamiński „Śliwa” i mjr Aleksander Krzyżanowski „Dziemido”.', 'Przedstawiciel Kurii - ks. Romuald Świrkowski.', 'Przedstawiciel PPS-WRN - dr Jerzy Dobrzański „Maciej”, „Irwid”.', 'Przedstawiciel Stronnictwa Narodowego- mgr Witold Świerzewski „Bartek”.', 'Przedstawiciel Sanacji - Adam Galiński „Adam” „Pan P”.', 'Przedstawiciel Stronnictwa Ludowego od jesieni 1941 r. - prof. Ludwik Chmaj „Jaroński”.']
  },
  podokreg_kowienski: {
    list: ['Komendant - por. Zbigniew Jentys „Habdank”.', 'Z- ca komendanta do spraw wojskowych - rtm Wincenty Chrząszczewski „Kruk”.', 'Z- ca komendanta do spraw politycznych - Stanisław May „Dziadzio”.', 'Szef Oddziału Organizacyjnego - Tadeusz Kognowicki „Złoty”.', 'Szef Łączności Zewnętrznej - Stanisław Mikulicz, a następnie ppor. Eryk Budzyński „Brankard”.', 'Kwatermistrz - Józef Majewski „Literat”.', 'Szef Oddziału Propagandy i Prasy - Zygmunt Ugiański „Redaktor”.', 'Komendant wojskowy miasta Kowna - por. Kazimierz Będzicha „Grzegorz”, „Jakub”.']
  },
  podokreg_obwody: {
    list: ['Obwód Kowno - Mieczysław Turkiewicz „Szofer”.', 'Obwód Kiejdany - chor. Franciszek Madoński „Pochmurny”.', 'Obwód Szawle -Teodor Magurski „Michał”.']
  },
  pion_podokreg_kowienski: {
    cards: [{
      id: 0,
      img: '/historia/okres_39_41/Julian_Kulikowski.jpg',
      desc: 'Mjr dypl. Julian Kulikowski „Ryngraf”'
    }, {
      id: 1,
      img: '/historia/okres_39_41/Zbigniew_Jentys.jpg',
      desc: 'por. Zbigniew Jentys „Habdank”'
    }, {
      id: 2,
      img: '/historia/okres_39_41/Wincenty_Chrzaszczewski.jpg',
      desc: 'Rtm. Wincenty Chrząszczewski „Kruk”'
    }, {
      id: 3,
      img: '/historia/okres_39_41/Tadeusz_Kognowicki.jpg',
      desc: 'Tadeusz Kognowicki „Złoty”'
    }, {
      id: 4,
      img: '/historia/okres_39_41/Adam_Dowgird.jpg',
      desc: 'Dr Adam Dowgird „Dominik”'
    }, {
      id: 5,
      img: '/historia/okres_39_41/Zygmunt_Szczesny_Brzozowski.jpg',
      desc: 'Zygmunt Szczęsny-Brzozowski „Gustaw”'
    }],
    list: ['Komendant - dr Adam Dowgird „Dominik”, „Florian”.', 'Z- ca Komendanta do Spraw Cywilnych - Zygmunt Szczęsny- Brzozowski „Gustaw”.', 'Z- ca Komendanta do Spraw Wojskowych - rtm. Wincenty Chrząszczewski „Kruk”.', 'Szef Łączności - Hipolit Józef Mickiewicz „Adam”.', 'Szef Wydziału Organizacyjnego - Piotr Gieduszko.', 'Szef Komórki Informacji o Ruchu Litewskim - Gerard Knoch.', 'Szef Łączności z Komendą Okręgu Wileńskiego - Joanna Niedziałkowska „Ewa”.']
  },
  inspektorat_e: {
    list: ['Inspektor - rtm. Wincenty Chrząszczewski „Kruk”.', 'Adiutant Inspektora - ppor. Eryk Budzyński „Brankard”.', 'Kwatermistrz - Jan Chmielewski „Ojciec”.', 'Łącznicy Inspektora - Filomena Majerówna „Mała” i Julian Iwaszkiewicz „Ferdynand”.']
  }
});

/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("4Teq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta__ = __webpack_require__("p3jY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_404__ = __webpack_require__("thLP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home__ = __webpack_require__("wUZA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_aktualnosci__ = __webpack_require__("tJJ7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_aktualnosci_spuscizna_jana_gozdawy__ = __webpack_require__("03yE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_aktualnosci_relacja_z_obchodow__ = __webpack_require__("p/cU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_aktualnosci_urocz_w_wilnie__ = __webpack_require__("mFul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_aktualnosci_odzn_gen_krzyzanowski__ = __webpack_require__("Ks7a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_aktualnosci_zawiesz_posw_votum__ = __webpack_require__("OsWC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_o_autorze__ = __webpack_require__("HO1f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_kolekcja__ = __webpack_require__("VBAp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_historia__ = __webpack_require__("pnAP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_historia_okres_39_41__ = __webpack_require__("oWpz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_historia_okres_41_44__ = __webpack_require__("BvEH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_historia_dzialalnosc_bojowa__ = __webpack_require__("Tg1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_historia_powolanie_zgrupowan__ = __webpack_require__("gqSj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_historia_rozbrojenie_aresztowanie_epilog_dokumenty__ = __webpack_require__("Gz1I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_historia_tablice_epitafijne__ = __webpack_require__("6+8O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_historia_bibliografia__ = __webpack_require__("heqx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_srodowiska__ = __webpack_require__("MABx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_srodowiska_okreg_wilenski__ = __webpack_require__("apWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_srodowiska_srod_gdansk__ = __webpack_require__("eww+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_srodowiska_srod_warszawa__ = __webpack_require__("pzRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_sponsorzy__ = __webpack_require__("zvaF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_kontakt__ = __webpack_require__("xgm+");
































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_meta___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '*',
    name: 'site_404',
    component: __WEBPACK_IMPORTED_MODULE_3__components_404__["a" /* default */],
    meta: {
      title: 'AK Wilno - 404'
    }
  }, {
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_4__components_home__["a" /* default */],
    meta: {
      title: 'AK Wilno - Strona Główna'
    }
  }, {
    path: '/index.html',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_4__components_home__["a" /* default */],
    meta: {
      title: 'AK Wilno - Strona Główna'
    }
  }, {
    path: '/o_autorze',
    name: 'o_autorze',
    component: __WEBPACK_IMPORTED_MODULE_11__components_o_autorze__["a" /* default */],
    meta: {
      title: 'AK Wilno - O Autorze'
    }
  }, {
    path: '/aktualnosci',
    name: 'aktualnosci',
    component: __WEBPACK_IMPORTED_MODULE_5__components_aktualnosci__["a" /* default */],
    meta: {
      title: 'AK Wilno - Aktualności'
    }
  }, {
    path: '/aktualnosci/spuscizna_jana_gozdawy_golebiowskiego',
    name: 'spuscizna_jana_gozdawy',
    component: __WEBPACK_IMPORTED_MODULE_6__components_aktualnosci_spuscizna_jana_gozdawy__["a" /* default */],
    meta: {
      title: 'Spuścizna Jana Gozdawy-Gołębiowskiego udostępniona w OSA'
    }
  }, {
    path: '/aktualnosci/relacja_z_obchodow',
    name: 'relacja_z_obchodow',
    component: __WEBPACK_IMPORTED_MODULE_7__components_aktualnosci_relacja_z_obchodow__["a" /* default */],
    meta: {
      title: 'AK Wilno - Aktualności - Obchody 70. rocznicy operacji „Ostra Brama”'
    }
  }, {
    path: '/aktualnosci/urocz_w_wilnie',
    name: 'urocz_w_wilnie',
    component: __WEBPACK_IMPORTED_MODULE_8__components_aktualnosci_urocz_w_wilnie__["a" /* default */],
    meta: {
      title: 'AK Wilno - Aktualności - Uroczystości w Wilnie i zbiórka darów na rzecz żołnierzy AK'
    }
  }, {
    path: '/aktualnosci/odzn_gen_krzyzanowski',
    name: 'odzn_gen_krzyzanowski',
    component: __WEBPACK_IMPORTED_MODULE_9__components_aktualnosci_odzn_gen_krzyzanowski__["a" /* default */],
    meta: {
      title: 'AK Wilno - Aktualności - Odznaczenie dla Generała A. Krzyżanowskiego "Wilka"'
    }
  }, {
    path: '/aktualnosci/zawiesz_posw_votum',
    name: 'zawiesz_posw_votum',
    component: __WEBPACK_IMPORTED_MODULE_10__components_aktualnosci_zawiesz_posw_votum__["a" /* default */],
    meta: {
      title: 'AK Wilno - Aktualności - Zawieszenie i poświęcenie votum ryngrafów AK'
    }
  }, {
    path: '/historia',
    name: 'historia',
    component: __WEBPACK_IMPORTED_MODULE_13__components_historia__["a" /* default */],
    meta: {
      title: 'AK Wilno - Historia AK na Wileńszczyźnie'
    }
  }, {
    path: '/historia/okres_39_41',
    name: 'okres_39_41',
    component: __WEBPACK_IMPORTED_MODULE_14__components_historia_okres_39_41__["a" /* default */],
    meta: {
      title: 'AK Wilno - Okres Wrzesień 39\' - Czerwiec 41\''
    }
  }, {
    path: '/historia/okres_41_44',
    name: 'okres_41_44',
    component: __WEBPACK_IMPORTED_MODULE_15__components_historia_okres_41_44__["a" /* default */],
    meta: {
      title: 'AK Wilno - Okres Czerwiec 41\' - Lipiec 44\''
    }
  }, {
    path: '/historia/dzialalnosc_bojowa',
    name: 'dzialalnosc_bojowa',
    component: __WEBPACK_IMPORTED_MODULE_16__components_historia_dzialalnosc_bojowa__["a" /* default */],
    meta: {
      title: 'AK Wilno - Działalność bojowa Oddziałów i Brygad'
    }
  }, {
    path: '/historia/powolanie_zgrupowan',
    name: 'powolanie_zgrupowan',
    component: __WEBPACK_IMPORTED_MODULE_17__components_historia_powolanie_zgrupowan__["a" /* default */],
    meta: {
      title: 'AK Wilno - Powołanie Zgrupowań - Operacja "Ostra Brama" i walki pod Krawczunami'
    }
  }, {
    path: '/historia/rozbrojenie_aresztowanie_epilog_dokumenty',
    name: 'rozbrojenie_aresztowanie_epilog_dokumenty',
    component: __WEBPACK_IMPORTED_MODULE_18__components_historia_rozbrojenie_aresztowanie_epilog_dokumenty__["a" /* default */],
    meta: {
      title: 'AK Wilno - Aresztowania, rozbrojenia i represje sowieckie - EPILOG'
    }
  }, {
    path: '/historia/tablice_epitafijne',
    name: 'tablice_epitafijne',
    component: __WEBPACK_IMPORTED_MODULE_19__components_historia_tablice_epitafijne__["a" /* default */],
    meta: {
      title: 'AK Wilno - Tablice Epitafijne Okręgu Wileńskiego'
    }
  }, {
    path: '/historia/bibliografia',
    name: 'bibliografia',
    component: __WEBPACK_IMPORTED_MODULE_20__components_historia_bibliografia__["a" /* default */],
    meta: {
      title: 'AK Wilno - Bibliografia'
    }
  }, {
    path: '/kolekcja',
    name: 'kolekcja',
    component: __WEBPACK_IMPORTED_MODULE_12__components_kolekcja__["a" /* default */],
    meta: {
      title: 'AK Wilno - Kolekcja osobista śp. Janusza Bohdanowicza'
    }
  }, {
    path: '/srodowiska',
    name: 'srodowiska',
    component: __WEBPACK_IMPORTED_MODULE_21__components_srodowiska__["a" /* default */],
    meta: {
      title: 'AK Wilno - Środowiska kombatanckie'
    }
  }, {
    path: '/srodowiska/okreg_wilenski',
    name: 'okreg_wilenski',
    component: __WEBPACK_IMPORTED_MODULE_22__components_srodowiska_okreg_wilenski__["a" /* default */],
    meta: {
      title: 'AK Wilno - OKRĘG WILEŃSKI POLSKIEGO PAŃSTWA PODZIEMNEGO'
    }
  }, {
    path: '/srodowiska/srod_gdansk',
    name: 'srod_gdansk',
    component: __WEBPACK_IMPORTED_MODULE_23__components_srodowiska_srod_gdansk__["a" /* default */],
    meta: {
      title: 'AK Wilno - Środowisko Wileńskie w Gdańsku'
    }
  }, {
    path: '/srodowiska/srod_warszawa',
    name: 'srod_warszawa',
    component: __WEBPACK_IMPORTED_MODULE_24__components_srodowiska_srod_warszawa__["a" /* default */],
    meta: {
      title: 'AK Wilno - Środowisko Wileńskie w Warszawie'
    }
  }, {
    path: '/sponsorzy',
    name: 'sponsorzy',
    component: __WEBPACK_IMPORTED_MODULE_25__components_sponsorzy__["a" /* default */],
    meta: {
      title: 'AK Wilno - Sponsorzy'
    }
  }, {
    path: '/kontakt',
    name: 'kontakt',
    component: __WEBPACK_IMPORTED_MODULE_26__components_kontakt__["a" /* default */],
    meta: {
      title: 'AK Wilno - Kontakt'
    }
  }]
}));

/***/ }),

/***/ "YzLN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("O Autorze")]),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"9"}},[_c('p',[_c('b',[_vm._v("Janusz Bohdanowicz")]),_vm._v(" ps. "),_c('b',[_vm._v("„Czortek”")]),_vm._v(", syn Franciszka - zawodowego podoficera Wojska Polskiego, urodził się\n        24 czerwca 1922 r. w Wilnie. Uczęszczał do Gimnazjum im. Króla Zygmunta Augusta w Wilnie. Zaprzysiężony 15 października 1942 r.\n        przez dowódcę plutonu Garnizonu miasta Wilna, Dzielnicy Kalwaryjska kpt. rezerwy Aleksandra Downarowicza ps. „Burza”.\n        W Garnizonie miasta Wilna służył do 15 kwietnia 1944 r. Zagrożony aresztowaniem został odkomenderowany do 7.\n        Brygady Armii Krajowej Okręgu Wileńskiego por. Wilhelma Tupikowskiego ps. „Wilhelm\".\n        Służył do rozbrojenia przez wojska NKWD 18 lipca 1944 r. Został aresztowany i osadzony w obozie Miedniki Królewskie,\n        skąd 28 lipca 1944 r. wywieziony w głąb ZSRR do Kaługi, a następnie do obozu pracy leśnej w Średnikach.\n        Do Kraju powrócił 5 stycznia 1946 r. i zamieszkał w Krakowie. W styczniu 1948 r. przeniósł się do Gdańska, a od 2005 r.\n        mieszkał w Warszawie."),_c('br'),_c('br'),_vm._v(" "),_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.autor_audio_modal",modifiers:{"autor_audio_modal":true}}],staticClass:"btn-white-space"},[_vm._v("Kliknij aby wsyłuchać wypowiedź Jana Bohdanowicza na temat opracowań")])],1)]),_vm._v(" "),_c('b-col',{attrs:{"md":"3","cols":"12"}},[_c('b-img',{attrs:{"width":"200px","center":"","src":"/o_autorze/autor.jpg","center":"","fluid":""}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("\n    W latach 80. aktywnie uczestniczył w tworzeniu się organizacji kombatanckich weteranów Armii Krajowej. Był Przewodniczącym Środowiska Żołnierzy 7. Brygady „Wilhelma”, Prezesem Środowiska Wileńskiego Światowego Związku Żołnierzy Armii Krajowej w Gdańsku, a następnie w Warszawie, członkiem Komisji Historycznej Okręgu Wileńskiego, vice prezesem Zarządu Okręgu Wileńskiego, członkiem Rady Naczelnej Związku, członkiem Prezydium Zarządu Głównego, Przewodniczącym Komisji Współpracy z Młodzieżą Szkolną Światowego Związku Żołnierzy Armii Krajowej. Od 18 kwietnia 2011 r. do 20 września 2012 r. był Prezesem Okręgu Wileńskiego ŚZŻAK.\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    Janusz Bohdanowicz przez 25 lat zajmował się upowszechnianiem wiedzy historycznej na temat Armii Krajowej na Wileńszczyźnie.\n    Organizował konkursy o Armii Krajowej dla młodzieży szkolnej. Napisał monografię o historii 7. Brygady „Wilhelma” pt. Brygada\n    \"Wilhelma\": Oddziały Partyzanckie \"Żuka\" i \"Gozdawy\". Gromadził fundusze, projektował i nadzorował odbudowę cmentarza-kwatery\n    żołnierzy 7. Brygady w Skorbucianach (Litwa), jak również bieżące remonty zabytkowego kościółka w Skorbucianach.\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    Janusz Bohdanowicz zmarł 5 lipca 2013 r. w Warszawie. Uroczysty pogrzeb wojskowy odbył się 12 lipca o godz. 14.00 na\n    Cmentarzu Wojskowym na Powązkach w Warszawie. Zasłużył, aby pamięć o Nim nie zginęła!\n  ")]),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"10","xl":"8"}},[_c('b-carousel',{staticStyle:{"text-shadow":"1px 1px 2px #333","margin":"0 0em 2em 0em"},attrs:{"id":"carousel_o_autorze","controls":"","indicators":"","background":"#ababab","interval":4000}},_vm._l((_vm.carousels),function(carousel){return _c('div',{key:carousel.id},[_c('b-carousel-slide',{attrs:{"text":carousel.title,"caption":carousel.text,"img-src":carousel.img}})],1)}),0)],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"autor_audio_modal","size":"lg","title":"Od Autora","ok-only":"","ok-title":"Zamknij"},on:{"hidden":_vm.onHidden}},[_c('a-player',{ref:"o_autorze_player",attrs:{"showlrc":3,"music":{
        title: 'Od Autora',
        author: 'Janusz Bohdanowicz',
        url: '/o_autorze/od_autora.mp3',
        pic: '/o_autorze/autor.jpg',
        lrc: '/o_autorze/od_autora.lrc'
    }}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZseY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sideBar'
});

/***/ }),

/***/ "aPSQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__("rKsW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]);

/***/ }),

/***/ "aPm1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Zawieszenie i poświęcenie votum ryngrafów Armii Krajowej w Kościołach na Litwie")]),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',[_vm._v("\n        W kwietniu 2011r. Prezes Okręgu Wileńskiego Światowego Związku Żołnierzy Armii Krajowej – Janusz Bohdanowicz –\n        wziął udział w uroczystości poświęcenia nowej dzwonnicy przy kaplicy w Skorbucianach koło Wilna, gdzie znajduje\n        się cmentarz żołnierzy 7 Wileńskiej Brygady AK, poległych w czasie II Wojny Światowej. W trakcie tego spotkania ze\n        strony Prezesa Akcji Wyborczej Polaków na Litwie, p. Waldemara Tomaszewskiego, poszła propozycja upamiętnienia miejsc\n        pochówku żołnierzy AK z tej i innych brygad wileńskich przez zainstalowanie we właściwych kościołach odpowiednich\n        ryngrafów – votum.\n      ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"6"}},[_c('p',[_vm._v("\n        Sprawa ta została omówiona na następnym spotkaniu w lipcu 2011r. w Krawczunach, z\n        okazji uroczystości rocznicy Operacji „Ostra Brama”, czyli walk AK o Wilno. Ustalono, że także ryngrafy –\n        vota zostaną umieszczone w kościołach, przy których znajduje się cmentarz poległych żołnierzy:\n        "),_c('ul',{staticClass:"mt-4"},[_c('li',[_vm._v("3 Brygady – w Koloni Wileńskiej")]),_vm._v(" "),_c('li',[_vm._v("6 Brygady – w Koleśnikach")]),_vm._v(" "),_c('li',[_vm._v("7 Brygady – w Skorbucianach")])])])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"4"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":"/aktualnosci/zawiesz_posw_votum/zawiesz_posw_votum_foto_1.jpg"}}),_c('br')],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"6"}},[_c('p',[_vm._v("\n        Patronat nad tą akcją objęła Akcja Wyborcza Polaków na Litwie, biorąc na siebie dokonanie niezbędnych uzgodnień\n        z parafiami w/w kościołów, lokalnymi władzami (rejonowymi i gminnymi) oraz właściwymi szkołami.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Powyższe ryngrafy zostały zaprojektowane przez właściwe brygady według jednego ogólnego wzoru, w porozumieniu z\n        Zarządem Okręgu Wileńskiego SZŻAK. Brygady sfinansowały też wykonanie tych ryngrafów.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Uroczyste poświęcenie zainstalowanych już w kościołach ryngrafów nastąpiło w dniu 13-15 maja 2012 r. w\n        obecności delegacji z Polski, obejmującej przedstawicieli Zarządu Okręgu Wileńskiego SZŻAK i środowisk\n        zainteresowanych brygad. W uroczystościach tych wzięli też udział przedstawiciele Konsulatu RP na Litwie,\n        Akcji Wyborczej Polaków na Litwie i lokalnych władz.\n      ")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"5"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":"/aktualnosci/zawiesz_posw_votum/zawiesz_posw_votum_foto_2.jpg"}}),_c('br')],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',[_vm._v("\n        Osobom z miejscowej ludności polskiej na Litwie, które przyczyniły się do zainstalowania omawianych ryngrafów –\n        votum i do zorganizowania uroczystości ich poświęcenia zostały w dowód wdzięczności wręczone pamiątkowe ryngrafy\n        poszczególnych brygad – w sumie 21 ryngrafów.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Najważniejsze momenty uroczystości przedstawia film, którego nagranie zostało sfinansowane z\n        funduszy przekazanych przez Środowisko Wileńskie AK w USA.\n      ")])])],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"12","md":"9"}},[_c('b-carousel',{staticClass:"carousel_votum",staticStyle:{"text-shadow":"1px 1px 2px #333","margin":"0 0em 2em 0em"},attrs:{"controls":"","indicators":"","background":"#ababab","interval":0}},_vm._l((_vm.carousels),function(carousel){return _c('div',{key:carousel.id},[_c('b-carousel-slide',{attrs:{"caption":carousel.title,"text":carousel.text,"img-src":carousel.img}})],1)}),0)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "afmS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_aplayer_vue__ = __webpack_require__("HPoU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a8494de2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_aplayer_vue__ = __webpack_require__("ma6R");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_aplayer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a8494de2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_aplayer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "apWd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_okreg_wilenski_vue__ = __webpack_require__("Q5zO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e4de778_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_okreg_wilenski_vue__ = __webpack_require__("eAUp");
function injectStyle (ssrContext) {
  __webpack_require__("rX3i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_okreg_wilenski_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e4de778_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_okreg_wilenski_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bh3G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ciLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-2"},[_vm._v("404")]),_vm._v(" "),_c('p',[_vm._v("\n    Nie znaleziono strony o podanym adresie."),_c('br'),_vm._v("\n    Aby przejść do strony głównej kliknij "),_c('router-link',{attrs:{"active-class":"activeNav","to":"/","exact":""}},[_vm._v("tutaj")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dXrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.name && this.$children.length === 0) {
      console.warn('Invalid prop: prop "name" is required.');
      return;
    }

    if (this.icon) {
      return;
    }

    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;

      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ "eAUp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("OKRĘG WILEŃSKI POLSKIEGO PAŃSTWA PODZIEMNEGO")]),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',[_vm._v("\n        W roku 1970 Edward Gierek objął najwyższe stanowisko Władz partyjnych w Kraju i jednocześnie\n        zostały bardzo złagodzone inwigilacje, aresztowania i represje stosowane przez Służby Bezpieczeństwa\n        do żołnierzy Armii Krajowej Okręgu Wileńskiego.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Pierwszą legalnie organizowaną uroczystością o zasięgu krajowym było odsłonięcie tablicy epitafijnej poświęconej\n        komendantowi żołnierzom 3. Brygady „Szczerbca” por. Gracjana Fróga w kościele pw. Św. Bartłomieja. Powstanie\n        idei ufundowania tej tablicy sięga roku 1966 kiedy powstało nielegalne w ówczesnych czasach Środowisko 3.\n        Brygady „Szczerbca”. Pomysłodawcami budowy tej tablicy byli: Sabina Korejwo „Sabina”, Marian Korejwo „Milimetr”,\n        Zdzisław Christa „Mamut”, Tadeusz Dunowski „Ali” i inni. Pomimo silnych interwencji organów Służby Bezpieczeństwa\n        w stosunku do inicjatorów jak i projektanta tablicy została ona wykonana, zamocowana i poświęcona 25.09.1971 r.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        W tym samym czasie czynnie działały Środowiska innych Brygad i Kół żołnierzy Armii Krajowej Okręgu\n        Wileńskiego we Wrocławiu, Łodzi, Szczecinie, Olsztynie i Warszawie. Środowiska te próbowały oficjalnie\n        organizować na swoim terenie Kluby Żołnierzy Armii Krajowej Okręgu Wileńskiego jako jednostki legalne w\n        ramach jedynego Związku Kombatanckiego ZBoWiD, nie wszędzie to się udawało.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        W tym samym czasie istniała już tzw. Rada Starszych, którą tworzyli żyjący oficerowie Komendy\n        Okręgu i dowódcy Brygad i Oddziałów.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        W roku 1990 został sądownie zarejestrowany Światowy Związek Żołnierzy Armii Krajowej (ŚZŻAK),\n        do którego czynne Środowiska Brygadowe i Koła Okręgowe wstąpiły gremialnie. Statut ŚZŻAK przewidywał\n        podział jednostek na Koła zrzeszające żołnierzy Armii Krajowej mieszkających na obszarze działalności\n        Koła bez względu na przynależność do Okręgów AK oraz Środowiska zrzeszające żołnierzy danej jednostki\n        bojowej bez względu na miejsce bieżącego zamieszkania.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        W roku 1992 Środowisko Wileńskie w Gdańsku zgłosiło swój akces do Okręgu Wileńskiego ŚZŻAK. Od tego czasu\n        Okręg Wileński obejmował swoją działalnością dwa Środowiska: Warszawskie i Gdańskie. Oba Środowiska działały\n        samodzielnie wg uchwalonych programów przez swoje Walne Zgromadzenia i posiadanych środków finansowych.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Drugim Prezesem Okręgu Wileńskiego został , wybrany na Walnym Zebraniu Sprawozdawczo-Wyborczym kol. Lech Iwanowski\n        „Lancet” żołnierz 3. Brygady „Szczerbca”. Pierwszym Prezesem Okręgu Wileńskiego ŚZŻAK został kol.\n        Ryszard Andrys-Jankowski „Orlik”.\n      ")]),_vm._v(" "),_c('b-row',_vm._l((_vm.okreg_wilenski.profiles),function(profile){return _c('b-col',{key:profile.id,attrs:{"xl":profile.cols.xl,"lg":profile.cols.lg,"md":profile.cols.md,"cols":profile.cols.sm}},[_c('b-card',{staticClass:"mb-2",staticStyle:{"width":"10em","min-height":"24em"},attrs:{"img-src":profile.img,"img-top":"","tag":"article"}},[_c('p',{staticClass:"card-text"},[_vm._v("\n              "+_vm._s(profile.text)+"\n            ")])])],1)}),1),_vm._v(" "),_c('p',[_vm._v("\n        Dnia 20 września 2012 roku na skutek pogarszającego się stanu zdrowia zrezygnował ze stanowiska prezesa\n        Okręgu Wileńskiego. Na jego miejsce wybrano wiceprezesa okręgu Włodzimierza Mikucia, na okres zorganizowania\n        zjazdu delegatów i zarządów środowisk i wybrania nowego prezesa.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Trzecim Prezesem Zarządu Okręgu Wileńskiego ŚZŻAK został kol. Ludwik Świda „Błysk”, również żołnierz 3.\n        Brygady. Funkcje tą pełnił przez dwie kadencje. Jego podstawową działalnością w tym okresie było\n        organizowanie trzech kolejnych spotkań historyków polskich i litewskimi dla uzgodnień na podstawie\n        materiałów źródłowych działalności Armii Krajowej na terytorium Polskiego Państwa Podziemnego na obszarze\n        Województwa Wileńskiego do czasu podpisania Kontraktu zmieniającego granice Państwa Polskiego tzn. do 14 lutego 1946 roku.\n      ")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"7"}},[_c('p',[_vm._v("\n            Po rozwiązaniu w Gdańsku Komisji Historycznej Okręgu Wileńskiego, na zebraniu plenarnym Zarządu\n            wybrano nową komisję Historyczną Okręgu Wileńskiego. Przewodniczącym został Jan Leszek Malinowski „Orland”.\n            Podął się kontynuowania wydawania periodyku Okręgu Wileńskiego pod zmienionym tytułem i wprowadzeniu\n            informacji z bieżącej działalności Zarządu i podległych Środowisk. Należność dla drukarni opłacać będzie Zarząd Okręgu.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Organizował remonty i odbudowywanie cmentarzy Żołnierzy Armii Krajowej przez Radę Ochrony Pamięci Walk i\n            Męczeństwa na terenie Wileńszczyzny. W tym okresie odbudowano i wyremontowano następujące cmentarze: w\n            Kolonii Wileńskiej, Kalwarii Wileńskiej, w Wilnie na Rossie, w Puszczy Rudnickiej żołnierzy „Komara”, w\n            Wodzianach i Marcebolinie.\n            Czwartym Prezesem do dnia 28 kwietnia 2011 roku był kol. Henryk Szostakowski.\n            Piątym Prezesem Okręgu Wileńskiego 28 kwietnia 2011 roku został wybrany kol. Janusz Bohdanowicz „Czortek” przez delegatów Środowisk Wileńskich w Gdańsku i Warszawie, jednocześnie pozostając prezesem Środowiska Wileńskiego w Warszawie.\n            Działalność Środowisk Okręgu Wileńskiego przedstawiamy indywidualnie.\n          ")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('b-img',{attrs:{"center":"","src":"/srodowiska/okreg_wilenski/pamietnik_okregu_wilenskiego.jpg","center":"","fluid":""}})],1)],1),_vm._v(" "),_c('p',{staticClass:"display-4"},[_vm._v("Cmentarze żołnierzy")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v(" Armii Krajowej na Wileńszczyźnie")]),_vm._v(" "),_c('p',[_vm._v("\n        Największym odrestaurowanym cmentarzem poległych żołnierzy Armii Krajowej na Wileńszczyźnie jest\n        cmentarz w Wilnie na Rossie, przy mauzoleum serca Marszałka Polski Józefa Piłsudskiego. Pozostałe w\n        kolejności dat ich odbudowy:\n      ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("w Skorbucianach pod Wilnem – cmentarz 7. Brygady „Wilhelma”, ")]),_vm._v(" "),_c('li',[_vm._v("w Mikuliszkach – obecnie Białoruś – cmentarz 3. Brygady „Szczerbca” i 6. Brygady „Tońki”, ")]),_vm._v(" "),_c('li',[_vm._v("w Koleśnikach – cmentarz 6. Brygady „Konara”, ")]),_vm._v(" "),_c('li',[_vm._v("w Worzianach – obecnie Białoruś – cmentarz 5. Brygady „Łupaszki”, ")]),_vm._v(" "),_c('li',[_vm._v("w Kalwarii Wileńskiej – cmentarz poległych w walkach o Wilno z 1. Brygady „Juranda”, 4. Brygady „Ronina”, 36. Brygady „Wujka”, ")]),_vm._v(" "),_c('li',[_vm._v("w Kolonii Wileńskiej – cmentarz poległych w walkach o Wilno żołnierzy 3. Brygady „Szczerbca”i II batalionu „Krysi”, ")]),_vm._v(" "),_c('li',[_vm._v("pod Marcebolinem – obecnie Białoruś - cmentarz żołnierzy 23. Brygady „Ostrogi”, ")]),_vm._v(" "),_c('li',[_vm._v("Puszcza Rudnicka – miejsce pochówku – poległych żołnierzy Oddziału „Komara”, ")]),_vm._v(" "),_c('li',[_vm._v("nad jeziorem Narocz– prawdopodobne miejsce egzekucji 80 żołnierzy Oddziału „Kmicica”,")]),_vm._v(" "),_c('li',[_vm._v("Nowosady – obecnie Białoruś – cmentarz żołnierzy Oddziału „Edka”, ")]),_vm._v(" "),_c('li',[_vm._v("Ławże koło Oszmiany – obecnie Białoruś – miejsce pochówku żołnierzy Oddziału W. Mikuća „Jarema”. ")]),_vm._v(" "),_c('li',[_vm._v("Graużyszki – obecnie Białoruś – cmentarz żołnierzy 13. Brygady „Nietoperza” i 8. Brygady Tura”, ")]),_vm._v(" "),_c('li',[_vm._v("Dubicze – cmentarz pochowanych po ekshumacji prochów żołnierzy 6. Brygady „Konara” i II batalionu 77 pp. AK „Krysi”, ")]),_vm._v(" "),_c('li',[_vm._v("Ejszyszki – cmentarz pochowanych po ekshumacji prochów dowódcy II batalionu 77 pp. AK „Krysi” i jego żołnierzy,")]),_vm._v(" "),_c('li',[_vm._v("Glinciszki koło Podbrzezia - cmentarz 38 mieszkańców Glińczyszek zamordowanych przez policję Litewską z posterunku w Podbrzeziu w dniu 30 czerwca 1944r.")])]),_vm._v(" "),_c('p',[_vm._v("\n        Na kilkunastu cmentarzach parafialnych na terenie obecnej Litwy i Białorusi postawiono\n        nowe jednolite krzyże z tabliczkami epitafijnymi.\n      ")])],1)],1),_vm._v(" "),_vm._l((_vm.okreg_wilenski.videos),function(video){return _c('b-row',{key:video.id,staticClass:"mb-5"},[_c('b-col',{attrs:{"md":"7"}},[_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":video.url,"allowfullscreen":""}})],1),_vm._v(" "),_c('b-col',{staticClass:"lead",attrs:{"md":"4"}},[_vm._v("\n      "+_vm._s(video.text)+"\n    ")])],1)}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',{staticClass:"display-4"},[_vm._v("Glinciszki")]),_vm._v(" "),_c('p',[_vm._v("\n        Zaczęło się w Glinciszkach koło Podbrzezia. Był to majątek Jeleńskich administrowany przymusowo\n        przez Landbweirtschafungsgessellschaft Ostland (LO), w grupie majątków, której dyrektorem był\n        Władysław Komar. Nad ranem 20 czerwca patrol 5 Brygady dowodzony przez Antoniego Rymszę „Maksa”\n        urządził koło Glinciszek zasadzkę, w którą wpadł litewski patrol policyjny, tracąc 4 zabitych.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Kilka godzin później przybył z Podbrzezia oddział 258 batalionu litewskiego pod dowództwem por.\n        Polekauskasa i dokonał krwawego odwetu, zabijając 10 Polaków za 1 Litwina. Zamordowano ogółem 38 osób, wśród\n        których – oprócz mieszkańców miejscowych – znalazło się kilka przypadkowych osób. Masakrę opisał naoczny świadek,\n        czternastoletni wówczas Henryk Konieczny, który wyszedł wcześniej z ogrodu, skąd – ukryty za krzakiem – obserwował\n        przebieg masakry. Rozstrzeliwano partiami, nie szczędząc nikogo – dzieci, starców, kobiet. Zabito między innymi\n        czworo małych dzieci od 3 do 5 lat i czworo ludzi starych, od 63 do 84 lat. Jedenastu mężczyzn sprowadzonych\n        specjalnie przez policję musiał wykopać dół, do którego byle jak wrzucono ciała ofiar.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Wieść o zbrodni dotarła telefonicznie do Komara, który natychmiast wyruszył do Glinciszek samochodem\n        służbowym w towarzystwie zastępcy kierownika LO – Niemca Hofmanna - i niemieckiego kierowcy.\n        Po zorientowaniu się na miejscu o tragicznym wydarzeniu, Komar wyruszył w drogę powrotną do Wilna\n        przez Podbrzezie. Tu doszło do nowej tragedii. Litwini zatrzymali samochód, wyciągnęli z niego Komara,\n        a Niemcom kazali jechać dalej. Komar wyrwał się litewskim policjantom, lecz przy próbie ucieczki został zastrzelony.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Wśród Litwinów panowało podobno przekonanie, że zlikwidowali komendanta AK „Wilka”.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Wkrótce przybyli do Glinciszek niemieccy policjanci wraz z przedstawicielami LO. Po przeprowadzeniu\n        dochodzenia ściągnęli z Podbrzezia Litwinów i kazali im dokonać ekshumacji zwłok. Ekshumacje przeprowadzono,\n        zwłoki włożono do trumien i pogrzebano nieopodal drogi do Podbrzezia. Władysław Komar za zgodą Gebietskommissara\n        Wolffa został pochowany przez rodzinę na Rossie.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Protokół ekshumacji sporządziła Irena Sławinska, pracowniczka kancelarii majątku Glinciszki.\n        Była ona absolwentką wydziału humanistycznego USB i poza pracą w kancelarii prowadziła dla miejscowej\n        młodzieży komplety tajnego nauczania. Odpis protokołu zachowała , dzięki czemu znana jest pełna\n        lista ofiar potwornej zbrodni.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Na rozkaz naczelnika niemieckiego sztabu zwalczania partyzantów Musila aresztowano dowódcę oddziału\n        litewskiego Polekauskasa, odpowiedzialnego za dokonanie masakry, i 33 żołnierzy. Stanęli oni przed sądem SS.\n      ")]),_vm._v(" "),_c('p',{staticClass:"text-right"},[_vm._v("Longin Tomaszewski")])])],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"10","xl":"6"}},[_c('b-carousel',{staticClass:"carousel_okreg",staticStyle:{"text-shadow":"1px 1px 2px #333","margin":"0 0em 2em 0em"},attrs:{"controls":"","indicators":"","background":"#ababab","interval":0}},_vm._l((_vm.okreg_wilenski.carousel),function(carousel){return _c('div',{key:carousel.id},[_c('b-carousel-slide',{attrs:{"caption":carousel.title,"text":carousel.text,"img-src":carousel.img}})],1)}),0)],1)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eI7/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_srodowiska_js__ = __webpack_require__("Mcx+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'srodowiska',
  data: function data() {
    return {
      srodowiska: __WEBPACK_IMPORTED_MODULE_0__models_srodowiska_js__["a" /* default */].srodowiska
    };
  },
  metaInfo: {
    title: 'Środowiska',
    meta: [{ name: 'description', content: 'Okręg Wileński Polskiego Państwa Podziemnego, Środowisko Wileńskie w Gdańsku oraz w Warszawie' }, { name: 'og:url', content: 'http://akwilno.pl/srodowiska' }, { name: 'og:title', content: 'Środowiska' }, { name: 'og:image', content: '/srodowiska/okreg_wilenski.jpg' }, { name: 'og:description', content: 'Okręg Wileński Polskiego Państwa Podziemnego, Środowisko Wileńskie w Gdańsku oraz w Warszawie' }, { name: 'twitter:url', content: 'http://akwilno.pl/srodowiska' }, { name: 'twitter:title', content: 'Środowiska' }, { name: 'witter:image', content: '/srodowiska/okreg_wilenski.jpg' }, { name: 'twitter:description', content: 'Okręg Wileński Polskiego Państwa Podziemnego, Środowisko Wileńskie w Gdańsku oraz w Warszawie' }]
  }
});

/***/ }),

/***/ "eww+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_srod_gdansk_vue__ = __webpack_require__("NV6A");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_202f1489_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_srod_gdansk_vue__ = __webpack_require__("AdjB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_srod_gdansk_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_202f1489_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_srod_gdansk_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fcFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__("qRo1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */]);

/***/ }),

/***/ "gT/o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gqSj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_powolanie_zgrupowan_vue__ = __webpack_require__("z+9x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73f52551_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_powolanie_zgrupowan_vue__ = __webpack_require__("ofZi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_powolanie_zgrupowan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73f52551_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_powolanie_zgrupowan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hRS/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("AK Wilno")]),_vm._v(" "),_c('p',[_vm._v("\n    Twórcą strony internetowej www.AKWilno.pl jest śp. Janusz Bohdanowicz, który znaczną część swojego życia poświęcił na gromadzenie materiałów\n    o Armii Krajowej na Wileńszczyźnie, cyfryzacji zbiorów oraz ich upowszechnienie w postaci skanów fotografii, dokumentów i tekstów.\n  ")]),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"12","xl":"10"}},[_c('b-carousel',{staticClass:"carousel",staticStyle:{"text-shadow":"1px 1px 2px #333","margin":"0 0em 2em 0em"},attrs:{"controls":"","indicators":"","background":"#ababab","interval":4000}},_vm._l((_vm.carousels),function(carousel){return _c('div',{key:carousel.id},[_c('b-carousel-slide',{attrs:{"caption":carousel.title,"text":carousel.text,"img-src":carousel.img}})],1)}),0)],1)],1),_vm._v(" "),_c('p',[_vm._v("\n    Na stronie znajdują się cenne informacje, dotyczące żołnierzy Armii Krajowej na Wileńszczyźnie w okresie II wojny światowej -\n    życiorysy dowódców oraz kalendaria działalności Brygad i Oddziałów Armii Krajowej, opracowania związane z operacją „Ostra Brama”,\n    tworzeniem się struktur Podziemnego Państwa Polskiego na obszarze Wileńszczyzny. Strona powstała z myślą o badaczach dziejów Polski w XX wieku,\n    pasjonatach historii czynów zbrojnych w XX wieku oraz dla tych wszystkich ludzi,\n    którzy nadal poszukują informacji o swoich bliskich. Celem nadrzędnym, który postawił sobie śp. Janusz Bohdanowicz,\n     była myśl o ocaleniu pamięci o żołnierzach Armii Krajowej dla przyszłych pokoleń Polaków.\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    Ideę tę podtrzymuje Ośrodek KARTA, który od 2013 r. opiekuje się stroną internetową po śmierci p. Janusza Bohdanowicza.\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "heqx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bibliografia_vue__ = __webpack_require__("hmTh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92456076_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bibliografia_vue__ = __webpack_require__("1bRH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bibliografia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92456076_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bibliografia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hmTh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_historia_bibliografia__ = __webpack_require__("RgFJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bibliografia',
  data: function data() {
    return {
      people: __WEBPACK_IMPORTED_MODULE_0__models_historia_bibliografia__["a" /* default */].people
    };
  },
  metaInfo: {
    title: 'Bibliografia',
    meta: [{ name: 'description', content: '' }, { name: 'og:url', content: 'http://akwilno.pl/historia/bibliografia' }, { name: 'og:title', content: 'Bibliografia' }, { name: 'og:image', content: '/main/menu_logo.png' }, { name: 'og:description', content: '' }, { name: 'twitter:url', content: 'http://akwilno.pl/historia/bibliografia' }, { name: 'twitter:title', content: 'Bibliografia' }, { name: 'witter:image', content: '/main/menu_logo.png' }, { name: 'twitter:description', content: '' }]
  }
});

/***/ }),

/***/ "iu87":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_aktualnosci_js__ = __webpack_require__("z9yW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'aktualnosci',
  data: function data() {
    return {
      news: __WEBPACK_IMPORTED_MODULE_0__models_aktualnosci_js__["a" /* default */].news
    };
  },
  metaInfo: {
    title: 'Aktualności',
    meta: [{ name: 'description', content: 'AK Wilno - Aktualności ze strony' }, { name: 'og:url', content: 'http://akwilno.pl/aktualnosci' }, { name: 'og:title', content: 'Aktualności' }, { name: 'og:image', content: '/aktualnosci/relacja_z_obchodow.jpg' }, { name: 'og:description', content: 'AK Wilno - Aktualności ze strony' }, { name: 'twitter:url', content: 'http://akwilno.pl/aktualnosci' }, { name: 'twitter:title', content: 'AK Wilno' }, { name: 'witter:image', content: '/aktualnosci/relacja_z_obchodow.jpg' }, { name: 'twitter:description', content: 'AK Wilno - Aktualności ze strony' }]
  }
});

/***/ }),

/***/ "iw8l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  carousels: [{
    id: 0,
    title: '',
    text: 'Patent dla Janusza Bohdanowicza wydany przez Kierownika Urzędu ds. Kombatantów i Osób Represjonowanych oraz Prezesa Rady Ministrów Rzeczypospolitej Polskiej w 1999 roku.',
    img: "/o_autorze/o_autorze_1.jpg"
  }, {
    id: 1,
    title: '',
    text: 'Podziękowanie dla Janusza Bohdanowicza od Leszka Pałasza, Starosty Bytowskiego za organizację konkursu „Armia Krajowa w Okręgu Wileńskim” z 21 stycznia 2002 roku.',
    img: "/o_autorze/o_autorze_2.jpg"
  }, {
    id: 2,
    title: '',
    text: 'Podziękowanie dla Janusza Bohdanowicza za przygotowanie wystawy fotograficznej na uroczystość poświęcenia sztandaru od Komitetu Fundacji Sztandaru Okręgu Nowogródzkiego Armii Krajowej.',
    img: "/o_autorze/o_autorze_3.jpg"
  }, {
    id: 3,
    title: '',
    text: 'Arkusz weryfikacyjny do zaświadczenia o służbie Janusza Bohdanowicza w 7. Brygadzie „Wilhelma” Armii Krajowej.',
    img: "/o_autorze/o_autorze_4.jpg"
  }, {
    id: 4,
    title: '',
    text: 'Uzasadnienie nadania Januszowi Bohdanowiczowi ps. „Czortek” odznaczenia Krzyża Walecznych.',
    img: "/o_autorze/o_autorze_5.jpg"
  }, {
    id: 5,
    title: '',
    text: 'Artykuł pt. „My z 7. Wileńskiej Brygady AK” – wspomnienia Janusza Bohdanowicza ps. „Czortek”, opublikowane w 1990 roku.',
    img: "/o_autorze/o_autorze_6_7.jpg"
  }, {
    id: 6,
    title: '',
    text: 'Artykuł Jerzego Surwiło pt. „Wyświęcenie cmentarza żołnierskiego 7. Brygady AK. Skorbuciany, 14 lipca 1991”, opublikowany w „Kurierze Wileńskim”.',
    img: "/o_autorze/o_autorze_8.jpg"
  }, {
    id: 7,
    title: '',
    text: 'Artykuł pt. „Nasze wspólne dziedzictwo. W Koleśnikach na Jasnej Górze”, opublikowany w „Kurierze Wileńskim” z 13 lipca 1993 roku.',
    img: "/o_autorze/o_autorze_9.jpg"
  }, {
    id: 8,
    title: '',
    text: 'Artykuł Krystyny Adamowicz pt. "Dobroczynność. Łańcuch gorących serc", opublikowany w „Kurierze Wileńskim” z 29 października 1994 roku.',
    img: "/o_autorze/o_autorze_10.jpg"
  }, {
    id: 9,
    title: '',
    text: 'Artykuł pt. „Kolejna akcja dobroczynności. Pan Janusz Bohdanowicz znowu pomaga”, opublikowany w „Kurierze Wileńskim” z 22 kwietnia 1995 roku.',
    img: "/o_autorze/o_autorze_11.jpg"
  }]
});

/***/ }),

/***/ "jLiD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Historia AK na Wileńszczyźnie")]),_c('br'),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},_vm._l((_vm.historiaList),function(msg){return _c('div',{key:msg.id},[_c('b-media',{staticClass:"mb-3",attrs:{"tag":"li"}},[_c('b-img',{attrs:{"slot":"aside","src":msg.img,"width":"120"},slot:"aside"}),_vm._v(" "),_c('h5',{staticClass:"mt-0 mb-2"},[_c('router-link',{staticClass:"router-link-list",attrs:{"active-class":"activeSide","to":msg.url,"exact":""}},[_vm._v(_vm._s(msg.title))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"10"}},[_vm._v("\n            "+_vm._s(msg.text)),_c('router-link',{attrs:{"active-class":"activeSide","to":msg.url,"exact":""}},[_vm._v(".....więcej")])],1)],1)],1)],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kJiG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__("9NuQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */]);

/***/ }),

/***/ "mFul":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_urocz_w_wilnie_vue__ = __webpack_require__("CMmO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f996bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_urocz_w_wilnie_vue__ = __webpack_require__("Nzle");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_urocz_w_wilnie_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f996bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_urocz_w_wilnie_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ma6R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aplayer"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mlNU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_aplayer__ = __webpack_require__("afmS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_o_autorze_js__ = __webpack_require__("iw8l");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'o_autorze',
  components: {
    'a-player': __WEBPACK_IMPORTED_MODULE_0_vue_aplayer__["a" /* default */]
  },
  data: function data() {
    return {
      carousels: __WEBPACK_IMPORTED_MODULE_1__models_o_autorze_js__["a" /* default */].carousels
    };
  },
  methods: {
    onHidden: function onHidden() {
      var o_autorze_player = this.$refs.o_autorze_player.control;
      o_autorze_player.pause();
      o_autorze_player.audio.currentTime = 0;
    }
  },
  metaInfo: {
    title: 'O Autorze',
    meta: [{ name: 'description', content: 'Janusz Bohdanowicz ps. „Czortek”, syn Franciszka - zawodowego podoficera Wojska Polskiego, urodził się 24 czerwca 1922 r. w Wilnie. Uczęszczał do Gimnazjum im. Króla Zygmunta Augusta w Wilnie...' }, { name: 'og:url', content: 'http://akwilno.pl/o_autorze' }, { name: 'og:title', content: 'O Autorze' }, { name: 'og:image', content: '/o_autorze/autor.jpg' }, { name: 'og:description', content: 'Janusz Bohdanowicz ps. „Czortek”, syn Franciszka - zawodowego podoficera Wojska Polskiego, urodził się 24 czerwca 1922 r. w Wilnie. Uczęszczał do Gimnazjum im. Króla Zygmunta Augusta w Wilnie...' }, { name: 'twitter:url', content: 'http://akwilno.pl/o_autorze' }, { name: 'twitter:title', content: 'O Autorze' }, { name: 'witter:image', content: '/o_autorze/autor.jpg' }, { name: 'twitter:description', content: 'Janusz Bohdanowicz ps. „Czortek”, syn Franciszka - zawodowego podoficera Wojska Polskiego, urodził się 24 czerwca 1922 r. w Wilnie. Uczęszczał do Gimnazjum im. Króla Zygmunta Augusta w Wilnie...' }]
  }
});

/***/ }),

/***/ "nCfJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_historia_tablice_epitafijne__ = __webpack_require__("Otsa");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tablice_epitafijne',
  data: function data() {
    return {
      tables: __WEBPACK_IMPORTED_MODULE_0__models_historia_tablice_epitafijne__["a" /* default */].tables
    };
  },
  metaInfo: {
    title: 'Tablice Epitafijne Okręgu Wileńskiego',
    meta: [{ name: 'description', content: 'Zdjęcia tablic epitafijnych Okręgu Wileńskiego z podziałem na miasta, w których się znajdują oraz z opisem dokładnej lokalizacji poszczególnych tablic' }, { name: 'og:url', content: 'http://akwilno.pl/historia/tablice_epitafijne' }, { name: 'og:title', content: 'Tablice Epitafijne Okręgu Wileńskiego' }, { name: 'og:image', content: '/historia/tablice_epitafijne.jpg' }, { name: 'og:description', content: 'Zdjęcia tablic epitafijnych Okręgu Wileńskiego z podziałem na miasta, w których się znajdują oraz z opisem dokładnej lokalizacji poszczególnych tablic' }, { name: 'twitter:url', content: 'http://akwilno.pl/historia/tablice_epitafijne' }, { name: 'twitter:title', content: 'Tablice Epitafijne Okręgu Wileńskiego' }, { name: 'witter:image', content: '/historia/tablice_epitafijne.jpg' }, { name: 'twitter:description', content: 'Zdjęcia tablic epitafijnych Okręgu Wileńskiego z podziałem na miasta, w których się znajdują oraz z opisem dokładnej lokalizacji poszczególnych tablic' }]
  }
});

/***/ }),

/***/ "nD/r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_historia_dzialalnosc_bojowa__ = __webpack_require__("7+tn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dzialalnosc_bojowa',
  data: function data() {
    return {
      fields: ['brygada', 'data', 'link'],
      brygady: __WEBPACK_IMPORTED_MODULE_0__models_historia_dzialalnosc_bojowa__["a" /* default */].brygady
    };
  },
  metaInfo: {
    title: 'Działalność bojowa Oddziałów i Brygad',
    meta: [{ name: 'description', content: 'Brygady i Oddziały Okręgu Wileńskiego Armii Krajowej (kolejność wg rozpoczęcia działań)' }, { name: 'og:url', content: 'http://akwilno.pl/historia/dzialalnosc_bojowa' }, { name: 'og:title', content: 'Działalność bojowa Oddziałów i Brygad' }, { name: 'og:image', content: '/historia/dzialalnosc_bojowa.jpg' }, { name: 'og:description', content: 'Brygady i Oddziały Okręgu Wileńskiego Armii Krajowej (kolejność wg rozpoczęcia działań)' }, { name: 'twitter:url', content: 'http://akwilno.pl/historia/dzialalnosc_bojowa' }, { name: 'twitter:title', content: 'Działalność bojowa Oddziałów i Brygad' }, { name: 'witter:image', content: '/historia/dzialalnosc_bojowa.jpg' }, { name: 'twitter:description', content: 'Brygady i Oddziały Okręgu Wileńskiego Armii Krajowej (kolejność wg rozpoczęcia działań)' }]
  }
});

/***/ }),

/***/ "nHb0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oEnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Okres Wrzesień 39' - Czerwiec 41'")]),_c('br'),_vm._v(" "),_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"md":"5"}},[_c('p',{staticClass:"lead"},[_vm._v("POLSKIE PAŃSTWO PODZIEMNE. PODZIAŁ NA OKRĘGI")]),_vm._v(" "),_c('b-img',{attrs:{"center":"","fluid":"","src":"/historia/okres_39_41/polskie_panstwo_pod_podzial_okregi.jpg"}}),_c('br')],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('p',{staticClass:"lead"},[_vm._v("OKRĘG WILEŃSKI ARMII KRAJOWEJ")]),_vm._v(" "),_c('b-img',{attrs:{"center":"","fluid":"","src":"/historia/okres_39_41/okreg_wilenski_armii_krajowej.jpg"}}),_c('br')],1)],1),_vm._v(" "),_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"md":"8"}},[_c('b-card',[_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":"/historia/okres_39_41/Michał_Tadeusz_Tokarzewski_Karaszewicz.jpg"}}),_c('br')],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('strong',[_vm._v("Generał broni Michał Tadeusz Tokarzewski-Karaszewicz")]),_c('br'),_vm._v("\n            Twórca Polskiego Państwa Podziemnego"),_c('br'),_vm._v("\n            Dowódca Służby Zwycięstwa Polski.\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"justify-content-md-center mt-3"},[_c('b-col',{attrs:{"md":"8"}},[_c('b-card',[_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":"/historia/okres_39_41/Cyryl_Ratajski.jpg"}}),_c('br')],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('strong',[_vm._v("Cyryl Ratajski \"Juliański\"")]),_c('br'),_vm._v("\n            Delegat na Kraj w randze Premiera Polskiego Państwa Podziemnego."),_c('br'),_vm._v("\n            W roku 1940 został mianowany na delegata Rządu Emigracyjnego na Kraj.\n            Dymisja z tego stanowiska została przyjęta 5 sierpnia 1942 roku przez Premiera gen. Władysława Sikorskiego.\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"justify-content-md-center mt-3 mb-4"},[_c('b-col',{attrs:{"md":"8"}},[_c('b-card',[_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":"/historia/okres_39_41/Zygmunt_Fedorowicz.jpg"}}),_c('br')],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('strong',[_vm._v("Zygmunt Fedorowicz \"Albin\", \"Pani Maria\", \"Józef\"")]),_c('br'),_vm._v("\n            Pierwszy Delegat na Województwo Wileńskie Polskiego Państwa Polskiego mianowany 28.02.1942 r.\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3 mb-4"},[_c('b-col',{attrs:{"cols":"11"}},[_c('p',[_c('strong',[_vm._v("Wacław Dziewulski.")]),_c('br'),_vm._v("\n        ARMIA KRAJOWA WILEŃSZCZYZNY NA TLE DZIEJÓW WOJENNYCH"),_c('br'),_vm._v(" "),_c('i',[_vm._v("\n          Rodakom, którym rzeczywistość powojennych lat Polski- z przyczyn ustrojowych - nie pozwoliła poznać historii\n          Wileńszczyzny przedkładam wspomnienia, przemyślenia i refleksje, które być może ułatwią zrozumienie polskiego\n          patriotyzmu Kresów Północno-Wschodnich, opłaconego bezmiarem cierpień i ofiar.\n        ")])]),_vm._v(" "),_c('p',{staticClass:"display-4"},[_vm._v("1.Trzy pierwsze okupacje (1939-1941)")]),_vm._v(" "),_c('p',[_vm._v("\n        Po 17. września Wileńszczyzna znalazła się pod okupacją radziecką. Czas tymczasowości tzw. Zachodniej Białorusi okupant\n        wykorzystał na wywożenie wszelkich zasobów magazynowych oraz maszyn i urządzeń. Szkoły i uniwersytet działały normalnie.\n        Związek Radziecki - wbrew prawu międzynarodowemu - przekazał Litwie zaanektowane Wilno wraz z pasem przygranicznym. Kowno,\n        przed zajęciem darowanych terenów, anulowało prawodawstwo polskie i rozciągnęło jurysdykcję litewską na skrawek Rzeczpospolitej.\n        Polacy stracili wszystko: instytucje samorządowe, szkoły, teatr, harcerstwo, zakłady... pracę i środki do życia.\n        Uniwersytet Stefana Batorego, zawieszony przez carów, władze suwerennego państwa litewskiego 15 grudnia 1939 r. - zlikwidowały.\n        W przed dzień wigilii Bożego Narodzenia, pracownicy mieszkający w gmachach uczelni otrzymali nakazy natychmiastowej eksmisji.\n        Studentów deportowano do obozów pracy w pobliżu granicy łotewskiej. Część profesorów i księży zamknięto w obozie przymusowej\n        pracy w Perweniszkach. Bezwzględna litwinizacja i wysoce represyjne traktowanie polskojęzycznego społeczeństwa upoważnia do\n        traktowania bezprawia jako okupacji litewskiej. W połowie czerwca 1940 r. Litwa została przyłączona do Związku Radzieckiego,\n        co dla Wilna oznaczało drugą okupację - radziecką; przeważająca zaś większość Wileńszczyzny bezprawnie należała już od września\n        39 r. do radzieckiej Białorusi. Litewska policja natychmiast przekształciła się w komunistyczną milicję. Władze radzieckie\n        tolerowały język polski; były więc namiastki polskiego szkolnictwa, prasy. teatru... . Szybko jednak narastała sowietyzacja\n        wszystkich dziedzin życia, a głęboki regres gospodarczy pogłębiał udrękę. Niewygodnych obywateli nowej republiki radzieckiej\n        licznie aresztowano, a niezależnie rozpoczęło się deportowanie całych rodzin do Kazachstanu. Tydzień przed inwazją niemiecką\n        na Związek Radziecki rozpoczęło się wywożenie na ogromną skalę. Część pociągów towarowych z Polakami nie zdążyła oddalić się\n        od strefy działań wojennych; jedynie nieliczni wrócili. Wycofującemu się NKWD nie wolno było zostawić więźniów, a więc ich\n        mordowano żeby uciekać przed nadciągającymi Niemcami.\n      ")]),_vm._v(" "),_c('p',{staticClass:"display-4"},[_vm._v("2. Okupacja hitlerowska (1941-1944)")]),_vm._v(" "),_c('p',[_vm._v("\n        Rozpoczęcie agresji niemieckiej wywołało paniczną ucieczkę części elity rządzącej oraz natychmiastową zmianę orientacji\n        Litwinów. Niedawni zagorzali komuniści nagle stali się wojującymi anty komunistami, którzy strzelali do maruderów porzuconych\n        przez dowództwo radzieckie, a w miastach etnicznej Litwy samorzutnie wszczęli pogromy Żydów. Milicja podporządkowała się nowym\n        władcom świata. Litewska frakcja gestapo przystąpiła natychmiast do terroryzowania społeczeństwa polskiego. Hitlerowskie władze\n        zastrzegły sobie jedynie ferowanie wyroków śmierci. Ochotniczy zaciąg Litwinów do paramilitarnych oddziałów mordujących Żydów\n        w Ponarach - skazanych przez rasizm na zagładę - zaskoczył Niemców; wciąż mogli wybierać wśród stale zgłaszających się\n        ochotników. Społeczeństwo litewskie traktowało to zjawisko jako naturalne i oczywiste. Dla nas były to objawy społecznej\n        patologii narodu katolickiego. Ruch oporu na Wileńszczyźnie rozpoczął się spontanicznie jeszcze przed wejściem wojsk radzieckich\n        we wrześniu 39 r. udzielanie gościny Polakom początkowo napływającym z zachodu, a następnie ze wschodu. Zabezpieczenie broni,\n        dokumentów...., ukrywanie i przekazywanie dalej osób zagrożonych. Solidarność Wilnian była wzorcowa. Nawiązywane były kontakty\n        pomiędzy oficerami, którzy pozostali. Tworzyły się grupy patriotyczne. Zalążki tajnych ugrupowań ujawniały swe istnienie\n        kolportując ulotki, odezwy, komunikaty, informacje.... W miarę upływu czasu tworzyły się większe organizmy konspiracyjne\n        podziemnego Państwa Polskiego. Stopniowo wtapiały się one w ruch ogólnopolski o nazwie Służba Zwycięstwu Polski (SZP), ten zaś w\n        1940 r. przekształcił się w Związek Walki Zbrojnej (ZWZ), a 1942 r. przemianowany został w Armię Krajową (AK). Społeczeństwo\n        Wileńszczyzny szybko opanowało kanony konspiracji. Przedłużająca się wojna wymagała uruchomienia kształcenia młodzieży; rozwijało\n        się tajne nauczanie. Sytuacja Niemców na froncie wschodnim stawała się krytyczna, a to odbijało się na jego zapleczu. W lecie\n        zarządzono oddawanie rowerów, w zimie - nart i futer na potrzeby wojska. Urzędy pracy energicznie \"wyczesywały\" zdolnych do\n        niewolniczej pracy w przemyśle zbrojeniowym bombardowanym przez Aliantów oraz do obsługi transportu konnego na bezpośrednim\n        zapleczu frontu wschodniego. Rolnikom zwiększano kontyngenty. Lokalne władze litewskie usilnie starały się chronić swoich kosztem\n        Polaków. W dużych zespołach leśnych Wileńszczyzny pojawiły się zorganizowane grupy radzieckie sterowane i zaopatrywane przez\n        Moskwę, która od września 39 r. polskie tereny traktowała jako swoje. Ludność polska bezradna wobec przemocy była grabiona,\n        wywożona, mordowana. Coraz to więcej zagrożonych młodych mężczyzn uciekało do lasu. Tworząc oddziały przeciwdziałające samowoli\n        lokalnych władz niemieckich i litewskich oraz leśnych oddziałów radzieckich. Oddziały AK wymagały zaplecza. Całe społeczeństwo\n        polskie uczestniczyło we wspomaganiu: służby informacyjne, skrzynki kontaktowe, pomoc sanitarna, fałszywe dokumenty, wydawanie\n        prasy, heroiczne poczynania emisariuszy i łączniczek... AK - Wilno nie otrzymywało zrzutów z Zachodu i z tej racji istniała\n        konieczność samodzielnego zdobywania broni. Ludność wiejska na ogół solidarnie sprzyjała AK dzięki czemu podziemne wojsko miało\n        solidne oparcie w terenie. Armia Krajowa na Wileńszczyźnie stanowiła jedyną polską organizację wojskową skupiającą wszystkie siły\n        społeczne w walce z Niemcami. Terror narastał. Gestapo, przy walnym udziale służb litewskich, dokonywało coraz to liczniejszych\n        aresztowań: przepełnione cele więzienia na Łukiszkach, gehenna piwnic gestapo przy ul. Ofiarnej, doły śmierci w lesie ponarskim,\n        gdzie ochotnicy litewscy wymordowali ok. 70 tysięcy polskich Żydów oraz wiele tysięcy Polaków, którzy dobrowolnie podjęli walkę\n        o godność ludzką i wolność ziemi ojczystej. Front wschodni zbliżał się do Wilna.\n      ")]),_vm._v(" "),_c('p',{staticClass:"display-4"},[_vm._v("3. Zagłada (1944-1945)")]),_vm._v(" "),_c('p',[_vm._v("\n        AK brało udział w walkach z Niemcami na przedpolach i przedmieściach Wilna. Dowódcy radzieccy gratulowali dowódcom brygad AK.\n        W kilka dni później NKWD podstępnie aresztowało sztab AK, okrążyło i rozbroiło poszczególne ugrupowania. Wyżsi oficerowie AK\n        trafili do więzień.... żołnierze do Kaługi. W Wilnie aresztowania, przesłuchiwania, wyroki ( za zdradę radzieckiej ojczyzny ! )\n        więzienia, łagry, mordercza praca niewolnicza na nieludzkiej ziemi. Jedynie nieliczne grupki AK usiłowały przeciwstawić się nowemu\n        okupantowi, ale sprawa była beznadziejna. Ci co uniknęli aresztowania usiłowali przedostać się przez nową granicę Polski; jedni z\n        bronią w ręku inni ze zmienionymi dokumentami. Tymczasem pojawiło się nowe zagrożenie - łapanki na mężczyzn w wieku poborowym.\n        Najpierw chodziło o wsparcie frontu utrzymującego się w Prusach Wschodnich, gdzie - nazywając rzecz po imieniu - brakowało \"mięsa\n        armatniego\" . Następnie zaś - o niewolników do zatopionych przez Niemców kopalni w Donbasie. Wileńszczyzna przez cały okres wojny,\n        aż do podpisania traktatu pokojowego, stanowiła integralną część Rzeczpospolitej pozostającej w stanie wojny z Rzeszą Niemiecką.\n        Data 1 i 17 września 1939 r. stanowiły zapowiedź wielkich zmian, lecz Teheran i Jałta przesądziły o losie Polski.\n      ")]),_vm._v(" "),_c('p',{staticClass:"display-4"},[_vm._v("4. Unicestwienie")]),_vm._v(" "),_c('p',[_vm._v("\n        Na zachód od Bugu, w zniewolonej Polsce delegatury NKWD-NKGB inwigilowały, przesłuchiwały, więziły, rozstrzeliwały,\n        deportowały do ZSRR... Pokolenie akowskie - w tym i wileńskie - było w Polsce przez służby UB maltretowane, dziesiątkowane,\n        unicestwiane, a potem przez długie lata szkalowane. Pokolenie akowskie, wyrosłe z ideałów okresu wywalczonej niepodległości,\n        poniosło przeogromne ofiary nie tylko cierpień i krwi, ale również poniżenia ideałów patriotycznych. Do milionowych ofiar w\n        Kraju, na Zachodzie i na nieludzkiej ziemi oraz do zniszczeń gospodarczych należy doliczyć - realizowane przez lata -\n        spustoszenia duchowe, polegające na perfidnym przeinaczaniu prawdy, lekceważeniu patriotyzmu i ignorowaniu tradycji narodowej\n        oraz na negowaniu najwyższych wartości społecznych. Nieuniknionym następstwem nieprzestrzegania fundamentalnych norm moralności\n        społecznej jest zapaść kulturalna elit społecznych; zapaść, która sięga aż po obecne czasy i jeszcze przez długie lata będzie w\n        Polsce odczuwalna.\n      ")]),_vm._v(" "),_c('p',{staticClass:"display-4"},[_vm._v("Wileńszczyzna w okresie od 1 do 18 września 1939r")]),_vm._v(" "),_c('p',[_vm._v("\n        Organizacje i grupy konspiracyjne samorzutnie powstawały wśród znajomych i kolegów w miejscu zamieszkania i pracy,\n        studentów Uniwersytetu Stefana Batorego, uczniów gimnazjów, powracających z wojny oficerów i żołnierzy z jednostek\n        stacjonujących w Wilnie oraz z uciekinierów z centralnej Polski, którzy znaleźli się na tych terenach. Jako pierwsze\n        powstały organizacje, które zaczęły swoją działalność charytatywną od udzielania pomocy tym, którzy znaleźli się w\n        krytycznym położeniu z powodu braku środków do życia. Okupacyjne władze sowieckie nie udzielały im żadnej pomocy. W\n        tym czasie również bardzo ważnym zadaniem były sprawy dostarczania odpowiednich dokumentów i to takich, które chroniłyby\n        przed aresztowaniem, umożliwiały podjęcie pracy zarobkowej, zameldowania się i t. p. Do połowy września 1939 roku na terenie\n        miasta Wilna i województwa wileńskiego działały o ograniczonym zakresie działania następujące organizacje:\n      ")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Towarzystwo Samopomocy Obywatelskiej - ks. Kazimierza Kucharskiego.")]),_vm._v(" "),_c('b-row',{staticClass:"justify-content-md-center mt-3 mb-4"},[_c('b-col',{attrs:{"md":"11"}},[_c('b-card',[_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":"/historia/okres_39_41/Kazimierz_Kucharski.jpg"}}),_c('br')],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('strong',[_vm._v("Ks. Kazimierz Kucharski TJ syn Ziemi Rzeszowskiej")]),_c('br'),_vm._v("\n                wywodzący się z ubogiej rodziny rolniczej, własnymi siłami ukończył gimnazjum w Sanoku, po czym w 1916 r.\n                wstąpił do nowicjatu jezuitów. W 1920 r. przerwał studia filozoficzne i teologiczne, aby ochotniczo z grupą\n                kleryków pełnić na froncie służbę sanitarną. Po otrzymaniu święceń kapłańskich kontynuując studia, uczył w\n                szkołach jezuickich w Chyrowie, Pińsku, a od 1925 r. w Wilnie. Ukoronowaniem zdobywania wiedzy było uzyskanie\n                doktoratu w 1936 r.\n              ")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":"/historia/okres_39_41/Jadłodajnia_przy_ulicy_Wielkiej.jpg"}}),_c('br')],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('p',[_vm._v("\n        Po wybuchu wojny w 1939 r. założył Towarzystwo Samopomocy Obywatelskiej, jednocześnie był łącznikiem z placówkami\n        dyplomatycznymi państw - oficjalnie lub tylko dyskretnie w różny sposób - wspomagających społeczność polską na Litwie\n        Kowieńskiej i na Wileńszczyźnie. Współorganizator Służby Zwycięstwu Polski i Związku Walki Zbrojnej Okręgu Wileńskiego.\n        Aresztowany przez NKWD w kwietniu 1941 r. i wywieziony do Moskwy. Po zwolnieniu wstąpił do Armii Polskiej tworzonej przez gen.\n        Andersa, w której służył jako kapelan.\n      ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":"/historia/okres_39_41/Kazimierz_Kucharski_w_otoczeniu_grupy.jpg"}}),_c('br')],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('p',[_vm._v("\n        Ks. Kazimierz Kucharski w otoczeniu grupy wileńskich lekarzy, którzy zostali rozpoznani. Zdjęcie wykonane prawdopodobnie w\n        czerwcu 1940 roku na dziedzińcu klasztoru Ojców Jezuitów. W dolnym rzędzie od lewej: dr Zygmunt Kłosowski, dr Henryk Rudziński,\n        dr Zofia Olechowicz-Świdowa, dr Edmund Kuncewicz, dr Zdzisław Świeżyński, dr Stanisław Markiewicz, ks. Kazimierz Kucharski,\n        NN, dr Jan Szelhaus, NN, dr Jadwiga Rymaszewska, NN, dr Maria Dulewiczowi, NN, NN, NN. W górnym rzędzie od lewej: dr Adam\n        Łapiński.\n      ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',{staticClass:"lead"},[_vm._v("\n        Komitet Pomocy Uchodźcom Wojennym - Ignacego Zagórskiego."),_c('br'),_vm._v("\n        Komitet Pomocy Ofiarom Wojny – dr Kazimierza Pelczara."),_c('br'),_vm._v("\n        Związek Bojowników Niepodległości- organizacja harcerska kierowana przez harcmistrza Józefa Grzesiaka\n      ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"3"}},[_c('b-card',{staticClass:"mb-2",staticStyle:{"width":"10em","min-height":"25em"},attrs:{"img-src":"/historia/okres_39_41/Dr_Kazimierz_Pelczar.jpg","img-top":"","tag":"article"}},[_c('p',{staticClass:"card-text"},[_vm._v("\n          Dr Kazimierz Pelczar\n        ")])])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-card',{staticClass:"mb-2",staticStyle:{"width":"10em","min-height":"25em"},attrs:{"img-src":"/historia/okres_39_41/Jozef_Grzesiak.jpg","img-top":"","tag":"article"}},[_c('p',{staticClass:"card-text"},[_vm._v("\n          Kpt. Józef Grzesiak \"Kmita\"\n        ")])])],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('p',[_vm._v("\n        Organizacje te utworzyły się w pierwszej dekadzie września 1939 roku, a podstawową ich działalnością była pomoc\n        dla napływającej do Wilna i okolic uciekinierów z zachodnich i centralnych województw Polski. Sprawy zakwaterowania,\n        wyżywienia, pomocy medycznej, zaginionych dokumentów osobistych umożliwiających zameldowanie i podjęcie pracy zarobkowej\n        były w tym okresie bardzo ważne i często zapobiegały przed aresztowaniem przez NKWD. Organizacje te pracowały do połowy\n        1940 roku.\n      ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":"/historia/okres_39_41/Obszar_wojewodztwa_Wilenskiego_kolor_zołty_wlaczony_do_Panstwa_Litewskiego.jpg"}}),_c('br')],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('span',{staticClass:"lead"},[_vm._v("\n        Obszar województwa Wileńskiego kolor żółty włączony do Państwa Litewskiego był\n        do 21.06.1941 r. obszarem Okręgu Wileńskiego SZP i ZWZ.\n      ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{attrs:{"cols":"11"}},[_c('p',{staticClass:"display-4"},[_vm._v("Pierwsza okupacja sowiecka i litewska od 18 września do 15 kwietnia 1940 roku")]),_vm._v(" "),_c('p',[_vm._v("\n        Po wkroczeniu wojsk sowieckich na teren województwa Wileńskiego , władzę objęły Rosjanie, wprowadzono wymianę złotego na\n        ruble, wprowadzono ścisłą reglamentację artykułów żywnościowych i przemysłowych. Wprowadzono kartki, zaczęły się ogromne\n        kolejki przed sklepami, na wzór działających kilku organizacji humanitarnych, zaczęły się tworzyć konspiracyjne tak niosące\n        pomoc humanitarną jak i społeczne i polityczne przeciwstawiające się bardzo agresywnej propagandzie sowieckiej.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Do końca 1939 roku na terenie miasta Wilna i województwa wileńskiego działały – początkowo jako kadrowe –\n        o ograniczonym zakresie działania następujące organizacje :\n      ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"justify-content-sm-center"},_vm._l((_vm.okres_39_41.pierwsza_okupacja.cards),function(card){return _c('b-col',{key:card.id,attrs:{"md":"3","cols":"6"}},[_c('b-card',{staticClass:"mb-2",staticStyle:{"width":"10em","min-height":"25em"},attrs:{"img-src":card.img,"img-top":"","tag":"article"}},[_c('p',{staticClass:"card-text"},[_vm._v("\n          "+_vm._s(card.desc)+"\n        ")])])],1)}),1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('ul',_vm._l((_vm.okres_39_41.pierwsza_okupacja.list),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n        Były to organizacje o bardzo zróżnicowanym obliczu politycznym, które stawiały sobie jako zadanie naczelne:\n      ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("integrację społeczeństwa polskiego na rzecz odzyskania niepodległości,")]),_vm._v(" "),_c('li',[_vm._v("walkę z defetyzmem i wrogą propagandą sowiecką i litewską oraz pomoc materialną potrzebującym.")])]),_vm._v(" "),_c('p',[_vm._v("\n        W okresie działań wojennych do 17 września 1939 r. do Wilna przebyło około 27.000 uchodźców z zachodnich i\n        centralnych dzielnic Polski, uciekając przed bombardowaniem i działaniami frontowymi. Większość tych ludzi\n        zdołała przetrwać nadchodzącą zimę, uzyskując pomoc materialną, jakieś mieszkania, a nawet dokumenty umożliwiające\n        podjęcie pracy. Dzięki tym ludziom organizującym tą działalność, życie uchodźców stawało się bardziej znośne.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        W grudniu 1939 r. na skutek usilnych działań kierownictwa Służby Zwycięstwu Polski , jako organizacji ogólnokrajowej,\n        delegowani z Warszawy ppłk dypl. Nikodem Sulik, przy bardzo wydatnej pomocy ks. Kazimierza Kucharskiego, mjr rez.\n        Władysława Kamińskiego i ppłk Adama Obtułowicza, większość działających na terenie miasta Wilna i województwa\n        wileńskiego organizacji i związków, podporządkowała się utworzonemu sztabowi organizacji Służba Zwycięstwu Polski, Okręg Wilno.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Dowódcą Okręgu wileńskiego miał zostać ppłk Adam Obtułowicz , a zastępcami – ppłk Nikodem Sulik i mjr rez. Władysław Kamiński.\n        Na skutek sprzeciwu Kierownictw podporządkowujących się organizacji , ppłk Adam Obtułowicz zrzekł się tego stanowiska.\n        Dowódcą został aprobowany przez wszystkich ppłk Nikodem Sulik, a ppłk Adam Obtułowicz objął stanowisko szefa sztabu Komendy\n        Okręgu Wileńskiego.\n      ")]),_vm._v(" "),_c('p',{staticClass:"display-4"},[_vm._v("Konspiracyjne władze cywilne Okręgu Wileńskiego")]),_vm._v(" "),_c('p',[_vm._v("\n        W dniu 28 grudnia 1939 r. na terenie Kolegium ojców Jezuitów odbyło się spotkanie przedstawicieli działających na\n        Wileńszczyźnie związków, organizacji i działaczy politycznych. Byli to :\n      ")]),_vm._v(" "),_c('ul',_vm._l((_vm.okres_39_41.konsp_wladze.list),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0),_vm._v(" "),_c('p',{staticClass:"lead mt-3"},[_vm._v("\n        Na spotkaniu tym ustalono cztery podstawowe zasady działalności Służby Zwycięstwu Polski, organizacji podlegającej\n        Rządowi Rzeczypospolitej Polskiej na Emigracji i brzmiały one:\n      ")]),_vm._v(" "),_c('ol',_vm._l((_vm.okres_39_41.zasady_dzialalnosci.list),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0)])],1),_vm._v(" "),_c('b-row',{staticClass:"justify-content-sm-center"},_vm._l((_vm.okres_39_41.zasady_dzialalnosci.cards),function(card){return _c('b-col',{key:card.id,attrs:{"md":"3","cols":"6"}},[_c('b-card',{staticClass:"mb-2",staticStyle:{"width":"10em","min-height":"25em"},attrs:{"img-src":card.img,"img-top":"","tag":"article"}},[_c('p',{staticClass:"card-text"},[_vm._v("\n          "+_vm._s(card.desc)+"\n        ")])])],1)}),1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',[_vm._v("\n        Ustalono również, że podporządkowujące się Służbie Zwycięstwu Polski organizacje, będą mogły zachować swoją autonomię\n        polityczną. Uczestniczące w spotkaniu organizacje polityczne, zrezygnowały z tworzenia odrębnych struktur wojskowych.\n        Oficerem łącznikowym pomiędzy dowództwem wojewódzkim Służby Zwycięstwu Polski, a poszczególnymi organizacjami oraz koordynatorem\n        działań, został mjr/ppłk Aleksander Krzyżanowski „Dziemido”, „Wilk”. W tym czasie również, powstało ciało doradcze reprezentujące\n        główne stronnictwa polityczne, działające na tym terenie, oraz Kurię Metropolitarną i otrzymało nazwę Rada Wojewódzka Obrony\n        Narodowej. Powstał również organ prasowy Służby Zwycięstwu Polski pod nazwą „Polska w walce”, którego kierownictwo powierzono\n        mjr rez. Władysławowi Kamińskiemu „Śliwa”. O utworzeniu na terenie Wileńszczyzny Dowództwa Wojewódzkiego i Rady Wojewódzkiej,\n        powiadomiono Premiera Rządu Rzeczypospolitej Polskiej na Emigracji i Naczelnego Wodza gen. Władysława Sikorskiego w Paryżu, za\n        pośrednictwem specjalnego kuriera kpt. dypl. Aleksandra Bluma. Wyjechał on z Wilna 30 grudnia 1939 r. Droga wiodła przez Rygę,\n        Sztokholm, Malmo, Amsterdam do Paryża, dotarł w końcu stycznia 1940 r. i złożył tam raport.\n      ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"justify-content-md-center mt-3 mb-4"},[_c('b-col',{attrs:{"md":"11"}},[_c('b-card',[_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":"/historia/okres_39_41/Nikodem_Sulik.jpg"}}),_c('br')],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('strong',[_vm._v("Ppłk Nikodem Sulik „Karol Sarnowski” , „Jodko”, „Ładyna”.")]),_c('br'),_vm._v("\n            Pierwszy Komendant Służby Zwycięstwa Polski i Związku Walki Zbrojnej Okręgu Wileńskiego\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',[_vm._v("\n        Ppłk Nikodem Sulik w listopadzie 1939 r. został skierowany przez gen. Michała Karaszewicza-Tokarzewskiego do Wilna i\n        desygnowany na Komendanta Okręgu Wileńskiego. Po przemianowaniu SZP na ZWZ objął w marcu 1940 r. to stanowisko.\n         Aresztowany 13.04.1941 r. przez NKWD (na ulicy) osadzony w więzieniu w Wilnie, a następnie przewieziony do Moskwy.\n         Zwolniony 13.08.1942 r. wstąpił do Armii Polskiej organizowanej przez gen. Andersa w ZSRR. Po awansach na stopień pułkownika,\n         a następnie generała brygady dowodził 5. Kresową Dywizją Piechoty w bitwie pod Monte Cassino. Po wojnie osiedlił się w Anglii,\n         gdzie zmarł 14.01.1954 r.\n      ")]),_vm._v(" "),_c('p',{staticClass:"display-4"},[_vm._v("Komenda Okręgu Wilno SZP i Związku Walki Zbrojnej")]),_vm._v(" "),_c('p',[_vm._v("\n        W styczniu 1940 r. rozkazem Naczelnego Wodza, Służba Zwycięstwu Polski, została przemianowana na Związek Walki Zbrojnej.\n        Dotychczasowa nazwa Dowództwo Wojewódzkie, została zmieniona na Komendę Okręgu.\n        W tym czasie Komenda Okręgu Wileńskiego miała następującą obsadę personalną :\n      ")]),_vm._v(" "),_c('ul',_vm._l((_vm.okres_39_41.komenda_wilno.list),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0)])],1),_vm._v(" "),_c('b-row',{staticClass:"justify-content-sm-center"},_vm._l((_vm.okres_39_41.komenda_wilno.cards),function(card){return _c('b-col',{key:card.id,attrs:{"md":"3","cols":"6"}},[_c('b-card',{staticClass:"mb-2",staticStyle:{"width":"10em","min-height":"25em"},attrs:{"img-src":card.img,"img-top":"","tag":"article"}},[_c('p',{staticClass:"card-text"},[_vm._v("\n          "+_vm._s(card.desc)+"\n        ")])])],1)}),1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',{staticClass:"lead mt-3"},[_vm._v("Rada Wojewódzka Obrony Narodowej")]),_vm._v(" "),_c('ul',_vm._l((_vm.okres_39_41.rada_woj.list),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0),_vm._v(" "),_c('p',{staticClass:"lead mt-3"},[_vm._v("Inne Organizacje Niepodległościowe na obszarze Okręgu Wilno.")]),_vm._v(" "),_c('p',[_vm._v("\n        Niezależnie od Związku Walki Zbrojnej, w marcu 1940 r. powstała samodzielna organizacja o nazwie Liga Wojenna Walki Zbrojnej,\n        którą kierował mjr dypl. Julian Kulikowski „Witold Drohomirski”. Zasięgiem swoim obejmowała ona powiaty : wileńsko -\n        trocki, oszmiański i święciański. Organizacja ta dopiero we wrześniu 1941 r. podporządkowała się i została wcielona do\n        Związku Walki Zbrojnej, jako organizacji ogólnokrajowej. Na początku 1940 r. na skutek nieporozumień w Stronnictwie Narodowym,\n        za ugodę z Sanacją, Roman Piekarski,utworzył nową samodzielną organizację. Skupiała ona przeważnie młodzież miejską.\n        Organizacja ta dopiero w połowie 1942 r. podporządkowała się Armii Krajowej.\n      ")]),_vm._v(" "),_c('p',{staticClass:"lead mt-3"},[_vm._v("Nowy podział administracyjny Okręgu Wileńskiego ZWZ.")]),_vm._v(" "),_c('p',[_vm._v("\n        Z chwilą powołania Związku Walki Zbrojnej nastąpiła reorganizacja terytorialna. Obszar Polski został podzielony na tak zwane\n        Obszary. Województwo Wileńskie uległo podziałowi. Teren, który został przekazany przez władze sowieckie Litwie, w tym i miasto\n        Wilno, organizacyjnie podlegał bezpośrednio Komendantowi Głównemu gen. Kazimierzowi Sosnkowskiemu „Józef Godzięba”, z pominięciem\n        Komendy Głównej w Warszawie. Pozostała część województwa, przyłączona do Białorusi, podlegała Komendantowi Obszaru Nr 2 w\n        Białymstoku. Stan taki utrzymywał się aż do momentu wybuch wojny niemiecko sowieckiej, to jest do końca czerwca 1941 r.\n        Od tego czasu pod komendę Okręgu Wileńskiego dostał się teren całego województwa wileńskiego Polskiego Państwa Podziemnego.\n        Okręg Wileński Związku Walki Zbrojnej, organizacyjnie zaczął podlegać Komendzie Głównej w Warszawie.\n      ")]),_vm._v(" "),_c('p',{staticClass:"lead mt-3"},[_vm._v("Podokręg Kowieński.")]),_vm._v(" "),_c('p',[_vm._v("\n        Nie bez znaczenia będzie podać, że w sierpniu 1940 r. utworzony został Podokręg Kowieński Związku Walki Zbrojnej.\n        W marcu 1941 r. obsada personalna kierownictwa tego Podokręgu przedstawiała się następująco:\n      ")]),_vm._v(" "),_c('ul',_vm._l((_vm.okres_39_41.podokreg_kowienski.list),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0),_vm._v(" "),_c('p',{staticClass:"lead mt-3"},[_vm._v("Podokręg został podzielony na trzy Obwody, a ich Komendantami byli :")]),_vm._v(" "),_c('ul',_vm._l((_vm.okres_39_41.podokreg_obwody.list),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0),_vm._v(" "),_c('p',{staticClass:"lead mt-3"},[_vm._v("Pion Wojskowy Podokręgu Kowieńskiego w roku 1942 miał następującą obsadę personalną :")])])],1),_vm._v(" "),_c('b-row',{staticClass:"justify-content-sm-center"},_vm._l((_vm.okres_39_41.pion_podokreg_kowienski.cards),function(card){return _c('b-col',{key:card.id,attrs:{"xl":"2","md":"4","cols":"6"}},[_c('b-card',{staticClass:"mb-2",staticStyle:{"width":"10em","min-height":"25em"},attrs:{"img-src":card.img,"img-top":"","tag":"article"}},[_c('p',{staticClass:"card-text"},[_vm._v("\n          "+_vm._s(card.desc)+"\n        ")])])],1)}),1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('ul',_vm._l((_vm.okres_39_41.pion_podokreg_kowienski.list),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0),_vm._v(" "),_c('p',{staticClass:"lead mt-3"},[_vm._v("Powołany Inspektorat „E” miał następującą obsadę :")]),_vm._v(" "),_c('ul',_vm._l((_vm.okres_39_41.inspektorat_e.list),function(el){return _c('li',[_vm._v(_vm._s(el))])}),0),_vm._v(" "),_c('p',[_vm._v("\n        Działalność Komendy Podokręgu i Inspektoratu „E” różniła się od działalności jaką prowadzono na terenach województwa\n        Wileńskiego. Działali oni na terenach, gdzie większość ludności była narodowości litewskiej, bardzo często kolaborującej z\n        okupantem niemieckim. Pomimo tego, działalnością swoją zintegrowali Polaków, mieszkających na Litwie od dawna lub tych,\n        którzy znaleźli się tam w wyniku działań wojennych.\n      ")]),_vm._v(" "),_c('p',{staticClass:"display-4 mt-3"},[_vm._v("Pierwsze masowe aresztowania przez NKWD")]),_vm._v(" "),_c('p',[_vm._v("\n        Penetracja polskich organizacji konspiracyjnych, przez służby NKWD, była prowadzona tak przez służby formalne jak również przez\n        konfidentów zwerbowanych w tamtym okresie. NKWD miało również swoich agentów już dawno zainstalowanych na Wileńszczyźnie.\n        Byli nimi między innymi – nauczyciel gimnazjalny Antoni Wendorff, por. Oziewicz, por. Chomczyński oraz wydalony z Wojska\n        Polskiego oficer Szabłowski oraz żona płk Kazimierza Bąbińskiego. Na niektórych z nich został wydany przez Sądy Konspiracyjne,\n        wyroki śmierci. Niektórych NKWD sam przeniósł na inny teren, po zdekonspirowaniu ich przez wywiad Związku Walki Zbrojnej.\n        Już w lipcu 1940 r. Komenda Okręgu wiedziała, że NKWD jest na tropie organizacji i posiada bardzo dużo informacji o jej\n        kierownictwie. Pierwsze bardziej masowe aresztowania były w sierpniu 1940 r. Aresztowano między innymi: – Aleksandra Prystora,\n        hrabiego Michała Tyszkiewicza, prof. Władysława Wielowiejskiego, adwokata Tadeusza Kiersnowskiego i żonę płk Pełczyńskiego Wandę\n        – ludzi bardzo blisko pracujących z Komendą Okręgu. Prawie cudem aresztowania uniknęli: Szef I Oddziału Komendy Okręgu kpt. dypl.\n        Antoni Olechnowicz „Pohorecki”, oficer dyspozycyjny Komendy Garnizonu miasta – kpt. Stanisław Skrzecz „Poleski”, adiutant\n        Komendanta Garnizonu ppor. Antoni Burzyński „Kmicic”. W listopadzie 1940 r. na ulicy aresztowano dowódcę konspiracyjnego 6 pp.\n        leg.-Antoniego Piotrowskiego."),_c('br'),_vm._v("\n        W marcu 1941 r. aresztowano większość członków Komendy Podokręgu Kowieńskiego, paraliżując na dłuższy czas jego działalność.\n        W Wilnie na ulicy w kwietniu aresztowano Komendanta Garnizonu miasta – kpt. Karola Zielińskiego „Czerw”, „Tomczyk” i „Brzoza”,\n        Szefa Łączności Komendy Okręgu – por. Stefana Czernika „Orwat”, Kwatermistrza Garnizonu – Stanisława Kiałkę „Bolesław”,\n        „Ślęczek”, „Drzewica”i „Jelonek”, który posiadał bardzo mocne dokumenty i szybko został zwolniony.\n        NKWD znało również nazwisko, stopień wojskowy i pseudonim ppłk Aleksandra Krzyżanowskiego „Wesołowski”, „Dziemido” i „Wilk”.\n        Musiał on odtąd bardzo często zmieniać kwaterę i dużo lepiej ukrywać się."),_c('br'),_vm._v("\n        W Wielkim Tygodniu 1941 r. aresztowano mjr rez. Władysława Kamińskiego „Śliwa”, członka Komendy Okręgu, odpowiedzialnego za\n        łączność z Komendą Główną, ppłk Zygmunta Cetnerowskiego „Zygmunt”– szefa Wydziału Komendy Okręgu, kpt. Aleksandra Rybnika\n        „Aleksy” – nowo mianowanego Komendanta Garnizonu i jego adiutanta – ppor. Józefa Bujnowskiego „Walter”.\n        W niedzielę Wielkanocną 13 kwietnia 1941 r. aresztowany został na ulicy, wychodzący z kościoła, ppłk dypl. Nikodem Sulik\n        „Karol Jodko”, „Ładyna”– Komendant Okręgu."),_c('br'),_vm._v("\n        Stało się wiadome, że służby NKWD mają bardzo dokładne rozeznanie i rozpracowaną organizację. Nie wiadomo jest, czy NKWD\n        posiadane wiadomości uzyskało od konfidentów zainstalowanych bardzo blisko Komendy Okręgu, czy też pierwsi aresztowani nie\n        wytrzymali zastosowanych metod śledztwa. W tej sytuacji dotychczasowy szef sztabu Komendy Okręgu – ppłk Aleksander Krzyżanowski\n        „Wilk” , przejął obowiązki Komendanta Okręgu. Przeniósł się do Landwarowa i stamtąd kierował organizacją.\n        25 maja 1941 r. aresztowany został, również na ulicy ks. Kazimierz Kucharski „Szczepan”. Od soboty 14 czerwca do 23\n        czerwca 1941 r. nastąpiły masowe aresztowania i natychmiastowe wywiezienie w głąb ZSRR."),_c('br'),_vm._v("\n        Aresztowań dokonywano według uprzednio przygotowanych wykazów całymi rodzinami, bez względu na wiek. Przewożono ich\n        bezpośrednio do podstawionych na stacji kolejowej wagonów. Z samego miasta i jego najbliższych okolic aresztowano i wywieziono\n        ok. 2200 osób, a z terenów Litwy ok. 5400 osób, w przeważającej części narodowości polskiej.\n        Wybuch wojny niemiecko - sowieckiej i bardzo szybkie zajęcie Wilna przez wojska niemieckie, paniczna ucieczka funkcjonariuszy\n        i wojsk NKWD, uratowała bardzo wielu uprzednio aresztowanych i przebywających w więzieniach członków organizacji, przed\n        wywiezieniem w głąb ZSRR."),_c('br'),_vm._v("\n        Między innymi z wagonów już przygotowanych do odjazdu, uwolnieni zostali: kpt. dypl. Mieczysław Potocki „Węgielny”, późniejszy\n        komendant Inspektoratu „BC” i dowódca II Zgrupowania Armii Krajowej, por. Gracjan Fróg, późniejszy komendant 3. Brygady\n        „Szczerbiec”, oraz dr Stanisław Wawrzyńczak i Eugeniusz Gulczyński – z późniejszego BIP-u. Ostatnim transportem , który odszedł\n        został wywieziony ks. Kazimierz Kucharski."),_c('br'),_vm._v("\n        Przed odstąpieniem i ucieczką, służba więzienna i NKWD w więzieniach w Starej Wilejce i Berezweczu dokonały masowych\n        mordów więźniów, których nie dało się wywieźć."),_c('br'),_vm._v("\n        W momencie wybuchu wojny niemiecko - sowieckiej w obozie w Perweniszkach – później przez Niemców przemianowanego na obóz\n        koncentracyjny, było ok. 500 więźniów. Zostali oni wraz z litewską załogą strażników wybici z karabinów maszynowych przez\n        czołgi sowieckie, które wjechały na teren obozu.\n      ")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oTbp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-container',{attrs:{"id":"menuContainer","fluid":""}},[_c('navBar'),_vm._v(" "),_c('sideBar')],1),_vm._v(" "),_c('div',{attrs:{"id":"mainContainer"}},[_c('b-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oWpz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_okres_39_41_vue__ = __webpack_require__("AEMW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05064915_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_okres_39_41_vue__ = __webpack_require__("oEnI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_okres_39_41_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05064915_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_okres_39_41_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ofZi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Powołanie Zgrupowań - Operacja \"Ostra Brama\" i walki pod Krawczunami")]),_c('br'),_vm._v(" "),_vm._l((_vm.powolania.zgrupowania),function(zgrupowanie){return _c('div',{key:zgrupowanie.id,staticClass:"mb-3"},[_c('p',{staticClass:"display-4"},[_vm._v(_vm._s(zgrupowanie.name))]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('p',[_vm._v("\n          W zgrupowaniu uczestniczyli:\n          "),_c('ul',_vm._l((zgrupowanie.participants),function(uczestnik){return _c('li',{staticClass:"mb-2"},[_vm._v(_vm._s(uczestnik))])}),0)]),_vm._v(" "),_c('p',[_vm._v(_vm._s(zgrupowanie.img.desc))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":zgrupowanie.img.url}}),_c('br')],1)],1)],1)}),_vm._v(" "),_c('b-row',{staticClass:"mb-5"},[_c('b-col',{attrs:{"md":"6"}},[_c('span',{staticClass:"lead"},[_vm._v("Operacja „Ostra Brama”")]),_vm._v(" "),_c('b-img',{attrs:{"center":"","fluid":"","src":"/historia/powolanie_zgrupowan/operacja_ostra_brama.gif"}}),_c('br')],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('span',{staticClass:"lead"},[_vm._v("Plan ufortyfikowania miasta Wilna na dzień 6 lipca 1944")]),_vm._v(" "),_c('b-img',{attrs:{"center":"","fluid":"","src":"/historia/powolanie_zgrupowan/plan_miasta_wilna.jpg"}}),_c('br')],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6","order-md":"1","order":"2"}},[_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":"https://www.youtube.com/embed/ZzEmwwyCIVY","allowfullscreen":""}})],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","order-md":"2","order":"1"}},[_c('p',{staticClass:"lead"},[_vm._v("Drogi do \"Ostrej Bramy\" (fragment)")])])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p/cU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relacja_z_obchodow_vue__ = __webpack_require__("sBCC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10e64adc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relacja_z_obchodow_vue__ = __webpack_require__("/LL+");
function injectStyle (ssrContext) {
  __webpack_require__("FCnN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relacja_z_obchodow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10e64adc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relacja_z_obchodow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pUeM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Tablice Epitafijne Okręgu Wileńskiego")]),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},_vm._l((_vm.tables),function(table){return _c('div',{key:table.id,staticClass:"mb-5"},[_c('p',{staticClass:"text-center display-4"},[_vm._v(_vm._s(table.city))]),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"10","xl":"6"}},[_c('b-carousel',{staticClass:"carousel",staticStyle:{"text-shadow":"1px 1px 2px #333","margin":"0 0em 2em 0em"},attrs:{"controls":"","indicators":"","background":"#ababab","interval":0}},_vm._l((table.carousel),function(carousel){return _c('div',{key:carousel.id},[_c('b-carousel-slide',{attrs:{"caption":carousel.title,"text":carousel.text,"img-src":carousel.img}})],1)}),0)],1)],1)],1)}),0)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pg2O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'site_404'
});

/***/ }),

/***/ "pnAP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_historia_vue__ = __webpack_require__("HBxM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3af7d8e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_historia_vue__ = __webpack_require__("jLiD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_historia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3af7d8e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_historia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__("osty");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__("H7H4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pzRx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_srod_warszawa_vue__ = __webpack_require__("/5eB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dcef63e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_srod_warszawa_vue__ = __webpack_require__("qLbI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_srod_warszawa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dcef63e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_srod_warszawa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qLbI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Środowisko Wileńskie w Warszawie")]),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('p',[_vm._v("\n        W latach 1981-1983 kol. Ryszard Andrys-Jankowski w porozumieniu z Radą Starszych Okręgu Wileńskiego\n        (organizacją nie formalną) rozpoczął starania u Władz Administracyjnych RP i w Zarządzie Głównym ZBoWiD\n        zarejestrowania Klubu Żołnierzy Armii Krajowej. Współpracował ze wszystkimi na terenie kraju\n        przedstawicielami Środowisk Brygadowych Armii Krajowej Okręgu Wileńskiego. Klub taki został\n        zarejestrowany w ZBoWiD-dzie w 1987 roku.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Po powstaniu ogólnopolskiej organizacji Światowy Związek Żołnierzy Armii Krajowej (ŚZŻAK),\n        w roku 1990 wszyscy członkowie Klubu wstąpili do tego Związku jako Środowisko Wileńskie.\n        Regulamin tego Związku przywidywał podział na Okręgi i Koła-Środowiska. Zgłoszenie się\n        Środowiska Wileńskiego w Gdańsku do Okręgu Wileńskiego w Warszawie, spowodowało konieczność\n        podziału dotychczasowego Środowiska Wileńskiego na samodzielny Okręg Wileński w Warszawie.\n        Podlegały jemu dwa Środowiska Wileńskie w Warszawie i w Gdańsku. Przez pierwsze trzy lata\n        Okręg Wileński i Środowisko Warszawskie Okręgu Wileńskiego miały wspólne kierownictwo i administrację.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Walny Zjazd Okręgu Wileńskiego spowodował wyłonienie oddzielnych Władz Okręgu Wileńskiego\n        i samodzielny Zarząd Środowiska Warszawskiego Okręgu Wileńskiego. Pierwszym Prezesem Zarządu\n        Środowiska Warszawskiego został kol. Ryszard Andrys-Jankowski,\n        ze wspólną częścią administracyjną z Okręgiem Wileńskim.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Piątym Prezesem na Walnym Zebraniu Sprawozdawczo-Wyborczym w dn. 19.03.2009 roku wybrany został kol.\n        Janusz Bohdanowicz. Nowy Zarząd Środowiska zmienił i zarejestrował nową nazwę jako Środowisko Wileńskie\n        w Warszawie i założył własne konto bankowe oraz rozpoczął samodzielną działalność historyczną polegającą\n        na współpracy z młodzieżą gimnazjalną i licealną i nauczycielami tych szkół.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Od zamieszkania w Warszawie kol. Janusza Bohdanowicza i przeniesieniu członkostwa Związku z\n        Gdańska do Warszawy w 2004 roku, Środowisko rozpoczęło działalność historyczną ze szkołami\n        organizując konkursy historyczne i prelekcję.\n      ")])])],1),_vm._v(" "),_c('b-row',_vm._l((_vm.srod_warszawa.profiles),function(profile){return _c('b-col',{key:profile.id,attrs:{"xl":profile.cols.xl,"lg":profile.cols.lg,"md":profile.cols.md,"cols":profile.cols.sm}},[_c('b-card',{staticClass:"mb-2",staticStyle:{"width":"10em","min-height":"25em"},attrs:{"img-src":profile.img,"img-top":"","tag":"article"}},[_c('p',{staticClass:"card-text"},[_vm._v("\n          "+_vm._s(profile.text)+"\n        ")])])],1)}),1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('ol',{staticClass:"mb-5"},_vm._l((_vm.srod_warszawa.lists.konkursy),function(item,index){return _c('li',[_vm._v(_vm._s(item))])}),0),_vm._v(" "),_vm._l((_vm.srod_warszawa.videos),function(video){return _c('b-row',{key:video.id,staticClass:"mb-5"},[_c('b-col',{attrs:{"md":"7"}},[_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":video.url,"allowfullscreen":""}})],1),_vm._v(" "),_c('b-col',{staticClass:"lead",attrs:{"md":"4"}},[_vm._v("\n      "+_vm._s(video.text)+"\n    ")])],1)}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('ol',{staticClass:"mb-5"},_vm._l((_vm.srod_warszawa.lists.sympozja),function(sympozjum){return _c('li',{key:sympozjum.id},[_vm._v("\n      "+_vm._s(sympozjum.text)+" Tematy:\n      "),_c('ul',_vm._l((sympozjum.list),function(item,index){return _c('li',[_vm._v(_vm._s(item))])}),0)])}),0),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('b-row',{staticClass:"mb-5"},[_c('b-col',{attrs:{"cols":"11"}},[_c('p',[_vm._v("\n        Oceniano za poprawność historyczną, wykorzystanie bibliografii, forma literacka opracowania i poprawność rycin.\n        Każda z ocen w skali od 1 do 10. Opracowania które uzyskały średnią matematyczną ocenę powyżej 6,8 punktów są\n        wykazywane jako wzorcowe w przekazie elektronicznym do wszystkich bibliotek szkół, z którymi Środowisko Wileńskie\n        w Warszawie współpracuje.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Oceniającymi opracowania ze Środowiska byli: Janusz Cierpiński, Romuald Paprocki, Aleksander Kostrowicki,\n        Tadeusz Siemaszko, Józef Bandzo, Ewa Dunowska i Janusz Bohdanowicz oraz z poza Środowiska: Sylwia Kaczanowska,\n        Wojciech Barański, Halina Gromczewska, Włodzimierz Mikuć, Ryszard Bzinkowski i Ryszard Dudka.\n      ")]),_c('p',[_vm._v("\n        Wszystkie prace wydrukowano i przekazano szkołom po 4 egzemplarze w tym 2 egz. do biblioteki i 2 egz. autorom opracowań.\n        Wszyscy uczniowie piszący opracowania otrzymali imienne dyplomy za udział w konkursie, nauczyciele dyplomy za\n        opiekę merytoryczną oraz dyrektorzy dyplomy za udział szkoły w konkursie.\n      ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_vm._l((_vm.srod_warszawa.lists.prelekcje_materialy_biblioteki),function(element){return _c('div',{key:element.id,staticClass:"mb-4"},[_c('p',[_c('b',{staticClass:"lead"},[_vm._v(_vm._s(element.title))])]),_vm._v(" "),_c('ol',{staticClass:"mb-5"},_vm._l((element.list),function(item,index){return _c('li',[_vm._v(_vm._s(item))])}),0)])}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"7"}},[_c('p',[_vm._v("\n            W tym samym okresie w tych samych szkołach odbyły się prelekcje na temat Wileńszczyzny za okres 1914 do 1944 i\n            działalności niepodległościowej SZP, ZWZ i AK w okresie wszystkich pięciu okupacji\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Środowisko wydało na potrzeby szkół średnich (gimnazjów i liceów) 48 zeszytów historycznych, przekazując je do\n            bibliotek szkolnych. Nauczycielom historii w gimnazjach i liceach przekazano bezpłatnie 42 książki o tematyce\n            Okręgu Wileńskiego pisane przez historyków.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Dodatkowo zorganizowano i przeprowadzono trzy prelekcje publiczne w Domu Spotkań z Historią Fundacji KARTA w\n            Warszawie ul. Karowa. Do bibliotek szkolnych przekazano również 35 zeszytów z opracowaniami laureatów konkursów\n            historycznych (sympozjów) jako materiały pomocnicze.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Środowisko na początku 2011 roku w ramach działalności historycznej zaproponowało dla chętnych ze Środowisk\n            Brygadowych wydanie pamiątkowych ryngrafów metalowych, na których widnieje Orzeł Ruszczyca i odznaka\n            poszczególnych Brygad. Każda z Brygad prowadzi imienną ewidencję i wystawia legitymację. 3.Brygadę „Szczerbca”\n            prowadzi kol. Ewa Chyża-Dunowska, 6. Brygadę „Tońki” i „Konara” kol. Janusz Cierpiński i Janusz Bohdanowicz oraz\n            7. Brygadę „Wilhelma” kol. Janusz Bohdanowicz.\n          ")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"8"}},[_c('b-carousel',{staticClass:"carousel",staticStyle:{"text-shadow":"1px 1px 2px #333","margin":"0 0em 2em 0em"},attrs:{"controls":"","indicators":"","background":"#ababab","interval":0}},_vm._l((_vm.srod_warszawa.carousel),function(carousel){return _c('div',{key:carousel.id},[_c('b-carousel-slide',{attrs:{"caption":carousel.title,"text":carousel.text,"img-src":carousel.img}})],1)}),0)],1)],1)],1)],1),_vm._v(" "),_c('b-button',{staticClass:"mb-5 btn-white-space",attrs:{"target":"_blank","href":"/srodowiska/srod_warszawa/MAT_HIS_NA_OGOLNO_POLSKI_KONKURS.zip"}},[_vm._v("\n        MATERIAŁY HISTORYCZNE NA OGÓLNO POLSKI KONKURS\n      ")]),_vm._v(" "),_vm._l((_vm.srod_warszawa.lists.zarzad_wykaz),function(element){return _c('div',{key:element.id,staticClass:"mb-4"},[_c('p',[_c('b',{staticClass:"lead"},[_vm._v(_vm._s(element.title))])]),_vm._v(" "),_c('ol',{staticClass:"mb-5"},_vm._l((element.list),function(item,index){return _c('li',[_vm._v(_vm._s(item))])}),0)])})],2)],1)],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',{staticClass:"lead"},[_vm._v("Konkursy organizowane jako Środowisko Wileńskie w Warszawie w okresie od 2006 do 2010 roku")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',{staticClass:"lead"},[_vm._v("Konkursy- sympozja zorganizowane w okresie 2007 – 2009")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',{staticClass:"lead"},[_vm._v("Łącznie otrzymano i oceniono 19 opracowań.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qeZy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'kontakt',
  metaInfo: {
    title: 'Kolekcja osobista śp. Janusza Bohdanowicza',
    meta: [{ name: 'description', content: 'W 2009 roku Archiwum Ośrodka KARTA otrzymało w darze kolekcję osobistą Janusza Bohdanowicza pseud. „Czortek”. Wśród materiałów przekazanych do Archiwum Ośrodka KARTA znajdują się teczki osobowe byłych żołnierzy Armii Krajowej Okręgu Wileńskiego...' }, { name: 'og:url', content: 'http://akwilno.pl/kolekcja' }, { name: 'og:title', content: 'Kolekcja osobista śp. Janusza Bohdanowicza' }, { name: 'og:image', content: '/main/menu_logo.png' }, { name: 'og:description', content: 'W 2009 roku Archiwum Ośrodka KARTA otrzymało w darze kolekcję osobistą Janusza Bohdanowicza pseud. „Czortek”. Wśród materiałów przekazanych do Archiwum Ośrodka KARTA znajdują się teczki osobowe byłych żołnierzy Armii Krajowej Okręgu Wileńskiego...' }, { name: 'twitter:url', content: 'http://akwilno.pl/kolekcja' }, { name: 'twitter:title', content: 'Kolekcja osobista śp. Janusza Bohdanowicza' }, { name: 'witter:image', content: '/main/menu_logo.png' }, { name: 'twitter:description', content: 'W 2009 roku Archiwum Ośrodka KARTA otrzymało w darze kolekcję osobistą Janusza Bohdanowicza pseud. „Czortek”. Wśród materiałów przekazanych do Archiwum Ośrodka KARTA znajdują się teczki osobowe byłych żołnierzy Armii Krajowej Okręgu Wileńskiego...' }]
  }
});

/***/ }),

/***/ "r15W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__("xKc6");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("X7DP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r4EB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rX3i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rrPM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sBCC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_aktualnosci_relacja_z_obchodow_js__ = __webpack_require__("WfX2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'relacja_z_obchodow',
  data: function data() {
    return {
      relacja: __WEBPACK_IMPORTED_MODULE_0__models_aktualnosci_relacja_z_obchodow_js__["a" /* default */].carousel
    };
  },
  metaInfo: {
    title: 'Obchody 70. rocznicy operacji „Ostra Brama” w Wilnie 5- 8 lipiec 2014 r.',
    meta: [{ name: 'description', content: 'Siedemdziesiąt lat temu żołnierze Armii Krajowej podjęli walkę o Wilno, pragnąc wyzwolić je własnymi siłami z rąk niemieckich przed wejściem Armii Czerwonej, która wypierając Niemców nie niosła ze sobą wolności, lecz sowieckie zniewolenie.' }, { name: 'og:url', content: 'http://akwilno.pl/relacja_z_obchodow' }, { name: 'og:title', content: 'Obchody 70. rocznicy operacji „Ostra Brama” w Wilnie 5- 8 lipiec 2014 r.' }, { name: 'og:image', content: '/aktualnosci/relacja_z_obchodow.jpg' }, { name: 'og:description', content: 'Siedemdziesiąt lat temu żołnierze Armii Krajowej podjęli walkę o Wilno, pragnąc wyzwolić je własnymi siłami z rąk niemieckich przed wejściem Armii Czerwonej, która wypierając Niemców nie niosła ze sobą wolności, lecz sowieckie zniewolenie.' }, { name: 'twitter:url', content: 'http://akwilno.pl/relacja_z_obchodow' }, { name: 'twitter:title', content: 'Obchody 70. rocznicy operacji „Ostra Brama” w Wilnie 5- 8 lipiec 2014 r.' }, { name: 'witter:image', content: '/aktualnosci/relacja_z_obchodow.jpg' }, { name: 'twitter:description', content: 'Siedemdziesiąt lat temu żołnierze Armii Krajowej podjęli walkę o Wilno, pragnąc wyzwolić je własnymi siłami z rąk niemieckich przed wejściem Armii Czerwonej, która wypierając Niemców nie niosła ze sobą wolności, lecz sowieckie zniewolenie.' }]
  }
});

/***/ }),

/***/ "tJJ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aktualnosci_vue__ = __webpack_require__("iu87");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4a97a82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aktualnosci_vue__ = __webpack_require__("S1EH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aktualnosci_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4a97a82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aktualnosci_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tUJr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rozbrojenie_aresztowanie_epilog_dokumenty',
  metaInfo: {
    title: 'Aresztowania, rozbrojenia i represje sowieckie - EPILOG',
    meta: [{ name: 'description', content: 'Dnia 17 lipca 1944 roku wydzielony z szeregów 7. Brygady Oddział po wycofaniu się z Bogusz, forsownym marszem dowodzony przez Komendanta "Wilhelma" przesuwał się w kierunku Puszczy Rudnickiej. Po drodze napotkał pozostałą część Brygady ,czasowo dowodzoną przez kpt. "Czarnego Jana"' }, { name: 'og:url', content: 'http://akwilno.pl/historia/rozbrojenie_aresztowanie_epilog_dokumenty' }, { name: 'og:title', content: 'Aresztowania, rozbrojenia i represje sowieckie - EPILOG' }, { name: 'og:image', content: '/historia/rozbrojenie_aresztowanie_epilog_dokumenty.jpg' }, { name: 'og:description', content: 'Dnia 17 lipca 1944 roku wydzielony z szeregów 7. Brygady Oddział po wycofaniu się z Bogusz, forsownym marszem dowodzony przez Komendanta "Wilhelma" przesuwał się w kierunku Puszczy Rudnickiej. Po drodze napotkał pozostałą część Brygady ,czasowo dowodzoną przez kpt. "Czarnego Jana"' }, { name: 'twitter:url', content: 'http://akwilno.pl/historia/rozbrojenie_aresztowanie_epilog_dokumenty' }, { name: 'twitter:title', content: 'Aresztowania, rozbrojenia i represje sowieckie - EPILOG' }, { name: 'witter:image', content: '/historia/rozbrojenie_aresztowanie_epilog_dokumenty.jpg' }, { name: 'twitter:description', content: 'Dnia 17 lipca 1944 roku wydzielony z szeregów 7. Brygady Oddział po wycofaniu się z Bogusz, forsownym marszem dowodzony przez Komendanta "Wilhelma" przesuwał się w kierunku Puszczy Rudnickiej. Po drodze napotkał pozostałą część Brygady ,czasowo dowodzoną przez kpt. "Czarnego Jana"' }]
  }
});

/***/ }),

/***/ "tbYJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "thLP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__ = __webpack_require__("pg2O");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bf169ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__("ciLx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bf169ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tvW4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sideBar_vue__ = __webpack_require__("ZseY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c57b9ea8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sideBar_vue__ = __webpack_require__("G5Ao");
function injectStyle (ssrContext) {
  __webpack_require__("1TLu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c57b9ea8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c57b9ea8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vaPR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wUZA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("FGQs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37908ad8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("hRS/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37908ad8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_menu_navBar__ = __webpack_require__("9BR3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menu_sideBar__ = __webpack_require__("tvW4");
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    navBar: __WEBPACK_IMPORTED_MODULE_0__components_menu_navBar__["a" /* default */],
    sideBar: __WEBPACK_IMPORTED_MODULE_1__components_menu_sideBar__["a" /* default */]
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'AK Wilno',
    // all titles will be injected into this template
    titleTemplate: '%s | AK Wilno',
    meta: [{ name: 'keywords', content: 'AK, Wilno, Janusz, Bohdanowicz, ostra, brama, czortek, ośrodek, karta, historia, wielńszczyzna, oddziay, brygady, tablice, epitafijne, środowiska, kombatanckie, Gdańsk, Warszawa, Państwo, Podziemne, Vue, Javascript, HTML, Dawid Bonik' }, { name: 'author', content: 'Dawid Bonik' }, { name: 'og:type', content: 'website' }, { name: 'og:site_name', content: 'AK Wilno' }, { name: 'og:locale', content: 'pl_PL' }, { name: 'article:author', content: 'Dawid Bonik' }, { name: 'twitter:card', content: 'summary' }, { name: 'twitter:site', content: '@osrodekkarta' }, { name: 'twitter:creator', content: '@Boni0' }],
    link: [{ rel: 'icon', href: '/static/main/site_ico.ico' }]
  }
});

/***/ }),

/***/ "xKc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__("E9Zr");
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__progress__["a" /* default */]);

/***/ }),

/***/ "xNNT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Środowiska")]),_c('br'),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},_vm._l((_vm.srodowiska),function(msg){return _c('div',{key:msg.id},[_c('b-media',{staticClass:"mb-3",attrs:{"tag":"li"}},[_c('b-img',{attrs:{"slot":"aside","src":msg.img,"width":"120"},slot:"aside"}),_vm._v(" "),_c('h5',{staticClass:"mt-0 mb-2"},[_c('router-link',{staticClass:"router-link-list",attrs:{"active-class":"activeSide","to":msg.url,"exact":""}},[_vm._v(_vm._s(msg.title))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"10"}},[_vm._v("\n            "+_vm._s(msg.text)),_c('router-link',{attrs:{"active-class":"activeSide","to":msg.url,"exact":""}},[_vm._v(".....więcej")])],1)],1)],1)],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xgm+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kontakt_vue__ = __webpack_require__("H1rm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d0414f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kontakt_vue__ = __webpack_require__("5DkK");
function injectStyle (ssrContext) {
  __webpack_require__("BuPm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d0414f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kontakt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d0414f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kontakt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xlOB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  carousels: [{
    id: 0,
    title: '1944, Wileńszczyzna.',
    text: 'Przysięga grupy żołnierzy z 5 Brygady Partyzanckiej AK, prawdopodobnie z 1 komp. Przysięgę odbiera kapelan 5 Brygady ks. Aleksander Grabowski ps. "Ignacy". Fot. Sergiusz Sprudin, zbiór zdjęć Janusza Chorążaka',
    img: "/home/main_1.jpg"
  }, {
    id: 1,
    title: '1944, Turgiele, Wileńszczyzna',
    text: 'Honorowa straż 3 Wileńskiej Brygady Partyzanckiej AK przy grobie pańskim. Fot. Leonard Siemaszko ps. „Długi”, kolekcja Wincentego Borodziewicza, zbiory Ośrodka KARTA, przekazała Wanda Borodziewicz',
    img: "/home/main_2.jpg"
  }, {
    id: 2,
    title: '9.04.1944, Turgiele, Wileńszczyzna.',
    text: 'Kawaleria 3 Brygady Armii Krajowej – przed żołnierzami dowódca szwadronu kawalerii porucznik Władysław Kitowski ps. „Grom”, (od lewej w kolumnie) partyzant Ludwik Błuś ps. „Smutny”, zastępca dowódcy podporucznik Tadeusz Duszyński (?) ps. „Wołodyjowski”, partyzant Kazimierz Buncler ps. "Mik", partyzant Izbicki ps. „Hel”. Fot. NN, kolekcja Wincentego Borodziewicza, zbiory Ośrodka KARTA, przekazała Wanda Borodziewicz',
    img: "/home/main_3.jpg"
  }, {
    id: 3,
    title: '9.04.1944, Turgiele.',
    text: 'Komendant Okręgu Wileńskiego Armii Krajowej podpułkownik Aleksander Krzyżanowski ps. „Wilk” dekoruje odznaczeniami oficerów i żołnierzy 3 Wileńskiej Brygady Partyzanckiej. W szeregu przed komendantem stoją (od lewej)” porucznik Gracjan Fróg ps. Szczerbiec, lekarz brygady Lech Iwanowski, dowódca plutonu Romuald Rajs. Fot. NN, kolekcja Wincentego Borodziewicza, zbiory Ośrodka KARTA, przekazała Wanda Borodziewicz',
    img: "/home/main_4.jpg"
  }, {
    id: 4,
    title: 'Luty 1944',
    text: 'Partyzanci 1 plutonu 6 Wileńskiej Samodzielnej Brygady Partyzanckiej Armii Krajowej w marszu. Pluton prowadzi Wincenty Borodziewicz ps. „Szkrab”. Fot. NN, kolekcja Wincentego Borodziewicza, zbiory Ośrodka KARTA, przekazała Wanda Borodziewicz',
    img: "/home/main_5.jpg"
  }, {
    id: 5,
    title: 'Styczeń 1944, Wileńszczyzna.',
    text: '6 Wileńska Samodzielna Brygada Partyzancka Armii Krajowej. Fot. NN, kolekcja Wincentego Borodziewicza, zbiory Ośrodka KARTA, przekazała Wanda Borodziewicz',
    img: "/home/main_6.jpg"
  }, {
    id: 6,
    title: 'Lipiec 1944, Puszcza Rudnicka. ',
    text: 'Major Czesław Dębicki ps. Jerema dokonuje odprawy partyzantów swojego zgrupowania. Fot. NN, kolekcja Wincentego Borodziewicza, zbiory Ośrodka KARTA, przekazała Wanda Borodziewicz',
    img: "/home/main_7.jpg"
  }, {
    id: 7,
    title: '17.07.1944, Czarny Bór, pow. Wileńsko-Trocki.',
    text: 'Oddział partyzancki Bazy z Kedywu Komendy Okręgu Wileńskiego AK po akcji "Burza". Uroczystość przed kościołem z udziałem duchowieństwa i okolicznej ludności cywilnej. Kobieta wręcza kwiaty dowódcy oddziału plut. pchor. Andrzejowi Święcickiemu "Fryczowi". Fot. Zygmunt Zniszczyński, zbiory Ośrodka KARTA',
    img: "/home/main_8.jpg"
  }]
});

/***/ }),

/***/ "z+9x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_historia_powolanie_zgrupowan__ = __webpack_require__("CS0e");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'powolanie_zgrupowan',
  data: function data() {
    return {
      powolania: __WEBPACK_IMPORTED_MODULE_0__models_historia_powolanie_zgrupowan__["a" /* default */]
    };
  },
  metaInfo: {
    title: 'Powołanie Zgrupowań - Operacja "Ostra Brama" i walki pod Krawczunami',
    meta: [{ name: 'description', content: 'Lista powoanych zgrupowań z uwzględnieniem uczestników oraz dowódców inspektoratów, plany operacji, urtyfikowania miasta Wilna oraz fragment dokumentu "Droga do „Ostrej Bramy”"' }, { name: 'og:url', content: 'http://akwilno.pl/historia/powolanie_zgrupowan' }, { name: 'og:title', content: 'Powołanie Zgrupowań - Operacja "Ostra Brama" i walki pod Krawczunami' }, { name: 'og:image', content: '/historia/powolanie_zgrupowan.jpg' }, { name: 'og:description', content: 'Lista powoanych zgrupowań z uwzględnieniem uczestników oraz dowódców inspektoratów, plany operacji, urtyfikowania miasta Wilna oraz fragment dokumentu "Droga do „Ostrej Bramy”"' }, { name: 'twitter:url', content: 'http://akwilno.pl/historia/powolanie_zgrupowan' }, { name: 'twitter:title', content: 'Powołanie Zgrupowań - Operacja "Ostra Brama" i walki pod Krawczunami' }, { name: 'witter:image', content: '/historia/powolanie_zgrupowan.jpg' }, { name: 'twitter:description', content: 'Lista powoanych zgrupowań z uwzględnieniem uczestników oraz dowódców inspektoratów, plany operacji, urtyfikowania miasta Wilna oraz fragment dokumentu "Droga do „Ostrej Bramy”"' }]
  }
});

/***/ }),

/***/ "z9yW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  news: [{
    id: 0,
    title: 'Spuścizna Jana Gozdawy-Gołębiowskiego udostępniona w OSA',
    text: 'Zakończyliśmy realizację projektu obejmującego opracowanie, digitalizację i upowszechnienie kolekcji osobistej Jana Gozdawy-Gołębiowskiego (1925 – 2013). W jej skład wchodzą materiały dotyczące życia Jana Gozdawy-Gołębiowskiego, jego braci, również żołnierzy AK oraz materiały dokumentujące działania Armii Krajowej na terenie Obszaru Warszawskiego ',
    url: "/aktualnosci/spuscizna_jana_gozdawy_golebiowskiego",
    img: '/aktualnosci/spuscizna_jana_gozdawy_golebiowskiego.jpg'
  }, {
    id: 1,
    title: 'Obchody 70. rocznicy operacji „Ostra Brama”',
    text: 'Siedemdziesiąt lat temu żołnierze Armii Krajowej podjęli walkę o Wilno, pragnąc wyzwolić je własnymi siłami z rąk niemieckich przed wejściem Armii Czerwonej, która wypierając Niemców nie niosła ze sobą wolności, lecz sowieckie zniewolenie. Opanowanie Wilna i wystąpienie wobec Sowietów przez władze cywilne i wojskowe Polskiego Państwa Podziemnego',
    url: "/aktualnosci/relacja_z_obchodow",
    img: '/aktualnosci/relacja_z_obchodow.jpg'
  }, {
    id: 2,
    title: 'Uroczystosci w Wilnie oraz zbiórka darów na rzecz żołnierzy AK',
    text: 'W obchodach wezmą udział kombatanci – żołnierze Armii Krajowej zPolski, Białorusi i Litwy oraz członkowie Stowarzyszenia, nauczyciele wraz zuczniami i harcerzami z patriotycznych szkół w Bujwidzach, Wojdatach, Soleczniakach, Wilnie, Sejnach, Suwałkach, Augustowie, Białymstoku, Warszawie, Wołominie i Krakowie',
    url: "/aktualnosci/urocz_w_wilnie",
    img: '/aktualnosci/urocz_w_wilnie.jpg'
  }, {
    id: 3,
    title: 'Odznaczenie dla gen. A. Krzyżanowskiego "Wilka"',
    text: 'Żołnierze Armii Krajowej Okręgu Wileńskiego i Nowogródzkiego na spotkaniu u Prezydenta Rzeczpospolitej dla wręczenia po śmierci odznaczenia dla gen. A. Krzyżanowskiego "Wilka"',
    url: "/aktualnosci/odzn_gen_krzyzanowski",
    img: '/aktualnosci/odzn_gen_krzyzanowski.jpg'
  }, {
    id: 4,
    title: 'Zawieszenie i poświęcenie votum',
    text: 'W kwietniu 2011r. Prezes Okręgu Wileńskiego Światowego Związku Żołnierzy Armii Krajowej – Janusz Bohdanowicz – wziął udział w uroczystości poświęcenia nowej dzwonnicy przy kaplicy w Skorbucianach koło Wilna, gdzie znajduje się cmentarz żołnierzy 7 Wileńskiej Brygady AK, poległych w czasie II Wojny Światowej',
    url: "/aktualnosci/zawiesz_posw_votum",
    img: '/aktualnosci/zawiesz_posw_votum.jpg'
  }]
});

/***/ }),

/***/ "zvaF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sponsorzy_vue__ = __webpack_require__("Fqf/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f6d7f4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sponsorzy_vue__ = __webpack_require__("Fo1U");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sponsorzy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f6d7f4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sponsorzy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.263cf43a597d5d147c7f.js